webpackJsonp([5],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(709),
    baseMatchesProperty = __webpack_require__(710),
    identity = __webpack_require__(102),
    isArray = __webpack_require__(35),
    property = __webpack_require__(796);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(102),
    overRest = __webpack_require__(219),
    setToString = __webpack_require__(220);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(819);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(162),
    isObjectLike = __webpack_require__(65);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(150),
    isFlattenable = __webpack_require__(735);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(216);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(92),
    arrayIncludes = __webpack_require__(148),
    arrayIncludesWith = __webpack_require__(149),
    cacheHas = __webpack_require__(98),
    createSet = __webpack_require__(719),
    setToArray = __webpack_require__(160);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(706),
    getValue = __webpack_require__(728);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isObjectLike = __webpack_require__(65);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(58);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(92),
    arrayIncludes = __webpack_require__(148),
    arrayIncludesWith = __webpack_require__(149),
    arrayMap = __webpack_require__(33),
    baseUnary = __webpack_require__(96),
    cacheHas = __webpack_require__(98);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71),
    getRawTag = __webpack_require__(725),
    objectToString = __webpack_require__(753);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(739),
    listCacheDelete = __webpack_require__(740),
    listCacheGet = __webpack_require__(741),
    listCacheHas = __webpack_require__(742),
    listCacheSet = __webpack_require__(743);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(147),
    setCacheAdd = __webpack_require__(756),
    setCacheHas = __webpack_require__(757);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(57);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndexBy = __webpack_require__(155),
    identity = __webpack_require__(102),
    isSymbol = __webpack_require__(58);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295,
    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndex(array, value, retHighest) {
  var low = 0,
      high = array == null ? low : array.length;

  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
    while (low < high) {
      var mid = (low + high) >>> 1,
          computed = array[mid];

      if (computed !== null && !isSymbol(computed) &&
          (retHighest ? (computed <= value) : (computed < value))) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return high;
  }
  return baseSortedIndexBy(array, value, identity, retHighest);
}

module.exports = baseSortedIndex;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34);

/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length) &&
    predicate(array[index], index, array)) {}

  return isDrop
    ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
    : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
}

module.exports = baseWhile;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(35),
    isKey = __webpack_require__(159),
    stringToPath = __webpack_require__(766),
    toString = __webpack_require__(822);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(736);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(744),
    mapCacheDelete = __webpack_require__(745),
    mapCacheGet = __webpack_require__(746),
    mapCacheHas = __webpack_require__(747),
    mapCacheSet = __webpack_require__(748);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(152);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(99),
    toKey = __webpack_require__(63);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(94),
    baseIsNaN = __webpack_require__(207),
    strictIndexOf = __webpack_require__(764);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(92),
    arrayIncludes = __webpack_require__(148),
    arrayIncludesWith = __webpack_require__(149),
    arrayMap = __webpack_require__(33),
    baseUnary = __webpack_require__(96),
    cacheHas = __webpack_require__(98);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(33),
    baseIndexOf = __webpack_require__(152),
    baseIndexOfWith = __webpack_require__(702),
    baseUnary = __webpack_require__(96),
    copyArray = __webpack_require__(213);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

module.exports = basePullAll;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(58);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295,
    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeMin = Math.min;

/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndexBy(array, value, iteratee, retHighest) {
  value = iteratee(value);

  var low = 0,
      high = array == null ? 0 : array.length,
      valIsNaN = value !== value,
      valIsNull = value === null,
      valIsSymbol = isSymbol(value),
      valIsUndefined = value === undefined;

  while (low < high) {
    var mid = nativeFloor((low + high) / 2),
        computed = iteratee(array[mid]),
        othIsDefined = computed !== undefined,
        othIsNull = computed === null,
        othIsReflexive = computed === computed,
        othIsSymbol = isSymbol(computed);

    if (valIsNaN) {
      var setLow = retHighest || othIsReflexive;
    } else if (valIsUndefined) {
      setLow = othIsReflexive && (retHighest || othIsDefined);
    } else if (valIsNull) {
      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
    } else if (valIsSymbol) {
      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
    } else if (othIsNull || othIsSymbol) {
      setLow = false;
    } else {
      setLow = retHighest ? (computed <= value) : (computed < value);
    }
    if (setLow) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return nativeMin(high, MAX_ARRAY_INDEX);
}

module.exports = baseSortedIndexBy;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(73),
    baseFlatten = __webpack_require__(28),
    baseUniq = __webpack_require__(54);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(22);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(57),
    isArrayLike = __webpack_require__(162),
    isIndex = __webpack_require__(56),
    isObject = __webpack_require__(64);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(35),
    isSymbol = __webpack_require__(58);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(703),
    isObjectLike = __webpack_require__(65);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(226),
    isLength = __webpack_require__(163);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(72),
    arrayMap = __webpack_require__(33),
    baseProperty = __webpack_require__(208),
    baseTimes = __webpack_require__(211),
    isArrayLikeObject = __webpack_require__(22);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = arrayFilter(array, function(group) {
    if (isArrayLikeObject(group)) {
      length = nativeMax(group.length, length);
      return true;
    }
  });
  return baseTimes(length, function(index) {
    return arrayMap(array, baseProperty(index));
  });
}

module.exports = unzip;


/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(91),
    stackClear = __webpack_require__(759),
    stackDelete = __webpack_require__(760),
    stackGet = __webpack_require__(761),
    stackHas = __webpack_require__(762),
    stackSet = __webpack_require__(763);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(696),
    eq = __webpack_require__(57);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(704),
    isObjectLike = __webpack_require__(65);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 208 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(716),
    isIndex = __webpack_require__(56);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(57);

/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (!index || !eq(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

module.exports = baseSortedUniq;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

module.exports = baseZipObject;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(92),
    arraySome = __webpack_require__(695),
    cacheHas = __webpack_require__(98);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(204);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(714),
    shortOut = __webpack_require__(758);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(28);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(151);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39),
    stubFalse = __webpack_require__(813);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(165)(module)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isObject = __webpack_require__(64);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(707),
    baseUnary = __webpack_require__(96),
    nodeUtil = __webpack_require__(752);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(694),
    baseKeys = __webpack_require__(708),
    isArrayLike = __webpack_require__(162);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__(154);

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

module.exports = pullAll;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(204),
    arrayMap = __webpack_require__(33),
    unzip = __webpack_require__(164);

/**
 * This method is like `_.unzip` except that it accepts `iteratee` to specify
 * how regrouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  regrouped values.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
 * // => [[1, 10, 100], [2, 20, 200]]
 *
 * _.unzipWith(zipped, _.add);
 * // => [3, 30, 300]
 */
function unzipWith(array, iteratee) {
  if (!(array && array.length)) {
    return [];
  }
  var result = unzip(array);
  if (iteratee == null) {
    return result;
  }
  return arrayMap(result, function(group) {
    return apply(iteratee, undefined, group);
  });
}

module.exports = unzipWith;


/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'chunk': __webpack_require__(767),
  'compact': __webpack_require__(768),
  'concat': __webpack_require__(769),
  'difference': __webpack_require__(771),
  'differenceBy': __webpack_require__(772),
  'differenceWith': __webpack_require__(773),
  'drop': __webpack_require__(774),
  'dropRight': __webpack_require__(775),
  'dropRightWhile': __webpack_require__(776),
  'dropWhile': __webpack_require__(777),
  'fill': __webpack_require__(778),
  'findIndex': __webpack_require__(779),
  'findLastIndex': __webpack_require__(780),
  'first': __webpack_require__(781),
  'flatten': __webpack_require__(222),
  'flattenDeep': __webpack_require__(782),
  'flattenDepth': __webpack_require__(783),
  'fromPairs': __webpack_require__(784),
  'head': __webpack_require__(224),
  'indexOf': __webpack_require__(786),
  'initial': __webpack_require__(787),
  'intersection': __webpack_require__(788),
  'intersectionBy': __webpack_require__(789),
  'intersectionWith': __webpack_require__(790),
  'join': __webpack_require__(791),
  'last': __webpack_require__(36),
  'lastIndexOf': __webpack_require__(792),
  'nth': __webpack_require__(795),
  'pull': __webpack_require__(797),
  'pullAll': __webpack_require__(229),
  'pullAllBy': __webpack_require__(798),
  'pullAllWith': __webpack_require__(799),
  'pullAt': __webpack_require__(800),
  'remove': __webpack_require__(801),
  'reverse': __webpack_require__(802),
  'slice': __webpack_require__(803),
  'sortedIndex': __webpack_require__(804),
  'sortedIndexBy': __webpack_require__(805),
  'sortedIndexOf': __webpack_require__(806),
  'sortedLastIndex': __webpack_require__(807),
  'sortedLastIndexBy': __webpack_require__(808),
  'sortedLastIndexOf': __webpack_require__(809),
  'sortedUniq': __webpack_require__(810),
  'sortedUniqBy': __webpack_require__(811),
  'tail': __webpack_require__(814),
  'take': __webpack_require__(815),
  'takeRight': __webpack_require__(816),
  'takeRightWhile': __webpack_require__(817),
  'takeWhile': __webpack_require__(818),
  'union': __webpack_require__(823),
  'unionBy': __webpack_require__(824),
  'unionWith': __webpack_require__(825),
  'uniq': __webpack_require__(826),
  'uniqBy': __webpack_require__(827),
  'uniqWith': __webpack_require__(828),
  'unzip': __webpack_require__(164),
  'unzipWith': __webpack_require__(230),
  'without': __webpack_require__(829),
  'xor': __webpack_require__(830),
  'xorBy': __webpack_require__(831),
  'xorWith': __webpack_require__(832),
  'zip': __webpack_require__(833),
  'zipObject': __webpack_require__(834),
  'zipObjectDeep': __webpack_require__(835),
  'zipWith': __webpack_require__(836)
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
angular.module('taric.model.about', ['ngResource', 'common.helper']).factory('Metadata', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/metadata/', {}, {
        get: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('AboutModel', ["Metadata", "$q", function (Metadata, $q) {
    var model = this;
    var result;
    model.getMetadata = function () {
        var deferred = $q.defer();
        if (result) {
            deferred.resolve(result);
        } else {
            Metadata.get({}, function (returningResult) {
                result = returningResult;
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
        }
        return deferred.promise;
    };
}]);

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 1/3/2017.
 */
angular.module('arctic.tariff.about', ['common.helper', 'pascalprecht.translate', 'taric.model.about']).controller('AboutController', ["AboutModel", "CONSTANTS", function (AboutModel, CONSTANTS) {
    var aboutCtrl = this;
    aboutCtrl.init = function () {
        AboutModel.getMetadata().then(function (result) {
            aboutCtrl.version = result.version;
        }, function (error) {
            //Do nothing if we can not load the version
        });
    };
}]);

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 1/3/2017.
 */

angular.module('arctic.tariff.callback', ['common.helper', 'pascalprecht.translate']).controller('CallbackController', ["$state", "CONSTANTS", function ($state, CONSTANTS) {
    var callbackCtrl = this;
    callbackCtrl.init = function () {
        $state.go(CONSTANTS.menu.landingPage);
    };
}]);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 3/14/2016.
 */
angular.element(document).ready(function () {

	var initInjector = angular.injector(['ng']);
	var $http = initInjector.get('$http');
	var initConfig = function initConfig(data) {

		angular.module('common.config', []).constant('CONSTANTS', data);
		angular.bootstrap(document, ["arctic.tariff"]);
	};

	$http({
		url: 'config.json' + '?d=' + Date.now(),
		method: 'GET',
		headers: { 'Content-Type': 'application/json; charset=UTF-8' }
	}).then(function (response) {
		initConfig(response.data);
	});
});

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 4/25/2016.
 */

angular.module('common.directive.country', ['common.helper', 'common.model.geoarea']).component('agCountry', {
    bindings: {
        countryId: '@',
        countryCodeId: '@',
        countryDescription: '@',
        countryCodeDescription: '@',
        hasCountryGroup: '@',
        country: '<',
        control: '=',
        simulationDate: '<',
        onCountryChange: '&',
        onHandleError: '&'
    },
    controller: ["GeographicalAreaModel", "CommonHelper", "$filter", "$translate", "$rootScope", "$q", function controller(GeographicalAreaModel, CommonHelper, $filter, $translate, $rootScope, $q) {
        var ctrl = this;

        ctrl.handleError = function (errorCode, errorParams) {
            ctrl.onHandleError({
                error: {
                    errorCode: errorCode, errorParams: errorParams
                }
            });
        };

        ctrl.getCountries = function () {
            if (!ctrl.countriesAndRegions) {
                return [];
            }
            var countries = ctrl.countriesAndRegions.items.filter(function (geoArea) {
                return geoArea.type === 'C';
            });
            return countries.sort(function (country1, country2) {
                return $filter('description')(country1.descriptions).localeCompare($filter('description')(country2.descriptions), CommonHelper.getLanguageCode($translate.use()));
            });
        };

        ctrl.getRegions = function () {
            if (!ctrl.countriesAndRegions) {
                return [];
            }
            var regions = ctrl.countriesAndRegions.items.filter(function (geoArea) {
                return geoArea.type === 'R';
            });
            return regions.sort(function (region1, region2) {
                return $filter('description')(region1.descriptions).localeCompare($filter('description')(region2.descriptions), CommonHelper.getLanguageCode($translate.use()));
            });
        };

        ctrl.getGroups = function () {
            if (!ctrl.countriesAndRegions) {
                return [];
            }
            var groups = ctrl.countriesAndRegions.items.filter(function (geoArea) {
                return geoArea.type === 'G';
            });
            return groups.sort(function (group1, group2) {
                return $filter('description')(group1.descriptions).localeCompare($filter('description')(group2.descriptions), CommonHelper.getLanguageCode($translate.use()));
            });
        };

        ctrl.loadCountriesAndRegions = function () {
            ctrl.countries = ctrl.getCountries();
            ctrl.regions = ctrl.getRegions();
            ctrl.groups = ctrl.getGroups();
        };

        $rootScope.$on('$translateChangeSuccess', function () {
            ctrl.loadCountriesAndRegions();
        });

        ctrl.reload = function (reloadDate) {
            var deferred = $q.defer();
            if (reloadDate) {
                GeographicalAreaModel.getCountriesOfOrigin(reloadDate).then(function (countries) {
                    ctrl.countriesAndRegions = countries;
                    // If there is selected country, only display it when it exists at reloadDate
                    var found = false;
                    if (ctrl.country) {
                        //Find the country from the list
                        for (var i = 0; i < ctrl.countriesAndRegions.items.length; i++) {
                            var geoAreaId = ctrl.countriesAndRegions.items[i].id;
                            if (ctrl.country === geoAreaId) {
                                ctrl.countryCode = geoAreaId;
                                found = true;
                                break;
                            }
                        }
                    }
                    if (!found) {
                        ctrl.countryCode = null;
                        ctrl.country = null;
                    }
                    ctrl.loadCountriesAndRegions();
                    deferred.resolve();
                }, function (error) {
                    ctrl.handleError(error.data.code, error.data.params);
                    deferred.reject(error);
                });
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        };

        //Update the country select box when user enters the country code in the input text
        ctrl.countryCodeChange = function () {
            var countryCode = CommonHelper.removeSpaceCharacters(ctrl.countryCode);

            //Wait until user enters 2 characters
            if (countryCode.length === 1 || countryCode.length === 3) {
                return;
            } else {

                //Find the country from the list
                var found = false;
                for (var i = 0; i < ctrl.countriesAndRegions.items.length; i++) {
                    var geoAreaId = ctrl.countriesAndRegions.items[i].id;
                    if (ctrl.countryCode.toUpperCase() === geoAreaId) {
                        ctrl.country = geoAreaId;
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    ctrl.country = null;
                }

                ctrl.onCountryChange({ country: ctrl.country });
            }
        };

        //Update the country code when the country of origin select box is changed
        ctrl.countryChange = function () {
            ctrl.countryCode = ctrl.country;
            ctrl.onCountryChange({ country: ctrl.country });
        };

        ctrl.validate = function () {
            var countryCode = CommonHelper.removeSpaceCharacters(ctrl.countryCode);
            var country = CommonHelper.removeSpaceCharacters(ctrl.country);
            if (countryCode.toUpperCase() !== country.toUpperCase()) {
                return "i18n.common.validation.country.code.invalid";
            }

            return null;
        };

        ctrl.updateCountryCode = function (countryCode) {
            ctrl.countryCode = countryCode;
        };

        ctrl.init = function () {
            if (ctrl.control) {
                ctrl.control.reload = ctrl.reload;
                ctrl.control.validate = ctrl.validate;
                ctrl.control.updateCountryCode = ctrl.updateCountryCode;
            }
            if (!ctrl.countryId) {
                ctrl.countryId = "country";
            }
            if (!ctrl.countryCodeId) {
                ctrl.countryCodeId = "countryCode";
            }

            // The country list must always be loaded when initializing country drop-box component.
            if (ctrl.simulationDate) {
                ctrl.reload(ctrl.simulationDate);
            } else {
                ctrl.reload(new Date());
            }
        };

        ctrl.init();
    }],
    templateUrl: 'common/directive/country.tmpl.html'
});

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pli on 8/25/2016.
 */
angular.module('common.directive.monetaryUnit', ['common.helper', 'taric.model.monetaryunits']).component('agMonetaryUnit', {
    bindings: {
        monetaryUnitId: '@',
        monetaryUnitCodeId: '@',
        monetaryUnitDescription: '@',
        monetaryUnitCodeDescription: '@',
        monetaryUnit: '<',
        control: '=',
        fromDate: '<',
        onMonetaryUnitChange: '&',
        onHandleError: '&'
    },
    controller: ["MonetaryUnitsModel", "CommonHelper", "$filter", "$translate", "$rootScope", function controller(MonetaryUnitsModel, CommonHelper, $filter, $translate, $rootScope) {
        var ctrl = this;

        ctrl.handleError = function (errorCode, errorParams) {
            ctrl.onHandleError({
                error: {
                    errorCode: errorCode, errorParams: errorParams
                }
            });
        };

        ctrl.getMonetaryUnits = function () {
            if (!ctrl.monetaryUnitsResult) {
                return [];
            }
            var monetaryUnits = ctrl.monetaryUnitsResult.items;
            return monetaryUnits.sort(function (monetaryUnit1, monetaryUnit2) {
                return monetaryUnit1.id.localeCompare(monetaryUnit2.id, CommonHelper.getLanguageCode($translate.use()));
            });
        };

        ctrl.loadMonetaryUnits = function () {
            ctrl.monetaryUnits = ctrl.getMonetaryUnits();
        };

        $rootScope.$on('$translateChangeSuccess', function () {
            ctrl.loadMonetaryUnits();
        });

        ctrl.reload = function (reloadDate) {
            if (!reloadDate) {
                return;
            }
            ctrl.monetaryUnitCode = null;
            MonetaryUnitsModel.customsValueMonetaryUnits(reloadDate).then(function (monetaryUnits) {
                ctrl.monetaryUnitsResult = monetaryUnits;
                ctrl.monetaryUnitCode = ctrl.monetaryUnit;
                ctrl.loadMonetaryUnits();
            }, function (error) {
                ctrl.handleError(error.data.code, error.data.params);
            });
        };

        //Update the monetaryUnit select box when user enters the monetaryUnit in the input text
        ctrl.monetaryUnitCodeChange = function () {
            var monetaryUnitCode = CommonHelper.removeSpaceCharacters(ctrl.monetaryUnitCode);

            //Wait until user enters 3 characters
            if (monetaryUnitCode.length === 2) {
                return;
            } else {
                //Find the monetaryUnit from the list
                var found = false;
                for (var i = 0; i < ctrl.monetaryUnitsResult.items.length; i++) {
                    var monetaryUnitId = ctrl.monetaryUnitsResult.items[i].id;
                    if (ctrl.monetaryUnitCode.toUpperCase() === monetaryUnitId) {
                        ctrl.monetaryUnit = monetaryUnitId;
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    ctrl.monetaryUnit = null;
                }
                ctrl.onMonetaryUnitChange({ monetaryUnit: ctrl.monetaryUnit });
            }
        };

        //Update the monetaryUnit when the monetaryUnits select box is changed
        ctrl.monetaryUnitChange = function () {
            ctrl.monetaryUnitCode = ctrl.monetaryUnit;
            ctrl.onMonetaryUnitChange({ monetaryUnit: ctrl.monetaryUnit });
        };

        ctrl.validate = function () {
            var monetaryUnitCode = CommonHelper.removeSpaceCharacters(ctrl.monetaryUnitCode);
            var monetaryUnit = CommonHelper.removeSpaceCharacters(ctrl.monetaryUnit);

            if (monetaryUnitCode.toUpperCase() !== monetaryUnit.toUpperCase()) {
                return "i18n.common.validation.monetary.code.invalid";
            }
            return null;
        };

        ctrl.updateMonetaryUnitCode = function (monetaryUnitCode) {
            ctrl.monetaryUnitCode = monetaryUnitCode;
        };

        ctrl.init = function () {
            if (ctrl.control) {
                ctrl.control.reload = ctrl.reload;
                ctrl.control.validate = ctrl.validate;
                ctrl.control.updateMonetaryUnitCode = ctrl.updateMonetaryUnitCode;
            }
            if (!ctrl.monetaryUnitId) {
                ctrl.monetaryUnitId = "monetaryUnit";
            }
            if (!ctrl.monetaryUnitCodeId) {
                ctrl.monetaryUnitCodeId = "monetaryUnitCode";
            }
            ctrl.reload(ctrl.fromDate);
        };

        ctrl.init();
    }],
    templateUrl: 'common/directive/monetary-unit.tmpl.html'
});

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by minh on 24/6/2016.
 */
angular.module('common.filter.additionalCode', ['common.helper']).filter('additionalCode', ["CommonHelper", function (CommonHelper) {
    return function (additionalCode) {
        if (!additionalCode || typeof additionalCode !== "string") {
            return additionalCode;
        }
        additionalCode = CommonHelper.removeSpaceCharacters(additionalCode);

        if (additionalCode.length === 4) {
            return additionalCode.substr(0, 1) + " " + additionalCode.substr(1, 3);
        }

        return additionalCode;
    };
}]);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.filter.certificate', ['common.helper']).filter('certificate', ["CommonHelper", function (CommonHelper) {
    return function (certificate) {
        if (!certificate || typeof certificate !== "string") {
            return certificate;
        }
        certificate = CommonHelper.removeSpaceCharacters(certificate);

        if (certificate.length === 4) {
            return certificate.substr(0, 1) + " " + certificate.substr(1, 3);
        }

        return certificate;
    };
}]);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.filter.commoditycode', ['common.helper']).filter('commodityCode', ["CommonHelper", function (CommonHelper) {
    return function (commodityCode) {
        if (!commodityCode || isNaN(CommonHelper.removeSpaceCharacters(commodityCode))) {
            return commodityCode;
        }
        commodityCode = CommonHelper.removeSpaceCharacters(commodityCode);
        /*
            Pls see:
            https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
            page concerning regular expression:
            \B
            x(?=y)
            x(?!y)
            usage in below code.
         */
        if (commodityCode.length === 10) {
            return isNaN(commodityCode) ? "" : commodityCode.toString().replace(/\B(?=(\d{6})+(?!\d))/g, " ").substr(0, 5) + commodityCode.toString().substr(4, 10).replace(/\B(?=(\d{2})+(?!\d))/g, " ");
        } else if (commodityCode.length === 8) {
            return isNaN(commodityCode) ? "" : commodityCode.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ").substr(0, 3) + commodityCode.toString().substr(3, 8).replace(/\B(?=(\d{2})+(?!\d))/g, " ");
        } else if (commodityCode.length === 6) {
            return isNaN(commodityCode) ? "" : commodityCode.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ").substr(0, 2) + commodityCode.toString().substr(2, 6).replace(/\B(?=(\d{2})+(?!\d))/g, " ");
        } else if (commodityCode.length === 4) {
            return isNaN(commodityCode) ? "" : commodityCode.toString();
        }
        return commodityCode;
    };
}]);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.filter.decimalNumberCalcResult', ['common.config', 'common.helper']).filter('decimalNumberCalcResult', ["CONSTANTS", "CommonHelper", function (CONSTANTS, CommonHelper) {
    return function (number) {
        if (isNaN(number)) {
            return null;
        }
        var newNumber = number;
        var numDecimals = CONSTANTS.numberFractionCalcResult;

        switch (CONSTANTS.roundingCalcResult) {
            case 'TRUNCATE':
                /* Truncate decimal value after set number of decimals */
                newNumber = CommonHelper.truncateDecimalNumber(newNumber, numDecimals);
                break;
            default:
                /* Round decimal value */
                break;
        }
        return accounting.formatNumber(newNumber, numDecimals, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
    };
}]);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.filter.decimalNumberExchangeRateResult', ['common.config']).filter('decimalNumberExchangeRateResult', ["CONSTANTS", function (CONSTANTS) {
    return function (number) {
        if (isNaN(number)) {
            return null;
        }
        return accounting.formatNumber(number, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
    };
}]);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.filter.decimalNumber', ['common.config', 'common.helper']).filter('decimalNumber', ["CONSTANTS", "CommonHelper", function (CONSTANTS, CommonHelper) {
    return function (number, useNumberFraction, pNumberFraction) {
        if (isNaN(number)) {
            return null;
        }

        var numberFraction = CONSTANTS.numberFraction;
        if (!isNaN(pNumberFraction)) {
            // Use parameter number fraction
            numberFraction = pNumberFraction;
        } else if (useNumberFraction) {
            // Use the number fraction from the input number
            numberFraction = CommonHelper.getNumberFraction(number);
        }

        return CommonHelper.formatDecimalNumber(number, numberFraction, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
    };
}]);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.filter.description', ['pascalprecht.translate', 'common.helper']).filter('description', ["$translate", "CommonHelper", function ($translate, CommonHelper) {
    return function (descriptions, language) {
        if (!descriptions) {
            return null;
        }

        var descriptionFound = null;
        if (language) {

            //First, find the description of the given language parameter.
            descriptionFound = descriptions[language];
        }

        if (!descriptionFound) {

            //Find the description of the language being used.
            descriptionFound = descriptions[CommonHelper.getLanguageCode($translate.use())];
        }

        if (!descriptionFound) {

            //If there is no description for the language being used, find the English description
            descriptionFound = descriptions.en;
        }
        if (!descriptionFound) {

            //If there is not English description, use the first description from the description map.
            for (var lang in descriptions) {
                descriptionFound = descriptions[lang];
                break;
            }
        }

        return descriptionFound;
    };
}]);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.filter.dutyexpression.description', ['common.config', 'common.filter.description']).filter('dutyExpressionDescription', ["$filter", "CONSTANTS", function ($filter, CONSTANTS) {
    return function (dutyExpressions, measurementUnitCode) {
        if (!dutyExpressions) {
            return null;
        }
        var dutyExpressionDescription = $filter('description')(dutyExpressions);
        if (CONSTANTS.showMeasurementUnitCode && measurementUnitCode) {
            dutyExpressionDescription = dutyExpressionDescription + " (" + measurementUnitCode + ")";
        }
        return dutyExpressionDescription;
    };
}]);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.filter.footnote', ['common.helper']).filter('footnote', ["CommonHelper", function (CommonHelper) {
    return function (footnote) {
        if (!footnote || typeof footnote !== "string") {
            return footnote;
        }
        footnote = CommonHelper.removeSpaceCharacters(footnote);

        if (footnote.length === 5) {
            return footnote.substr(0, 2) + " " + footnote.substr(2, 4);
        } else if (footnote.length === 8) {
            return footnote.substr(0, 3) + " " + footnote.substr(3, 7);
        }

        return footnote;
    };
}]);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.filter.geographicalarea.description', ['common.config', 'common.filter.description']).filter('geographicalAreaDescription', ["$filter", "CONSTANTS", function ($filter, CONSTANTS) {
    return function (geoArea) {
        if (!geoArea) {
            return null;
        }
        var geoAreaDescription = $filter('description')(geoArea.descriptions);
        if (CONSTANTS.showGeographicalAreaCode) {
            geoAreaDescription = geoAreaDescription + " (" + geoArea.id + ")";
        }
        return geoAreaDescription;
    };
}]);

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.filter.measuretype.description', ['common.config', 'common.filter.description']).filter('measureTypeDescription', ["$filter", "CONSTANTS", function ($filter, CONSTANTS) {
    return function (measureType) {
        if (!measureType) {
            return null;
        }
        var measureTypeDescription = $filter('description')(measureType.descriptions);
        if (CONSTANTS.showMeasureTypeCode) {
            measureTypeDescription = measureTypeDescription + " (" + measureType.id + ")";
        }
        return measureTypeDescription;
    };
}]);

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by perl on 21/03/16.
 */
angular.module('common.filter.specialCharacterToHtml', []).filter('specialCharacterToHtml', function () {
    return function (descriptionWithSpecialCharacters) {
        if (!descriptionWithSpecialCharacters) {
            return;
        }
        var str;
        str = descriptionWithSpecialCharacters.toString().replace(/\|/g, "&nbsp;").replace(/!<P>!/g, "<br>").replace(/<P>/g, "<br>").replace(/!1!/g, "<br>").replace(/\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/\$(.)/g, "<sup>$1</sup>").replace(/\@(.)/g, "<sub>$1</sub>").replace(/\|/g, "&nbsp;").replace(/!o!/g, "&deg;").replace(/![xX]!/g, "x") // ACSMNT-3871: "times" sign displayed with a "x" instead of a dot as a symbol
        .replace(/!%!/g, "&permil;").replace(/!>=!/g, "&ge;").replace(/&#64;/g, "&commat;");
        return str;
    };
});

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.filter.truncateLongText', ['common.config']).filter('truncateLongText', ["CONSTANTS", function (CONSTANTS) {
    return function (longText) {
        if (!longText) {
            return null;
        }
        if (longText.length > CONSTANTS.maxDescriptionLength) {
            longText = longText.slice(0, CONSTANTS.maxDescriptionLength) + '...';
        }
        return longText;
    };
}]);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.filter.url', ['pascalprecht.translate', 'common.helper']).filter('url', ["$translate", "CommonHelper", function ($translate, CommonHelper) {
    return function (urls) {
        if (!urls) {
            return null;
        }

        //First, find the url of the language being used.
        var urlFound = urls[CommonHelper.getLanguageCode($translate.use())];
        if (!urlFound) {
            urlFound = urls.en;
        }
        if (!urlFound) {

            //If there is not English url, use the first url from the url map.
            for (var lang in urls) {
                urlFound = urls[lang];
                break;
            }
        }
        return urlFound;
    };
}]);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(75);

angular.module('common.helper', ['ui.bootstrap', 'common.config', 'common.filter.description', 'common.filter.specialCharacterToHtml', 'common.filter.decimalNumber']).factory('CommonHelper', ["CONSTANTS", "$filter", "$translate", "$q", "uibDatepickerPopupConfig", function (CONSTANTS, $filter, $translate, $q, uibDatepickerPopupConfig) {
    var helper = {
        removeSpaceCharacters: function removeSpaceCharacters(str) {
            if (!str) {
                return "";
            }
            return str.replace(/\s+/g, '');
        },
        getRestDateString: function getRestDateString(date) {
            if (!date) {
                return null;
            }

            //The date format yyyy-MM-dd is harded code intentionally because the rest api supports only this format.
            return $filter('date')(date, "yyyy-MM-dd");
        },
        getBookmarkDateString: function getBookmarkDateString(date) {
            if (!date) {
                return null;
            }

            // The bookmarkDateFormat must have day as dd, month as MM, and year as yyyy
            return $filter('date')(date, CONSTANTS.bookmarkDateFormat);
        },
        getOffset: function getOffset(page) {
            return (page - 1) * CONSTANTS.rowsPerPage;
        },
        //This method is used for pagination on client side
        loadDataPerTablePage: function loadDataPerTablePage(data, page) {
            data = data instanceof Array ? data : [data];
            var pageSize = CONSTANTS.rowsPerPage;
            var fromIndex = (page - 1) * pageSize;
            var toIndex = 0;
            if (data.length >= page * pageSize) {
                toIndex = page * pageSize;
            } else {
                toIndex = data.length;
            }
            if (toIndex > fromIndex) {
                return data.slice(fromIndex, toIndex);
            }
            return null;
        },
        validateCommodityCode: function validateCommodityCode(commodityCode, tradeDirection) {
            var errorCode = null;
            if (!commodityCode) {
                return null;
            }
            var inputValue = this.removeSpaceCharacters(commodityCode);

            //Validate the commodity code matches the pattern "^[0-9 ]*$"
            if (!inputValue.match("^[0-9 ]*$")) {
                return "i8n.jsfconv.cc.notNumeric";
            }

            var valid = true;

            //Validate if the commodity code has an even number of characters
            if (inputValue.length % 2 !== 0) {
                valid = false;
            } else if (inputValue.length > 10 && tradeDirection === 'I' || (tradeDirection === 'ER' || tradeDirection === 'E') && inputValue.length > 8) {
                valid = false;
            }
            if (!valid) {
                if (tradeDirection === 'ER') {
                    errorCode = "i8n.jsfconv.cc.not8oreven.exportRefund";
                } else if (tradeDirection === 'E') {
                    errorCode = "i8n.jsfconv.cc.not8oreven.export";
                } else if (tradeDirection === 'I') {
                    errorCode = "i8n.jsfconv.cc.not10oreven.import";
                } else {
                    errorCode = "i8n.jsfconv.cc.noteven";
                }
            }
            return errorCode;
        },
        validateStringByPattern: function validateStringByPattern(value, pattern, errorCode) {
            // If input value exists and does not match pattern, errorCode will be returned.
            if (!value) {
                return null;
            }
            var inputValue = this.removeSpaceCharacters(value);

            if (!inputValue.match(pattern)) {
                return errorCode;
            }

            return null;
        },
        isTooltipEnable: function isTooltipEnable(descriptions) {
            var description = $filter('description')(descriptions);
            var descriptionWithHtml = $filter('specialCharacterToHtml')(description);
            if (descriptionWithHtml && descriptionWithHtml.length > CONSTANTS.maxDescriptionLength) {
                return true;
            }
            return false;
        },
        isDecimalNumber: function isDecimalNumber(value) {
            // Verify that the value is not undefined nor null
            if (value === undefined || value === null || typeof value === "string" && this.removeSpaceCharacters(value) === '') {
                return false;
            }

            // Input value must not contain thousandsSeparator.
            // Replace configured decimalSeparator by default decimalSeparator '.'
            var defaultDecimalValue = value.toString().replace(CONSTANTS.decimalSeparator, '.');

            // If default decimalSeparator '.' is used and the value contains separator ',',
            // the separator ',' must be replaced by '.'
            if (CONSTANTS.decimalSeparator === '.') {
                defaultDecimalValue = defaultDecimalValue.replace(',', '.');
            }

            if (isNaN(defaultDecimalValue) || !isFinite(defaultDecimalValue)) {
                return false;
            }

            return true;
        },
        getDecimalNumber: function getDecimalNumber(number) {
            if (!this.isDecimalNumber(number)) {
                return null;
            } else {
                // Replace configured decimalSeparator by default decimalSeparator '.'
                number = number.toString().replace(CONSTANTS.decimalSeparator, '.');

                // If default decimalSeparator '.' is used and the value contains separator ',',
                // the separator ',' must be replaced by '.'
                if (CONSTANTS.decimalSeparator === '.') {
                    number = number.replace(',', '.');
                }

                // Remove redundant zero digits
                // Remove trailing zeros
                if (number.indexOf('.') >= 0) {
                    number = number.toString().replace(/\.?0+$/, '');
                }
                // Remove leading zeros
                number = number.toString().replace(/^0+(?!\.|$)/, '');

                var maxLength = this.getDecimalNumberMaxLength(number, null, '.');
                while (number.length > maxLength) {
                    number = number.substring(0, number.length - 1);
                }

                number = accounting.unformat(number);
            }

            return number;
        },
        truncateDecimalNumber: function truncateDecimalNumber(number, maxNumberFraction) {
            // The input number must be a decimal number
            var numberFraction = this.getNumberFraction(number);
            if (number === null || maxNumberFraction < 0 || numberFraction === 0) {
                return number;
            }

            // If the number fraction from the input decimal number is bigger than maxNumberFraction,
            // the input number will be truncated.
            if (numberFraction <= maxNumberFraction) {
                return number;
            }

            var truncatedNumberLength = number.toString().split('.')[0].length + 1 + maxNumberFraction;
            var truncatedNumber = accounting.unformat(number.toString().substring(0, truncatedNumberLength));
            return truncatedNumber;
        },
        getNumberFraction: function getNumberFraction(number) {
            // The input number must be a decimal number
            var numberFraction = 0;
            if (number !== null && number.toString().indexOf('.') >= 0) {
                numberFraction = number.toString().split('.')[1].length;
            }

            return numberFraction;
        },
        getDecimalNumberMaxLength: function getDecimalNumberMaxLength(number, thousandsSeparator, decimalSeparator) {
            // JavaScript Numbers can only handle accurate up to 15 digits.
            // If the number of digits exceeds 15, the decimal digits may not be correct.
            // Example: '9999999998.999999' -> 9999999998.999998
            var maxLength = 15;
            if (thousandsSeparator !== '' && number.toString().indexOf(thousandsSeparator) >= 0) {
                maxLength += number.toString().split(thousandsSeparator).length - 1;
            }
            if (number.toString().indexOf(decimalSeparator) >= 0) {
                maxLength++;
            }
            if (number.toString().indexOf('-') >= 0) {
                maxLength++;
            }

            return maxLength;
        },
        formatDecimalNumber: function formatDecimalNumber(number, numberFraction, thousandsSeparator, decimalSeparator) {
            // This method avoids some cases accounting.formatNumber wrongly decimal part when the number has 15 digits or more.
            // For example: 99999999999999.9 -> '99999999999999.91'
            // The input number must be a decimal number
            var formattedNumber = accounting.formatNumber(number, numberFraction, thousandsSeparator, decimalSeparator);
            var maxLength = this.getDecimalNumberMaxLength(formattedNumber, thousandsSeparator, decimalSeparator);
            while (formattedNumber.length > maxLength) {
                formattedNumber = formattedNumber.substring(0, formattedNumber.length - 1);
            }

            return formattedNumber;
        },
        validateDeclarableCommodityCode: function validateDeclarableCommodityCode(commodityCode, tradeDirection) {
            var errorCode = null;
            commodityCode = this.removeSpaceCharacters(commodityCode);
            if (commodityCode.length === 0) {
                errorCode = "i8n.error.commodity.commodityCode.required";
            } else if (!commodityCode.match("^[0-9 ]*$")) {
                errorCode = "i8n.jsfconv.cc.notNumeric";
            } else if (tradeDirection === 'I' && commodityCode.length !== 10) {
                errorCode = "i8n.cc.import.not10";
            } else if (tradeDirection === 'E' && commodityCode.length !== 8) {
                errorCode = "i8n.cc.export.not8";
            }
            return errorCode;
        },
        validateAdditionalCode: function validateAdditionalCode(adco) {
            var inputValue = this.removeSpaceCharacters(adco);

            //Validate the additional code matches the pattern "^[0-9A-Z][0-9A-Z]{3}$"
            if (!inputValue.match("^[0-9A-Z][0-9A-Z]{3}$")) {
                return "i8n.jsfvalid.ac.illchar";
            }
            return null;
        },
        validateFootnote: function validateFootnote(footnote) {
            var inputValue = this.removeSpaceCharacters(footnote);

            //Validate the footnote length and the pattern
            if (inputValue.length !== 5 && inputValue.length !== 8) {
                return "i8n.jsfvalid.footnote.illchar";
            }
            if (inputValue.length === 5 && (!inputValue.substr(0, 2).match("^[0-9A-Z]{2}$") || !inputValue.substr(2, 4).match("^[0-9]{3}$"))) {
                return "i8n.jsfvalid.footnote.illchar";
            }
            if (inputValue.length === 8 && (!inputValue.substr(0, 3).match("^[0-9A-Z]{3}$") || !inputValue.substr(3, 7).match("^[0-9]{5}$"))) {
                return "i8n.jsfvalid.footnote.illchar";
            }
            return null;
        },
        validateCertificate: function validateCertificate(certificate) {
            var inputValue = this.removeSpaceCharacters(certificate);

            //Validate the certificate matches the pattern "^[0-9A-Z][0-9A-Z]{3}$"
            if (!inputValue.match("^[0-9A-Z][0-9A-Z]{3}$")) {
                return "i8n.jsfvalid.c.illchar";
            }
            return null;
        },
        validatePreferenceCodeMappingVersion: function validatePreferenceCodeMappingVersion(tradeDirection, preferenceCodeMappingVersion) {
            var errorCode = null;
            if (tradeDirection === 'I') {
                preferenceCodeMappingVersion = this.removeSpaceCharacters(preferenceCodeMappingVersion);
                if (preferenceCodeMappingVersion.length === 0) {
                    errorCode = "i8n.error.preferenceCodeMappingVersion.required";
                } else if (!preferenceCodeMappingVersion.match("^[1-2 ]*$")) {
                    errorCode = "i8n.error.preferenceCodeMappingVersion.invalid";
                }
            }

            return errorCode;
        },
        loadImage: function loadImage(url, width, height, callBack, base64) {

            // this function is used to render base64 image that is used by pdf export
            // it uses canvas to render image then convert to base 64.
            // it needs image's url, original width and height of it
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            var context = canvas.getContext('2d');

            // load image from data url
            var imageObj = new Image();
            imageObj.onload = function () {
                context.fillStyle = 'white';
                context.fillRect(0, 0, width, height);
                context.drawImage(this, 0, 0, width, height);

                if (base64) {
                    var options = { logo: canvas.toDataURL('image/jpeg') };
                    callBack(options);
                } else {

                    var metaData = { logo: atob(canvas.toDataURL('image/jpeg').slice('data:image/jpeg;base64,'.length)) };
                    callBack(metaData);
                }
            };

            imageObj.src = url;
        },
        htmlTableToPdf: function htmlTableToPdf(doc, table, options) {

            // width of header table.
            var widths = [];

            // content of pdf.
            var body = [];

            // Table styles
            var tableHeaderBackgroundColor = '#19bd9c';
            var tableHeaderTextColor = '#ffffff';
            var tableTextColor = '#000000';

            // define width of headers according to html.
            // * means it would adjust it automatically
            for (var i = 0; i < table.rows[0].cells.length; i++) {
                var cell = table.rows[0].cells[i];
                widths.push('*');
            }

            // parse html table to extract content.
            // content is two dimension array
            // body[y] represents for rows, body[y][x] represents for cells
            for (var y = 0; y < table.rows.length; y++) {
                body[y] = [];
                for (var x = 0; x < table.rows[y].cells.length; x++) {

                    // extract cell content, remove all html tag and special characters. Only keep text content
                    var html = table.rows[y].cells[x].innerHTML;
                    var text = html.replace(/<(?:.|\n)*?>/gm, '');
                    text = this.decodeHTMLEntities(text);
                    text = text.replace(/(\r\n|\n|\r)/gm, "");
                    text = text.replace(/<br\s*[\/]?>/gi, "\r\n");
                    text = text.replace(/<(?:.|\n)*?>/gm, '');

                    // alignment of text inside the cells. This is defined in html 
                    var alignment = 'center';
                    if (table.rows[y].cells[x].className.indexOf('text-right') != -1) {

                        alignment = 'right';
                    } else if (table.rows[y].cells[x].className.indexOf('text-left') != -1) {

                        alignment = 'left';
                    }

                    // Only set bold text to the label column of description table, do not fill background color
                    var isRowHeader = table.rows[y].cells[x].className.indexOf('row-header') != -1;
                    var isTableHeader = table.rows[y].cells[x].nodeName.toLowerCase() === 'th' && !isRowHeader;

                    // parse colspan, rowspan property
                    var colspan = table.rows[y].cells[x].getAttribute('data-colspan');
                    var rowspan = table.rows[y].cells[x].getAttribute('data-rowspan');
                    var width = table.rows[y].cells[x].getAttribute('data-width');

                    if (width) widths[x] = width;

                    if (!colspan) colspan = 1;

                    if (!rowspan) rowspan = 1;

                    // Image cell. Using base64 image to replace html img tag
                    if (html.indexOf('img/') != -1) {

                        var imgData = 'flag';
                        var wi = 12;
                        var hi = 8;
                        var margin = 2;
                        if (html.indexOf('notchecked.png') != -1) {

                            imgData = 'unchecked';
                            wi = 11;
                            hi = 11;
                            margin = 0;
                        } else if (html.indexOf('checked.png') != -1) {

                            imgData = 'checked';
                            wi = 11;
                            hi = 11;
                            margin = 0;
                        } else if (html.indexOf('EU.png') != -1) {

                            imgData = 'eu';
                        } else if (html.indexOf('unreleased.gif') != -1) {

                            imgData = 'unreleased';
                            margin = 0;
                        }

                        body[y].push({
                            image: imgData,
                            alignment: alignment,
                            margin: [0, margin, 0, 0],
                            width: wi,
                            height: hi
                        });
                    }
                    // text cell
                    else {
                            body[y].push({
                                text: text,
                                alignment: alignment,
                                fontSize: isTableHeader ? 9 : 8.5,
                                rowSpan: rowspan * 1,
                                colSpan: colspan * 1,
                                bold: isTableHeader || isRowHeader,
                                fillColor: isTableHeader ? tableHeaderBackgroundColor : null,
                                color: isTableHeader ? tableHeaderTextColor : tableTextColor
                            });
                        }
                }
            }

            // Default table headerRows value = 1, which will be repeated on each pages.
            var headerRows = 1;
            if (options.headerRows || options.headerRows === 0) {
                headerRows = options.headerRows;
            }
            doc.push({
                table: {
                    headerRows: headerRows,
                    dontBreakRows: false,
                    widths: widths,
                    body: body
                },
                layout: table.className.indexOf('no-border') != -1 ? 'noBorders' : {
                    hLineWidth: function hLineWidth(i, node) {
                        return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
                    },
                    vLineWidth: function vLineWidth(i, node) {
                        return i === 0 || i === node.table.widths.length ? 0.5 : 0.5;
                    }
                }
            });
        },
        decodeHTMLEntities: function decodeHTMLEntities(text) {

            var entities = [['apos', '\''], ['amp', '&'], ['lt', '<'], ['gt', '>'], ['nbsp', ' '], ['deg', '°']];

            for (var i = 0, max = entities.length; i < max; ++i) {
                text = text.replace(new RegExp('&' + entities[i][0] + ';', 'g'), entities[i][1]);
            }

            return text;
        },
        printPlainDocument: function printPlainDocument(options, mode) {
            var deferred = $q.defer();
            var pdfMake = void 0;
            __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 842)).then(function (module) {
                pdfMake = module;
                __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 843)).then(function (pdfFonts) {
                    pdfMake.vfs = pdfFonts.pdfMake.vfs;
                    // this function is used to export pdf using pdfmaker
                    // it has two modes, landscape and portrait
                    if (mode == 'l') {

                        mode = 'landscape';

                        // align title to center in landscape mode
                        options.size = {
                            title: { x: 390 - options.title.length },
                            headerWidth: ['20%', '56%', '10%', '10%']
                        };
                    } else {

                        mode = 'portrait';

                        // align title to center in portrait mode
                        options.size = {
                            title: { x: 270 - options.title.length },
                            headerWidth: ['20%', '45%', '15%', '20%']
                        };
                    }

                    // Print out valid on and created date at the top right of the report
                    var dateText = "";
                    var dateData = "";
                    if (options.validDate) {

                        dateText += $filter('translate')('i8n.common.report.validOn') + ":";
                        dateData += options.validDate;
                    }

                    dateText += "\n" + $filter('translate')('i8n.common.report.reportedAt') + ":";
                    dateData += "\n" + $filter('date')(new Date(), CONSTANTS.dateTimeFormat);

                    // prepare the document structure that has header, body and footer
                    var doc = {
                        header: function header(currentPage, pageCount) {

                            var logoMargin = currentPage > 1 ? 30 : 30;
                            var titleMargin = mode === 'portrait' && options.title.length > 30 ? 15 : 30;
                            return {
                                margin: 10,
                                columns: [{
                                    table: {
                                        widths: options.size.headerWidth,
                                        body: [[{
                                            image: 'logo',
                                            width: CONSTANTS.pdfExport.logoWidth,
                                            height: CONSTANTS.pdfExport.logoHeight,
                                            margin: [logoMargin, 20]
                                        }, {
                                            text: options.title,
                                            fontSize: 15,
                                            bold: true,
                                            alignment: "center",
                                            margin: [0, titleMargin, 0, 0]
                                        }, {
                                            text: dateText,
                                            alignment: "left",
                                            fontSize: 9,
                                            bold: true,
                                            margin: [-5, 30]
                                        }, {
                                            text: dateData,
                                            alignment: "left",
                                            fontSize: 9,
                                            bold: true,
                                            margin: [0, 30]
                                        }]]
                                    },
                                    layout: 'noBorders'
                                }]
                            };
                        },
                        pageSize: 'A4',
                        pageMargins: [40, 40 + CONSTANTS.pdfExport.logoHeight, 40, 60],
                        content: options.contents,
                        pageOrientation: mode,
                        styles: {
                            defaultStyle: { font: CONSTANTS.printableFont }
                        },
                        footer: function footer(currentPage, pageCount) {
                            return { text: currentPage.toString(), alignment: 'center', margin: [0, 10, 0, 0] };
                        },
                        images: {
                            logo: options.logo,
                            flag: options.flag,
                            eu: options.eu,
                            checked: options.checked,
                            unchecked: options.unchecked,
                            unreleased: options.unreleased,
                            dutyCal: options.dutyCal
                        }
                    };

                    // download pdf, in safari it will open pdf in current window
                    pdfMake.createPdf(doc).download(options.title + '.pdf');
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            }, function () {
                deferred.reject();
            });
            return deferred.promise;
        },
        printExcel: function printExcel(tableId, fileName, ws, processCell) {
            var _this = this;

            var deferred = $q.defer();
            var XLSX = void 0;
            var saveAs = void 0;
            __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 844)).then(function (module) {
                XLSX = module;
                __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 841)).then(function (fileSaver) {
                    saveAs = fileSaver.saveAs;

                    // this function is used to convert html table to json excel format
                    var generateArray = function generateArray(table) {

                        var out = [];
                        var rows = table.querySelectorAll('tr');
                        var ranges = [];
                        for (var R = 0; R < rows.length; ++R) {
                            var outRow = [];
                            var row = rows[R];
                            var columns = row.querySelectorAll('td');
                            for (var C = 0; C < columns.length; ++C) {
                                var cell = columns[C];
                                var colspan = cell.getAttribute('colspan');
                                var rowspan = cell.getAttribute('rowspan');

                                var cellValue = _this.decodeHTMLEntities(cell.innerText).replace(/<br\s*[\/]?>/gi, "\r\n").replace(/<(?:.|\n)*?>/gm, '');

                                //Skip ranges
                                for (var xz = 0; xz < ranges.length; xz++) {
                                    var range = ranges[xz];
                                    if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                                        for (var i = 0; i <= range.e.c - range.s.c; ++i) {
                                            outRow.push(null);
                                        }
                                    }
                                }

                                //Handle Row Span
                                if (rowspan || colspan) {
                                    rowspan = rowspan || 1;
                                    colspan = colspan || 1;
                                    ranges.push({ s: { r: R, c: outRow.length }, e: { r: R + rowspan - 1, c: outRow.length + colspan - 1 } });
                                }

                                //Handle Value
                                outRow.push(cellValue !== "" ? cellValue : null);

                                //Handle Colspan
                                if (colspan) for (var k = 0; k < colspan - 1; ++k) {
                                    outRow.push(null);
                                }
                            }
                            out.push(outRow);
                        }
                        return [out, ranges];
                    };

                    // this function is used to format cells base on data (string text, aligment) in the json structure
                    var sheet_from_array_of_arrays = function sheet_from_array_of_arrays(data, opts) {

                        var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
                        for (var R = 0; R != data.length; ++R) {
                            for (var C = 0; C != data[R].length; ++C) {
                                if (range.s.r > R) range.s.r = R;
                                if (range.s.c > C) range.s.c = C;
                                if (range.e.r < R) range.e.r = R;
                                if (range.e.c < C) range.e.c = C;
                                var cell = { v: data[R][C] };
                                if (cell.v === null) continue;
                                var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

                                cell.t = 's';

                                // first 3 columns are bold
                                if (processCell) {

                                    processCell(cell, R, C);
                                } else {

                                    if (R === 0 && C === 0) {
                                        cell.s = {
                                            font: {
                                                name: CONSTANTS.printableFont,
                                                bold: true,
                                                sz: 12
                                            },
                                            alignment: {
                                                horizontal: "center"
                                            }
                                        };
                                    } else if (R === 0 && C > 0) {
                                        cell.s = {
                                            font: {
                                                name: CONSTANTS.printableFont,
                                                bold: true
                                            },
                                            alignment: {
                                                horizontal: "right"
                                            }
                                        };
                                    } else if (R === 2) {
                                        cell.s = {
                                            font: {
                                                name: CONSTANTS.printableFont,
                                                bold: true,
                                                sz: 11
                                            },
                                            alignment: {
                                                horizontal: "center"
                                            },
                                            border: {
                                                top: { style: "thin", color: { rgb: "000000" } }
                                            }
                                        };
                                    } else if (R > 2) {
                                        cell.s = {
                                            font: {
                                                name: CONSTANTS.printableFont,
                                                sz: 10
                                            },
                                            alignment: {
                                                wrapText: 1,
                                                horizontal: "center"
                                            }
                                        };

                                        if (C === 2) cell.s.alignment = { horizontal: "left" };else if (C >= 4) cell.s.alignment = { horizontal: "right" };
                                    }
                                }

                                ws[cell_ref] = cell;
                            }
                        }
                        if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
                        return ws;
                    };

                    // excel constructor
                    var Workbook = function Workbook() {
                        if (!(this instanceof Workbook)) return new Workbook();
                        this.SheetNames = [];
                        this.Sheets = {};
                    };

                    // convert array to byte stream
                    var s2ab = function s2ab(s) {
                        var buf = new ArrayBuffer(s.length);
                        var view = new Uint8Array(buf);
                        for (var i = 0; i != s.length; ++i) {
                            view[i] = s.charCodeAt(i) & 0xFF;
                        }return buf;
                    };

                    // format date
                    var datenum = function datenum(v, date1904) {
                        if (date1904) v += 1462;
                        var epoch = Date.parse(v);
                        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                    };

                    // get table html from id
                    var theTable = document.getElementById(tableId);
                    var oo = generateArray(theTable);
                    var ranges = oo[1];

                    /* original data */
                    var data = oo[0];
                    var ws_name = "SheetJS";

                    var wb = new Workbook(),
                        ws1 = sheet_from_array_of_arrays(data);

                    /* add ranges to worksheet */
                    ws1['!merges'] = ranges;

                    /* add worksheet to workbook */
                    wb.SheetNames.push(ws_name);
                    wb.Sheets[ws_name] = ws1;

                    fileName = fileName + ".xlsx";

                    // callback for safai because it does not support download attribute
                    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    if (isSafari) {

                        var base64Str = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'base64' });
                        var form = document.createElement('form');
                        form.action = 'output.xlsx';
                        form.method = 'POST';
                        form.style.display = 'none';

                        // name hidden
                        var input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = 'name';
                        input.value = fileName;
                        form.appendChild(input);

                        // file hidden
                        input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = 'file';
                        input.value = base64Str;
                        form.appendChild(input);

                        var submit = document.createElement('input');
                        submit.type = 'submit';
                        submit.id = 'submitFile';
                        form.appendChild(submit);

                        document.body.appendChild(form);
                        document.forms[document.forms.length - 1].submit();
                        document.body.removeChild(form);
                    } else {

                        var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
                        saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName);
                    }
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        },
        compareDatesWithoutTime: function compareDatesWithoutTime(date1, date2) {
            var result = 0;
            if (!date1 && date2) {
                result = 1;
            } else if (date1 && !date2) {
                result = -1;
            } else if (date1 && date2) {
                var moment1 = moment(date1);
                var moment2 = moment(date2);
                if (moment1.isAfter(moment2, 'day')) {
                    result = 1;
                } else if (moment1.isSame(moment2, 'day')) {
                    result = 0;
                } else {
                    result = -1;
                }
            }

            return result;
        },
        validateSimulationDate: function validateSimulationDate(simulationDate) {
            var pastDateMoment = moment(CONSTANTS.pastDate, CONSTANTS.dateFormat.toUpperCase(), true);
            if (simulationDate && this.compareDatesWithoutTime(simulationDate, pastDateMoment.toDate()) <= 0) {
                return "sd.toolow_detail";
            }
            return null;
        },
        validateSimulationDateAfterOrBefore: function validateSimulationDateAfterOrBefore(simulationDate) {
            if (CONSTANTS.dateRestrictionEnabled) {
                var futureDateMoment = moment(new Date(), CONSTANTS.dateFormat.toUpperCase(), true);
                var pastDateMoment = moment(CONSTANTS.pastDate, CONSTANTS.dateFormat.toUpperCase(), true);
                if (simulationDate && this.compareDatesWithoutTime(simulationDate, futureDateMoment.toDate()) > 0) {
                    return "i8n.common.futureDate";
                } else if (simulationDate && this.compareDatesWithoutTime(simulationDate, pastDateMoment.toDate()) < 0) {
                    return "i8n.common.pastDate";
                }
            }
            return null;
        },
        getLanguageCode: function getLanguageCode(locale) {
            if (locale) {
                return locale.substring(0, 2);
            }
            return locale;
        },
        getLogoImagePath: function getLogoImagePath(useLogoConfigFile) {
            if (useLogoConfigFile && CONSTANTS.logoFileName) {
                return 'img/' + CONSTANTS.logoFileName;
            }
            var result = 'img/logo_';
            var locale = $translate.use();
            if (locale.length === 2) {
                result = result + locale + ".png";
            } else {
                result = result + locale.substring(3).toLowerCase() + ".png";
            }
            return result;
        },
        setDynamicLocale: function setDynamicLocale(tmhDynamicLocale) {
            // Change locale dynamically to load uib (Calendar popup) translation
            var langKey = $translate.use();
            if (langKey === undefined || langKey === null || langKey === '') {
                langKey = CONSTANTS.availableLanguages[0];
            }

            if (langKey.indexOf("_") >= 0) {
                // When langKey is "el_CY" or "el_GR", it needs be converted to "el-cy", "el-gr" to match the suffix of angular-locale files.
                var langKeyArray = langKey.split("_");
                tmhDynamicLocale.set(langKeyArray[0].toLowerCase() + "-" + langKeyArray[1].toLowerCase());
            } else {
                tmhDynamicLocale.set(langKey.toLowerCase());
            }
        },
        translateCalendarButtons: function translateCalendarButtons() {
            // Translation for Calendar popup's buttons and Pagination's buttons
            $translate(['i8n.common.button.current', 'i8n.common.button.clear', 'i8n.common.button.Close']).then(function (translations) {
                uibDatepickerPopupConfig.currentText = translations['i8n.common.button.current'];
                uibDatepickerPopupConfig.clearText = translations['i8n.common.button.clear'];
                uibDatepickerPopupConfig.closeText = translations['i8n.common.button.Close'];
            });
        },
        parseInputDate: function parseInputDate(dateString) {
            dateString = this.removeSpaceCharacters(dateString);
            if (dateString === "") {
                return null;
            }

            // Parse date parameter when user enters direct url, and bookmark support.
            var dateMoment = new moment(dateString, CONSTANTS.bookmarkDateFormat.toUpperCase(), true);
            if (dateMoment.isValid()) {
                return dateMoment.toDate();
            }

            // Parse date parameter when user opens a screen from lookup action or search result.
            // In this case, rest api date format "yyyy-MM-dd" is used.
            var inputDate = Date.parse(dateString);
            if (!isNaN(inputDate)) {
                return inputDate;
            }

            return null;
        },
        formatDate: function formatDate(dateObj, dateString) {
            // Datepicker allows any input date formats returned by method #getAltInputDateFormats
            // Method #formatDate reformats any input date to be displayed as CONSTANTS.dateFormat
            if (dateObj === null || dateObj === undefined) {
                return dateObj;
            }

            // If dateObj is a valid Date, format dateObj to be displayed as CONSTANTS.dateFormat
            if (dateObj instanceof Date && !isNaN(dateObj)) {
                var dateMoment = new moment(dateObj, CONSTANTS.dateFormat.toUpperCase(), true);

                // If user only inputs day and month dd/MM, the year of last valid dateObj will be used.
                // If the last dateObj is null or undefined, year 1900 will be used.
                // So we replace the year in both cases by the current year.
                if (dateString && dateString.length <= 5 || dateMoment.year() === 1900) {
                    dateMoment.year(moment().year());
                }
                return dateMoment.toDate();
            }

            return dateObj;
        },
        getAltInputDateFormats: function getAltInputDateFormats() {
            // Return alternative date formats, which support leading zeros of day and month,
            // all separators of '.', '/', '-',
            // and all customers:
            // Cyprus,Greece,Luxembourg: dd/MM/yyyy
            // Denmark:     ddMMyyyy
            // Estonia:     dd.MM.yyyy
            // Netherlands: d-M-yyyy
            // Sweden:      yyyy-MM-dd
            // Others:      ddMM, dd/MM, dd.MM, dd-MM
            //              yyyy/MM/dd, yyyy.MM.dd
            // If user does not input any of alternative date formats, the date value is undefined
            // If user inputs empty date, the date value is null
            return ["ddMMyyyy", "d!/M!/yyyy", "d!.M!.yyyy", "d!-M!-yyyy", "yyyy-M!-d!", "ddMM", "d!/M!", "d!.M!", "d!-M!", "yyyy/M!/d!", "yyyy.M!.d!"];
        },
        getValidSelectedItem: function getValidSelectedItem(items, value, defaultValue) {
            // If the input value does not exist in items, the default value will be returned.
            if (value) {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].id && value === items[i].id || items[i].type && value === items[i].type) {
                        return value;
                    }
                }
            }

            return defaultValue;
        },
        getDistinctCodeList: function getDistinctCodeList(codes, code) {
            // Get a distinct list of the given codes
            code = this.removeSpaceCharacters(code);
            return code ? array.union([code], codes) : array.union(codes);
        },
        getDistinctCodesString: function getDistinctCodesString(codes, code) {
            // Build a distinct codes string of the given codes separated by ','
            var distinctCodes = this.getDistinctCodeList(codes, code);
            return distinctCodes.join(',');
        },
        setCookie: function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            var expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        },
        getCookie: function getCookie(name) {
            var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? v[2] : null;
        }
    };
    return helper;
}]); /**
     * Created by MinhQuan on 3/14/2016.
     */

//Angular ui boostrap

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.footnote', ['ngResource', 'common.config']).factory('QueryFootnote', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/foot/footnotes/:typeAndId', {}, {
        find: {
            method: 'GET',
            isArray: false
        },
        queryFootnotes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/foot/footnotes'
        },
        queryFootnoteTypes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/foot/footnoteTypes'
        }
    });
}]).service('FootnotePopupModel', ["$q", "QueryFootnote", "CommonHelper", function ($q, QueryFootnote, CommonHelper) {
    var model = this;
    model.findFootnote = function (footnoteId, simulationDate) {
        var deferred = $q.defer();
        QueryFootnote.find({ typeAndId: footnoteId, simulationdate: CommonHelper.getRestDateString(simulationDate) }, function (footnote) {
            deferred.resolve(footnote);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]).service('FootnoteLookupModel', ["$q", "$translate", "QueryFootnote", "CommonHelper", "CONSTANTS", function ($q, $translate, QueryFootnote, CommonHelper, CONSTANTS) {
    var model = this,
        searchCriteria = {},
        searchResult = null;
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.getSearchResult = function () {
        return searchResult;
    };
    model.resetSearchResult = function () {
        searchResult = null;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
    };
    // Initialize search criteria when opening use case from menu.
    model.resetSearchCriteria();

    model.searchFootnotes = function (page) {
        var deferred = $q.defer();
        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            footnoteType: searchCriteria.footnoteType,
            footnoteId: searchCriteria.footnoteId,
            offset: CommonHelper.getOffset(page),
            count: CONSTANTS.rowsPerPage,
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol,
            language: CommonHelper.getLanguageCode($translate.use())
        };
        var result = QueryFootnote.queryFootnotes(options, function () {
            searchResult = {};
            searchResult.totalItems = result.count;
            searchResult.footnotes = result.items;
            searchResult.currentPage = page;
            deferred.resolve(searchResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]).service('FootnoteTypeModel', ["$q", "QueryFootnote", function ($q, QueryFootnote) {
    var model = this;
    model.queryFootnoteTypes = function () {
        var deferred = $q.defer();
        QueryFootnote.queryFootnoteTypes(function (footnoteTypes) {
            deferred.resolve(footnoteTypes);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.model.geoarea', ['ngResource', 'common.helper']).factory('GeophicalArea', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/gear/groups/:id/memberships', {}, {
        queryMembership: {
            method: 'GET',
            isArray: false
        },
        find: {
            method: 'GET',
            isArray: false,
            url: '/arctictariff-public-web/service/api/geoArea/:id'
        },
        getCountriesOfOrigin: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/gear/countriesAndRegions/'
        },
        getCountriesRegionsAndGroups: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/gear/countriesRegionsAndGroups/'
        }

    });
}]).service('GeographicalAreaModel', ["GeophicalArea", "$q", "CommonHelper", function (GeophicalArea, $q, CommonHelper) {
    var model = this;
    model.queryMembershipByGroupId = function (origin, simulationDate) {
        var deferred = $q.defer();
        GeophicalArea.queryMembership({ id: origin, simulationdate: CommonHelper.getRestDateString(simulationDate) }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.findGeographicalArea = function (id, simulationDate) {
        var deferred = $q.defer();
        GeophicalArea.find({ id: id, simulationDate: simulationDate }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getCountriesOfOrigin = function (simulationDate) {
        var deferred = $q.defer();
        GeophicalArea.getCountriesOfOrigin({ simulationdate: CommonHelper.getRestDateString(simulationDate) }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getCountriesRegionsAndGroups = function (simulationDate) {
        var deferred = $q.defer();
        GeophicalArea.getCountriesRegionsAndGroups({ simulationdate: CommonHelper.getRestDateString(simulationDate) }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.model.language', ['ngResource', 'common.config']).factory('Language', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/lang/languages', {}, {
        getPreferredUILanguages: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('LanguageModel', ["Language", "$q", function (Language, $q) {
    var model = this;
    model.getPreferredUILanguages = function () {
        var deferred = $q.defer();
        Language.getPreferredUILanguages({}, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.model.measuretype', ['ngResource', 'common.helper']).factory('MeasureType', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/meae/measureTypes', {}, {
        queryMeasureTypes: {
            method: 'GET',
            isArray: false
        },
        queryMeasureTypesSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/ref/meae/measureTypes'
        }

    });
}]).service('MeasureTypeModel', ["MeasureType", "$q", "CommonHelper", "AuthorizeModel", function (MeasureType, $q, CommonHelper, AuthorizeModel) {
    var model = this;

    model.getMeasureTypes = function (tradeDirection, startDate, endDate) {
        var deferred = $q.defer();
        if (AuthorizeModel.loggedIn) {
            MeasureType.queryMeasureTypesSecure({
                startDate: CommonHelper.getRestDateString(startDate),
                endDate: CommonHelper.getRestDateString(endDate),
                tradeDirection: tradeDirection === 'I' || tradeDirection === 'E' ? tradeDirection : null,
                filterHiddenMeasureTypes: false
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                // Use unauthenticated query
                MeasureType.queryMeasureTypes({
                    startDate: CommonHelper.getRestDateString(startDate),
                    endDate: CommonHelper.getRestDateString(endDate),
                    tradeDirection: tradeDirection === 'I' || tradeDirection === 'E' ? tradeDirection : null
                }, function (result) {
                    deferred.resolve(result);
                }, function (error) {
                    deferred.reject(error);
                });
            });
        } else {
            MeasureType.queryMeasureTypes({
                startDate: CommonHelper.getRestDateString(startDate),
                endDate: CommonHelper.getRestDateString(endDate),
                tradeDirection: tradeDirection === 'I' || tradeDirection === 'E' ? tradeDirection : null
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
        }

        return deferred.promise;
    };
}]);

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.menu', ['ngResource', 'common.config']).service('MenuModel', function () {

	var observerCallbacks = [];
	var printable = false;
	var exportable = false;
	var helpIndex = '';

	var helpMaps = {
		"taric.nomenclature.sbn": 1,
		"taric.nomenclature.sbt": 2,
		"taric.adco.view": 2,
		"taric.nomenclature.ct": 3,
		"taric.measure.ccrm": 4,
		"taric.measure.mcc": 5,
		"taric.duty.calculate": 6,
		"taric.duty.exchangerates": 7,
		"taric.duty.meursing": 8,
		"taric.quota.search": 9,
		"taric.quota.view": 9,
		"taric.report.pt": 10,
		"taric.moreinfo.links": 11,
		"taric.moreinfo.codelists.search": 65,
		"taric.moreinfo.codelists.view": 65,
		"taric.report.relief.search": 44,
		"taric.report.relief.view": 44,
		"taric.report.mlr": 66,
		"taric.report.measure": 67,
		"taric.report.measureAmendments": 68
	};

	var printableStates = ['taric.quota.search', 'taric.quota.view', 'taric.nomenclature.ct', 'taric.measure.ccrm', 'taric.measure.mcc', 'taric.duty.exchangerates', 'taric.duty.meursing', 'taric.report.pt', 'taric.moreinfo.links', 'taric.moreinfo.codelists', 'taric.nomenclature.sbt', 'taric.moreinfo.codelists.search', 'taric.moreinfo.codelists.view', 'taric.report.relief.search', 'taric.report.relief.view', 'taric.report.mlr', 'taric.report.measure', 'taric.report.measureAmendments'];

	var exportableStates = ['taric.duty.exchangerates', 'taric.moreinfo.codelists.search', 'taric.moreinfo.codelists.view', 'taric.report.measure', 'taric.report.measureAmendments', 'taric.nomenclature.ct', 'taric.report.mlr'];

	var enablePrintable = function enablePrintable() {
		printable = true;
	};

	var disablePrintable = function disablePrintable() {
		printable = false;
	};

	var enableExportable = function enableExportable() {
		exportable = true;
	};

	var disableExportable = function disableExportable() {
		exportable = false;
	};

	var setHelpIndex = function setHelpIndex(index) {

		if (printableStates.indexOf(index) > -1) {

			enablePrintable();
		} else {

			disablePrintable();
		}

		if (exportableStates.indexOf(index) > -1) {

			enableExportable();
		} else {

			disableExportable();
		}

		helpIndex = helpMaps[index];
	};

	var registerObserverCallback = function registerObserverCallback(callback) {
		observerCallbacks.push(callback);
	};

	var notifyObservers = function notifyObservers() {

		angular.forEach(observerCallbacks, function (callback) {
			callback();
		});
	};

	var data = function data() {
		return {
			printable: printable,
			exportable: exportable,
			helpIndex: helpIndex
		};
	};

	return {
		enablePrintable: enablePrintable,
		disablePrintable: disablePrintable,
		enableExportable: enableExportable,
		disableExportable: disableExportable,
		setHelpIndex: setHelpIndex,
		registerObserverCallback: registerObserverCallback,
		notifyObservers: notifyObservers,
		data: data
	};
});

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Model for getting monetary unit data
 */
angular.module('taric.model.monetaryunits', ['ngResource', 'common.config']).factory('MonetaryUnits', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/moun/monetaryUnits', {}, {
        queryMonetaryUnits: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('MonetaryUnitsModel', ["$q", "MonetaryUnits", "CommonHelper", function ($q, MonetaryUnits, CommonHelper) {
    var model = this;

    model.customsValueMonetaryUnits = function (simulationDate) {
        var deferred = $q.defer();
        MonetaryUnits.queryMonetaryUnits({
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            type: "C"
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    model.dutyMonetaryUnits = function (simulationDate) {
        var deferred = $q.defer();
        MonetaryUnits.queryMonetaryUnits({
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            type: "D"
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 2/15/2017.
 */

angular.module('common.template.about.popup', ['common.helper', 'pascalprecht.translate', 'taric.model.about']).controller('AboutPopupController', ["CONSTANTS", "$uibModalInstance", "AboutModel", function (CONSTANTS, $uibModalInstance, AboutModel) {
    var aboutPopupCtrl = this;
    aboutPopupCtrl.init = function () {
        AboutModel.getMetadata().then(function (result) {
            aboutPopupCtrl.version = result.version;
        }, function (error) {
            //Do nothing if we can not load the version
        });
    };
    aboutPopupCtrl.close = function () {
        $uibModalInstance.dismiss('Close');
    };
}]);

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/**
 * Created by MinhQuan on 12/22/2015.
 */

angular.module('common.template.additional-code.popup', ['common.filter.description', 'taric.model.additional-code']).controller('AdditionalCodePopupController', ["CONSTANTS", "$uibModalInstance", "$uibModal", "additionalCode", "simulationDate", function (CONSTANTS, $uibModalInstance, $uibModal, additionalCode, simulationDate) {
    var additionalCodePopupCtrl = this;
    additionalCodePopupCtrl.additionalCode = additionalCode;
    additionalCodePopupCtrl.simulationDate = simulationDate;
    additionalCodePopupCtrl.dateFormat = CONSTANTS.dateFormat;
    additionalCodePopupCtrl.close = function () {
        $uibModalInstance.dismiss('Close');
    };

    additionalCodePopupCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, additionalCodePopupCtrl.simulationDate);
                }]
            }
        });
    };
}]);

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.template.additional-codes.popup', ['common.filter.description']).controller('AdditionalCodesPopupController', ["CONSTANTS", "$uibModalInstance", "$uibModal", "simulationDate", "additionalCodes", "commodityCode", function (CONSTANTS, $uibModalInstance, $uibModal, simulationDate, additionalCodes, commodityCode) {
    var adcosPopupCtrl = this;
    adcosPopupCtrl.additionalCodes = additionalCodes;
    adcosPopupCtrl.simulationDate = simulationDate;
    adcosPopupCtrl.commodityCode = commodityCode;
    adcosPopupCtrl.dateFormat = CONSTANTS.dateFormat;
    adcosPopupCtrl.close = function () {
        $uibModalInstance.dismiss('Close');
    };

    adcosPopupCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, adcosPopupCtrl.simulationDate);
                }]
            }
        });
    };
}]);

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.template.condition.popup', ['pascalprecht.translate', 'common.filter.description', 'common.config', 'taric.model.measure']).controller('ConditionPopupController', ["CONSTANTS", "$uibModalInstance", "measureConditionHeadResult", "$translate", "MeasureForNomenclatureSearchModel", "$filter", function (CONSTANTS, $uibModalInstance, measureConditionHeadResult, $translate, MeasureForNomenclatureSearchModel, $filter) {
    var conditionPopupCtrl = this;
    conditionPopupCtrl.dateFormat = CONSTANTS.dateFormat;
    conditionPopupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
    conditionPopupCtrl.currentPage = 1;
    conditionPopupCtrl.numberOfConditionRows = measureConditionHeadResult.count;
    conditionPopupCtrl.createMeasureConditionRow = function (measureConditionHead) {
        var conditionRow = {};
        conditionRow.type = measureConditionHead.type;
        conditionRow.additionalCode = measureConditionHead.additionalCode;
        conditionRow.startDate = measureConditionHead.startDate;
        conditionRow.endDate = measureConditionHead.endDate;
        conditionRow.conditionDocuments = measureConditionHead.conditionDocuments;
        conditionRow.quotaOrderNumber = measureConditionHead.quotaOrderNumber;
        conditionRow.geographicalAreaId = measureConditionHead.geographicalAreaId;

        // Document conditions
        conditionRow.documentConditions = [];

        // Component conditions
        conditionRow.componentConditions = [];

        // Price conditions
        conditionRow.priceConditions = [];

        // Credibility conditions
        conditionRow.credibilityConditions = [];

        // Quantity conditions
        conditionRow.quantityConditions = [];

        var documentIdx = 0;
        var priceIdx = 0;
        var componentIdx = 0;
        var credibilityIdx = 0;
        var quantityIdx = 0;

        for (var i = 0; i < measureConditionHead.conditionDocuments.length; i++) {
            switch (measureConditionHead.conditionDocuments[i].code) {
                case "0":
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                case "00":
                case "01":
                case "02":
                case "03":
                case "04":
                case "05":
                case "06":
                case "07":
                case "08":
                case "09":
                case "A":
                case "B":
                case "C":
                case "H":
                case "K":
                case "Q":
                case "W":
                case "Y":
                case "YA":
                case "YB":
                case "YC":
                case "YD":
                case "YE":
                case "YF":
                case "YG":
                case "YH":
                case "Z":
                case "P":
                    var idx = 0;
                    var componentsExist = false;
                    for (idx = 0; idx < measureConditionHead.conditionDocuments[i].documents.length; idx++) {
                        if ($filter('description')(measureConditionHead.conditionDocuments[i].documents[idx].dutyExpressionDescriptions)) {
                            componentsExist = true;
                            break;
                        }
                    }
                    if (componentsExist) {
                        conditionRow.componentConditions[componentIdx] = measureConditionHead.conditionDocuments[i];
                        componentIdx++;
                    } else {
                        conditionRow.documentConditions[documentIdx] = measureConditionHead.conditionDocuments[i];
                        documentIdx++;
                    }
                    break;

                case "F":
                case "G":
                case "L":
                case "M":
                case "N":
                case "V":
                    conditionRow.priceConditions[priceIdx] = measureConditionHead.conditionDocuments[i];
                    priceIdx++;
                    break;

                case "R":
                case "S":
                case "U":
                case "J":
                case "O":
                case "X":
                    conditionRow.credibilityConditions[credibilityIdx] = measureConditionHead.conditionDocuments[i];
                    credibilityIdx++;
                    break;

                case "E":
                case "I":
                    conditionRow.quantityConditions[quantityIdx] = measureConditionHead.conditionDocuments[i];
                    quantityIdx++;
                    break;

                default:
                    break;
            }
        }

        return conditionRow;
    };

    conditionPopupCtrl.loadData = function (items) {
        conditionPopupCtrl.rows = [];
        items.forEach(function (measureConditionHead) {
            conditionPopupCtrl.rows.push(conditionPopupCtrl.createMeasureConditionRow(measureConditionHead));
        });
    };

    conditionPopupCtrl.loadData(measureConditionHeadResult.items);

    //This method should be used only for the button 'VIEW CONDITIONS' in the use case Query measures for nomenclature
    conditionPopupCtrl.measureConditionPageChanged = function (page) {
        conditionPopupCtrl.loadingConditions = true;
        MeasureForNomenclatureSearchModel.queryMeasureConditionsForNomenclature(page).then(function (result) {
            conditionPopupCtrl.loadData(result.items);
            conditionPopupCtrl.loadingConditions = false;
        }, function (error) {
            conditionPopupCtrl.loadingConditions = false;
            conditionPopupCtrl.errorCode = error.data.code;
            conditionPopupCtrl.errorParams = error.data.params;
            conditionPopupCtrl.errorType = error.data.type;
        });
    };

    conditionPopupCtrl.close = function () {
        $uibModalInstance.dismiss('Close');
    };
}]);

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/**
 * Created by MinhQuan on 12/22/2015.
 */

angular.module('common.template.footnote.popup', ['common.filter.description', 'common.filter.specialCharacterToHtml']).controller('FootnotePopupController', ["$uibModalInstance", "footnote", "CONSTANTS", function ($uibModalInstance, footnote, CONSTANTS) {
    var footnotePopupCtrl = this;
    footnotePopupCtrl.dateFormat = CONSTANTS.dateFormat;
    footnotePopupCtrl.footnote = footnote;
    footnotePopupCtrl.close = function () {
        $uibModalInstance.dismiss('Close');
    };
}]);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('common.template.footnotes.popup', ['common.filter.description', 'common.filter.specialCharacterToHtml']).controller('FootnotesPopupController', ["$uibModalInstance", "measureFootnotes", "commodityCode", function ($uibModalInstance, measureFootnotes, commodityCode) {
    var footnotesPopupCtrl = this;
    footnotesPopupCtrl.measureFootnotes = measureFootnotes;
    footnotesPopupCtrl.commodityCode = commodityCode;

    footnotesPopupCtrl.close = function () {
        $uibModalInstance.dismiss('Close');
    };
}]);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.template.geoarea.popup', []).controller('GeographicalAreaPopupController', ["$uibModalInstance", "origin", "geoAreaMemberships", function ($uibModalInstance, origin, geoAreaMemberships) {
  var geoAreaPopupCtrl = this;
  geoAreaPopupCtrl.origin = origin;
  geoAreaPopupCtrl.geoAreaMemberships = geoAreaMemberships;
  geoAreaPopupCtrl.close = function () {
    $uibModalInstance.dismiss('Close');
  };
}]);

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 12/17/2015.
 */
angular.module('common.template.measure.popup', ['common.filter.description']).controller('MeasurePopupController', ["CONSTANTS", "$uibModalInstance", "measureExtendedInfo", function (CONSTANTS, $uibModalInstance, measureExtendedInfo) {
    var measurePopupCtrl = this;
    measurePopupCtrl.measureType = measureExtendedInfo.measureType;
    measurePopupCtrl.startDate = measureExtendedInfo.startDate;
    measurePopupCtrl.implicitEndDate = measureExtendedInfo.implicitEndDate;
    measurePopupCtrl.regulationRetros = measureExtendedInfo.regulationRetros;
    measurePopupCtrl.measureRetros = measureExtendedInfo.measureRetros;
    measurePopupCtrl.taxCodes = measureExtendedInfo.taxCodes;
    measurePopupCtrl.preferenceCodes = measureExtendedInfo.preferenceCodes;
    measurePopupCtrl.hasEndUseProcedureCode44 = measureExtendedInfo.hasEndUseProcedureCode44;
    measurePopupCtrl.preuccPreferenceCodes = measureExtendedInfo.preuccPreferenceCodes;
    measurePopupCtrl.dateFormat = CONSTANTS.dateFormat;
    measurePopupCtrl.close = function () {
        $uibModalInstance.dismiss('Close');
    };
}]);

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 10/6/2016.
 */
angular.module('arctic.tariff.home', ['common.helper', 'pascalprecht.translate']).controller('HomeController', ["$translate", "CONSTANTS", function ($translate, CONSTANTS) {
    var homeCtrl = this;
    homeCtrl.init = function () {
        homeCtrl.installationCountry = CONSTANTS.installationCountry;
        homeCtrl.branding = CONSTANTS.branding;
    };
}]);

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('taric.model.news', ['ngResource', 'common.helper']).factory('RssFeed', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/news/rssFeeds/', {}, {
        getRssFeeds: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('NewsModel', ["RssFeed", "$q", function (RssFeed, $q) {
    var model = this;
    model.getRssFeeds = function (category) {
        var deferred = $q.defer();
        var result = RssFeed.getRssFeeds({ category: category }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 1/3/2017.
 */

angular.module('arctic.tariff.news', ['common.helper', 'pascalprecht.translate', 'taric.model.news']).controller('NewsController', ["NewsModel", "CONSTANTS", "defaultRssFeeds", function (NewsModel, CONSTANTS, defaultRssFeeds) {
    var newsCtrl = this;
    newsCtrl.init = function () {
        newsCtrl.dateFormat = CONSTANTS.dateFormat;
        newsCtrl.rssFeedEntries = defaultRssFeeds.items;
    };

    newsCtrl.loadRssFeed = function (category) {
        newsCtrl.loading = true;
        newsCtrl.errorCode = null;
        NewsModel.getRssFeeds(category).then(function (result) {
            newsCtrl.rssFeedEntries = result.items;
            newsCtrl.loading = false;
        }, function (error) {
            newsCtrl.errorCode = "i8n.common.rss_not_reachable";
            newsCtrl.loading = false;
        });
    };
}]);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by minh on 23/6/2016.
 */

angular.module('taric.adco.lookup', ['taric.model.additional-code', 'common.filter.additionalCode', 'common.helper']).controller('TaricAdcoLookupController', ["CONSTANTS", "TaricAdcoLookupModel", "CommonHelper", "additionalCodeTypes", "$state", "$stateParams", "$rootScope", "$timeout", function (CONSTANTS, TaricAdcoLookupModel, CommonHelper, additionalCodeTypes, $state, $stateParams, $rootScope, $timeout) {
    var taricAdcoLookupCtrl = this;

    taricAdcoLookupCtrl.init = function () {
        // If an invalid additionalCodeType is passed as parameter from other use cases, it needs to be set to null.
        if (TaricAdcoLookupModel.getSearchCriteria().additionalCodeType) {
            var validAdditionalCodeType = false;
            for (var i = 0; i < additionalCodeTypes.items.length; i++) {
                if (TaricAdcoLookupModel.getSearchCriteria().additionalCodeType === additionalCodeTypes.items[i].type) {
                    validAdditionalCodeType = true;
                    break;
                }
            }
            if (!validAdditionalCodeType) {
                TaricAdcoLookupModel.getSearchCriteria().additionalCodeType = null;
            }
        }

        taricAdcoLookupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        taricAdcoLookupCtrl.searchCriteria = TaricAdcoLookupModel.getSearchCriteria();
        taricAdcoLookupCtrl.searchAdcoResult = TaricAdcoLookupModel.searchAdcoResult();
        taricAdcoLookupCtrl.dateFormat = CONSTANTS.dateFormat;
        taricAdcoLookupCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        taricAdcoLookupCtrl.installationCountry = CONSTANTS.installationCountry;
        taricAdcoLookupCtrl.additionalCodeTypes = additionalCodeTypes;
    };

    taricAdcoLookupCtrl.search = function () {
        //Load data for the first page
        this.loadDataFromServer(1);
    };

    //Load data for a given page
    taricAdcoLookupCtrl.loadDataFromServer = function (page) {
        // Reset search result before searching
        taricAdcoLookupCtrl.resetSearchResult();
        taricAdcoLookupCtrl.searching = true;
        TaricAdcoLookupModel.searchAdcos(page).then(function (searchAdcoResult) {
            taricAdcoLookupCtrl.searchAdcoResult = searchAdcoResult;
            taricAdcoLookupCtrl.searching = false;
        }, function (error) {
            taricAdcoLookupCtrl.errorCode = error.data.code;
            taricAdcoLookupCtrl.errorParams = error.data.params;
            taricAdcoLookupCtrl.searching = false;
        });
    };

    taricAdcoLookupCtrl.resetSearchResult = function () {
        taricAdcoLookupCtrl.searchAdcoResult = null;
        TaricAdcoLookupModel.resetSearchResult();
    };

    //Handle page change for the Additional code search result table
    taricAdcoLookupCtrl.searchAdcoResultPageChanged = function (page) {
        taricAdcoLookupCtrl.loadDataFromServer(page);
    };

    taricAdcoLookupCtrl.openDatePicker = function ($event) {
        taricAdcoLookupCtrl.isDatePickerOpen = true;
    };

    taricAdcoLookupCtrl.resetError = function () {
        taricAdcoLookupCtrl.handleError(null);
    };

    taricAdcoLookupCtrl.handleError = function (error) {
        if (!error) {
            taricAdcoLookupCtrl.errorCode = null;
            taricAdcoLookupCtrl.errorParams = null;
        } else {
            taricAdcoLookupCtrl.errorCode = error.errorCode;
            taricAdcoLookupCtrl.errorParams = error.errorParams;
        }
    };

    taricAdcoLookupCtrl.returnToCallerPage = function (additionalCodeTypeAndId) {
        // Do not return simulationDate to CallerPage to avoid affecting other search criteria.
        $state.go($stateParams.frm, {
            ad: CommonHelper.removeSpaceCharacters(additionalCodeTypeAndId),
            "frm": 'adcoLookup'
        });
    };

    taricAdcoLookupCtrl.onChangeAdditionalCode = function () {
        taricAdcoLookupCtrl.searchCriteria.additionalCode = taricAdcoLookupCtrl.searchCriteria.additionalCode.toUpperCase();
    };

    taricAdcoLookupCtrl.hasNationalAdditionalCodeTypes = function () {
        var nationalAdditionalCodeTypes = taricAdcoLookupCtrl.additionalCodeTypes.items.filter(function (additionalCodeType) {
            return additionalCodeType.national === true;
        });
        return nationalAdditionalCodeTypes.length > 0;
    };

    taricAdcoLookupCtrl.isTooltipEnable = function (descriptions) {
        return CommonHelper.isTooltipEnable(descriptions);
    };

    taricAdcoLookupCtrl.onDateChange = function (dateString) {
        taricAdcoLookupCtrl.resetError();
        taricAdcoLookupCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(taricAdcoLookupCtrl.searchCriteria.simulationDate, dateString);
    };

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        taricAdcoLookupCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            taricAdcoLookupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by minh on 27/6/2016.
 */

angular.module('taric.model.adcotype', ['ngResource', 'common.helper']).factory('QueryAdditionalCodeType', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/adco/additionalCodeTypes', {}, {
        queryAdditionalCodeTypes: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('AdditionalCodeTypeModel', ["$q", "QueryAdditionalCodeType", "CommonHelper", function ($q, QueryAdditionalCodeType, CommonHelper) {
    var model = this;
    model.queryAdditionalCodeTypes = function (meursingOnly) {
        var deferred = $q.defer();
        QueryAdditionalCodeType.queryAdditionalCodeTypes({ meursingOnly: meursingOnly }, function (additionalCodeTypes) {
            deferred.resolve(additionalCodeTypes);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.additional-code', ['ngResource', 'common.helper']).factory('QueryAdditionalCode', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/adco/:id', {}, {
        find: {
            method: 'GET',
            isArray: false
        },
        queryAdditionalCodes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/adco/additionalCodes'

        }
    });
}]).service('AdditionalCodePopupModel', ["$q", "QueryAdditionalCode", "CommonHelper", function ($q, QueryAdditionalCode, CommonHelper) {
    var model = this;
    model.findAdditionalCode = function (additionalCodeId, simulationDate, commodityCode) {
        var deferred = $q.defer();
        QueryAdditionalCode.find({ id: additionalCodeId, simulationDate: CommonHelper.getRestDateString(simulationDate), commodityCode: commodityCode }, function (additionalCode) {
            deferred.resolve(additionalCode);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]).service('TaricAdcoLookupModel', ["$q", "QueryAdditionalCode", "CommonHelper", "CONSTANTS", function ($q, QueryAdditionalCode, CommonHelper, CONSTANTS) {
    var model = this,
        searchCriteria = {},
        searchAdcoResult = null;
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.searchAdcoResult = function () {
        return searchAdcoResult;
    };
    model.resetSearchResult = function () {
        searchAdcoResult = null;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
    };
    // Initialize search criteria when opening use case from menu.
    model.resetSearchCriteria();

    model.searchAdcos = function (page) {
        var deferred = $q.defer();
        var result = QueryAdditionalCode.queryAdditionalCodes({ simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            additionalCodeType: searchCriteria.additionalCodeType, additionalCode: searchCriteria.additionalCode, meursingOnly: searchCriteria.meursingOnly,
            offset: CommonHelper.getOffset(page), count: CONSTANTS.rowsPerPage, sortOrder: searchCriteria.ascending ? 'A' : 'D', sortColumn: searchCriteria.sortCol,
            language: searchCriteria.language }, function () {
            searchAdcoResult = {};
            searchAdcoResult.totalItems = result.count;
            searchAdcoResult.adcos = result.items;
            searchAdcoResult.currentAdcoPage = page;
            deferred.resolve(searchAdcoResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by minh on 23/6/2016.
 */

var taricAdco = angular.module('taric.adco', ['taric.adco.lookup', 'taric.adco.view', 'taric.model.adcotype']);
taricAdco.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.adco', {
        abstract: true,
        url: '/adco',
        template: '<ui-view></ui-view>'
    }).state('taric.adco.lookup', {
        url: '/lookup?frm&sd&ad&mo',
        templateUrl: 'taric/adco/lookup/adco-lookup.tmpl.html',
        controller: 'TaricAdcoLookupController as taricAdcoLookupCtrl',
        resolve: {
            initializeSearchCriteria: ["TaricAdcoLookupModel", "$stateParams", "CommonHelper", function initializeSearchCriteria(TaricAdcoLookupModel, $stateParams, CommonHelper) {
                TaricAdcoLookupModel.resetSearchCriteria();
                TaricAdcoLookupModel.resetSearchResult();

                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        TaricAdcoLookupModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.ad && $stateParams.ad.length === 4) {
                    TaricAdcoLookupModel.getSearchCriteria().additionalCodeType = $stateParams.ad.substr(0, 1);
                    TaricAdcoLookupModel.getSearchCriteria().additionalCode = $stateParams.ad.substr(1, 3);
                }

                if ($stateParams.mo && $stateParams.mo === 'true') {
                    TaricAdcoLookupModel.getSearchCriteria().meursingOnly = true;
                } else {
                    TaricAdcoLookupModel.getSearchCriteria().meursingOnly = false;
                }
            }],
            additionalCodeTypes: ["TaricAdcoLookupModel", "AdditionalCodeTypeModel", function additionalCodeTypes(TaricAdcoLookupModel, AdditionalCodeTypeModel) {
                return AdditionalCodeTypeModel.queryAdditionalCodeTypes(TaricAdcoLookupModel.getSearchCriteria().meursingOnly);
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/adco');
            }],

            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.adco.view', {
        url: '/view?sd&ad',
        templateUrl: 'taric/adco/view/adco-view.tmpl.html',
        controller: 'ViewAdcoController as viewAdcoCtrl',
        resolve: {
            additionalCode: ["AdditionalCodePopupModel", "$stateParams", "CommonHelper", function additionalCode(AdditionalCodePopupModel, $stateParams, CommonHelper) {
                if ($stateParams.sd && $stateParams.ad && $stateParams.ad.length === 4) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        return AdditionalCodePopupModel.findAdditionalCode($stateParams.ad, inputDate);
                    }
                }

                return null;
            }],
            simulationDate: ["$stateParams", "CommonHelper", function simulationDate($stateParams, CommonHelper) {
                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        return inputDate;
                    }
                }

                return null;
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/nomenclature/sbt');
            }],

            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.adco.view', ['taric.model.additional-code']).controller('ViewAdcoController', ["additionalCode", "simulationDate", "CONSTANTS", "AdditionalCodePopupModel", "$uibModal", function (additionalCode, simulationDate, CONSTANTS, AdditionalCodePopupModel, $uibModal) {
    var viewAdcoCtrl = this;

    viewAdcoCtrl.init = function () {
        viewAdcoCtrl.dateFormat = CONSTANTS.dateFormat;
        viewAdcoCtrl.installationCountry = CONSTANTS.installationCountry;
        viewAdcoCtrl.selectedRow = additionalCode;
        viewAdcoCtrl.descriptionLanguages = [];
        if (viewAdcoCtrl.selectedRow) {
            // Sort languages of additional code descriptions
            for (var lang in viewAdcoCtrl.selectedRow.descriptions) {
                viewAdcoCtrl.descriptionLanguages.push(lang);
            }
            viewAdcoCtrl.descriptionLanguages.sort();
        }
    };

    viewAdcoCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, simulationDate);
                }]
            }
        });
    };
}]);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 26/09/16.
 */

angular.module('taric.auth.loginhelper', ['taric.auth.model', 'taric.auth.userhelper', 'ng']).factory('LoginHelper', ["$rootScope", "AuthorizeModel", "UserHelper", "$http", "$window", "jwtHelper", "CONSTANTS", "CommonHelper", function ($rootScope, AuthorizeModel, UserHelper, $http, $window, jwtHelper, CONSTANTS, CommonHelper) {
    var helper = {
        login: function login() {
            $http.get(CONSTANTS.auth_url + '/token').then(function (response) {
                if (!response.data.accessToken) {

                    // If user did not log in earlier, then just skip getting token
                    return;
                }
                AuthorizeModel.jwt = response.data.accessToken;
                $http.defaults.headers.common.Authorization = 'Bearer ' + AuthorizeModel.jwt;

                var tokenPayload = jwtHelper.decodeToken(AuthorizeModel.jwt);
                AuthorizeModel.loggedIn = true;
                if (CommonHelper.removeSpaceCharacters(tokenPayload.username) !== "") {
                    AuthorizeModel.userName = tokenPayload.username;
                } else {
                    AuthorizeModel.userName = tokenPayload.sub;
                }

                if (tokenPayload.roles !== "") {
                    AuthorizeModel.roles = tokenPayload.roles;
                } else {
                    AuthorizeModel.roles = tokenPayload.sub;
                }

                $rootScope.$broadcast('disableLogin');
                $rootScope.$broadcast('userName');
            }, function (err) {
                // Do nothing if can not get token
            });
        },
        setAuthorizationHeader: function setAuthorizationHeader() {
            if (AuthorizeModel.loggedIn) {
                // Set authorization header
                $http.defaults.headers.common.Authorization = 'Bearer ' + AuthorizeModel.jwt;
            } else {
                $http.defaults.headers.common.Authorization = null;
            }
        },
        goToLogin: function goToLogin() {
            var authUri = CONSTANTS.auth_url + '/auth?redirect_uri=' + encodeURIComponent(CONSTANTS.callback_url);
            $window.location.replace(authUri);
        }
    };
    return helper;
}]);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 23/09/16.
 */
angular.module('taric.auth.model', ['ngResource', 'common.config']).factory('Authorize', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/secure/user', {}, {
        getUser: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('AuthorizeModel', ["$rootScope", "$q", "Authorize", "$window", function ($rootScope, $q, Authorize, $window) {
    var model = this;

    model.init = function () {
        model.user = null;
        model.userName = null;
        model.password = null;
        model.jwt = null;
        model.roles = null;

        model.loggedIn = false;
    };

    model.logout = function () {
        model.init();
    };

    // Initialize first time
    model.init();

    model.getUser = function () {
        var deferred = $q.defer();
        Authorize.getUser(function (result) {
            deferred.resolve(result);
        }, function (error) {});
        return deferred.promise;
    };

    model.isIncludedUnreleasedDataViewer = function () {
        if (model.roles) {
            return model.roles.includes('taUnreleasedDataViewer');
        } else {
            return false;
        }
    };
}]);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 26/09/16.
 */

angular.module('taric.auth.userhelper', ['taric.auth.model', 'ng', 'common.config', 'angular-jwt']).factory('UserHelper', ["$rootScope", "AuthorizeModel", "$http", "CONSTANTS", function ($rootScope, AuthorizeModel, $http, CONSTANTS) {
    var helper = {
        getUser: function getUser() {
            $http.defaults.headers.common.Authorization = 'Bearer ' + AuthorizeModel.jwt;
            var userInfo = { username: null, fullname: null };

            AuthorizeModel.getUser().then(function (result) {
                userInfo = result;
                AuthorizeModel.user = userInfo.username;
                AuthorizeModel.userName = userInfo.fullname;
                // Used for test
                if (CONSTANTS.fakeSSO === true) {
                    AuthorizeModel.userName = CONSTANTS.fakeSSOusername;
                }
                $rootScope.$broadcast('userName');
            }, function (error) {
                // Token invalid
                if (CONSTANTS.credentialSetting === 'BASIC') {
                    AuthorizeModel.init();
                    $rootScope.$broadcast('enableLogin');
                } else {
                    $rootScope.$broadcast('userName');
                }
            });
        }
    };
    return helper;
}]);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.certificate.lookup', ['taric.model.certificate', 'common.filter.certificate', 'common.helper']).controller('CertificateLookupController', ["CONSTANTS", "CertificateLookupModel", "CommonHelper", "certificateTypes", "$state", "$stateParams", "$rootScope", "$timeout", function (CONSTANTS, CertificateLookupModel, CommonHelper, certificateTypes, $state, $stateParams, $rootScope, $timeout) {
    var certificateLookupCtrl = this;

    certificateLookupCtrl.init = function () {
        // If an invalid certificateType is passed as parameter from other use cases, it needs to be set to null.
        if (CertificateLookupModel.getSearchCriteria().certificateType) {
            var validCertificateType = false;
            for (var i = 0; i < certificateTypes.items.length; i++) {
                if (CertificateLookupModel.getSearchCriteria().certificateType === certificateTypes.items[i].type) {
                    validCertificateType = true;
                    break;
                }
            }
            if (!validCertificateType) {
                CertificateLookupModel.getSearchCriteria().certificateType = null;
            }
        }

        certificateLookupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        certificateLookupCtrl.searchCriteria = CertificateLookupModel.getSearchCriteria();
        certificateLookupCtrl.searchResult = CertificateLookupModel.getSearchResult();
        certificateLookupCtrl.dateFormat = CONSTANTS.dateFormat;
        certificateLookupCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        certificateLookupCtrl.installationCountry = CONSTANTS.installationCountry;
        certificateLookupCtrl.certificateTypes = certificateTypes;
    };

    certificateLookupCtrl.search = function () {
        //Load data for the first page
        this.loadDataFromServer(1);
    };

    //Load data for a given page
    certificateLookupCtrl.loadDataFromServer = function (page) {
        // Reset search result before searching
        certificateLookupCtrl.resetSearchResult();
        certificateLookupCtrl.searching = true;
        CertificateLookupModel.queryCertificates(page).then(function (searchResult) {
            certificateLookupCtrl.searchResult = searchResult;
            certificateLookupCtrl.searching = false;
        }, function (error) {
            certificateLookupCtrl.errorCode = error.data.code;
            certificateLookupCtrl.errorParams = error.data.params;
            certificateLookupCtrl.searching = false;
        });
    };

    certificateLookupCtrl.resetSearchResult = function () {
        certificateLookupCtrl.searchResult = null;
        CertificateLookupModel.resetSearchResult();
    };

    //Handle page change for the Additional code search result table
    certificateLookupCtrl.searchResultPageChanged = function (page) {
        certificateLookupCtrl.loadDataFromServer(page);
    };

    certificateLookupCtrl.openDatePicker = function ($event) {
        certificateLookupCtrl.isDatePickerOpen = true;
    };

    certificateLookupCtrl.resetError = function () {
        certificateLookupCtrl.handleError(null);
    };

    certificateLookupCtrl.handleError = function (error) {
        if (!error) {
            certificateLookupCtrl.errorCode = null;
            certificateLookupCtrl.errorParams = null;
        } else {
            certificateLookupCtrl.errorCode = error.errorCode;
            certificateLookupCtrl.errorParams = error.errorParams;
        }
    };

    certificateLookupCtrl.returnToCallerPage = function (certificateTypeAndId) {
        // Do not return simulationDate to CallerPage to avoid affecting other search criteria.
        $state.go($stateParams.frm, {
            ce: CommonHelper.removeSpaceCharacters(certificateTypeAndId),
            frm: 'certificateLookup'
        });
    };

    certificateLookupCtrl.onChangeCertificate = function () {
        certificateLookupCtrl.searchCriteria.certificateId = certificateLookupCtrl.searchCriteria.certificateId.toUpperCase();
    };

    certificateLookupCtrl.hasNationalCertificateTypes = function () {
        var nationalCertificateTypes = certificateLookupCtrl.certificateTypes.items.filter(function (certificateType) {
            return certificateType.national === true;
        });
        return nationalCertificateTypes.length > 0;
    };

    certificateLookupCtrl.isTooltipEnable = function (descriptions) {
        return CommonHelper.isTooltipEnable(descriptions);
    };

    certificateLookupCtrl.onDateChange = function (dateString) {
        certificateLookupCtrl.resetError();
        certificateLookupCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(certificateLookupCtrl.searchCriteria.simulationDate, dateString);
    };

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        certificateLookupCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            certificateLookupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.certificate', ['ngResource', 'common.config']).factory('QueryCertificate', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/cert/certificates', {}, {
        queryCertificates: {
            method: 'GET',
            isArray: false
        },
        queryCertificateTypes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/cert/certificateTypes'
        }
    });
}]).service('CertificateLookupModel', ["$q", "$translate", "QueryCertificate", "CommonHelper", "CONSTANTS", function ($q, $translate, QueryCertificate, CommonHelper, CONSTANTS) {
    var model = this,
        searchCriteria = {},
        searchResult = null;
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.getSearchResult = function () {
        return searchResult;
    };
    model.resetSearchResult = function () {
        searchResult = null;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
    };
    // Initialize search criteria when opening use case from menu.
    model.resetSearchCriteria();

    model.queryCertificates = function (page) {
        var deferred = $q.defer();
        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            certificateType: searchCriteria.certificateType,
            certificateId: searchCriteria.certificateId,
            offset: CommonHelper.getOffset(page),
            count: CONSTANTS.rowsPerPage,
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol,
            language: CommonHelper.getLanguageCode($translate.use())
        };
        var result = QueryCertificate.queryCertificates(options, function () {
            searchResult = {};
            searchResult.totalItems = result.count;
            searchResult.certificates = result.items;
            searchResult.currentPage = page;
            deferred.resolve(searchResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]).service('CertificateTypeModel', ["$q", "QueryCertificate", function ($q, QueryCertificate) {
    var model = this;
    model.queryCertificateTypes = function () {
        var deferred = $q.defer();
        QueryCertificate.queryCertificateTypes(function (certificateTypes) {
            deferred.resolve(certificateTypes);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var taricCertificate = angular.module('taric.certificate', ['taric.certificate.lookup']);
taricCertificate.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.certificate', {
        abstract: true,
        url: '/certificate',
        template: '<ui-view></ui-view>'
    }).state('taric.certificate.lookup', {
        url: '/lookup?frm&sd&ce',
        templateUrl: 'taric/certificate/lookup/certificate-lookup.tmpl.html',
        controller: 'CertificateLookupController as certificateLookupCtrl',
        resolve: {
            initializeSearchCriteria: ["CertificateLookupModel", "$stateParams", "CommonHelper", function initializeSearchCriteria(CertificateLookupModel, $stateParams, CommonHelper) {
                CertificateLookupModel.resetSearchCriteria();
                CertificateLookupModel.resetSearchResult();

                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        CertificateLookupModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.ce && $stateParams.ce.length === 4) {
                    CertificateLookupModel.getSearchCriteria().certificateType = $stateParams.ce.substr(0, 1);
                    CertificateLookupModel.getSearchCriteria().certificateId = $stateParams.ce.substr(1, 3);
                }
            }],
            certificateTypes: ["CertificateTypeModel", function certificateTypes(CertificateTypeModel) {
                return CertificateTypeModel.queryCertificateTypes();
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/certificate');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 4/25/2016.
 */
angular.module('taric.duty.calculate.adco', ['taric.model.cd', 'common.filter.description']).controller('CalculateDutyAdcoCtrl', ["CalculateDutyModel", "CONSTANTS", "CommonHelper", "$state", "$stateParams", function (CalculateDutyModel, CONSTANTS, CommonHelper, $state, $stateParams) {
    var calculateDutyAdcoCtrl = this;
    calculateDutyAdcoCtrl.init = function () {
        calculateDutyAdcoCtrl.dateFormat = CONSTANTS.dateFormat;
        calculateDutyAdcoCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
        calculateDutyAdcoCtrl.additionalCodes = CalculateDutyModel.getAdditionalCodes();
        calculateDutyAdcoCtrl.installationCountry = CONSTANTS.installationCountry;
        calculateDutyAdcoCtrl.isOpen = false;
        calculateDutyAdcoCtrl.categorizeAdditionalCodes();
        calculateDutyAdcoCtrl.updateSelectedAdditionalCodesFromParams();
        if (CalculateDutyModel.meursingAdditionalCode) {
            // Returned additional code from "search meursing additional code"
            calculateDutyAdcoCtrl.calculationInput.meursing = CalculateDutyModel.meursingAdditionalCode;
            CalculateDutyModel.meursingAdditionalCode = null;
        }
    };

    calculateDutyAdcoCtrl.updateSelectedAdditionalCodesFromParams = function () {
        if ($stateParams.ads && $stateParams.ads.length > 0) {
            var pAds = [];
            if ($stateParams.ads.constructor === Array) {
                pAds = $stateParams.ads;
            } else {
                pAds.push($stateParams.ads);
            }

            // Loop through AdditionalCodes from parameters to select default value in each groups: eu, national, export refund, optional
            for (var adsCount = 0; adsCount < pAds.length; adsCount++) {
                var selectedAdditionalCode = false;

                // Update selected eu, national, or export refund AdditionalCode
                for (var groupCount = 0; groupCount < calculateDutyAdcoCtrl.additionalCodes.adcoGroups.length; groupCount++) {
                    if (!selectedAdditionalCode) {
                        for (var count = 0; count < calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].items.length; count++) {
                            if (pAds[adsCount] === calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].items[count].typeAndId) {
                                if (calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].items[0].applicationCode === '0' || calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].items[0].applicationCode === '4') {
                                    // Update selected export refund AdditionalCode
                                    calculateDutyAdcoCtrl.calculationInput.exportRefundAdco = pAds[adsCount];
                                } else {
                                    // Update selected eu or national AdditionalCode
                                    calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].selectedAdco = pAds[adsCount];
                                }

                                selectedAdditionalCode = true;
                                break;
                            }
                        }
                    } else {
                        break;
                    }
                }

                // Update selected optional AdditionalCode
                if (!selectedAdditionalCode) {
                    for (var opCount = 0; opCount < calculateDutyAdcoCtrl.optionalAdditionalCodes.length; opCount++) {
                        if (pAds[adsCount] === calculateDutyAdcoCtrl.optionalAdditionalCodes[opCount].typeAndId) {
                            calculateDutyAdcoCtrl.calculationInput.optionalAdco = pAds[adsCount];
                            selectedAdditionalCode = true;
                            break;
                        }
                    }
                }

                // Update meursing AdditionalCode from search criteria of 'Measures for nomenclature' use case.
                if (!selectedAdditionalCode) {
                    calculateDutyAdcoCtrl.calculationInput.meursing = pAds[adsCount];
                    calculateDutyAdcoCtrl.additionalCodes.meursingApplicable = true;
                }
            }
        }
    };

    calculateDutyAdcoCtrl.lookupMeursing = function () {
        var country = calculateDutyAdcoCtrl.calculationInput.country;
        if (CommonHelper.removeSpaceCharacters(calculateDutyAdcoCtrl.calculationInput.countryOfPreferentialOrigin) !== "" && calculateDutyAdcoCtrl.calculationInput.preferenceCode && (calculateDutyAdcoCtrl.calculationInput.preferenceCode.startsWith('2') || calculateDutyAdcoCtrl.calculationInput.preferenceCode.startsWith('3'))) {
            country = calculateDutyAdcoCtrl.calculationInput.countryOfPreferentialOrigin;
        }
        $state.go('taric.duty.meursing', {
            frm: 'taric.duty.calculate',
            sd: CommonHelper.getBookmarkDateString(calculateDutyAdcoCtrl.calculationInput.simulationDate),
            co: country,
            cu: calculateDutyAdcoCtrl.calculationInput.dutyCurrency
        });
    };

    calculateDutyAdcoCtrl.next = function () {
        var valid = calculateDutyAdcoCtrl.validateForm();
        if (valid) {
            calculateDutyAdcoCtrl.updateCalculationInput();
            calculateDutyAdcoCtrl.navigatingToNextTab = true;
            CalculateDutyModel.goToNextTab('additionalCodes').then(function () {
                calculateDutyAdcoCtrl.navigatingToNextTab = false;
            }, function (error) {
                calculateDutyAdcoCtrl.updateError(error);
                calculateDutyAdcoCtrl.navigatingToNextTab = false;
            });
        }
    };

    calculateDutyAdcoCtrl.updateCalculationInput = function () {
        calculateDutyAdcoCtrl.calculationInput.additionalCodes = [];
        calculateDutyAdcoCtrl.additionalCodes.adcoGroups.forEach(function (group) {
            if (group.selectedAdco && group.selectedAdco !== "") {
                calculateDutyAdcoCtrl.calculationInput.additionalCodes.push(group.selectedAdco);
            }
        });
        if (CONSTANTS.showOptionalAdditionalCodes && calculateDutyAdcoCtrl.calculationInput.optionalAdco && calculateDutyAdcoCtrl.calculationInput.optionalAdco !== "") {
            calculateDutyAdcoCtrl.calculationInput.additionalCodes.push(calculateDutyAdcoCtrl.calculationInput.optionalAdco);
        }
        if (calculateDutyAdcoCtrl.additionalCodes.meursingApplicable) {
            var meursingCode = CommonHelper.removeSpaceCharacters(calculateDutyAdcoCtrl.calculationInput.meursing);
            if (meursingCode !== "") {
                calculateDutyAdcoCtrl.calculationInput.additionalCodes.push(meursingCode);
            }
        }
        if (calculateDutyAdcoCtrl.calculationInput.exportRefundAdco && calculateDutyAdcoCtrl.calculationInput.exportRefundAdco !== "") {
            calculateDutyAdcoCtrl.calculationInput.additionalCodes.push(calculateDutyAdcoCtrl.calculationInput.exportRefundAdco);
        }
    };

    calculateDutyAdcoCtrl.categorizeAdditionalCodes = function () {
        calculateDutyAdcoCtrl.euAdditionalCodes = [];
        calculateDutyAdcoCtrl.exportRefundAdditionalCodes = [];
        calculateDutyAdcoCtrl.nationalAdditionalCodes = [];
        calculateDutyAdcoCtrl.optionalAdditionalCodes = [];
        calculateDutyAdcoCtrl.additionalCodes.adcoGroups.forEach(function (group) {
            if (group.items.length > 0) {
                if (group.items[0].national) {
                    calculateDutyAdcoCtrl.nationalAdditionalCodes.push(group);
                } else {

                    //If it is an export refund group, add an 'None' option at the end of the group for the user to select.
                    if (group.items[0].applicationCode === '0' || group.items[0].applicationCode === '4') {
                        var noneOption = {
                            typeAndId: "",
                            descriptionKey: "i8n.qry.cd.additionalCodesTab.none"
                        };
                        group.items.forEach(function (item) {
                            calculateDutyAdcoCtrl.exportRefundAdditionalCodes.push(item);
                        });
                        calculateDutyAdcoCtrl.exportRefundAdditionalCodes.push(noneOption);
                    } else {

                        //Put the group under EU group
                        calculateDutyAdcoCtrl.euAdditionalCodes.push(group);
                    }
                }
            }
        });
        if (CONSTANTS.showOptionalAdditionalCodes) {
            if (!CalculateDutyModel.getOptionalAdditionalCodes()) {
                CalculateDutyModel.loadOptionalAdditionalCodes().then(function (result) {
                    calculateDutyAdcoCtrl.optionalAdditionalCodes = result.items;
                }, function (error) {
                    calculateDutyAdcoCtrl.updateError(error);
                });
            } else {
                calculateDutyAdcoCtrl.optionalAdditionalCodes = CalculateDutyModel.getOptionalAdditionalCodes().items;
            }
        }
    };

    calculateDutyAdcoCtrl.updateError = function (error) {
        if (!error) {
            calculateDutyAdcoCtrl.errorCode = null;
            calculateDutyAdcoCtrl.errorParams = null;
            calculateDutyAdcoCtrl.errorType = null;
        } else {
            calculateDutyAdcoCtrl.errorCode = error.data.code;
            calculateDutyAdcoCtrl.errorParams = error.data.params;
            calculateDutyAdcoCtrl.errorType = error.data.errorType;
        }
    };
    calculateDutyAdcoCtrl.validateForm = function () {
        calculateDutyAdcoCtrl.updateError(null);
        return calculateDutyAdcoCtrl.validateMeursingAdditionalCode() && calculateDutyAdcoCtrl.validateEUAdditionalCodes() && calculateDutyAdcoCtrl.validateNationalAdditionalCodes();
    };

    calculateDutyAdcoCtrl.validateMeursingAdditionalCode = function () {
        if (!calculateDutyAdcoCtrl.additionalCodes.meursingApplicable || CommonHelper.removeSpaceCharacters(calculateDutyAdcoCtrl.calculationInput.meursing) !== "") {
            return true;
        } else {
            calculateDutyAdcoCtrl.errorCode = "i8n.qry.cd.additionalCodesTab.meursing.missing";
            return false;
        }
    };

    calculateDutyAdcoCtrl.validateEUAdditionalCodes = function () {
        for (var i = 0; i < calculateDutyAdcoCtrl.euAdditionalCodes.length; i++) {
            var group = calculateDutyAdcoCtrl.euAdditionalCodes[i];
            if (!group.selectedAdco || group.selectedAdco === "") {
                calculateDutyAdcoCtrl.errorCode = "i8n.qry.cd.additionalCodesTab.eu-additionalcodes.missing";
                return false;
            }
        }
        return true;
    };

    calculateDutyAdcoCtrl.validateNationalAdditionalCodes = function () {
        for (var i = 0; i < calculateDutyAdcoCtrl.nationalAdditionalCodes.length; i++) {
            var group = calculateDutyAdcoCtrl.nationalAdditionalCodes[i];
            if (!group.selectedAdco || group.selectedAdco === "") {
                calculateDutyAdcoCtrl.errorCode = "i8n.qry.cd.additionalCodesTab.national-additionalcodes.missing";
                return false;
            }
        }
        return true;
    };
}]);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 29/04/16.
 */
angular.module('taric.duty.calculate', ['taric.model.cd', 'taric.duty.calculate.commodity', 'taric.duty.calculate.data', 'taric.duty.calculate.units', 'taric.duty.calculate.adco', 'taric.duty.calculate.results', 'taric.duty.calculate.doc', 'taric.duty.calculate.security']).controller('CalculateDutyCtrl', ["$window", "$translatePartialLoader", "$state", "$stateParams", "CalculateDutyModel", function ($window, $translatePartialLoader, $state, $stateParams, CalculateDutyModel) {
    var calculateDutyCtrl = this;

    // this is the minimum size before swithcing to mobile size
    var mobileSize = 660;

    calculateDutyCtrl.isSmallScreen = false;
    calculateDutyCtrl.typeScreen = 'tabs';

    calculateDutyCtrl.init = function () {

        calculateDutyCtrl.model = CalculateDutyModel;

        if ($window.innerWidth < mobileSize) {
            calculateDutyCtrl.isSmallScreen = true;
            calculateDutyCtrl.typeScreen = 'pills';
        } else {

            calculateDutyCtrl.isSmallScreen = false;
            calculateDutyCtrl.typeScreen = 'tabs';
        }
    };

    calculateDutyCtrl.returnToMeasuresForNomenclature = function () {
        $state.go('taric.measure.mcc', { frm: 'calDuties' });
    };

    calculateDutyCtrl.showBackToMeasures = function () {
        return $stateParams.frm === 'taric.measure.mcc';
    };

    angular.element($window).on('resize', function () {

        var el = document.querySelector("#calDutyTabs ul");
        if (el) {
            if ($window.innerWidth < mobileSize) {
                if (el) el.setAttribute("class", "nav nav-tabs nav-pills nav-stacked");
            } else {

                el.setAttribute("class", "nav nav-tabs");
            }
        }
    });
}]);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 4/25/2016.
 */

angular.module('taric.duty.calculate.commodity', ['common.directive.gonoTree', 'taric.model.cd', 'taric.auth.model', 'common.model.language', 'common.filter.commoditycode']).controller('CalculateDutyCommodityCtrl', ["$translatePartialLoader", "CalculateDutyModel", "LanguageModel", "SearchByNomenclatureModel", "GoodsNomenclatureTreeModel", "CommonHelper", "CONSTANTS", "$filter", "$rootScope", "AuthorizeModel", function ($translatePartialLoader, CalculateDutyModel, LanguageModel, SearchByNomenclatureModel, GoodsNomenclatureTreeModel, CommonHelper, CONSTANTS, $filter, $rootScope, AuthorizeModel) {
    $translatePartialLoader.addPart('taric/duties/calculate');
    var calculateDutyCommodityCtrl = this;
    calculateDutyCommodityCtrl.init = function () {
        calculateDutyCommodityCtrl.model = CalculateDutyModel;
        calculateDutyCommodityCtrl.dateFormat = CONSTANTS.dateFormat;
        calculateDutyCommodityCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        calculateDutyCommodityCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
        calculateDutyCommodityCtrl.simulationDate = calculateDutyCommodityCtrl.calculationInput.simulationDate;
        calculateDutyCommodityCtrl.commodityCode = calculateDutyCommodityCtrl.calculationInput.commodityCode;
        calculateDutyCommodityCtrl.updateExpandAll();
        LanguageModel.getPreferredUILanguages().then(function (result) {
            calculateDutyCommodityCtrl.languages = result.items;
        });
        calculateDutyCommodityCtrl.search();

        calculateDutyCommodityCtrl.model = CalculateDutyModel;
        calculateDutyCommodityCtrl.model.loggedIn = AuthorizeModel.loggedIn;
        calculateDutyCommodityCtrl.releaseManagement = CONSTANTS.releaseManagement;
        if (CONSTANTS.releaseManagement && AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer()) {
            calculateDutyCommodityCtrl.model.includeUnreleased = true;
            calculateDutyCommodityCtrl.showIncludeUnreleased = true;
        } else {
            calculateDutyCommodityCtrl.model.includeUnreleased = false;
            calculateDutyCommodityCtrl.showIncludeUnreleased = false;
        }
    };

    calculateDutyCommodityCtrl.search = function () {
        calculateDutyCommodityCtrl.errorCode = CommonHelper.validateCommodityCode(calculateDutyCommodityCtrl.calculationInput.commodityCode, calculateDutyCommodityCtrl.calculationInput.tradeDirection);
        if (calculateDutyCommodityCtrl.errorCode) {
            return;
        }
        if (!CONSTANTS.dateRestrictionEnabled) {
            calculateDutyCommodityCtrl.errorCode = CommonHelper.validateSimulationDate(calculateDutyCommodityCtrl.calculationInput.simulationDate);
            if (calculateDutyCommodityCtrl.errorCode) {
                calculateDutyCommodityCtrl.errorParams = { param0: CONSTANTS.pastDate };
                return;
            }
        }

        calculateDutyCommodityCtrl.searching = true;
        calculateDutyCommodityCtrl.treeDataList = null;

        SearchByNomenclatureModel.searchGoodsNomenclature(calculateDutyCommodityCtrl.calculationInput.commodityCode, calculateDutyCommodityCtrl.calculationInput.tradeDirection, calculateDutyCommodityCtrl.calculationInput.simulationDate, calculateDutyCommodityCtrl.calculationInput.language).then(function (result) {
            calculateDutyCommodityCtrl.treeDataList = GoodsNomenclatureTreeModel.buildGonoTree(result.items, calculateDutyCommodityCtrl.calculationInput.commodityCode, calculateDutyCommodityCtrl.calculationInput.expandAll);
            calculateDutyCommodityCtrl.searching = false;
            calculateDutyCommodityCtrl.checkForCommodityCodeExistence();

            if (calculateDutyCommodityCtrl.treeDataList) {
                calculateDutyCommodityCtrl.treeDataList.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(calculateDutyCommodityCtrl.calculationInput.simulationDate);
                if (calculateDutyCommodityCtrl.treeDataList.infoCode && "i8n.common.pastDate" === calculateDutyCommodityCtrl.treeDataList.infoCode) {
                    calculateDutyCommodityCtrl.treeDataList.infoParams = CONSTANTS.pastDate;
                }
            }
        }, function (error) {
            calculateDutyCommodityCtrl.errorCode = error.data.code;
            calculateDutyCommodityCtrl.errorParams = error.data.params;
            calculateDutyCommodityCtrl.searching = false;
            calculateDutyCommodityCtrl.remapErrorParameters();
        });
    };

    calculateDutyCommodityCtrl.resetError = function () {
        calculateDutyCommodityCtrl.handleError(null);
    };

    calculateDutyCommodityCtrl.handleError = function (error) {
        if (!error) {
            calculateDutyCommodityCtrl.errorCode = null;
            calculateDutyCommodityCtrl.errorParams = null;
        } else {
            calculateDutyCommodityCtrl.errorCode = error.errorCode;
            calculateDutyCommodityCtrl.errorParams = error.errorParams;
        }
    };

    calculateDutyCommodityCtrl.selectCommodityCode = function (commodityCode) {
        calculateDutyCommodityCtrl.resetError();
        commodityCode = $filter('commodityCode')(commodityCode);
        calculateDutyCommodityCtrl.model.setCommodityCode(commodityCode);
        calculateDutyCommodityCtrl.commodityCode = commodityCode;
    };

    calculateDutyCommodityCtrl.openDatePicker = function ($event) {
        calculateDutyCommodityCtrl.isDatePickerOpen = true;
    };

    calculateDutyCommodityCtrl.setSimulationDate = function (dateString) {
        calculateDutyCommodityCtrl.resetError();
        calculateDutyCommodityCtrl.simulationDate = CommonHelper.formatDate(calculateDutyCommodityCtrl.simulationDate, dateString);
        calculateDutyCommodityCtrl.model.setSimulationDate(calculateDutyCommodityCtrl.simulationDate);
    };

    calculateDutyCommodityCtrl.setCommodityCode = function () {
        calculateDutyCommodityCtrl.selectCommodityCode(calculateDutyCommodityCtrl.commodityCode);
    };

    calculateDutyCommodityCtrl.validateCommodityCode = function () {
        calculateDutyCommodityCtrl.errorCode = CommonHelper.validateDeclarableCommodityCode(calculateDutyCommodityCtrl.calculationInput.commodityCode, calculateDutyCommodityCtrl.calculationInput.tradeDirection);
        return calculateDutyCommodityCtrl.errorCode === null;
    };

    calculateDutyCommodityCtrl.validateSimulationDate = function () {
        if (!CONSTANTS.dateRestrictionEnabled) {
            calculateDutyCommodityCtrl.errorCode = CommonHelper.validateSimulationDate(calculateDutyCommodityCtrl.calculationInput.simulationDate);
            if (calculateDutyCommodityCtrl.errorCode) {
                calculateDutyCommodityCtrl.errorParams = { param0: CONSTANTS.pastDate };
            }
        }
        return calculateDutyCommodityCtrl.errorCode === null;
    };

    calculateDutyCommodityCtrl.gotoDataTab = function () {
        calculateDutyCommodityCtrl.errorCode = null;
        calculateDutyCommodityCtrl.navigatingToNextTab = true;
        CalculateDutyModel.isCommodityCodeDeclarable(calculateDutyCommodityCtrl.calculationInput.commodityCode, calculateDutyCommodityCtrl.calculationInput.simulationDate, calculateDutyCommodityCtrl.calculationInput.tradeDirection).then(function (result) {
            if (result) {
                calculateDutyCommodityCtrl.model.goToNextTab('commodity').then(function () {
                    calculateDutyCommodityCtrl.navigatingToNextTab = false;
                }, function (error) {
                    calculateDutyCommodityCtrl.errorCode = error.data.code;
                    calculateDutyCommodityCtrl.errorParams = error.data.params;
                    calculateDutyCommodityCtrl.navigatingToNextTab = false;
                });
            } else {
                calculateDutyCommodityCtrl.errorCode = "i8n.qry.cd.qryCalcDutiesBean.commodityCode.invalid";
            }

            calculateDutyCommodityCtrl.navigatingToNextTab = false;
        }, function (error) {
            calculateDutyCommodityCtrl.errorCode = error.data.code;
            calculateDutyCommodityCtrl.errorParams = error.data.params;
            calculateDutyCommodityCtrl.navigatingToNextTab = false;
        });
    };

    calculateDutyCommodityCtrl.updateExpandAll = function () {
        var commodityCode = CommonHelper.removeSpaceCharacters(calculateDutyCommodityCtrl.calculationInput.commodityCode);
        calculateDutyCommodityCtrl.shouldEnableExpandAll = commodityCode.length >= 2;
        if (!calculateDutyCommodityCtrl.shouldEnableExpandAll) {
            calculateDutyCommodityCtrl.calculationInput.expandAll = false;
        }
    };

    calculateDutyCommodityCtrl.checkForCommodityCodeExistence = function () {
        if (calculateDutyCommodityCtrl.treeDataList === null || calculateDutyCommodityCtrl.treeDataList.length === 0) {
            calculateDutyCommodityCtrl.errorCode = "tqf.cc.notFound";
            calculateDutyCommodityCtrl.errorParams = { param0: calculateDutyCommodityCtrl.commodityCode, param1: calculateDutyCommodityCtrl.commodityCode };
        }
    };

    calculateDutyCommodityCtrl.remapErrorParameters = function () {
        if (calculateDutyCommodityCtrl.errorCode === "tqf.cc.notFound") {
            calculateDutyCommodityCtrl.errorParams = { param0: calculateDutyCommodityCtrl.commodityCode, param1: calculateDutyCommodityCtrl.commodityCode };
        }
    };
}]);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 21/04/16.
 */
angular.module('taric.duty.calculate.data', ['common.helper', 'taric.model.cd', 'common.model.geoarea', 'common.filter.commoditycode', 'common.filter.description', 'common.filter.specialCharacterToHtml', 'common.filter.decimalNumber', 'taric.model.monetaryunits', 'common.filter.dutyexpression.description']).controller('CalculateDutyDataCtrl', ["$translatePartialLoader", "CalculateDutyModel", "MonetaryUnitsModel", "GeographicalAreaModel", "$filter", "CONSTANTS", "CommonHelper", "$stateParams", "$rootScope", function ($translatePartialLoader, CalculateDutyModel, MonetaryUnitsModel, GeographicalAreaModel, $filter, CONSTANTS, CommonHelper, $stateParams, $rootScope) {
    $translatePartialLoader.addPart('taric/duties/calculate');
    var dataCtrl = this;
    dataCtrl.init = function () {
        // Validated data used for calculation input
        dataCtrl.inputData = CalculateDutyModel.getCalculationInput();
        // Backing data model for view
        dataCtrl.model = CalculateDutyModel;

        // Initialize work area or copy from backing data model if we come here from other tabs
        if (dataCtrl.inputData.tradeDirection === 'I') {
            dataCtrl.isImport = true;
        } else {
            dataCtrl.isImport = false;
        }

        // If model hasn't been initialized get selection lists for countries and regions
        if (dataCtrl.model.countriesAndRegions.count === 0) {
            GeographicalAreaModel.getCountriesOfOrigin(dataCtrl.inputData.simulationDate).then(function (result) {
                dataCtrl.model.countriesAndRegions = result;
            }, function (error) {
                dataCtrl.errorCode = error.data.code;
                dataCtrl.errorParams = error.data.params;
                dataCtrl.errorType = error.data.errorType;
            });
        }

        // If model hasn't been initialized get selection lists for monetary units for customs value and duty
        if (dataCtrl.model.customsValueMonetaryUnits.count === 0) {
            MonetaryUnitsModel.customsValueMonetaryUnits(dataCtrl.inputData.simulationDate).then(function (result) {
                dataCtrl.model.customsValueMonetaryUnits = result;

                // Update selected customs value currency
                if ($stateParams.cu) {
                    for (var count = 0; count < dataCtrl.model.customsValueMonetaryUnits.items.length; count++) {
                        if ($stateParams.cu === dataCtrl.model.customsValueMonetaryUnits.items[count].id) {
                            dataCtrl.inputData.customsValueCurrency = $stateParams.cu;
                        }
                    }
                }
            }, function (error) {
                dataCtrl.errorCode = error.data.code;
                dataCtrl.errorParams = error.data.params;
                dataCtrl.errorType = error.data.errorType;
            });
            MonetaryUnitsModel.dutyMonetaryUnits(dataCtrl.inputData.simulationDate).then(function (result) {
                dataCtrl.model.dutyMonetaryUnits = result;

                // Update selected duty currency
                if ($stateParams.cu) {
                    for (var count = 0; count < dataCtrl.model.dutyMonetaryUnits.items.length; count++) {
                        if ($stateParams.cu === dataCtrl.model.dutyMonetaryUnits.items[count].id) {
                            dataCtrl.inputData.dutyCurrency = $stateParams.cu;
                        }
                    }
                }
            }, function (error) {
                dataCtrl.errorCode = error.data.code;
                dataCtrl.errorParams = error.data.params;
                dataCtrl.errorType = error.data.errorType;
            });
        }

        // Customs value
        if (dataCtrl.inputData.customsValue !== null) {
            dataCtrl.customsValue = CommonHelper.formatDecimalNumber(dataCtrl.inputData.customsValue, 2, '', CONSTANTS.decimalSeparator);
        }
        dataCtrl.customsValueCurrency = dataCtrl.inputData.customsValueCurrency;

        // Net weight
        if (dataCtrl.inputData.netWeight !== null) {
            dataCtrl.netWeight = CommonHelper.formatDecimalNumber(dataCtrl.inputData.netWeight, CommonHelper.getNumberFraction(dataCtrl.inputData.netWeight), '', CONSTANTS.decimalSeparator);
        }

        if (dataCtrl.inputData.supplementaryUnitValue !== null) {
            dataCtrl.supplementaryUnitValue = CommonHelper.formatDecimalNumber(dataCtrl.inputData.supplementaryUnitValue, CommonHelper.getNumberFraction(dataCtrl.inputData.supplementaryUnitValue), '', CONSTANTS.decimalSeparator);
        }

        // Duty currency
        dataCtrl.dutyCurrency = dataCtrl.inputData.dutyCurrency;
        dataCtrl.controlCountry = {};
        dataCtrl.controlCountryOfDispatch = {};
        dataCtrl.controlCountryOfPreferentialOrigin = {};

        dataCtrl.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(dataCtrl.inputData.simulationDate);
        if (dataCtrl.infoCode && "i8n.common.pastDate" === dataCtrl.infoCode) {
            dataCtrl.infoParams = CONSTANTS.pastDate;
        }

        dataCtrl.updateCalculationSupportVersionVisibility();
        dataCtrl.updateCountryOfPreferentialOrigin();
    };

    dataCtrl.updateCalculationSupportVersionVisibility = function () {
        dataCtrl.shouldShowCalculationVersion = true;
        var uccApplicableDate = moment(CONSTANTS.uccApplicableDate, CONSTANTS.dateFormat.toUpperCase(), true).toDate();
        if (CommonHelper.compareDatesWithoutTime(dataCtrl.inputData.simulationDate, uccApplicableDate) < 0 || CONSTANTS.supportedCalculationVersions.length <= 1) {
            dataCtrl.shouldShowCalculationVersion = false;
        }
    };

    dataCtrl.updateCountryOfPreferentialOrigin = function () {
        dataCtrl.showCountryOfPreferentialOrigin = true;
        if (dataCtrl.inputData.tradeDirection === 'E' || dataCtrl.inputData.version === 'PRE_UCC' || dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.countryOfDispatchRequired) {
            dataCtrl.showCountryOfPreferentialOrigin = false;
            dataCtrl.inputData.countryOfPreferentialOrigin = null;
        }
    };

    dataCtrl.updateProcedureCode = function () {
        if (dataCtrl.inputData.version === 'PRE_UCC') {
            dataCtrl.inputData.procedureCode = null;
        }
    };

    dataCtrl.onCalculationChange = function () {
        dataCtrl.updateCountryOfPreferentialOrigin();
        dataCtrl.loadPreferenceCodesAndSupplementaryUnit();
        dataCtrl.updateProcedureCode();
    };

    dataCtrl.resetError = function () {
        dataCtrl.errorCode = null;
        dataCtrl.errorParams = null;
        dataCtrl.errorType = null;
    };

    dataCtrl.getFormattedSimulationDate = function () {
        return $filter('date')(dataCtrl.inputData.simulationDate, CONSTANTS.dateFormat);
    };

    dataCtrl.getFormattedCommodityCode = function () {
        return $filter('commodityCode')(dataCtrl.inputData.commodityCode);
    };

    dataCtrl.getCountryOfDispatch = function () {
        for (var idx = 0; idx < dataCtrl.model.countriesAndRegions.items.length; idx++) {
            if (dataCtrl.model.countriesAndRegions.items[idx].id === dataCtrl.inputData.countryOfDispatch) {
                dataCtrl.model.countryOfDispatchObject = dataCtrl.model.countriesAndRegions.items[idx];
                break;
            }
        }
    };

    dataCtrl.getCountriesAndRegions = function () {
        return dataCtrl.model.countriesAndRegions.items;
    };

    dataCtrl.updateCountry = function (country) {
        dataCtrl.inputData.country = country;
        if (!dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.countryOfDispatchRequired) {
            dataCtrl.updateCountryOfPreferentialOrigin();
            dataCtrl.loadPreferenceCodesAndSupplementaryUnit();
        }
    };

    dataCtrl.onCountryOfDispatchChange = function (countryOfDispatch) {
        dataCtrl.inputData.countryOfDispatch = countryOfDispatch;
        dataCtrl.loadPreferenceCodesAndSupplementaryUnit();
    };

    dataCtrl.onCountryOfPreferentialOriginChange = function (countryOfPreferentialOrigin) {
        dataCtrl.inputData.countryOfPreferentialOrigin = countryOfPreferentialOrigin;
        dataCtrl.loadPreferenceCodesAndSupplementaryUnit();
    };

    dataCtrl.resetPreferenceCodesAndSupplementaryUnit = function () {
        dataCtrl.inputData.preferenceCode = null;
        dataCtrl.inputData.supplementaryUnit = null;
        dataCtrl.supplementaryUnitValue = null;
        dataCtrl.inputData.supplementaryUnitValue = null;
        dataCtrl.model.preferenceCodesAndSupplementaryUnit = { preferenceCodes: { count: 0, items: [] } };
    };

    // Load preference codes from server if country or countryOfPreferentialOrigin has changed
    dataCtrl.loadPreferenceCodesAndSupplementaryUnit = function () {
        dataCtrl.resetError();
        dataCtrl.resetPreferenceCodesAndSupplementaryUnit();
        dataCtrl.resetQuotaOrderNumbers();
        dataCtrl.resetCountryOfDispatch();
        dataCtrl.updateCountryOfPreferentialOrigin();
        if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.country) === "" && CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfPreferentialOrigin) === "") {
            return;
        }
        dataCtrl.loadingReferenceData = true;
        CalculateDutyModel.getPreferenceCodesAndSupplementaryUnit(dataCtrl.inputData.commodityCode, dataCtrl.inputData.country, dataCtrl.inputData.simulationDate, dataCtrl.inputData.tradeDirection, dataCtrl.inputData.countryOfPreferentialOrigin, dataCtrl.inputData.version).then(function (result) {
            dataCtrl.model.preferenceCodesAndSupplementaryUnit = result;
            dataCtrl.loadingReferenceData = false;
        }, function (error) {
            dataCtrl.errorCode = error.data.code;
            dataCtrl.errorParams = error.data.params;
            dataCtrl.errorType = error.data.errorType;
            dataCtrl.loadingReferenceData = false;
            return false;
        });
        return true;
    };

    dataCtrl.onPreferenceCodeChange = function () {
        dataCtrl.resetError();
        dataCtrl.loadQuotaOrderNumbersAndRequiredCountryOfDispatch();
    };

    // Load quota order numbers if preference code has changed
    dataCtrl.loadQuotaOrderNumbersAndRequiredCountryOfDispatch = function () {
        dataCtrl.resetQuotaOrderNumbers();
        dataCtrl.resetCountryOfDispatch();
        var countryOfPreferentialOrigin = CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfPreferentialOrigin);
        var country = CommonHelper.removeSpaceCharacters(dataCtrl.inputData.country);
        var preferenceCode = CommonHelper.removeSpaceCharacters(dataCtrl.inputData.preferenceCode);
        if ((country !== "" || countryOfPreferentialOrigin !== "") && preferenceCode !== "") {
            CalculateDutyModel.getQuotaOrderNumbersAndRequiredCountryOfDispatch(dataCtrl.inputData.tradeDirection, dataCtrl.inputData.commodityCode, dataCtrl.inputData.country, dataCtrl.inputData.preferenceCode, dataCtrl.inputData.simulationDate, dataCtrl.inputData.countryOfPreferentialOrigin, dataCtrl.inputData.version).then(function (result) {
                dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch = result;
                if (dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.countryOfDispatchRequired) {
                    dataCtrl.inputData.countryOfDispatch = dataCtrl.inputData.country;
                }
                dataCtrl.updateCountryOfPreferentialOrigin();
            }, function (error) {
                dataCtrl.errorCode = error.data.code;
                dataCtrl.errorParams = error.data.params;
                dataCtrl.errorType = error.data.errorType;

                if (dataCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }

                return false;
            });
        }
        return true;
    };

    dataCtrl.resetQuotaOrderNumbers = function () {
        dataCtrl.inputData.quotaOrderNumber = null;
        dataCtrl.inputData.useCurrentQuotaStatus = false;
        dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.quotaOrderNumbers = [];
    };

    dataCtrl.resetCountryOfDispatch = function () {
        dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.countryOfDispatchRequired = false;
        dataCtrl.inputData.countryOfDispatch = null;
    };

    dataCtrl.validateCustomsValue = function () {
        dataCtrl.resetError();
        dataCtrl.inputData.customsValue = null;

        if (dataCtrl.customsValue === null || dataCtrl.customsValue === '' || dataCtrl.customsValue === undefined) {
            dataCtrl.errorCode = 'i8n.qry.cd.faultcode.107';
            return false;
        }

        if (!CommonHelper.isDecimalNumber(dataCtrl.customsValue)) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnum';
            return false;
        }

        var customsValue = CommonHelper.getDecimalNumber(dataCtrl.customsValue);
        if (customsValue < 0) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnegative';
            return false;
        }

        // Customs Value: n..16,2
        // Valid pattern = "^\d{0,14}(\,|\.\d{0,2})?$"
        // Because JavaScript Numbers can only handle accurate up to 15 digits, max value is reduced 1 decimal digit
        if (customsValue > 99999999999999.9) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.toobig';
            return false;
        }

        // Do not remove trailing decimal zeros for "Customs Value"
        customsValue = CommonHelper.truncateDecimalNumber(customsValue, 2);
        dataCtrl.customsValue = CommonHelper.formatDecimalNumber(customsValue, 2, '', CONSTANTS.decimalSeparator);
        dataCtrl.inputData.customsValue = customsValue;

        return true;
    };

    dataCtrl.validateNetWeight = function () {
        dataCtrl.resetError();
        dataCtrl.inputData.netWeight = null;

        if (dataCtrl.netWeight === null || dataCtrl.netWeight === '' || dataCtrl.netWeight === undefined) {
            dataCtrl.errorCode = 'i8n.qry.cd.faultcode.108';
            return false;
        }

        if (!CommonHelper.isDecimalNumber(dataCtrl.netWeight)) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnum';
            return false;
        }

        var netWeight = CommonHelper.getDecimalNumber(dataCtrl.netWeight);
        if (netWeight < 0) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnegative';
            return false;
        }

        // Net Weight: n..16,6
        // Valid pattern = "^\d{0,10}(\,|\.\d{0,6})?$"
        // Because JavaScript Numbers can only handle accurate up to 15 digits, max value is reduced 1 decimal digit
        if (netWeight > 9999999999.99999) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.toobig';
            return false;
        }

        netWeight = CommonHelper.truncateDecimalNumber(netWeight, 6);
        dataCtrl.netWeight = CommonHelper.formatDecimalNumber(netWeight, CommonHelper.getNumberFraction(netWeight), '', CONSTANTS.decimalSeparator);
        dataCtrl.inputData.netWeight = netWeight;

        return true;
    };

    dataCtrl.validateSupplementaryUnit = function () {
        dataCtrl.resetError();
        dataCtrl.inputData.supplementaryUnitValue = null;

        if (dataCtrl.supplementaryUnitValue === null || dataCtrl.supplementaryUnitValue === '' || dataCtrl.supplementaryUnitValue === undefined) {
            dataCtrl.errorCode = 'i8n.qry.cd.faultcode.170';
            return false;
        }

        if (!CommonHelper.isDecimalNumber(dataCtrl.supplementaryUnitValue)) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnum';
            return false;
        }

        var supplementaryUnitValue = CommonHelper.getDecimalNumber(dataCtrl.supplementaryUnitValue);
        if (supplementaryUnitValue < 0) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.notnegative';
            return false;
        }

        // Supplementary Unit: n..16,6
        // Valid pattern = "^\d{0,10}(\,|\.\d{0,6})?$"
        // Because JavaScript Numbers can only handle accurate up to 15 digits, max value is reduced 1 decimal digit
        if (supplementaryUnitValue > 9999999999.99999) {
            dataCtrl.errorCode = 'i8n.jsfconv.decnum.toobig';
            return false;
        }

        supplementaryUnitValue = CommonHelper.truncateDecimalNumber(supplementaryUnitValue, 6);
        dataCtrl.supplementaryUnitValue = CommonHelper.formatDecimalNumber(supplementaryUnitValue, CommonHelper.getNumberFraction(supplementaryUnitValue), '', CONSTANTS.decimalSeparator);
        dataCtrl.inputData.supplementaryUnitValue = supplementaryUnitValue;

        return true;
    };

    dataCtrl.next = function () {
        var valid = dataCtrl.validateForm();
        if (valid) {
            dataCtrl.navigatingToNextTab = true;
            if (dataCtrl.inputData.version === 'UCC' && dataCtrl.isImport && dataCtrl.inputData.procedureCode.startsWith("44")) {
                // call to rest-service to validate procedure code
                CalculateDutyModel.isAllowedEndUseProcedureCode().then(function (result) {
                    if (result) {
                        dataCtrl.model.goToNextTab('data').then(function () {
                            dataCtrl.navigatingToNextTab = false;
                        }, function (error) {
                            dataCtrl.errorCode = error.data.code;
                            dataCtrl.errorParams = error.data.params;
                            dataCtrl.navigatingToNextTab = false;
                        });
                    } else {
                        dataCtrl.errorCode = "i8n.qry.cd.procedureCode.endUse_notAllowed";
                    }
                    dataCtrl.navigatingToNextTab = false;
                }, function (error) {
                    dataCtrl.errorCode = error.data.code;
                    dataCtrl.errorParams = error.data.params;
                    dataCtrl.errorType = error.data.errorType;
                    dataCtrl.navigatingToNextTab = false;

                    if (dataCtrl.errorCode === 'i8n.bl.unauthenticated') {
                        $rootScope.$broadcast('tokenInvalid');
                    }
                });
            } else {
                dataCtrl.model.goToNextTab('data').then(function () {
                    dataCtrl.navigatingToNextTab = false;
                }, function (error) {
                    dataCtrl.errorCode = error.data.code;
                    dataCtrl.errorParams = error.data.params;
                    dataCtrl.errorType = error.data.errorType;
                    dataCtrl.navigatingToNextTab = false;

                    if (dataCtrl.errorCode === 'i8n.bl.unauthenticated') {
                        $rootScope.$broadcast('tokenInvalid');
                        // Need to update dropdown
                        dataCtrl.onPreferenceCodeChange();
                    }
                });
            }
        }
        return valid;
    };

    dataCtrl.validateCountryAndCountryOfPreferentialOrigin = function () {
        var valid = dataCtrl.validateCountry() && dataCtrl.validateCountryOfPreferentialOrigin();
        if (!valid) {
            return false;
        }
        if (dataCtrl.inputData.version === 'UCC') {
            if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.country) === "") {
                if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfPreferentialOrigin) === "") {
                    dataCtrl.errorCode = 'i8n.qry.cd.missing.country_origin_and_or_country_of_preferential_origin';
                    return false;
                } else if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfPreferentialOrigin).length === 4 || dataCtrl.model.preferenceCodesAndSupplementaryUnit.preferenceCodes.count === 0) {
                    dataCtrl.errorCode = "i8n.qry.cd.missing.country_origin";
                    return false;
                }
            }
        } else if (dataCtrl.inputData.version === 'PRE_UCC') {
            if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.country) === "") {
                dataCtrl.errorCode = 'i8n.qry.cd.faultcode.110';
                return false;
            }
        }

        return true;
    };

    dataCtrl.validateProcedureCode = function () {
        dataCtrl.resetError();
        if (dataCtrl.inputData.version === 'UCC' && dataCtrl.isImport) {
            if (CommonHelper.removeSpaceCharacters(dataCtrl.inputData.procedureCode) === "") {
                dataCtrl.errorCode = "i8n.qry.cd.missing.procedure_code";
                return false;
            }

            if (!dataCtrl.inputData.procedureCode.match(/^([0-9]{2}|[0-9]{4})$/)) {
                dataCtrl.errorCode = "i8n.qry.cd.procedureCode.invalid";
                return false;
            }
        }

        return true;
    };

    dataCtrl.validateForm = function () {
        dataCtrl.resetError();
        var valid = true;

        if (valid && !dataCtrl.validateCustomsValue()) {
            valid = false;
        }
        if (valid && dataCtrl.inputData.customsValueCurrency === null && dataCtrl.model.customsValueMonetaryUnits.count > 1) {
            dataCtrl.errorCode = 'i8n.qry.cd.faultcode.106';
            valid = false;
        }
        if (valid && !dataCtrl.validateNetWeight()) {
            valid = false;
        }
        valid = valid && dataCtrl.validateCountryAndCountryOfPreferentialOrigin() && dataCtrl.validateCountryOfDispatch();
        if (valid && CommonHelper.removeSpaceCharacters(dataCtrl.inputData.preferenceCode) === "" && dataCtrl.isImport) {
            dataCtrl.errorCode = 'i8n.qry.cd.faultcode.171';
            valid = false;
        }

        if (valid && !dataCtrl.validateProcedureCode()) {
            valid = false;
        }

        if (valid && dataCtrl.model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit && !dataCtrl.validateSupplementaryUnit()) {
            valid = false;
        }
        if (valid && CommonHelper.removeSpaceCharacters(dataCtrl.inputData.quotaOrderNumber) === "" && dataCtrl.model.quotaOrderNumbersAndRequiredCountryOfDispatch.quotaOrderNumbers.length > 0) {
            dataCtrl.errorCode = 'i8n.qry.cd.faultcode.105';
            valid = false;
        }
        if (valid && dataCtrl.inputData.dutyCurrency === null && dataCtrl.model.dutyMonetaryUnits.count > 1) {
            dataCtrl.errorCode = 'i8n.qry.cd.faultcode.106';
            valid = false;
        }

        return valid;
    };

    dataCtrl.validateCountry = function () {
        dataCtrl.errorCode = dataCtrl.controlCountry.validate();
        return dataCtrl.errorCode === null;
    };

    dataCtrl.validateCountryOfPreferentialOrigin = function () {
        if (!dataCtrl.showCountryOfPreferentialOrigin) {
            return true;
        }
        dataCtrl.errorCode = dataCtrl.controlCountryOfPreferentialOrigin.validate();
        return dataCtrl.errorCode === null;
    };

    dataCtrl.validateCountryOfDispatch = function () {
        var valid = true;
        if (dataCtrl.model.countryOfDispatchEnabled) {
            dataCtrl.errorCode = dataCtrl.controlCountryOfDispatch.validate();
            valid = dataCtrl.errorCode === null;
            if (valid && CommonHelper.removeSpaceCharacters(dataCtrl.inputData.countryOfDispatch) === "") dataCtrl.errorCode = 'i8n.qry.cd.faultcode.110';
            valid = false;
        }
        return valid;
    };

    dataCtrl.handleError = function (error) {
        if (!error) {
            dataCtrl.errorCode = null;
            dataCtrl.errorParams = null;
        } else {
            dataCtrl.errorCode = error.errorCode;
            dataCtrl.errorParams = error.errorParams;
        }
    };
}]);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pli on 26/05/16.
 */
angular.module('taric.duty.calculate.doc', ['taric.model.cd', 'common.template.footnote.popup']).controller('CalculateDutyDocCtrl', ["CalculateDutyModel", "CONSTANTS", "$uibModal", function (CalculateDutyModel, CONSTANTS, $uibModal) {
    var docCtrl = this;
    docCtrl.init = function () {
        docCtrl.dateFormat = CONSTANTS.dateFormat;
        docCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
        docCtrl.documents = CalculateDutyModel.getDocuments().items;
        docCtrl.installationCountry = CONSTANTS.installationCountry;
        docCtrl.initDocuments();
        // Backing data model for view
        docCtrl.model = CalculateDutyModel;
    };

    docCtrl.updateError = function (error) {
        if (!error) {
            docCtrl.errorCode = null;
            docCtrl.errorParams = null;
            docCtrl.errorType = null;
        } else {
            docCtrl.errorCode = error.data.code;
            docCtrl.errorParams = error.data.params;
            docCtrl.errorType = error.data.errorType;
        }
    };

    docCtrl.initDocuments = function () {
        docCtrl.initDocuments = [];
        docCtrl.documents.forEach(function (group) {
            if (group) {
                docCtrl.initDocuments.push(group);
            }
        });
    };

    docCtrl.updateCalculationInput = function () {
        docCtrl.calculationInput.documents = [];
        for (var i = 0; i < docCtrl.initDocuments.length; i++) {
            var item = docCtrl.initDocuments[i];
            for (var j = 0; j < item.documentConditionGroups.length; j++) {
                if (item.documentConditionGroups[j].selectedDocument) {

                    // AA-950: a selectedDocument needs to be combined of MesureTypeId, MeasureConditionCode, and DocumentId (CertificateType + CertificateCode) to be unique.
                    docCtrl.calculationInput.documents.push(item.type.id + "_" + item.documentConditionGroups[j].code + "_" + item.documentConditionGroups[j].selectedDocument);
                }
            }
        }
    };

    docCtrl.validateForm = function () {
        docCtrl.updateError(null);
        var valid = true;
        for (var i = 0; i < docCtrl.initDocuments.length; i++) {
            var item = docCtrl.initDocuments[i];
            for (var j = 0; j < item.documentConditionGroups.length; j++) {
                if (item.documentConditionGroups[j].selectedDocument === undefined || item.documentConditionGroups[j].selectedDocument === null) {
                    docCtrl.errorCode = "i8n.qry.cd.qryCalcDutiesBean.document.noselection";
                    valid = false;
                }
            }
        }
        return valid;
    };

    docCtrl.next = function () {
        var valid = docCtrl.validateForm();
        if (valid) {
            docCtrl.updateCalculationInput();
            docCtrl.navigatingToNextTab = true;
            CalculateDutyModel.goToNextTab('documents').then(function () {
                docCtrl.navigatingToNextTab = false;
            }, function (error) {
                docCtrl.errorCode = error.data.code;
                docCtrl.errorParams = error.data.params;
                docCtrl.errorType = error.data.errorType;
                docCtrl.navigatingToNextTab = false;
            });
        }
    };

    docCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, docCtrl.calculationInput.simulationDate);
                }]
            }
        });
    };

    docCtrl.selectDocument = function (selectedDocument) {
        // AA-967 When a document is selected, the same document in a different group must be selected automatically.
        if (!selectedDocument) {
            return;
        }

        // Loop through document groups
        for (var i = 0; i < docCtrl.initDocuments.length; i++) {
            var item = docCtrl.initDocuments[i];
            for (var j = 0; j < item.documentConditionGroups.length; j++) {
                var group = item.documentConditionGroups[j];

                // If the group's selectedDocument is different from selectedDocument,
                // loop through its documents to select the same document.
                if (group.selectedDocument !== selectedDocument) {
                    for (var k = 0; k < group.documents.length; k++) {
                        if (group.documents[k].document.id === selectedDocument) {
                            group.selectedDocument = selectedDocument;
                            break;
                        }
                    }
                }

                // If the group is selected the same document, check the next group.
                if (group.selectedDocument === selectedDocument) {
                    break;
                }
            }
        }
    };
}]);

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 26/05/16.
 */

angular.module('taric.duty.calculate.results', ['taric.duty', 'taric.model.cd', 'taric.model.footnote', 'taric.auth.model', 'common.template.footnote.popup', 'common.template.measure.popup', 'common.config', 'common.filter.description', 'common.filter.decimalNumber', 'common.filter.decimalNumberCalcResult', 'common.helper', 'common.filter.specialCharacterToHtml']).controller('CalculateDutyResultsCtrl', ["$translatePartialLoader", "CalculateDutyModel", "FootnotePopupModel", "MeasurePopupModel", "$uibModal", "CONSTANTS", "CommonHelper", "$rootScope", "$scope", "$filter", "MenuModel", "AuthorizeModel", function ($translatePartialLoader, CalculateDutyModel, FootnotePopupModel, MeasurePopupModel, $uibModal, CONSTANTS, CommonHelper, $rootScope, $scope, $filter, MenuModel, AuthorizeModel) {
    $translatePartialLoader.addPart('taric/duties/calculate');
    var resultsCtrl = this;

    resultsCtrl.init = function () {
        // Backing data model for view
        resultsCtrl.model = CalculateDutyModel;

        resultsCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
        resultsCtrl.calculationResult = CalculateDutyModel.getCalculationResult();

        if (resultsCtrl.calculationInput.tradeDirection === 'I') {
            resultsCtrl.isImport = true;
        } else {
            resultsCtrl.isImport = false;
        }

        var countriesAndregions = CalculateDutyModel.countriesAndRegions;
        var preferenceCodes = null;

        resultsCtrl.dateFormat = CONSTANTS.dateFormat;

        // Only display VAT note for Denmark.
        resultsCtrl.showVatNote = false;
        if (CONSTANTS.installationCountry.toUpperCase() === 'DK') {
            resultsCtrl.showVatNote = true;
        }

        // Only display dutyCalculatorLink for Sweden.
        resultsCtrl.dutyCalculatorLink = CONSTANTS.dutyCalculatorLink;

        resultsCtrl.additionalCodes = null;
        resultsCtrl.countryDescriptions = null;
        resultsCtrl.countryOfPreferentialOriginDescriptions = null;
        resultsCtrl.countryOfDispatchDescriptions = null;
        resultsCtrl.preferenceCodeDescriptions = null;
        resultsCtrl.supplementaryUnit = null;
        resultsCtrl.supplementaryUnitDescriptions = null;
        resultsCtrl.measurementUnits = null;

        if (resultsCtrl.calculationInput.additionalCodes !== null) {
            resultsCtrl.additionalCodes = '';
            var str;
            for (var i = 0; i < resultsCtrl.calculationInput.additionalCodes.length; i++) {
                if (resultsCtrl.additionalCodes.length > 0) {
                    str = resultsCtrl.additionalCodes.concat(' ', resultsCtrl.calculationInput.additionalCodes[i]);
                    resultsCtrl.additionalCodes = str;
                } else {
                    resultsCtrl.additionalCodes = resultsCtrl.calculationInput.additionalCodes[i];
                }
            }
        }

        for (var _i = 0; _i < countriesAndregions.count; _i++) {
            if (resultsCtrl.calculationInput.country === countriesAndregions.items[_i].id) {
                resultsCtrl.countryDescriptions = countriesAndregions.items[_i].descriptions;
                break;
            }
        }

        if (resultsCtrl.calculationInput.countryOfPreferentialOrigin !== null) {
            for (var _i2 = 0; _i2 < countriesAndregions.count; _i2++) {
                if (resultsCtrl.calculationInput.countryOfPreferentialOrigin === countriesAndregions.items[_i2].id) {
                    resultsCtrl.countryOfPreferentialOriginDescriptions = countriesAndregions.items[_i2].descriptions;
                    break;
                }
            }
        }

        if (resultsCtrl.calculationInput.countryOfDispatch !== null) {
            for (var _i3 = 0; _i3 < countriesAndregions.count; _i3++) {
                if (resultsCtrl.calculationInput.countryOfDispatch === countriesAndregions.items[_i3].id) {
                    resultsCtrl.countryOfDispatchDescriptions = countriesAndregions.items[_i3].descriptions;
                    break;
                }
            }
        }

        if (resultsCtrl.calculationInput.preferenceCode !== null) {
            preferenceCodes = CalculateDutyModel.preferenceCodesAndSupplementaryUnit.preferenceCodes;
            for (var _i4 = 0; _i4 < preferenceCodes.count; _i4++) {
                if (resultsCtrl.calculationInput.preferenceCode === preferenceCodes.items[_i4].id) {
                    resultsCtrl.preferenceCodeDescriptions = preferenceCodes.items[_i4].descriptions;
                    break;
                }
            }
        }

        if (resultsCtrl.calculationInput.supplementaryUnitValue !== null) {
            resultsCtrl.supplementaryUnit = CalculateDutyModel.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id;
            resultsCtrl.supplementaryUnitDescriptions = CalculateDutyModel.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.descriptions;
        }

        if (resultsCtrl.calculationInput.measurementUnits !== null) {
            resultsCtrl.measurementUnits = CalculateDutyModel.measurementUnits;

            // If configured decimalSeparator is not default value '.',
            // convert values to DecimalNumber before displaying on GUI by decimalNumber filter.
            if (CONSTANTS.decimalSeparator !== '.') {
                for (var _i5 = 0; _i5 < resultsCtrl.measurementUnits.length; _i5++) {
                    resultsCtrl.measurementUnits[_i5].value = CommonHelper.getDecimalNumber(resultsCtrl.measurementUnits[_i5].value);
                }
            }
        }

        resultsCtrl.errorMessages = [];
        resultsCtrl.infoMessages = [];
        if (resultsCtrl.calculationResult.messages.length !== 0) {
            var erroridx = 0;
            var infoidx = 0;
            for (var _i6 = 0; _i6 < resultsCtrl.calculationResult.messages.length; _i6++) {
                if (resultsCtrl.calculationResult.messages[_i6].severity === 'INFORMATION') {
                    resultsCtrl.infoMessages[infoidx] = resultsCtrl.calculationResult.messages[_i6].descriptions;
                    infoidx++;
                } else {
                    // severity = 'ERROR'
                    resultsCtrl.errorMessages[erroridx] = resultsCtrl.calculationResult.messages[_i6].descriptions;
                    erroridx++;
                }
            }
        }

        resultsCtrl.measureMap = {};
        for (var _i7 = 0; _i7 < resultsCtrl.calculationResult.measures.length; _i7++) {
            resultsCtrl.measureMap[resultsCtrl.calculationResult.measures[_i7].sid] = resultsCtrl.calculationResult.measures[_i7];
        }

        resultsCtrl.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(resultsCtrl.calculationInput.simulationDate);
        if (resultsCtrl.infoCode && "i8n.common.pastDate" === resultsCtrl.infoCode) {
            resultsCtrl.infoParams = CONSTANTS.pastDate;
        }

        resultsCtrl.model = CalculateDutyModel;
        resultsCtrl.model.loggedIn = AuthorizeModel.loggedIn;
        if (CONSTANTS.releaseManagement) {
            resultsCtrl.model.includeUnreleased = AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer();
        } else {
            resultsCtrl.model.includeUnreleased = false;
        }
    };

    resultsCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, resultsCtrl.calculationInput.simulationDate);
                }]
            }
        });
    };

    resultsCtrl.openMeasurePopup = function (size, measure) {
        var preferenceCodesForMeasureOnly = false;
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/measure/measure-popup.tmpl.html',
            controller: 'MeasurePopupController as measurePopupCtrl',
            size: size,
            resolve: {
                measureExtendedInfo: ["MeasurePopupModel", function measureExtendedInfo(MeasurePopupModel) {

                    return MeasurePopupModel.getMeasureExtendedInfoForMeasureType(measure.sid, preferenceCodesForMeasureOnly, resultsCtrl.calculationInput.commodityCode, resultsCtrl.calculationInput.country, resultsCtrl.calculationInput.tradeDirection, resultsCtrl.calculationInput.preferenceCode, resultsCtrl.calculationInput.additionalCodes, resultsCtrl.calculationInput.simulationDate, resultsCtrl.calculationInput.version);
                }]
            }
        });
    };

    // this method is used for traversing the DOM inside the calculate of duties
    // remember that, it only extract visible DOM elements except elements that has classes hidden-div or hidden-table
    resultsCtrl.getChildElements = function (doc, element, options) {

        var elements = element.children;
        for (var i = 0; i < elements.length; i++) {

            if (elements[i].id != 'infoTable') {

                if (elements[i].className.indexOf('hidden-div') != -1 || elements[i].className.indexOf('hidden-table') != -1 || !!(elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length)) {

                    var name = elements[i].nodeName.toLowerCase();
                    if (name == 'p' || name == 'span') {

                        if (elements[i].innerHTML.indexOf('dutyCal.gif') != -1) {
                            // Print calculator icon and DutyCalculatorLink text when there is preference "dutyCalculatorLink"
                            doc.push({ text: '\n' });
                            doc.push({
                                table: {
                                    widths: ['*']['*'],
                                    body: [[{ // Get DutyCalculatorLink image
                                        image: 'dutyCal',
                                        alignment: 'left',
                                        margin: [0, 0, 0, 0],
                                        width: 12,
                                        height: 12
                                    }, { // Get DutyCalculatorLink text
                                        text: elements[i].getElementsByClassName('text-left')[0].innerHTML,
                                        alignment: "left",
                                        fontSize: 8.5,
                                        bold: false
                                    }]]
                                },
                                layout: 'noBorders'
                            });
                        } else if (elements[i].className.indexOf('alert') != -1) {
                            // Print errorMessages or infoMessages
                            // Remove all html tag and special characters. Only keep text content
                            var text = elements[i].innerHTML.replace(/<(?:.|\n)*?>/gm, '');
                            doc.push({ text: '\n' });
                            doc.push({
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: text,
                                        alignment: "left",
                                        fontSize: 9,
                                        bold: true
                                    }]]
                                }
                            });
                        } else {

                            if (doc.length > 0) {
                                doc.push({ text: '\n' });
                            }

                            var bold = elements[i].className.indexOf('-tab-heading') != -1 || elements[i].className.indexOf('dutycal-underline') != -1 ? true : false;
                            doc.push({
                                text: elements[i].innerHTML,
                                fontSize: bold ? 9 : 8.5,
                                bold: bold,
                                decoration: elements[i].className.indexOf('dutycal-underline') != -1 ? 'underline' : ''
                            });
                        }
                    } else if (name == 'table') {

                        // print table if it is a table
                        CommonHelper.htmlTableToPdf(doc, elements[i], options);
                    } else if (name == 'div') {

                        // keep printing if it is div
                        resultsCtrl.getChildElements(doc, elements[i], options);
                    } else if (name == 'form') {

                        // keep printing if it is form
                        resultsCtrl.getChildElements(doc, elements[i], options);
                    }
                }
            }
        }
    };

    resultsCtrl.print = function (options) {
        $rootScope.$broadcast('startSpinningPrint');
        $scope.$apply();

        //Prepare the html document for printing pdf
        var doc = [];
        var el = document.getElementById("results");
        var els = el.getElementsByClassName("nav-tabs");

        angular.forEach(els, function (el) {
            el.dataset.oldDisplay = el.style.display;
            el.style.display = 'none';
        });

        els = el.getElementsByClassName("tab-pane");
        angular.forEach(els, function (el) {
            el.dataset.oldDisplay = el.style.display;
            el.style.display = 'block';
        });

        resultsCtrl.getChildElements(doc, document.getElementById('calculateDutyResults'), options);

        //Update the html document to the original state
        els = el.getElementsByClassName("nav-tabs");
        angular.forEach(els, function (el) {
            el.style.display = el.dataset.oldDisplay;
            el.dataset.oldDisplay = null;
        });

        els = el.getElementsByClassName("tab-pane");
        angular.forEach(els, function (el) {
            el.style.display = el.dataset.oldDisplay;
            el.dataset.oldDisplay = null;
        });

        CommonHelper.printPlainDocument({
            contents: doc,
            logo: options.logo,
            flag: resultsCtrl.flagImg,
            eu: resultsCtrl.euImg,
            checked: resultsCtrl.checkedImg,
            unchecked: resultsCtrl.uncheckedImg,
            unreleased: resultsCtrl.unreleasedImg,
            dutyCal: resultsCtrl.dutyCalImg,
            validDate: $filter('date')(resultsCtrl.calculationInput.simulationDate, CONSTANTS.dateFormat),
            title: $filter('translate')('i8n.qry.cd.query.tab.calculate.title')
        }, 'l').then(function () {

            $rootScope.$broadcast('stopSpinningPrint');
        }, function (error) {

            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        $rootScope.$broadcast('stopSpinningPrint');

        // preload nation flag of the report
        CommonHelper.loadImage("img/flags/" + resultsCtrl.model.installationCountry + ".png", 21, 14, function (data) {

            resultsCtrl.flagImg = data.logo;

            // preload logo of the report
            // size of logo must be multipled 2 because it will increase resolution
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, resultsCtrl.print, true);
        }, true);
    });

    // preload load images that are being used in the report.
    CommonHelper.loadImage("img/status/checked.png", 16, 16, function (data) {
        resultsCtrl.checkedImg = data.logo;
    }, true);

    CommonHelper.loadImage("img/status/notchecked.png", 21, 14, function (data) {

        resultsCtrl.uncheckedImg = data.logo;
    }, true);

    CommonHelper.loadImage("img/flags/EU.png", 21, 14, function (data) {

        resultsCtrl.euImg = data.logo;
    }, true);

    CommonHelper.loadImage("img/status/unreleased.gif", 21, 14, function (data) {

        resultsCtrl.unreleasedImg = data.logo;
    }, true);

    CommonHelper.loadImage("img/references/dutyCal.gif", 20, 20, function (data) {

        resultsCtrl.dutyCalImg = data.logo;
    }, true);

    if (MenuModel) {

        MenuModel.enablePrintable();
        MenuModel.notifyObservers();
    }
}]);

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 8/1/2016.
 */
angular.module('taric.duty.calculate.security', ['taric.model.cd', 'common.filter.description', 'common.filter.decimalNumberCalcResult']).controller('CalculateDutySecurityCtrl', ["CalculateDutyModel", function (CalculateDutyModel) {
    var calculateDutySecurityCtrl = this;
    calculateDutySecurityCtrl.init = function () {
        calculateDutySecurityCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
        calculateDutySecurityCtrl.quotaSecurities = CalculateDutyModel.quotaSecurities;
        calculateDutySecurityCtrl.measureMap = {};
        for (var i = 0; i < CalculateDutyModel.getCalculationResult().measures.length; i++) {
            calculateDutySecurityCtrl.measureMap[CalculateDutyModel.getCalculationResult().measures[i].sid] = CalculateDutyModel.getCalculationResult().measures[i];
        }
    };
    calculateDutySecurityCtrl.next = function () {
        calculateDutySecurityCtrl.navigatingToNextTab = true;
        CalculateDutyModel.goToNextTab('security').then(function () {
            calculateDutySecurityCtrl.navigatingToNextTab = false;
        }, function (error) {
            calculateDutySecurityCtrl.updateError(error);
            calculateDutySecurityCtrl.navigatingToNextTab = false;
        });
    };

    calculateDutySecurityCtrl.updateError = function (error) {
        if (!error) {
            calculateDutySecurityCtrl.errorCode = null;
            calculateDutySecurityCtrl.errorParams = null;
            calculateDutySecurityCtrl.errorType = null;
        } else {
            calculateDutySecurityCtrl.errorCode = error.data.code;
            calculateDutySecurityCtrl.errorParams = error.data.params;
            calculateDutySecurityCtrl.errorType = error.data.errorType;
        }
    };
}]);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 19/05/16.
 */
angular.module('taric.duty.calculate.units', ['taric.model.cd', 'common.filter.description', 'common.filter.decimalNumber', 'common.helper']).controller('CalculateDutyUnitsCtrl', ["$translatePartialLoader", "CalculateDutyModel", "$filter", "$translate", "CommonHelper", "CONSTANTS", function ($translatePartialLoader, CalculateDutyModel, $filter, $translate, CommonHelper, CONSTANTS) {
    $translatePartialLoader.addPart('taric/duties/calculate');
    var unitsCtrl = this;

    unitsCtrl.init = function () {
        // Validated data used for calculation input
        unitsCtrl.inputData = CalculateDutyModel.getCalculationInput();

        // Backing data model for view
        unitsCtrl.model = CalculateDutyModel;

        unitsCtrl.resetError();

        if (unitsCtrl.inputData.measurementUnits !== null) {
            // Back from another tab. Set values.
            for (var i = 0; i < unitsCtrl.inputData.measurementUnits.length; i++) {
                unitsCtrl.model.measurementUnits[i].value = unitsCtrl.inputData.measurementUnits[i].value;
            }
        }
    };

    unitsCtrl.resetError = function () {
        unitsCtrl.errorCode = null;
        unitsCtrl.errorParams = null;
        unitsCtrl.errorType = null;
    };

    unitsCtrl.validateMeasurementUnitValue = function (measurementUnit) {
        unitsCtrl.resetError();

        if (measurementUnit.value === null || measurementUnit.value === '' || measurementUnit.value === undefined) {
            unitsCtrl.errorCode = 'i8n.qry.cd.faultcode.170';
            return false;
        }

        if (!CommonHelper.isDecimalNumber(measurementUnit.value)) {
            unitsCtrl.errorCode = 'i8n.jsfconv.decnum.notnum';
            return false;
        }

        var measurementUnitValue = CommonHelper.getDecimalNumber(measurementUnit.value);

        // Measurement Unit: n..16,6
        // Valid pattern = "^(-)?\d{0,10}(\,|\.\d{0,6})?$"
        // Because JavaScript Numbers can only handle accurate up to 15 digits, max value is reduced 1 decimal digit
        if (measurementUnitValue > 9999999999.99999) {
            unitsCtrl.errorCode = 'i8n.jsfconv.decnum.toobig';
            return false;
        }

        if (measurementUnitValue < -9999999999.99999) {
            unitsCtrl.errorCode = 'i8n.jsfconv.decnum.toosmall';
            return false;
        }

        measurementUnitValue = CommonHelper.truncateDecimalNumber(measurementUnitValue, 6);
        measurementUnit.value = CommonHelper.formatDecimalNumber(measurementUnitValue, CommonHelper.getNumberFraction(measurementUnitValue), '', CONSTANTS.decimalSeparator);

        return true;
    };

    unitsCtrl.validateMeasurementUnits = function () {
        var valid = true;
        var errorCode = null;
        if (unitsCtrl.model.measurementUnits.length > 0) {
            for (var i = 0; i < unitsCtrl.model.measurementUnits.length; i++) {
                if (!unitsCtrl.validateMeasurementUnitValue(unitsCtrl.model.measurementUnits[i])) {
                    valid = false;
                    // Save errorCode if not set.
                    if (errorCode === null && unitsCtrl.errorCode !== null) {
                        errorCode = unitsCtrl.errorCode;
                    }
                }
            }
        }
        if (!valid) {
            unitsCtrl.errorCode = errorCode;
        }
        return valid;
    };

    unitsCtrl.next = function () {
        var valid = unitsCtrl.validateForm();
        if (valid) {
            unitsCtrl.navigatingToNextTab = true;
            unitsCtrl.model.goToNextTab('units').then(function () {
                unitsCtrl.navigatingToNextTab = false;
            }, function (error) {
                unitsCtrl.errorCode = error.data.code;
                unitsCtrl.errorParams = error.data.params;
                unitsCtrl.errorType = error.data.errorType;
                unitsCtrl.navigatingToNextTab = false;
            });
        }
        return valid;
    };

    unitsCtrl.validateForm = function () {
        unitsCtrl.resetError();
        var valid = true;

        if (!unitsCtrl.validateMeasurementUnits()) {
            valid = false;
        } else {
            if (unitsCtrl.model.measurementUnits.length > 0) {
                // Create input data
                unitsCtrl.inputData.measurementUnits = [];
                for (var i = 0; i < unitsCtrl.model.measurementUnits.length; i++) {
                    unitsCtrl.inputData.measurementUnits[i] = {
                        id: unitsCtrl.model.measurementUnits[i].id,
                        value: unitsCtrl.model.measurementUnits[i].value
                    };
                }
            }
        }
        return valid;
    };
}]);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by perl on 23/08/16.
 */

angular.module('taric.duty.exchangerates', ['taric.model.er', 'taric.model.monetaryunits', 'common.filter.decimalNumber', 'common.helper', 'common.directive.monetaryUnit', 'common.filter.decimalNumberExchangeRateResult']).controller('ExchangeRatesController', ["CONSTANTS", "ExchangeRatesModel", "MonetaryUnitsModel", "$rootScope", "$scope", "$state", "$stateParams", "$translatePartialLoader", "$uibModal", "$filter", "CommonHelper", "$translate", "monetaryUnits", "$timeout", "$location", function (CONSTANTS, ExchangeRatesModel, MonetaryUnitsModel, $rootScope, $scope, $state, $stateParams, $translatePartialLoader, $uibModal, $filter, CommonHelper, $translate, monetaryUnits, $timeout, $location) {
    var exchangeRatesCtrl = this;
    exchangeRatesCtrl.searchExchangeRatesResult = null;
    exchangeRatesCtrl.calculateExchangeRateResult = null;
    exchangeRatesCtrl.reportDate = null;

    // Check whether the search form is valid or not
    exchangeRatesCtrl.validateSearchForm = function () {
        exchangeRatesCtrl.handleSearchError();
        return exchangeRatesCtrl.validateMonetaryUnit() && exchangeRatesCtrl.validateDates();
    };

    exchangeRatesCtrl.validateMonetaryUnit = function () {
        exchangeRatesCtrl.searchErrorCode = exchangeRatesCtrl.controlMonetaryUnit.validate();
        return exchangeRatesCtrl.searchErrorCode === null;
    };

    exchangeRatesCtrl.validateDates = function () {
        if (!CONSTANTS.dateRestrictionEnabled) {
            exchangeRatesCtrl.searchErrorCode = CommonHelper.validateSimulationDate(exchangeRatesCtrl.searchCriteria.fromDate);
            if (exchangeRatesCtrl.searchErrorCode) {
                exchangeRatesCtrl.searchErrorParams = { param0: CONSTANTS.pastDate };
                return false;
            }
            exchangeRatesCtrl.searchErrorCode = CommonHelper.validateSimulationDate(exchangeRatesCtrl.searchCriteria.toDate);
            if (exchangeRatesCtrl.searchErrorCode) {
                exchangeRatesCtrl.searchErrorParams = { param0: CONSTANTS.pastDate };
                return false;
            }
        }
        if (typeof exchangeRatesCtrl.searchCriteria.fromDate !== 'undefined' && exchangeRatesCtrl.searchCriteria.fromDate !== null && typeof exchangeRatesCtrl.searchCriteria.toDate !== 'undefined' && exchangeRatesCtrl.searchCriteria.toDate !== null) {
            if (CommonHelper.compareDatesWithoutTime(exchangeRatesCtrl.searchCriteria.toDate, exchangeRatesCtrl.searchCriteria.fromDate) < 0) {
                exchangeRatesCtrl.searchErrorCode = "i8n.qry.er.invalidPeriod";
                return false;
            }
        }
        return exchangeRatesCtrl.searchErrorCode === null;
    };

    //Check whether the external parameters are valid or not
    exchangeRatesCtrl.validateExternalParameters = function () {
        exchangeRatesCtrl.handleSearchError();
        return exchangeRatesCtrl.validateDates();
    };

    // Load data for a given page
    exchangeRatesCtrl.loadDataFromServer = function (pageNumber) {
        if (!exchangeRatesCtrl.validateSearchForm()) {
            return;
        }

        exchangeRatesCtrl.loadDataFromServerWithoutValidation(pageNumber);
    };

    //Load data for a given page without validation
    exchangeRatesCtrl.loadDataFromServerWithoutValidation = function (pageNumber) {
        // Reset search result before searching
        exchangeRatesCtrl.resetSearchResult();
        exchangeRatesCtrl.searching = true;
        ExchangeRatesModel.queryMonetaryExchangePeriodWithRateDirection(pageNumber).then(function (searchExchangeRatesResult) {
            exchangeRatesCtrl.searchExchangeRatesResult = searchExchangeRatesResult;
            exchangeRatesCtrl.searching = false;
            exchangeRatesCtrl.updateBrowserURL();

            if (typeof exchangeRatesCtrl.searchCriteria.fromDate !== 'undefined' && exchangeRatesCtrl.searchCriteria.fromDate !== null && exchangeRatesCtrl.searchCriteria.fromDate !== '') {
                exchangeRatesCtrl.searchExchangeRatesResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(exchangeRatesCtrl.searchCriteria.fromDate);
                if (exchangeRatesCtrl.searchExchangeRatesResult.infoCode && "i8n.common.pastDate" === exchangeRatesCtrl.searchExchangeRatesResult.infoCode) {
                    exchangeRatesCtrl.searchExchangeRatesResult.infoParams = CONSTANTS.pastDate;
                }
            }
            if (typeof exchangeRatesCtrl.searchCriteria.toDate !== 'undefined' && exchangeRatesCtrl.searchCriteria.toDate !== null && exchangeRatesCtrl.searchCriteria.toDate !== '') {
                exchangeRatesCtrl.searchExchangeRatesResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(exchangeRatesCtrl.searchCriteria.toDate);
                if (exchangeRatesCtrl.searchExchangeRatesResult.infoCode && "i8n.common.pastDate" === exchangeRatesCtrl.searchExchangeRatesResult.infoCode) {
                    exchangeRatesCtrl.searchExchangeRatesResult.infoParams = CONSTANTS.pastDate;
                }
            }
        }, function (error) {
            exchangeRatesCtrl.searchErrorCode = error.data.code;
            exchangeRatesCtrl.searchErrorParams = error.data.params;
            exchangeRatesCtrl.searching = false;
        });
    };

    exchangeRatesCtrl.resetSearchResult = function () {
        exchangeRatesCtrl.searchExchangeRatesResult = null;
    };

    exchangeRatesCtrl.search = function () {
        // Load data for the first page
        exchangeRatesCtrl.loadDataFromServer(1);
    };

    // Handle page change for the exchange rates search result table
    exchangeRatesCtrl.searchExchangeRatesResultPageChanged = function (pageNumber) {
        exchangeRatesCtrl.loadDataFromServer(pageNumber);
    };

    exchangeRatesCtrl.init = function () {
        // Validated data used for search exchange rates input
        exchangeRatesCtrl.searchInputData = ExchangeRatesModel.getSearchExchangeRatesInput();
        // Backing data model for view
        exchangeRatesCtrl.model = ExchangeRatesModel;
        exchangeRatesCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        exchangeRatesCtrl.searchCriteria = ExchangeRatesModel.getSearchCriteria();
        exchangeRatesCtrl.calculateCriteria = ExchangeRatesModel.getCalculateCriteria();
        exchangeRatesCtrl.installationCountry = CONSTANTS.installationCountry;
        exchangeRatesCtrl.installationCurrency = CONSTANTS.installationCurrency;
        exchangeRatesCtrl.calculateExchangeRateResult = ExchangeRatesModel.getCalculateExchangeRateResult();
        exchangeRatesCtrl.dateFormat = CONSTANTS.dateFormat;
        exchangeRatesCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        exchangeRatesCtrl.controlMonetaryUnit = {};
        exchangeRatesCtrl.monetaryUnits = monetaryUnits;
        exchangeRatesCtrl.model.customsValueMonetaryUnits = monetaryUnits;
        exchangeRatesCtrl.searchTabIndex = 0;
        exchangeRatesCtrl.calculateTabIndex = 1;
        exchangeRatesCtrl.activeTabIndex = exchangeRatesCtrl.searchTabIndex;
        exchangeRatesCtrl.menu = CONSTANTS.menu;

        if (exchangeRatesCtrl.isExternalLink() && exchangeRatesCtrl.validateExternalParameters()) {
            // Get valid monetaryUnit
            exchangeRatesCtrl.searchCriteria.monetaryUnit = CommonHelper.getValidSelectedItem(exchangeRatesCtrl.monetaryUnits.items, exchangeRatesCtrl.searchCriteria.monetaryUnit, null);

            // Only auto-search to support bookmark when there are required parameters, and all parameters are valid.
            exchangeRatesCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    exchangeRatesCtrl.isExternalLink = function () {
        return $stateParams.mu || $stateParams.ds || $stateParams.de;
    };

    exchangeRatesCtrl.resetSearchError = function () {
        exchangeRatesCtrl.handleSearchError(null);
    };

    exchangeRatesCtrl.resetCalculateError = function () {
        exchangeRatesCtrl.handleCalculateError(null);
    };

    exchangeRatesCtrl.handleSearchError = function (error) {
        if (!error) {
            exchangeRatesCtrl.searchErrorCode = null;
            exchangeRatesCtrl.searchErrorParams = null;
            exchangeRatesCtrl.searchErrorType = null;
        } else {
            exchangeRatesCtrl.searchErrorCode = error.errorCode;
            exchangeRatesCtrl.searchErrorParams = error.errorParams;
            exchangeRatesCtrl.searchErrorType = error.errorType;
        }
    };

    exchangeRatesCtrl.handleCalculateError = function (error) {
        if (!error) {
            exchangeRatesCtrl.calculateErrorCode = null;
            exchangeRatesCtrl.calculateErrorParams = null;
            exchangeRatesCtrl.calculateErrorType = null;
        } else {
            exchangeRatesCtrl.calculateErrorCode = error.errorCode;
            exchangeRatesCtrl.calculateErrorParams = error.errorParams;
            exchangeRatesCtrl.calculateErrorType = error.errorType;
        }
    };

    exchangeRatesCtrl.onMonetaryUnitChange = function (monetaryUnit) {
        exchangeRatesCtrl.searchCriteria.monetaryUnit = monetaryUnit;
    };

    exchangeRatesCtrl.hasNationalMonetaryUnits = function () {
        var nationalMonetaryUnits = exchangeRatesCtrl.monetaryUnits.items.filter(function (monetaryUnit) {
            return monetaryUnit.national === true;
        });
        return nationalMonetaryUnits.length > 0;
    };

    exchangeRatesCtrl.openDatePickerFromDate = function ($event) {
        exchangeRatesCtrl.isDatePickerOpenFromDate = true;
    };

    exchangeRatesCtrl.openDatePickerToDate = function ($event) {
        exchangeRatesCtrl.isDatePickerOpenToDate = true;
    };

    exchangeRatesCtrl.openDatePickerDate = function ($event) {
        exchangeRatesCtrl.isDatePickerOpenDate = true;
    };

    exchangeRatesCtrl.reloadSearchMonetaryUnits = function () {
        MonetaryUnitsModel.customsValueMonetaryUnits(exchangeRatesCtrl.searchCriteria.fromDate).then(function (monetaryUnits) {
            exchangeRatesCtrl.monetaryUnits = monetaryUnits;
        });
    };

    exchangeRatesCtrl.reloadCalculateMonetaryUnits = function () {
        MonetaryUnitsModel.customsValueMonetaryUnits(exchangeRatesCtrl.calculateCriteria.exchangeDate).then(function (monetaryUnits) {
            exchangeRatesCtrl.monetaryUnits = monetaryUnits;
        });
    };

    exchangeRatesCtrl.onFromDateChange = function (dateString) {
        exchangeRatesCtrl.resetSearchError();
        exchangeRatesCtrl.searchCriteria.fromDate = CommonHelper.formatDate(exchangeRatesCtrl.searchCriteria.fromDate, dateString);
        if (exchangeRatesCtrl.searchCriteria.fromDate) {
            exchangeRatesCtrl.reloadSearchMonetaryUnits();
        }
    };

    exchangeRatesCtrl.onToDateChange = function (dateString) {
        exchangeRatesCtrl.resetSearchError();
        exchangeRatesCtrl.searchCriteria.toDate = CommonHelper.formatDate(exchangeRatesCtrl.searchCriteria.toDate, dateString);
        if (exchangeRatesCtrl.searchCriteria.fromDate) {
            exchangeRatesCtrl.reloadSearchMonetaryUnits();
        }
    };

    exchangeRatesCtrl.onExchangeDateChange = function (dateString) {
        exchangeRatesCtrl.resetCalculateError();
        exchangeRatesCtrl.calculateCriteria.exchangeDate = CommonHelper.formatDate(exchangeRatesCtrl.calculateCriteria.exchangeDate, dateString);
        if (exchangeRatesCtrl.calculateCriteria.exchangeDate) {
            exchangeRatesCtrl.reloadCalculateMonetaryUnits();
        }
    };

    exchangeRatesCtrl.validateAmount = function () {
        exchangeRatesCtrl.calculateExchangeRateResult.amount = '0';
        exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = '0';

        if (!exchangeRatesCtrl.calculateCriteria.amount) {
            exchangeRatesCtrl.calculateErrorCode = 'i8n.qry.er.faultcode.106';
            return false;
        }

        if (!CommonHelper.isDecimalNumber(exchangeRatesCtrl.calculateCriteria.amount)) {
            exchangeRatesCtrl.calculateErrorCode = 'i8n.jsfconv.decnum.notnum';
            return false;
        }

        var amount = CommonHelper.getDecimalNumber(exchangeRatesCtrl.calculateCriteria.amount);
        if (amount < 0) {
            exchangeRatesCtrl.calculateErrorCode = 'i8n.jsfconv.decnum.notnegative';
            return false;
        }

        exchangeRatesCtrl.calculateCriteria.amount = CommonHelper.formatDecimalNumber(amount, CommonHelper.getNumberFraction(amount), '', CONSTANTS.decimalSeparator);

        return true;
    };

    exchangeRatesCtrl.validateFromCurrency = function () {
        var valid = true;
        if (!exchangeRatesCtrl.calculateCriteria.fromCurrency) {
            exchangeRatesCtrl.calculateCriteria.amount = '0';
            exchangeRatesCtrl.calculateExchangeRateResult.amount = '0';
            exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = '0';
            exchangeRatesCtrl.calculateErrorCode = 'i18n.common.validation.monetary.code.missing';
            valid = false;
        }
        return valid;
    };

    exchangeRatesCtrl.validateExchangeDate = function () {
        if (!CONSTANTS.dateRestrictionEnabled) {
            exchangeRatesCtrl.calculateErrorCode = CommonHelper.validateSimulationDate(exchangeRatesCtrl.calculateCriteria.exchangeDate);
            if (exchangeRatesCtrl.calculateErrorCode) {
                exchangeRatesCtrl.calculateErrorParams = { param0: CONSTANTS.pastDate };
            }
        }
        return exchangeRatesCtrl.calculateErrorCode === null;
    };

    // Check whether the calculate form is valid or not
    exchangeRatesCtrl.validateCalculateForm = function () {
        exchangeRatesCtrl.resetCalculateError();
        return exchangeRatesCtrl.validateAmount() && exchangeRatesCtrl.validateFromCurrency() && exchangeRatesCtrl.validateExchangeDate();
    };

    // Calculate exchange rate
    exchangeRatesCtrl.calculate = function () {
        if (!exchangeRatesCtrl.validateCalculateForm()) {
            return;
        }
        exchangeRatesCtrl.calculating = true;
        ExchangeRatesModel.resetCalculateResult();
        exchangeRatesCtrl.calculateExchangeRateResult = ExchangeRatesModel.getCalculateExchangeRateResult();
        ExchangeRatesModel.calculateExchangeRate().then(function (calculateExchangeRateResult) {
            exchangeRatesCtrl.calculateExchangeRateResult = calculateExchangeRateResult;
            exchangeRatesCtrl.calculateExchangeRateResult.amount = accounting.formatNumber(exchangeRatesCtrl.calculateExchangeRateResult.amount, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
            exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = accounting.formatNumber(exchangeRatesCtrl.calculateExchangeRateResult.amountEUR, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);

            exchangeRatesCtrl.calculating = false;

            exchangeRatesCtrl.calculateExchangeRateResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(exchangeRatesCtrl.calculateCriteria.exchangeDate);
            if (exchangeRatesCtrl.calculateExchangeRateResult.infoCode && "i8n.common.pastDate" === exchangeRatesCtrl.calculateExchangeRateResult.infoCode) {
                exchangeRatesCtrl.calculateExchangeRateResult.infoParams = CONSTANTS.pastDate;
                exchangeRatesCtrl.calculateCriteria.amount = '0';
                exchangeRatesCtrl.calculateExchangeRateResult.amount = '0';
                exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = '0';
            }
            if (exchangeRatesCtrl.calculateExchangeRateResult.infoCode && "i8n.common.futureDate" === exchangeRatesCtrl.calculateExchangeRateResult.infoCode) {
                exchangeRatesCtrl.calculateCriteria.amount = '0';
                exchangeRatesCtrl.calculateExchangeRateResult.amount = '0';
                exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = '0';
            }
        }, function (error) {
            exchangeRatesCtrl.calculateErrorCode = error.data.code;
            exchangeRatesCtrl.calculateErrorParams = error.data.params;
            exchangeRatesCtrl.calculating = false;
        });
    };

    // Calculate exchange rate for select row in GUI
    exchangeRatesCtrl.calculateRow = function (monetaryUnit, fromDate) {
        exchangeRatesCtrl.calculating = true;
        exchangeRatesCtrl.calculateExchangeRateResult = null;
        ExchangeRatesModel.resetCalculateResult();
        exchangeRatesCtrl.calculateCriteria.amount = 1;
        exchangeRatesCtrl.calculateCriteria.fromCurrency = monetaryUnit;
        var newFromDate = new Date(fromDate);
        newFromDate.setHours(0);
        newFromDate.setMinutes(0);
        newFromDate.setSeconds(0);
        exchangeRatesCtrl.calculateCriteria.exchangeDate = newFromDate;
        ExchangeRatesModel.calculateExchangeRate().then(function (calculateExchangeRateResult) {
            exchangeRatesCtrl.calculateExchangeRateResult = calculateExchangeRateResult;
            exchangeRatesCtrl.calculateExchangeRateResult.amount = accounting.formatNumber(exchangeRatesCtrl.calculateExchangeRateResult.amount, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
            exchangeRatesCtrl.calculateExchangeRateResult.amountEUR = accounting.formatNumber(exchangeRatesCtrl.calculateExchangeRateResult.amountEUR, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
            exchangeRatesCtrl.calculating = false;
        }, function (error) {
            exchangeRatesCtrl.calculateErrorCode = error.data.code;
            exchangeRatesCtrl.calculateErrorParams = error.data.params;
            exchangeRatesCtrl.calculating = false;
        });
    };

    exchangeRatesCtrl.selectCalculateTab = function () {
        exchangeRatesCtrl.activeTabIndex = exchangeRatesCtrl.calculateTabIndex;
    };

    // export excel
    exchangeRatesCtrl.exportExcel = function () {

        if (!exchangeRatesCtrl.validateSearchForm()) {

            return;
        }

        $rootScope.$broadcast('startSpinningExport');
        ExchangeRatesModel.queryMonetaryExchangePeriodWithRateDirection().then(function (searchExchangeRatesResult) {

            var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
            exchangeRatesCtrl.searchExchangeRatesExcelResult = searchExchangeRatesResult;
            document.getElementById('reportDateExtr').innerHTML = reportDate;

            setTimeout(function () {

                var title = $filter('translate')('i8n.qry.exchangerates.report.title');
                var ws = {
                    '!cols': [{
                        wpx: 90
                    }, {
                        wpx: 120
                    }, {
                        wpx: 400
                    }, {
                        wpx: 150
                    }, {
                        wpx: 330
                    }, {
                        wpx: 330
                    }, {
                        wpx: 330
                    }]
                };

                if (CONSTANTS.menu.exchangeRates.simpleView) {
                    ws = {
                        '!cols': [{
                            wpx: 120
                        }, {
                            wpx: 400
                        }, {
                            wpx: 150
                        }, {
                            wpx: 330
                        }]
                    };
                }
                CommonHelper.printExcel("exportExcelTable", title, ws).then(function () {
                    $rootScope.$broadcast('stopSpinningExport');
                }, function () {
                    $rootScope.$broadcast('stopSpinningExport');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            exchangeRatesCtrl.searchErrorCode = error.data.code;
            exchangeRatesCtrl.searchErrorParams = error.data.params;
            exchangeRatesCtrl.searching = false;
            $rootScope.$broadcast('stopSpinningExport');
        });
    };

    // print pdf
    exchangeRatesCtrl.print = function (options) {

        if (!exchangeRatesCtrl.validateSearchForm()) {
            $scope.$apply();

            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        ExchangeRatesModel.queryMonetaryExchangePeriodWithRateDirection().then(function (searchExchangeRatesResult) {

            exchangeRatesCtrl.searchExchangeRatesAllResult = searchExchangeRatesResult;
            setTimeout(function () {

                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    flag: exchangeRatesCtrl.flagImg,
                    eu: exchangeRatesCtrl.euImg,
                    validDate: $filter('date')(exchangeRatesCtrl.searchCriteria.fromDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qry.exchangerates.report.title')
                }, 'l').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            exchangeRatesCtrl.searchErrorCode = error.data.code;
            exchangeRatesCtrl.searchErrorParams = error.data.params;
            exchangeRatesCtrl.searching = false;
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage("img/flags/EU.png", 21, 14, function (options) {

            exchangeRatesCtrl.euImg = options.logo;
        }, true);

        var url = "img/flags/" + exchangeRatesCtrl.installationCountry + ".png";
        CommonHelper.loadImage(url, 21, 14, function (options) {

            exchangeRatesCtrl.flagImg = options.logo;
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, exchangeRatesCtrl.print, true);
        }, true);
    });

    $scope.$on('exportDocument', function (event, data) {

        exchangeRatesCtrl.exportExcel();
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        exchangeRatesCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            exchangeRatesCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });

    /**
     * 1.3. Query exchange rate - Search result:
     The url syntax:
     {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/duty/exchangerates?mu={MonetaryUnit}&ds={DateStart}&de={DateEnd}&l={Language}
       Example:
     http://www.testenv.se/arctictariff-public-web/#!/taric/duty/exchangerates?mu=AUD&ds=2015-01-01&de=2015-12-31&l=en
     */
    exchangeRatesCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        //Only support bookmark when user enters at least one search criterion
        if (CommonHelper.removeSpaceCharacters(exchangeRatesCtrl.searchCriteria.monetaryUnit) === "" && !CommonHelper.getBookmarkDateString(exchangeRatesCtrl.searchCriteria.fromDate) && !CommonHelper.getBookmarkDateString(exchangeRatesCtrl.searchCriteria.toDate)) {
            $location.search({}).replace();
            return;
        }
        $location.search({
            mu: CommonHelper.removeSpaceCharacters(exchangeRatesCtrl.searchCriteria.monetaryUnit),
            ds: CommonHelper.getBookmarkDateString(exchangeRatesCtrl.searchCriteria.fromDate),
            de: CommonHelper.getBookmarkDateString(exchangeRatesCtrl.searchCriteria.toDate),
            l: $translate.use()
        }).replace();
    };
}]);

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 26/08/16.
 */

angular.module('taric.duty.meursing', ['common.model.geoarea', 'taric.model.meursing', 'common.config', 'common.helper', 'common.filter.geographicalarea.description', 'common.directive.country', 'taric.model.monetaryunits', 'taric.model.links']).controller('SearchMeursingController', ["$window", "CONSTANTS", "$translatePartialLoader", "MeursingModel", "GeographicalAreaModel", "$state", "$stateParams", "$rootScope", "$scope", "CommonHelper", "$filter", "MonetaryUnitsModel", "TaricLinksSearchModel", "$translate", "countries", "currencies", "meursingItemLists", "milkProteinsList", "sucroseIsoglucoseList", "$location", function ($window, CONSTANTS, $translatePartialLoader, MeursingModel, GeographicalAreaModel, $state, $stateParams, $rootScope, $scope, CommonHelper, $filter, MonetaryUnitsModel, TaricLinksSearchModel, $translate, countries, currencies, meursingItemLists, milkProteinsList, sucroseIsoglucoseList, $location) {
    var meurCtrl = this;

    meurCtrl.init = function () {
        meurCtrl.model = MeursingModel;
        meurCtrl.searchCriteria = meurCtrl.model.getSearchCriteria();
        meurCtrl.controlCountry = {};
        meurCtrl.dateFormat = CONSTANTS.dateFormat;
        meurCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        meurCtrl.loadMeursingLinks();

        if (!meurCtrl.searchCriteria.useAdditionalCode && meursingItemLists) {
            meurCtrl.model.milkFatList = meursingItemLists.milkFatList;
            if (milkProteinsList) {
                meurCtrl.model.milkProteinsList = milkProteinsList;
            } else {
                meurCtrl.model.milkProteinsList = meursingItemLists.milkProteinsList;
            }
            meurCtrl.model.starchGlucoseList = meursingItemLists.starchGlucoseList;
            if (sucroseIsoglucoseList) {
                meurCtrl.model.sucroseIsoglucoseList = sucroseIsoglucoseList;
            } else {
                meurCtrl.model.sucroseIsoglucoseList = meursingItemLists.sucroseIsoglucoseList;
            }

            meurCtrl.searchCriteria.milkFatId = CommonHelper.getValidSelectedItem(meurCtrl.model.milkFatList.items, meurCtrl.searchCriteria.milkFatId, null);

            meurCtrl.searchCriteria.milkProteinId = CommonHelper.getValidSelectedItem(meurCtrl.model.milkProteinsList.items, meurCtrl.searchCriteria.milkProteinId, null);

            meurCtrl.searchCriteria.starchGlucoseId = CommonHelper.getValidSelectedItem(meurCtrl.model.starchGlucoseList.items, meurCtrl.searchCriteria.starchGlucoseId, null);

            meurCtrl.searchCriteria.sucroseIsoglucoseId = CommonHelper.getValidSelectedItem(meurCtrl.model.sucroseIsoglucoseList.items, meurCtrl.searchCriteria.sucroseIsoglucoseId, null);
        }

        meurCtrl.model.dutyMonetaryUnits = currencies;
        meurCtrl.searchCriteria.dutyCurrency = CommonHelper.getValidSelectedItem(meurCtrl.model.dutyMonetaryUnits.items, meurCtrl.searchCriteria.dutyCurrency, CONSTANTS.installationCurrency);

        if (meurCtrl.isExternalLink() && meurCtrl.validateExternalParameters()) {
            if (countries) {

                // get valid CountryCode
                meurCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(countries.items, meurCtrl.searchCriteria.country, null);
            }

            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            meurCtrl.loadDataFromServerWithoutValidation();
        }
    };

    meurCtrl.isExternalLink = function () {
        return (!$stateParams.frm || $stateParams.frm !== 'adcoLookup' && $stateParams.frm !== 'taric.measure.mcc' && $stateParams.frm !== 'taric.duty.calculate') && $stateParams.sd && $stateParams.cu && ($stateParams.ad || $stateParams.mf && $stateParams.mp && $stateParams.sg && $stateParams.si);
    };

    //Check whether the external parameters are valid or not
    meurCtrl.validateExternalParameters = function () {
        meurCtrl.resetError();
        return meurCtrl.validateSimulationDate() && meurCtrl.validateAdditionalCode() && meurCtrl.validateSelectLists() && meurCtrl.validateMonetaryUnit();
    };

    meurCtrl.cancelButtonClicked = function () {
        $state.go(meurCtrl.model.from, { ad: '7XXX', frm: 'taric.duty.meursing' });
    };

    meurCtrl.returnToCallerPageWithAdditionalCode = function () {
        $state.go(meurCtrl.model.from, {
            frm: 'taric.duty.meursing',
            ad: CommonHelper.removeSpaceCharacters(meurCtrl.model.meursingResult.additionalCode)
        });
    };

    meurCtrl.loadMeursingLinks = function () {

        // Get meursing links
        TaricLinksSearchModel.searchTariffLinksType('MEURSING_INFORMATION').then(function (result) {
            meurCtrl.model.meursingLinks = result;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.clearSearchResults = function () {
        meurCtrl.model.meursingResult = { "additionalCode": null };
    };

    meurCtrl.loadMonetaryUnits = function () {
        MonetaryUnitsModel.dutyMonetaryUnits(meurCtrl.searchCriteria.simulationDate).then(function (result) {
            meurCtrl.model.dutyMonetaryUnits = result;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.loadMeursingItemLists = function () {
        if (!meurCtrl.searchCriteria.simulationDate) {
            return;
        }

        //Load from meursing items from database
        MeursingModel.initMeursingItemLists(meurCtrl.searchCriteria.simulationDate).then(function (result) {
            meurCtrl.model.milkFatList = result.milkFatList;
            meurCtrl.model.milkProteinsList = result.milkProteinsList;
            meurCtrl.model.starchGlucoseList = result.starchGlucoseList;
            meurCtrl.model.sucroseIsoglucoseList = result.sucroseIsoglucoseList;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.setMilkFatProteinLists = function () {
        meurCtrl.searchCriteria.milkFatId = null;
        meurCtrl.searchCriteria.milkProteinId = null;

        MeursingModel.initMeursingItemLists(meurCtrl.searchCriteria.simulationDate).then(function (result) {
            meurCtrl.model.milkFatList = result.milkFatList;
            meurCtrl.model.milkProteinsList = result.milkProteinsList;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.setStarchSucroseLists = function () {
        meurCtrl.searchCriteria.starchGlucoseId = null;
        meurCtrl.searchCriteria.sucroseIsoglucoseId = null;

        MeursingModel.initMeursingItemLists(meurCtrl.searchCriteria.simulationDate).then(function (result) {
            meurCtrl.model.starchGlucoseList = result.starchGlucoseList;
            meurCtrl.model.sucroseIsoglucoseList = result.sucroseIsoglucoseList;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.updateSearchFields = function () {
        meurCtrl.resetError();
        if (!meurCtrl.searchCriteria.useAdditionalCode) {
            meurCtrl.searchCriteria.additionalCode = null;
            meurCtrl.resetMeursingListItem();
            meurCtrl.loadMeursingItemLists();
        } else {
            meurCtrl.resetMeursingListItem();
        }
        meurCtrl.clearSearchResults();
    };

    meurCtrl.resetMeursingListItem = function () {

        //Reset item list
        meurCtrl.model.milkFatList = { "items": [] };
        meurCtrl.model.milkProteinsList = { "items": [] };
        meurCtrl.model.starchGlucoseList = { "items": [] };
        meurCtrl.model.sucroseIsoglucoseList = { "items": [] };

        //Reset selected items
        meurCtrl.searchCriteria.milkFatId = null;
        meurCtrl.searchCriteria.milkProteinId = null;
        meurCtrl.searchCriteria.starchGlucoseId = null;
        meurCtrl.searchCriteria.sucroseIsoglucoseId = null;
    };

    meurCtrl.lookupAdditionalCode = function (additionalCode) {
        meurCtrl.resetError();
        $state.go('taric.adco.lookup', {
            frm: 'taric.duty.meursing',
            sd: CommonHelper.getBookmarkDateString(meurCtrl.searchCriteria.simulationDate),
            ad: CommonHelper.removeSpaceCharacters(additionalCode),
            mo: true
        });
    };

    meurCtrl.openDatePicker = function ($event) {
        meurCtrl.isDatePickerOpen = true;
    };

    meurCtrl.onDateChange = function (dateString) {
        meurCtrl.resetError();
        meurCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(meurCtrl.searchCriteria.simulationDate, dateString);
        if (!meurCtrl.searchCriteria.simulationDate) {
            return;
        }

        meurCtrl.searchCriteria.dutyCurrency = CONSTANTS.installationCurrency;
        meurCtrl.loadMonetaryUnits();
        meurCtrl.controlCountry.reload(meurCtrl.searchCriteria.simulationDate);
        meurCtrl.updateSearchFields();
    };

    //Check whether the search form is valid or not
    meurCtrl.validateForm = function () {
        meurCtrl.resetError();
        return meurCtrl.validateSimulationDate() && meurCtrl.validateCountryCode() && meurCtrl.validateAdditionalCode() && meurCtrl.validateSelectLists() && meurCtrl.validateMonetaryUnit();
    };

    meurCtrl.validateCountryCode = function () {
        meurCtrl.errorCode = meurCtrl.controlCountry.validate();
        return meurCtrl.errorCode === null;
    };

    meurCtrl.validateAdditionalCode = function () {
        if (!meurCtrl.searchCriteria.useAdditionalCode) {
            return true;
        }

        if (meurCtrl.searchCriteria.additionalCode === null || meurCtrl.searchCriteria.additionalCode === '') {
            meurCtrl.errorCode = 'i8n.qry.meur.search.search.mandatoryFields.missing';
            return false;
        }
        return true;
    };

    meurCtrl.validateMonetaryUnit = function () {
        var params = meurCtrl.searchCriteria;
        if (params.dutyCurrency === '') {
            meurCtrl.errorCode = 'i8n.qry.meur.search.search.mandatoryFields.missing';
            return false;
        }
        return true;
    };

    meurCtrl.validateSelectLists = function () {
        var params = meurCtrl.searchCriteria;

        if (params.useAdditionalCode) {
            return true;
        }
        if (params.milkFatId === null || params.milkFatId === '' || params.milkProteinId === null || params.milkProteinId === '' || params.starchGlucoseId === null || params.starchGlucoseId === '' || params.sucroseIsoglucoseId === null || params.sucroseIsoglucoseId === '') {
            meurCtrl.errorCode = 'i8n.qry.meur.search.search.mandatoryFields.missing';
            return false;
        }
        return true;
    };

    meurCtrl.validateSimulationDate = function () {
        if (meurCtrl.searchCriteria.simulationDate === undefined) {
            meurCtrl.errorCode = 'i8n.qry.meur.search.search.mandatoryFields.missing';
            return false;
        }
        if (!CONSTANTS.dateRestrictionEnabled) {
            meurCtrl.errorCode = CommonHelper.validateSimulationDate(meurCtrl.searchCriteria.simulationDate);
            if (meurCtrl.errorCode) {
                meurCtrl.errorParams = { param0: CONSTANTS.pastDate };
            }
        }
        return meurCtrl.errorCode === null;
    };

    meurCtrl.resetError = function () {
        meurCtrl.errorCode = null;
        meurCtrl.errorParams = null;
        meurCtrl.errorType = null;
    };

    meurCtrl.updateCountry = function (country) {
        meurCtrl.resetError();
        meurCtrl.searchCriteria.country = country;
    };

    meurCtrl.updateMilkProteinItems = function () {
        if (meurCtrl.searchCriteria.milkFatId) {
            meurCtrl.model.updateMilkProteinItems(meurCtrl.searchCriteria.milkFatId, meurCtrl.searchCriteria.simulationDate).then(function (result) {
                meurCtrl.model.milkProteinsList = result;
                meurCtrl.searchCriteria.milkProteinId = null;
            }, function (error) {
                meurCtrl.errorCode = error.data.code;
                meurCtrl.errorParams = error.data.params;
                meurCtrl.errorType = error.data.type;
            });
        } else {
            meurCtrl.setMilkFatProteinLists();
        }
    };

    meurCtrl.updateSucroseIsoglucoseItems = function () {
        if (meurCtrl.searchCriteria.starchGlucoseId) {
            meurCtrl.model.updateSucroseIsoglucoseItems(meurCtrl.searchCriteria.starchGlucoseId, meurCtrl.searchCriteria.simulationDate).then(function (result) {
                meurCtrl.model.sucroseIsoglucoseList = result;
                meurCtrl.searchCriteria.sucroseIsoglucoseId = null;
            }, function (error) {
                meurCtrl.errorCode = error.data.code;
                meurCtrl.errorParams = error.data.params;
                meurCtrl.errorType = error.data.type;
            });
        } else {
            meurCtrl.setStarchSucroseLists();
        }
    };

    meurCtrl.search = function () {
        if (!meurCtrl.validateForm()) {
            return false;
        }

        meurCtrl.loadDataFromServerWithoutValidation();
    };

    //Load data without validation
    meurCtrl.loadDataFromServerWithoutValidation = function () {
        var r = {
            "additionalCode": null,
            "milkFat": null,
            "milkProteins": null,
            "starchGlucose": null,
            "sucroseIsoglucose": null,
            "ergaOmnesDutyRates": { "items": [] },
            "otherDutyRates": { "items": [] }
        };

        meurCtrl.searching = true;
        meurCtrl.clearSearchResults();
        meurCtrl.model.getMeursingResult().then(function (result) {
            r = result;
            r.ergaOmnesDutyRates = result.ergaOmnesDutyRates;
            r.otherDutyRates = result.otherDutyRates;
            meurCtrl.model.meursingResult = r;
            meurCtrl.searching = false;
            meurCtrl.updateBrowserURL();
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
            meurCtrl.searching = false;
        });
    };

    meurCtrl.openMeursingPopup = function (meursingLinks) {
        var meursingLink = $filter('description')(meursingLinks);
        var meursingLinkPopupStyle = 'scrollbars=yes,resizable=yes,top=100,left=100,width=800,height=800';
        $window.open(meursingLink, '_blank', meursingLinkPopupStyle);
    };

    /**
     * Meursing
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/duty/meursing?sd={SimulationDate}&cu={Currency}&co={Country}&ad={AdditionalCode}&mf={MilkFat}&mp={MilkProteins}&sg={StarchGlucose}&si={SucroseIsoglucose}&l={Language}
     *
     * Example:
     * http://www.testenv.se/arctictariff-public-web/#!/taric/duty/meursing?sd=2015-01-01&cu=EUR&co=US&mf=01.010.0.0010&mp=01.020.0.0020&sg=01.010.1.0110&si=01.020.1.0140&l=en
     */
    meurCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Keep additional parameters to return to caller page.
        $location.search({
            sd: CommonHelper.getBookmarkDateString(meurCtrl.searchCriteria.simulationDate),
            cu: meurCtrl.searchCriteria.dutyCurrency,
            co: meurCtrl.searchCriteria.country,
            ad: meurCtrl.searchCriteria.additionalCode,
            mf: meurCtrl.searchCriteria.milkFatId,
            mp: meurCtrl.searchCriteria.milkProteinId,
            sg: meurCtrl.searchCriteria.starchGlucoseId,
            si: meurCtrl.searchCriteria.sucroseIsoglucoseId,
            l: $translate.use(),
            frm: $stateParams.frm !== 'adcoLookup' ? $stateParams.frm : null
        }).replace();
    };

    // export pdf
    meurCtrl.print = function (options) {

        if (!meurCtrl.validateForm()) {
            $scope.$apply();
            return false;
        }

        $rootScope.$broadcast('startSpinningPrint');

        meurCtrl.model.getMeursingResult().then(function (result) {
            var r = result;
            r.ergaOmnesDutyRates = result.ergaOmnesDutyRates;
            r.otherDutyRates = result.otherDutyRates;
            meurCtrl.model.meursingAllResult = r;
            if (meurCtrl.model.meursingAllResult.additionalCode) {

                setTimeout(function () {

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportFormTable'), options);
                    doc.push({ text: '\n' });

                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportMeursingInfo'), options);
                    doc.push({ text: '\n' });

                    // Do not repeat table header for Meursing on each pages.
                    options.headerRows = 0;
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        validDate: $filter('date')(meurCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qry.meur.search.search.title')
                    }, 'p').then(function () {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, function (error) {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });
                }, 1000);
            }
        }, function (error) {

            // show errors here
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, meurCtrl.print, true);
    });
}]);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 21/04/16.
 */

angular.module('taric.model.cd', ['common.helper', 'ngResource']).factory('CalculateDuty', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/cd/commodity/declarable', {}, {
        isCommodityCodeDeclarable: {
            method: 'GET',
            isArray: false
        },
        getPreferenceCodesAndSupplementaryUnit: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/selectionsBasedOnCommodityAndCountry'
        },
        getQuotaOrderNumbersAndRequiredCountryOfDispatch: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/selectionsBasedOnPreferenceCode'
        },
        getQuotaOrderNumbersAndRequiredCountryOfDispatchSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/cd/selectionsBasedOnPreferenceCode'
        },
        getMeasurementUnits: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/measurementUnits'
        },
        isAllowedEndUseProcedureCode: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/isAllowedEndUseProcedureCode'
        },
        isAllowedEndUseProcedureCodeSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/cd/isAllowedEndUseProcedureCode'
        },
        getAdditionalCodes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/additionalCodes'
        },
        getAdditionalCodesSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/cd/additionalCodes'
        },
        getOptionalAdditionalCodes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/optionalAdditionalCodes'
        },
        getDocuments: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/documents'
        },
        getResults: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/calculationResult'
        },
        getResultsSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/cd/calculationResult'
        }
    });
}]).service('CalculateDutyModel', ["$q", "CalculateDuty", "CommonHelper", "CONSTANTS", "$translate", "$timeout", "AuthorizeModel", "$rootScope", function ($q, CalculateDuty, CommonHelper, CONSTANTS, $translate, $timeout, AuthorizeModel, $rootScope) {
    var model = this;
    var calculationInput = {
        language: CommonHelper.getLanguageCode($translate.use()),
        simulationDate: new Date(),
        commodityCode: '',
        tradeDirection: 'I',
        customsValue: null,
        netWeight: null,
        country: null,
        countryOfDispatch: null,
        preferenceCode: null,
        supplementaryUnitValue: null,
        quotaOrderNumber: null,
        useCurrentQuotaStatus: false,
        customsValueCurrency: CONSTANTS.installationCurrency,
        dutyCurrency: CONSTANTS.installationCurrency,
        measurementUnits: null,
        additionalCodes: null,
        documents: null,
        expandAll: false,
        countryOfPreferentialOrigin: null,
        version: 'UCC'
    };
    var calculationResult = null;

    model.tabRendering = {};
    model.lastRestSimulationDate = null;
    model.countriesAndRegions = { count: 0, items: [] };
    model.customsValueMonetaryUnits = { count: 0, items: [] };
    model.dutyMonetaryUnits = { count: 0, items: [] };
    model.preferenceCodesAndSupplementaryUnit = { preferenceCodes: { count: 0, items: [] } };
    model.quotaOrderNumbersAndRequiredCountryOfDispatch = { "quotaOrderNumbers": [], "countryOfDispatchRequired": false };
    model.quotaOrderNumbersEnabled = false;
    model.countryOfDispatchEnabled = false;
    model.countryOfDispatchObject = null;
    model.measurementUnits = null;
    model.documents = null;
    model.meursingAdditionalCode = null;

    $rootScope.$on('clearSearchResult', function (event, data) {
        model.reset();
    });

    model.calculationResult = function () {
        return calculationResult;
    };
    model.resetCalculationResult = function () {
        calculationResult = null;
    };
    model.getCalculationInput = function () {
        return calculationInput;
    };
    model.getCalculationResult = function () {
        return calculationResult;
    };
    model.setSimulationDate = function (simulationDate) {
        var newDate = CommonHelper.getRestDateString(simulationDate);
        if (newDate !== model.lastRestSimulationDate) {
            calculationInput.simulationDate = simulationDate;
            model.reset();
        }
        model.lastRestSimulationDate = newDate;
    };
    model.setCommodityCode = function (commodityCode) {
        var res = CommonHelper.removeSpaceCharacters(commodityCode);
        if (res !== calculationInput.commodityCode) {
            model.reset();
            calculationInput.commodityCode = res;
        }
    };

    model.reset = function () {
        model.countriesAndRegions = { count: 0, items: [] };
        model.customsValueMonetaryUnits = { count: 0, items: [] };
        model.dutyMonetaryUnits = { count: 0, items: [] };

        model.tabRendering = {
            activeIndex: 0,
            commodity: {
                disabled: false,
                index: 0
            },
            data: {
                disabled: true,
                index: 1
            },
            additionalCodes: {
                disabled: true,
                index: 2
            },
            documents: {
                disabled: true,
                index: 3
            },
            units: {
                disabled: true,
                index: 4
            },
            security: {
                disabled: true,
                index: 5
            },
            results: {
                disabled: true,
                index: 6
            }
        };
        model.updateCalculationSupportVersion();
        model.resetDataTab();
        model.resetAdditionalCodesTab();
        model.resetMeasurementUnitsTab();
        model.resetDocumentsTab();
        model.resetSecurityTab();
        model.resetResultsTab();

        if (CONSTANTS.releaseManagement) {
            model.includeUnreleased = AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer();
        } else {
            model.includeUnreleased = false;
        }
        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.resetDataTab = function () {
        calculationInput.customsValue = null;
        calculationInput.netWeight = null;
        calculationInput.country = null;
        calculationInput.countryOfPreferentialOrigin = null;
        calculationInput.procedureCode = null;
        calculationInput.countryOfDispatch = null;
        calculationInput.preferenceCode = null;
        calculationInput.supplementaryUnitValue = null;
        calculationInput.quotaOrderNumber = null;
        calculationInput.useCurrentQuotaStatus = false;
        calculationInput.customsValueCurrency = CONSTANTS.installationCurrency;
        calculationInput.dutyCurrency = CONSTANTS.installationCurrency;
        model.preferenceCodesAndSupplementaryUnit = { preferenceCodes: { count: 0, items: [] } };
        model.quotaOrderNumbersAndRequiredCountryOfDispatch = {
            "quotaOrderNumbers": [],
            "countryOfDispatchRequired": false
        };
        model.quotaOrderNumbersEnabled = false;
        model.countryOfDispatchEnabled = false;
        model.countryOfDispatchInfoText = null;
    };

    model.updateCalculationSupportVersion = function () {
        calculationInput.version = 'UCC';
        var uccApplicableDate = moment(CONSTANTS.uccApplicableDate, CONSTANTS.dateFormat.toUpperCase(), true).toDate();
        if (CommonHelper.compareDatesWithoutTime(calculationInput.simulationDate, uccApplicableDate) < 0) {
            calculationInput.version = 'PRE_UCC';
        } else {
            if (CONSTANTS.supportedCalculationVersions.length === 1) {
                calculationInput.version = CONSTANTS.supportedCalculationVersions[0];
            }
        }
    };

    model.resetAdditionalCodesTab = function () {
        calculationInput.meursing = null;
        calculationInput.additionalCodes = null;
        calculationInput.optionalAdco = "";
        calculationInput.meursing = null;
        calculationInput.exportRefundAdco = "";
        model.tabRendering.additionalCodes.disabled = true;
        model.additionalCodes = null;
        model.optionalAdditionalCodes = null;
    };

    model.resetMeasurementUnitsTab = function () {
        calculationInput.measurementUnits = null;
        model.measurementUnits = null;
        model.tabRendering.units.disabled = true;
    };

    model.resetSecurityTab = function () {
        model.quotaSecurities = [];
        if (model.calculationInput) {
            model.calculationInput.selectedQuotaSecurity = null;
        }
        model.tabRendering.security.disabled = true;
    };

    model.resetDocumentsTab = function () {
        calculationInput.documents = null;
        model.documents = null;
        model.tabRendering.documents.disabled = true;
    };

    model.resetResultsTab = function () {
        model.noAmounts = [];
        model.noSummary = null;
        model.noSecAmounts = [];
        model.sivAmounts = [];
        model.sivSummary = null;
        model.sivSecAmounts = [];
        model.uvAmounts = [];
        model.uvSummary = null;
        model.uvSecAmounts = [];
        model.calculationMeasures = [];
        model.calculationsTabsEnabled = false;
        model.installationCountry = CONSTANTS.installationCountry;
    };

    model.initializeCalculateDuty = function () {
        model.reset();
        calculationInput.language = CommonHelper.getLanguageCode($translate.use());
        calculationInput.simulationDate = new Date();
        model.lastRestSimulationDate = CommonHelper.getRestDateString(calculationInput.simulationDate);
        calculationInput.commodityCode = '';
        calculationInput.tradeDirection = 'I';
    };

    model.isCommodityCodeDeclarable = function (commodityCode, simulationDate, tradeDirection) {
        var deferred = $q.defer();
        CalculateDuty.isCommodityCodeDeclarable({
            commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            tradedirection: tradeDirection
        }, function (result) {
            deferred.resolve(result.declarable);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getQuotaOrderNumbersAndRequiredCountryOfDispatch = function (tradeDirection, commodityCode, country, preferenceCode, simulationDate, countryOfPreferentialOrigin, version) {
        var deferred = $q.defer();
        if (model.loggedIn) {
            CalculateDuty.getQuotaOrderNumbersAndRequiredCountryOfDispatchSecure({
                commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
                simulationdate: CommonHelper.getRestDateString(simulationDate),
                tradedirection: tradeDirection,
                country: country,
                preferencecode: preferenceCode,
                filterHiddenMeasureTypes: false,
                countryOfPreferentialOrigin: countryOfPreferentialOrigin,
                version: version
            }, function (resultSecure) {
                deferred.resolve(resultSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.getQuotaOrderNumbersAndRequiredCountryOfDispatch({
                commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
                simulationdate: CommonHelper.getRestDateString(simulationDate),
                tradedirection: tradeDirection,
                country: country,
                preferencecode: preferenceCode,
                filterHiddenMeasureTypes: true,
                countryOfPreferentialOrigin: countryOfPreferentialOrigin,
                version: version
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

    model.getPreferenceCodesAndSupplementaryUnit = function (commodityCode, country, simulationDate, tradeDirection, countryOfPreferentialOrigin, version) {
        var deferred = $q.defer();
        if (model.loggedIn) {
            CalculateDuty.getPreferenceCodesAndSupplementaryUnit({
                commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
                country: country,
                simulationdate: CommonHelper.getRestDateString(simulationDate),
                tradedirection: tradeDirection,
                filterHiddenMeasureTypes: false,
                countryOfPreferentialOrigin: countryOfPreferentialOrigin,
                version: version
            }, function (resultSecure) {
                deferred.resolve(resultSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.getPreferenceCodesAndSupplementaryUnit({
                commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
                country: country,
                simulationdate: CommonHelper.getRestDateString(simulationDate),
                tradedirection: tradeDirection,
                filterHiddenMeasureTypes: true,
                countryOfPreferentialOrigin: countryOfPreferentialOrigin,
                version: version
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

    model.loadMeasurementUnits = function () {
        var deferred = $q.defer();
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        CalculateDuty.getMeasurementUnits({
            commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
            country: calculationInput.country,
            countryofdispatch: calculationInput.countryOfDispatch,
            simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
            tradedirection: calculationInput.tradeDirection,
            preferencecode: calculationInput.preferenceCode,
            additionalcodes: calculationInput.additionalCodes,
            netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
            customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
            customsvalueMonetaryunit: calculationInput.customsValueCurrency,
            dutyamountMonetaryunit: calculationInput.dutyCurrency,
            supplementaryunit: suppUnit,
            ordernumber: calculationInput.quotaOrderNumber,
            documents: calculationInput.documents,
            countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
            version: calculationInput.version,
            procedureCode: calculationInput.procedureCode,
            includeUnreleased: model.includeUnreleased
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.loadAdditionalCodes = function () {
        var deferred = $q.defer();
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        if (model.loggedIn) {
            CalculateDuty.getAdditionalCodesSecure({
                commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                country: calculationInput.country,
                countryofdispatch: calculationInput.countryOfDispatch,
                simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                tradedirection: calculationInput.tradeDirection,
                preferencecode: calculationInput.preferenceCode,
                netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsvalueMonetaryunit: calculationInput.customsValueCurrency,
                dutyamountMonetaryunit: calculationInput.dutyCurrency,
                supplementaryunit: suppUnit,
                ordernumber: calculationInput.quotaOrderNumber,
                usecurrentquotastatus: calculationInput.useCurrentQuotaStatus,
                filterHiddenMeasureTypes: false,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode,
                includeUnreleased: model.includeUnreleased
            }, function (resultSecure) {
                model.additionalCodes = resultSecure;
                deferred.resolve(resultSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.getAdditionalCodes({
                commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                country: calculationInput.country,
                countryofdispatch: calculationInput.countryOfDispatch,
                simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                tradedirection: calculationInput.tradeDirection,
                preferencecode: calculationInput.preferenceCode,
                netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsvalueMonetaryunit: calculationInput.customsValueCurrency,
                dutyamountMonetaryunit: calculationInput.dutyCurrency,
                supplementaryunit: suppUnit,
                ordernumber: calculationInput.quotaOrderNumber,
                usecurrentquotastatus: calculationInput.useCurrentQuotaStatus,
                filterHiddenMeasureTypes: true,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode
            }, function (result) {
                model.additionalCodes = result;
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

    model.isAllowedEndUseProcedureCode = function () {
        var deferred = $q.defer();
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        if (model.loggedIn) {
            CalculateDuty.isAllowedEndUseProcedureCodeSecure({
                commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                country: calculationInput.country,
                countryofdispatch: calculationInput.countryOfDispatch,
                simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                tradedirection: calculationInput.tradeDirection,
                preferencecode: calculationInput.preferenceCode,
                netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsvalueMonetaryunit: calculationInput.customsValueCurrency,
                dutyamountMonetaryunit: calculationInput.dutyCurrency,
                supplementaryunit: suppUnit,
                ordernumber: calculationInput.quotaOrderNumber,
                usecurrentquotastatus: calculationInput.useCurrentQuotaStatus,
                filterHiddenMeasureTypes: false,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode,
                includeUnreleased: model.includeUnreleased
            }, function (resultSecure) {
                deferred.resolve(resultSecure.allowed);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.isAllowedEndUseProcedureCode({
                commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                country: calculationInput.country,
                countryofdispatch: calculationInput.countryOfDispatch,
                simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                tradedirection: calculationInput.tradeDirection,
                preferencecode: calculationInput.preferenceCode,
                netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsvalueMonetaryunit: calculationInput.customsValueCurrency,
                dutyamountMonetaryunit: calculationInput.dutyCurrency,
                supplementaryunit: suppUnit,
                ordernumber: calculationInput.quotaOrderNumber,
                usecurrentquotastatus: calculationInput.useCurrentQuotaStatus,
                filterHiddenMeasureTypes: true,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode
            }, function (result) {
                deferred.resolve(result.allowed);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

    model.loadOptionalAdditionalCodes = function () {
        var deferred = $q.defer();
        CalculateDuty.getOptionalAdditionalCodes({
            simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate)
        }, function (result) {
            model.optionalAdditionalCodes = result;
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.loadDocuments = function () {
        var deferred = $q.defer();
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        CalculateDuty.getDocuments({
            simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
            commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
            tradedirection: calculationInput.tradeDirection,
            additionalcodes: calculationInput.additionalCodes,
            country: calculationInput.country,
            countryOfDispatch: calculationInput.countryOfDispatch,
            customsValue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
            customsValueMonetaryUnit: calculationInput.customsValueCurrency,
            netWeight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
            orderNumber: calculationInput.quotaOrderNumber,
            supplementaryUnit: suppUnit,
            preferencecode: calculationInput.preferenceCode,
            dutyamountMonetaryunit: calculationInput.dutyCurrency,
            useCurrentQuotaStatus: calculationInput.useCurrentQuotaStatus,
            countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
            version: calculationInput.version,
            procedureCode: calculationInput.procedureCode,
            includeUnreleased: model.includeUnreleased
        }, function (result) {
            model.documents = result;
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.loadResults = function () {
        var deferred = $q.defer();

        var measurementUnits = null;
        if (calculationInput.measurementUnits !== null) {
            measurementUnits = [];
            var str;
            for (var i = 0; i < calculationInput.measurementUnits.length; i++) {
                str = '';
                str = str.concat(calculationInput.measurementUnits[i].id, ':', CommonHelper.getDecimalNumber(calculationInput.measurementUnits[i].value));
                measurementUnits[i] = str;
            }
        }
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        if (model.loggedIn) {
            CalculateDuty.getResultsSecure({
                simulationDate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                commodityCode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                tradeDirection: calculationInput.tradeDirection,
                additionalCodes: calculationInput.additionalCodes,
                documents: calculationInput.documents,
                country: calculationInput.country,
                countryOfDispatch: calculationInput.countryOfDispatch,
                customsValue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsValueMonetaryUnit: calculationInput.customsValueCurrency,
                netWeight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                orderNumber: calculationInput.quotaOrderNumber,
                supplementaryUnit: suppUnit,
                measurementUnits: measurementUnits,
                useCurrentQuotaStatus: calculationInput.useCurrentQuotaStatus,
                preferenceCode: calculationInput.preferenceCode,
                dutyAmountMonetaryUnit: calculationInput.dutyCurrency,
                includeUnreleased: model.includeUnreleased,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode
            }, function (result) {
                calculationResult = result;
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.getResults({
                simulationDate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                commodityCode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                tradeDirection: calculationInput.tradeDirection,
                additionalCodes: calculationInput.additionalCodes,
                documents: calculationInput.documents,
                country: calculationInput.country,
                countryOfDispatch: calculationInput.countryOfDispatch,
                customsValue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsValueMonetaryUnit: calculationInput.customsValueCurrency,
                netWeight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                orderNumber: calculationInput.quotaOrderNumber,
                supplementaryUnit: suppUnit,
                measurementUnits: measurementUnits,
                useCurrentQuotaStatus: calculationInput.useCurrentQuotaStatus,
                preferenceCode: calculationInput.preferenceCode,
                dutyAmountMonetaryUnit: calculationInput.dutyCurrency,
                includeUnreleased: false,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode
            }, function (result) {
                calculationResult = result;
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

    model.goToNextTab = function (currentTab) {
        var deferred = $q.defer();
        model.getNextTab(currentTab).then(function (nextTab) {
            model.handleTabVisibility(currentTab, nextTab);
        }, function (error) {
            if (error.data.code === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
            deferred.reject(error);
        });
        return deferred.promise;
    };

    /**
     * Get the next tab from the current tab.
     * This method should be used only after all data in the current tab has been validated.
     *
     * @param currentTab The current tab
     */
    model.getNextTab = function (currentTab) {
        var deferred = $q.defer();
        switch (currentTab) {
            case 'commodity':
                deferred.resolve('data');
                break;
            case 'data':
                model.shouldGoToTabAdditionalCodes().then(function (result) {
                    if (result) {
                        deferred.resolve('additionalCodes');
                    } else {
                        model.getNextTab('additionalCodes').then(function (result) {
                            deferred.resolve(result);
                        }, function (error) {
                            deferred.reject(error);
                        });
                    }
                }, function (error) {
                    deferred.reject(error);
                });
                break;
            case 'additionalCodes':
                model.shouldGoToTabDocuments().then(function (result) {
                    if (result) {
                        deferred.resolve('documents');
                    } else {
                        model.getNextTab('documents').then(function (result) {
                            deferred.resolve(result);
                        }, function (error) {
                            deferred.reject(error);
                        });
                    }
                }, function (error) {
                    deferred.reject(error);
                });

                break;
            case 'documents':
                model.shouldGoToTabUnits().then(function (result) {
                    if (result) {
                        deferred.resolve('units');
                    } else {
                        model.getNextTab('units').then(function (result) {
                            deferred.resolve(result);
                        }, function (error) {
                            deferred.reject(error);
                        });
                    }
                }, function (error) {
                    deferred.reject(error);
                });

                break;
            case 'units':
                model.shouldGoToTabSecurity().then(function (result) {
                    if (result) {
                        deferred.resolve('security');
                    } else {
                        model.getNextTab('security').then(function (result) {
                            deferred.resolve(result);
                        }, function (error) {
                            deferred.reject(error);
                        });
                    }
                }, function (error) {
                    deferred.reject(error);
                });

                break;
            case 'security':
                model.shouldGoToTabResults().then(function (result) {
                    if (result) {
                        deferred.resolve('results');
                    } else {
                        model.getNextTab('results').then(function (result) {
                            deferred.resolve(result);
                        }, function (error) {
                            deferred.reject(error);
                        });
                    }
                }, function (error) {
                    deferred.reject(error);
                });

                break;
            default:

                //If there is no matching tab, stay at the current tab.
                deferred.resolve(currentTab);
                break;

        }
        return deferred.promise;
    };

    /**
     * Move to the next tab and therefore, make the current tab inactive
     * @param currentTab The current tab
     * @param nextTab The next tab
     */
    model.handleTabVisibility = function (currentTab, nextTab) {
        model.tabRendering.activeIndex = model.tabRendering[nextTab].index;
        model.tabRendering[nextTab].disabled = false;
    };

    model.shouldGoToTabAdditionalCodes = function () {
        var deferred = $q.defer();

        //Reset previous data of additional codes tab before checking
        model.resetAdditionalCodesTab();
        model.loadAdditionalCodes().then(function (cdAdco) {
            if (cdAdco.adcoGroups.length > 0 || cdAdco.meursingApplicable) {
                deferred.resolve(true);
            } else if (CONSTANTS.showOptionalAdditionalCodes) {
                model.loadOptionalAdditionalCodes().then(function (cdOptAdco) {
                    if (cdOptAdco.items.length > 0 && calculationInput.tradeDirection === 'I') {
                        deferred.resolve(true);
                    } else {
                        deferred.resolve(false);
                    }
                }, function (error) {
                    deferred.reject(error);
                });
            } else {
                deferred.resolve(false);
            }
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.shouldGoToTabDocuments = function () {
        var deferred = $q.defer();

        //Reset previous data of documents tab before checking
        model.resetDocumentsTab();
        model.loadDocuments().then(function (result) {
            if (result.items.length > 0) {
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.shouldGoToTabUnits = function () {
        var deferred = $q.defer();

        //Reset previous data in the units tab before checking
        model.resetMeasurementUnitsTab();
        model.loadMeasurementUnits().then(function (result) {
            if (result.count > 0) {
                model.measurementUnits = [];
                for (var i = 0; i < result.count; i++) {
                    model.measurementUnits[i] = {
                        id: result.items[i].id,
                        descriptions: result.items[i].descriptions,
                        value: null
                    };
                }
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.shouldGoToTabSecurity = function () {
        var deferred = $q.defer();

        //Reset previous data in the security tab before checking
        model.resetSecurityTab();
        model.loadResults().then(function (result) {
            if (result.calculations !== null) {
                for (var i = 0; i < result.calculations.length; i++) {
                    var calculation = result.calculations[i];
                    if ((calculation.type === 'NO' || calculation.type === 'UV') && calculation.securityItems) {
                        var securitySize = calculation.securityItems.length;
                        for (var j = 0; j < securitySize; j++) {
                            if (calculation.securityItems[j].securityType === 'QUOTA') {
                                model.quotaSecurities.push(calculation.securityItems[j]);
                            }
                        }
                    }
                }
            }

            if (!CONSTANTS.enableSecurityTab) {
                deferred.resolve(false);
            } else {

                //Select the first quota security by default
                if (model.quotaSecurities.length >= 1) {
                    calculationInput.selectedQuotaSecurity = model.quotaSecurities[0].measureSid + "";
                }

                if (model.quotaSecurities.length > 1 || model.quotaSecurities.length === 1 && CONSTANTS.selectIfOneSecurityItem) {
                    deferred.resolve(true);
                } else {
                    deferred.resolve(false);
                }
            }
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.shouldGoToTabResults = function () {
        var deferred = $q.defer();

        //Reset the result tab
        model.resetResultsTab();
        model.updateCalculationResults(calculationResult);
        deferred.resolve(true);

        return deferred.promise;
    };

    model.updateCalculationResults = function (calculationResult) {
        if (calculationResult.measures !== null && calculationResult.calculations !== null) {
            for (var i = 0; i < calculationResult.calculations.length; i++) {
                var calculation = calculationResult.calculations[i];
                if (calculation.type === 'NO') {
                    model.noAmounts = model.getAmounts(calculation.dutyItems);
                    model.noSummary = calculation.dutyItemsSummary;
                    model.noSecAmounts = model.getSecurityAmounts(calculation.securityItems);
                } else if (calculation.type === 'SIV') {
                    model.sivAmounts = model.getAmounts(calculation.dutyItems);
                    model.sivSummary = calculation.dutyItemsSummary;
                    model.sivSecAmounts = model.getSecurityAmounts(calculation.securityItems);
                } else if (calculation.type === 'UV') {
                    model.uvAmounts = model.getAmounts(calculation.dutyItems);
                    model.uvSummary = calculation.dutyItemsSummary;
                    model.uvSecAmounts = model.getSecurityAmounts(calculation.securityItems);
                }
            }
            model.calculationsTabsEnabled = !(model.sivAmounts.length === 0 && model.uvAmounts.length === 0);
            model.calculationMeasures = [];
            for (var _i = 0; _i < calculationResult.measures.length; _i++) {
                if (model.isQuotaSecurityMeasure(calculationResult.measures[_i].sid) && calculationResult.measures[_i].sid + "" !== calculationInput.selectedQuotaSecurity) {
                    continue;
                }
                model.calculationMeasures.push(calculationResult.measures[_i]);
            }
        }
    };

    model.isQuotaSecurityMeasure = function (measureSid) {
        if (model.quotaSecurities) {
            var size = model.quotaSecurities.length;
            for (var i = 0; i < size; i++) {
                if (model.quotaSecurities[i].measureSid === measureSid) {
                    return true;
                }
            }
        }
        return false;
    };

    model.getAmounts = function (dutyItems) {
        var amounts = [];
        var i, j;
        var idx = 0;
        if (dutyItems === null) {
            return amounts;
        }
        for (var _i2 = 0; _i2 < dutyItems.length; _i2++) {
            var dutyItem = dutyItems[_i2];
            if (!dutyItem.amounts) {
                continue;
            }
            for (var _j = 0; _j < dutyItem.amounts.length; _j++) {
                var amount = {};
                if (_j === 0) {
                    amount.dutyItem = dutyItem;
                } else {
                    amount.dutyItem = null;
                }
                amount.amount = dutyItem.amounts[_j];
                amounts[idx] = amount;
                idx++;
            }
        }
        return amounts;
    };

    model.getSecurityAmounts = function (dutyItems) {
        var amounts = [];
        var i, j;
        var idx = 0;
        if (dutyItems === null) {
            return amounts;
        }
        for (var _i3 = 0; _i3 < dutyItems.length; _i3++) {
            var dutyItem = dutyItems[_i3];
            if (dutyItem.securityType === "QUOTA" && dutyItem.measureSid + "" !== calculationInput.selectedQuotaSecurity) {
                continue;
            }
            var amount = {};
            amount.dutyItem = dutyItem;
            amount.vatItem = dutyItem.vatSecurityItem;
            amounts[idx] = amount;
            idx++;
        }
        return amounts;
    };

    model.getAdditionalCodes = function () {
        return model.additionalCodes;
    };

    model.getOptionalAdditionalCodes = function () {
        return model.optionalAdditionalCodes;
    };

    model.getDocuments = function () {
        return model.documents;
    };
}]);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Model for getting monetary unit data
 */
angular.module('taric.model.er', ['common.helper', 'ngResource', 'common.config']).factory('ExchangeRates', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/moun/er/exchangerates', {}, {
        queryMonetaryExchangePeriodWithRateDirection: {
            method: 'GET',
            isArray: false
        },
        exchangeMoneyForGUI: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/moun/er/calculateexchangerate'
        }
    });
}]).service('ExchangeRatesModel', ["$q", "ExchangeRates", "CommonHelper", "$translate", "CONSTANTS", function ($q, ExchangeRates, CommonHelper, $translate, CONSTANTS) {
    var model = this;

    var searchCriteria = {},
        calculateCriteria = {},
        calculateExchangeRateResult = {};

    model.customsValueMonetaryUnits = { count: 0, items: [] };

    var searchExchangesRateInput = {
        currency: CONSTANTS.installationCurrency,
        fromDate: new Date(),
        toDate: null,
        language: CommonHelper.getLanguageCode($translate.use())
    };

    model.getSearchExchangeRatesInput = function () {
        return searchExchangesRateInput;
    };

    model.getCalculateExchangeRateResult = function () {
        return calculateExchangeRateResult;
    };

    model.resetCalculateResult = function () {
        calculateExchangeRateResult = {};
        calculateExchangeRateResult.amount = '0';
        calculateExchangeRateResult.amountEUR = '0';
    };

    model.getSearchCriteria = function () {
        return searchCriteria;
    };

    model.getCalculateCriteria = function () {
        return calculateCriteria;
    };

    model.resetSearchCriteria = function () {
        // Set the default search criteria when the model is initialized
        searchCriteria = {};
        searchCriteria.fromDate = new Date();
        searchCriteria.toDate = null;
        searchCriteria.language = CommonHelper.getLanguageCode($translate.use());
        searchCriteria.ascending = true;
    };

    model.resetCalculateCriteria = function () {
        // Set the default calculate criteria when the model is initialized
        calculateCriteria = {};
        calculateCriteria.amount = '0';
        calculateCriteria.exchangeDate = new Date();
        calculateCriteria.fromCurrency = CONSTANTS.installationCurrency;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetCalculateCriteria();
        model.resetCalculateResult();
    };

    model.reset();

    model.queryMonetaryExchangePeriodWithRateDirection = function (pageNumber) {
        var deferred = $q.defer();

        var options = {
            currency: CommonHelper.removeSpaceCharacters(searchCriteria.monetaryUnit),
            fromDate: CommonHelper.getRestDateString(searchCriteria.fromDate),
            toDate: CommonHelper.getRestDateString(searchCriteria.toDate),
            language: CommonHelper.getLanguageCode($translate.use()),
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol
        };

        if (pageNumber) {
            options.offset = CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = ExchangeRates.queryMonetaryExchangePeriodWithRateDirection(options, function () {
            var searchExchangeRatesResult = {};
            searchExchangeRatesResult.totalItems = result.count;
            searchExchangeRatesResult.monetaryExchangePeriods = result.items;

            if (pageNumber) {
                searchExchangeRatesResult.currentPage = pageNumber;
            }

            deferred.resolve(searchExchangeRatesResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.calculateExchangeRate = function () {
        var deferred = $q.defer();

        var options = {
            amount: CommonHelper.getDecimalNumber(calculateCriteria.amount),
            fromCurrency: CommonHelper.removeSpaceCharacters(calculateCriteria.fromCurrency),
            exchangeDate: CommonHelper.getRestDateString(calculateCriteria.exchangeDate)
        };

        var result = ExchangeRates.exchangeMoneyForGUI(options, function () {
            calculateExchangeRateResult = {};
            calculateExchangeRateResult.amount = result.amount;
            calculateExchangeRateResult.amountEUR = result.amountEUR;
            deferred.resolve(calculateExchangeRateResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pbo on 21/04/16.
 */

angular.module('taric.model.meursing', ['common.helper', 'ngResource', 'common.config']).factory('Meursing', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/meur/meursingitems', {}, {
        queryItems: {
            method: 'GET',
            isArray: false
        },
        querySecondaryItems: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/meur/secondaryMeursingitems'
        },
        getMeursingResult: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/meur/meursingResult'
        }
    });
}]).service('MeursingModel', ["$q", "Meursing", "CommonHelper", "CONSTANTS", "$translate", function ($q, Meursing, CommonHelper, CONSTANTS, $translate) {
    var model = this;

    var searchCriteria = {};
    model.reset = function () {
        model.cancelButtonEnabled = false;
        model.from = null;
        model.milkFatList = { "items": [] };
        model.milkProteinsList = { "items": [] };
        model.starchGlucoseList = { "items": [] };
        model.sucroseIsoglucoseList = { "items": [] };
        model.meursingResult = { "additionalCode": null };
        model.countriesAndRegions = { "count": 0, "items": [] };
        model.dutyMonetaryUnits = { "count": 0, "items": [] };
        model.meursingLinks = { "count": 0, "items": [] };
        model.initSearchCriteria();
    };

    model.resetSearchResult = function () {
        model.meursingResult = { "additionalCode": null };
    };

    model.initSearchCriteria = function () {
        var p = model.getSearchCriteria();
        p.language = CommonHelper.getLanguageCode($translate.use());
        p.simulationDate = new Date();
        p.dutyCurrency = CONSTANTS.installationCurrency;
        p.country = null;
        p.useAdditionalCode = false;
        p.additionalCode = null;
        p.milkFatId = null;
        p.milkProteinId = null;
        p.starchGlucoseId = null;
        p.sucroseIsoglucoseId = null;
    };

    model.getSearchCriteria = function () {
        return searchCriteria;
    };

    model.initMeursingItemLists = function (simulationDate) {
        var deferred = $q.defer();
        Meursing.queryItems({
            simulationdate: CommonHelper.getRestDateString(simulationDate)
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.updateMilkProteinItems = function (milkFatId, simulationDate) {
        var deferred = $q.defer();
        Meursing.querySecondaryItems({
            id: milkFatId,
            simulationdate: CommonHelper.getRestDateString(simulationDate)
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.updateSucroseIsoglucoseItems = function (starchGlucoseId, simulationDate) {
        var deferred = $q.defer();
        Meursing.querySecondaryItems({
            id: starchGlucoseId,
            simulationdate: CommonHelper.getRestDateString(simulationDate)
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getMeursingResult = function () {
        var deferred = $q.defer();
        var p = model.getSearchCriteria();
        if (p.useAdditionalCode) {
            Meursing.getMeursingResult({
                simulationdate: CommonHelper.getRestDateString(p.simulationDate),
                dutyamountMonetaryunit: p.dutyCurrency,
                countryCode: p.country,
                useAdditionalCode: p.useAdditionalCode,
                additionalCode: p.additionalCode
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            Meursing.getMeursingResult({
                simulationdate: CommonHelper.getRestDateString(p.simulationDate),
                dutyamountMonetaryunit: p.dutyCurrency,
                countryCode: p.country,
                useAdditionalCode: p.useAdditionalCode,
                milkFatId: p.milkFatId,
                milkProteinId: p.milkProteinId,
                starchGlucoseId: p.starchGlucoseId,
                sucroseIsoglucoseId: p.sucroseIsoglucoseId
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };
}]);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
angular.module('taric.duty', ['taric.duty.calculate', 'taric.duty.exchangerates', 'taric.duty.meursing']).config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.duty', {
        abstract: true,
        url: '/duty',
        template: '<ui-view></ui-view>'
    }).state('taric.duty.calculate', {
        url: '/calculate?frm&cc&sd&d&ads&co&cu&ad&ur&pv',
        templateUrl: 'taric/duties/calculate/cd.tmpl.html',
        resolve: {
            initializeCalculateDuty: ["CalculateDutyModel", "$stateParams", function initializeCalculateDuty(CalculateDutyModel, $stateParams) {
                if (!$stateParams.ad) {
                    CalculateDutyModel.initializeCalculateDuty();
                }
            }],
            goToDataTab: ["CalculateDutyModel", "$stateParams", "$filter", "CommonHelper", function goToDataTab(CalculateDutyModel, $stateParams, $filter, CommonHelper) {
                if ($stateParams.frm) {
                    // Reset Calculation Result when opening Calculate Duty use case from other use cases.
                    CalculateDutyModel.resetCalculationResult();

                    if ($stateParams.cc) {
                        CalculateDutyModel.getCalculationInput().commodityCode = $filter('commodityCode')($stateParams.cc);
                    }
                    if ($stateParams.d) {
                        if ($stateParams.d === 'I' || $stateParams.d === 'E') {
                            CalculateDutyModel.getCalculationInput().tradeDirection = $stateParams.d;
                        }
                    }
                    if ($stateParams.sd) {
                        var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                        if (inputDate) {
                            CalculateDutyModel.getCalculationInput().simulationDate = inputDate;
                            CalculateDutyModel.updateCalculationSupportVersion();
                        }
                    }

                    CalculateDutyModel.goToNextTab('commodity');

                    if ($stateParams.co) {
                        CalculateDutyModel.getCalculationInput().country = $stateParams.co;

                        CalculateDutyModel.getPreferenceCodesAndSupplementaryUnit(CalculateDutyModel.getCalculationInput().commodityCode, CalculateDutyModel.getCalculationInput().country, CalculateDutyModel.getCalculationInput().simulationDate, CalculateDutyModel.getCalculationInput().tradeDirection, CalculateDutyModel.getCalculationInput().countryOfPreferentialOrigin, CalculateDutyModel.getCalculationInput().version).then(function (result) {

                            CalculateDutyModel.preferenceCodesAndSupplementaryUnit = result;
                        });
                        CalculateDutyModel.getCalculationInput().preferenceCode = null;
                    }

                    if ($stateParams.ur) {
                        CalculateDutyModel.getCalculationInput().includeUnreleased = $stateParams.ur === 'true';
                    }
                }
            }],
            goToAdditionalCodesTab: ["CalculateDutyModel", "$stateParams", function goToAdditionalCodesTab(CalculateDutyModel, $stateParams) {
                // If return from search meursing additional code
                if ($stateParams.ad) {
                    // Return from meursing search with additional code
                    if ($stateParams.ad === '7XXX') {
                        // Dummy value for "not selected"
                        CalculateDutyModel.meursingAdditionalCode = null;
                    } else {
                        CalculateDutyModel.meursingAdditionalCode = $stateParams.ad;
                    }
                    CalculateDutyModel.goToNextTab('data');
                }
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/duties/calculate');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.duty.exchangerates', {
        url: '/exchangerates?mu&ds&de&l',
        templateUrl: 'taric/duties/exchangerates/er-exchangerates.tmpl.html',
        controller: 'ExchangeRatesController as exchangeRatesCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["ExchangeRatesModel", "$stateParams", "$translate", "CommonHelper", function initializeData(ExchangeRatesModel, $stateParams, $translate, CommonHelper) {
                ExchangeRatesModel.reset();
                if ($stateParams.mu) {
                    ExchangeRatesModel.getSearchCriteria().monetaryUnit = $stateParams.mu;
                }
                if ($stateParams.ds) {
                    var fromDate = CommonHelper.parseInputDate($stateParams.ds);
                    if (fromDate) {
                        ExchangeRatesModel.getSearchCriteria().fromDate = fromDate;
                    }
                }
                if ($stateParams.de) {
                    var toDate = CommonHelper.parseInputDate($stateParams.de);
                    if (toDate) {
                        ExchangeRatesModel.getSearchCriteria().toDate = toDate;
                    }
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            monetaryUnits: ["MonetaryUnitsModel", "ExchangeRatesModel", function monetaryUnits(MonetaryUnitsModel, ExchangeRatesModel) {
                return MonetaryUnitsModel.customsValueMonetaryUnits(ExchangeRatesModel.getSearchCriteria().fromDate);
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/duties/exchangerates');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.duty.meursing', {
        url: '/meursing?sd&cu&co&ad&mf&mp&sg&si&l&frm',
        templateUrl: 'taric/duties/meursing/meursing-search.tmpl.html',
        controller: 'SearchMeursingController as searchMeursingCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["$stateParams", "MeursingModel", "CommonHelper", "$translate", function initializeData($stateParams, MeursingModel, CommonHelper, $translate) {
                if ($stateParams.frm !== 'adcoLookup') {
                    MeursingModel.reset();
                    if ($stateParams.frm) {
                        MeursingModel.cancelButtonEnabled = true;
                        MeursingModel.from = $stateParams.frm;
                    }
                } else {
                    MeursingModel.resetSearchResult();
                }
                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        MeursingModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.cu) {
                    MeursingModel.getSearchCriteria().dutyCurrency = $stateParams.cu;
                }
                if ($stateParams.co) {
                    MeursingModel.getSearchCriteria().country = $stateParams.co;
                }
                if ($stateParams.ad) {
                    MeursingModel.getSearchCriteria().useAdditionalCode = true;
                    MeursingModel.getSearchCriteria().additionalCode = $stateParams.ad;
                } else {
                    if ($stateParams.mf) {
                        MeursingModel.getSearchCriteria().milkFatId = $stateParams.mf;
                    }
                    if ($stateParams.mp) {
                        MeursingModel.getSearchCriteria().milkProteinId = $stateParams.mp;
                    }
                    if ($stateParams.sg) {
                        MeursingModel.getSearchCriteria().starchGlucoseId = $stateParams.sg;
                    }
                    if ($stateParams.si) {
                        MeursingModel.getSearchCriteria().sucroseIsoglucoseId = $stateParams.si;
                    }
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            countries: ["GeographicalAreaModel", "MeursingModel", "$stateParams", function countries(GeographicalAreaModel, MeursingModel, $stateParams) {
                var result = null;
                // Only get countries to support bookmark when there are required parameters.
                if (!$stateParams.frm && $stateParams.sd && $stateParams.cu && $stateParams.co) {
                    result = GeographicalAreaModel.getCountriesOfOrigin(MeursingModel.getSearchCriteria().simulationDate);
                }
                return result;
            }],
            currencies: ["MonetaryUnitsModel", "MeursingModel", function currencies(MonetaryUnitsModel, MeursingModel) {
                return MonetaryUnitsModel.dutyMonetaryUnits(MeursingModel.getSearchCriteria().simulationDate);
            }],
            meursingItemLists: ["MeursingModel", "$stateParams", function meursingItemLists(MeursingModel, $stateParams) {
                var result = null;
                // Only get meursingItemLists when it is not searched with additional code.
                if (!$stateParams.ad) {
                    result = MeursingModel.initMeursingItemLists(MeursingModel.getSearchCriteria().simulationDate);
                }
                return result;
            }],
            milkProteinsList: ["MeursingModel", "$stateParams", function milkProteinsList(MeursingModel, $stateParams) {
                var result = null;
                // Only get milkProteinsList when it is not searched with additional code.
                if (!$stateParams.ad && $stateParams.mf) {
                    result = MeursingModel.updateMilkProteinItems($stateParams.mf, MeursingModel.getSearchCriteria().simulationDate);
                }
                return result;
            }],
            sucroseIsoglucoseList: ["MeursingModel", "$stateParams", function sucroseIsoglucoseList(MeursingModel, $stateParams) {
                var result = null;
                // Only get sucroseIsoglucoseList when it is not searched with additional code.
                if (!$stateParams.ad && $stateParams.sg) {
                    result = MeursingModel.updateSucroseIsoglucoseItems($stateParams.sg, MeursingModel.getSearchCriteria().simulationDate);
                }
                return result;
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/duties/meursing');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.enablePrintable();
                MenuModel.disableExportable();
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.footnote.lookup', ['taric.model.footnote', 'common.filter.footnote', 'common.helper']).controller('FootnoteLookupController', ["CONSTANTS", "FootnoteLookupModel", "CommonHelper", "footnoteTypes", "$state", "$stateParams", "$rootScope", "$timeout", function (CONSTANTS, FootnoteLookupModel, CommonHelper, footnoteTypes, $state, $stateParams, $rootScope, $timeout) {
    var footnoteLookupCtrl = this;

    footnoteLookupCtrl.init = function () {
        // If an invalid footnoteType is passed as parameter from other use cases, it needs to be set to null.
        if (FootnoteLookupModel.getSearchCriteria().footnoteType) {
            var validFootnoteType = false;
            for (var i = 0; i < footnoteTypes.items.length; i++) {
                if (FootnoteLookupModel.getSearchCriteria().footnoteType === footnoteTypes.items[i].type) {
                    validFootnoteType = true;
                    break;
                }
            }
            if (!validFootnoteType) {
                FootnoteLookupModel.getSearchCriteria().footnoteType = null;
            }
        }

        footnoteLookupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        footnoteLookupCtrl.searchCriteria = FootnoteLookupModel.getSearchCriteria();
        footnoteLookupCtrl.searchResult = FootnoteLookupModel.getSearchResult();
        footnoteLookupCtrl.dateFormat = CONSTANTS.dateFormat;
        footnoteLookupCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        footnoteLookupCtrl.installationCountry = CONSTANTS.installationCountry;
        footnoteLookupCtrl.footnoteTypes = footnoteTypes;
    };

    footnoteLookupCtrl.search = function () {
        //Load data for the first page
        this.loadDataFromServer(1);
    };

    //Load data for a given page
    footnoteLookupCtrl.loadDataFromServer = function (page) {
        // Reset search result before searching
        footnoteLookupCtrl.resetSearchResult();
        footnoteLookupCtrl.searching = true;
        FootnoteLookupModel.searchFootnotes(page).then(function (searchResult) {
            footnoteLookupCtrl.searchResult = searchResult;
            footnoteLookupCtrl.searching = false;
        }, function (error) {
            footnoteLookupCtrl.errorCode = error.data.code;
            footnoteLookupCtrl.errorParams = error.data.params;
            footnoteLookupCtrl.searching = false;
        });
    };

    footnoteLookupCtrl.resetSearchResult = function () {
        footnoteLookupCtrl.searchResult = null;
        FootnoteLookupModel.resetSearchResult();
    };

    //Handle page change for the Additional code search result table
    footnoteLookupCtrl.searchResultPageChanged = function (page) {
        footnoteLookupCtrl.loadDataFromServer(page);
    };

    footnoteLookupCtrl.openDatePicker = function ($event) {
        footnoteLookupCtrl.isDatePickerOpen = true;
    };

    footnoteLookupCtrl.resetError = function () {
        footnoteLookupCtrl.handleError(null);
    };

    footnoteLookupCtrl.handleError = function (error) {
        if (!error) {
            footnoteLookupCtrl.errorCode = null;
            footnoteLookupCtrl.errorParams = null;
        } else {
            footnoteLookupCtrl.errorCode = error.errorCode;
            footnoteLookupCtrl.errorParams = error.errorParams;
        }
    };

    footnoteLookupCtrl.returnToCallerPage = function (footnoteTypeAndId) {
        // Do not return simulationDate to CallerPage to avoid affecting other search criteria.
        $state.go($stateParams.frm, {
            fn: CommonHelper.removeSpaceCharacters(footnoteTypeAndId),
            frm: 'footnoteLookup'
        });
    };

    footnoteLookupCtrl.onChangeFootnote = function () {
        footnoteLookupCtrl.searchCriteria.footnoteId = footnoteLookupCtrl.searchCriteria.footnoteId.toUpperCase();
    };

    footnoteLookupCtrl.hasNationalFootnoteTypes = function () {
        var nationalFootnoteTypes = footnoteLookupCtrl.footnoteTypes.items.filter(function (footnoteType) {
            return footnoteType.national === true;
        });
        return nationalFootnoteTypes.length > 0;
    };

    footnoteLookupCtrl.isTooltipEnable = function (descriptions) {
        return CommonHelper.isTooltipEnable(descriptions);
    };

    footnoteLookupCtrl.onDateChange = function (dateString) {
        footnoteLookupCtrl.resetError();
        footnoteLookupCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(footnoteLookupCtrl.searchCriteria.simulationDate, dateString);
    };

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        footnoteLookupCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            footnoteLookupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var taricFootnote = angular.module('taric.footnote', ['taric.footnote.lookup', 'taric.footnote.view']);
taricFootnote.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.footnote', {
        abstract: true,
        url: '/footnote',
        template: '<ui-view></ui-view>'
    }).state('taric.footnote.lookup', {
        url: '/lookup?frm&sd&fo',
        templateUrl: 'taric/footnote/lookup/footnote-lookup.tmpl.html',
        controller: 'FootnoteLookupController as footnoteLookupCtrl',
        resolve: {
            initializeSearchCriteria: ["FootnoteLookupModel", "$stateParams", "CommonHelper", function initializeSearchCriteria(FootnoteLookupModel, $stateParams, CommonHelper) {
                FootnoteLookupModel.resetSearchCriteria();
                FootnoteLookupModel.resetSearchResult();

                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        FootnoteLookupModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.fo && $stateParams.fo.length === 5) {
                    FootnoteLookupModel.getSearchCriteria().footnoteType = $stateParams.fo.substr(0, 2);
                    FootnoteLookupModel.getSearchCriteria().footnoteId = $stateParams.fo.substr(2, 4);
                } else if ($stateParams.fo && $stateParams.fo.length === 8) {
                    FootnoteLookupModel.getSearchCriteria().footnoteType = $stateParams.fo.substr(0, 3);
                    FootnoteLookupModel.getSearchCriteria().footnoteId = $stateParams.fo.substr(3, 7);
                }
            }],
            footnoteTypes: ["FootnoteTypeModel", function footnoteTypes(FootnoteTypeModel) {
                return FootnoteTypeModel.queryFootnoteTypes();
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/footnote');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.footnote.view', {
        url: '/view?sd&fn',
        templateUrl: 'taric/footnote/view/footnote-view.tmpl.html',
        controller: 'ViewFootnoteController as viewFootnoteCtrl',
        resolve: {
            footnote: ["FootnotePopupModel", "$stateParams", "CommonHelper", function footnote(FootnotePopupModel, $stateParams, CommonHelper) {
                if ($stateParams.sd && $stateParams.fn) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        return FootnotePopupModel.findFootnote($stateParams.fn, inputDate);
                    }
                }

                return null;
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/nomenclature/sbt');
            }],

            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.footnote.view', ['taric.model.footnote']).controller('ViewFootnoteController', ["footnote", "CONSTANTS", function (footnote, CONSTANTS) {
    var viewFootnoteCtrl = this;

    viewFootnoteCtrl.init = function () {
        viewFootnoteCtrl.dateFormat = CONSTANTS.dateFormat;
        viewFootnoteCtrl.selectedRow = footnote;
        viewFootnoteCtrl.descriptionLanguages = [];
        if (viewFootnoteCtrl.selectedRow) {
            // Sort languages of additional code descriptions
            for (var lang in viewFootnoteCtrl.selectedRow.descriptions) {
                viewFootnoteCtrl.descriptionLanguages.push(lang);
            }
            viewFootnoteCtrl.descriptionLanguages.sort();
        }
    };
}]);

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.measure.ccrm', ['common.model.geoarea', 'common.model.measuretype', 'common.template.geoarea.popup', 'taric.model.measure', 'common.template.measure.popup', 'common.template.additional-code.popup', 'common.template.condition.popup', 'taric.model.footnote', 'common.template.footnote.popup', 'common.helper', 'common.filter.measuretype.description', 'common.filter.geographicalarea.description', 'common.filter.truncateLongText', 'common.directive.country', 'taric.auth.model', 'common.filter.dutyexpression.description']).controller('SearchMeasuresByCCController', ["CONSTANTS", "$translatePartialLoader", "MeasureTypeModel", "MeasureByCCSearchModel", "$uibModal", "GeographicalAreaModel", "$state", "CommonHelper", "measureTypes", "$filter", "$translate", "$rootScope", "$scope", "AuthorizeModel", "$timeout", "$stateParams", "countries", "$location", function (CONSTANTS, $translatePartialLoader, MeasureTypeModel, MeasureByCCSearchModel, $uibModal, GeographicalAreaModel, $state, CommonHelper, measureTypes, $filter, $translate, $rootScope, $scope, AuthorizeModel, $timeout, $stateParams, countries, $location) {
    var searchMeasuresByCCCtrl = this;
    var model = MeasureByCCSearchModel;
    searchMeasuresByCCCtrl.init = function () {
        searchMeasuresByCCCtrl.searchCriteria = MeasureByCCSearchModel.getSearchCriteria();
        searchMeasuresByCCCtrl.installationCountry = CONSTANTS.installationCountry;
        searchMeasuresByCCCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        searchMeasuresByCCCtrl.dateFormat = CONSTANTS.dateFormat;
        searchMeasuresByCCCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        searchMeasuresByCCCtrl.searchMeasureResult = MeasureByCCSearchModel.getSearchMeasureResult();
        searchMeasuresByCCCtrl.measureTypes = measureTypes;
        searchMeasuresByCCCtrl.controlCountry = {};
        searchMeasuresByCCCtrl.releaseManagement = CONSTANTS.releaseManagement;

        // get valid MeasureType
        if (measureTypes) {
            searchMeasuresByCCCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(measureTypes.items, searchMeasuresByCCCtrl.searchCriteria.measureType, null);
        }

        searchMeasuresByCCCtrl.model = MeasureByCCSearchModel;
        searchMeasuresByCCCtrl.model.loggedIn = AuthorizeModel.loggedIn;
        if (CONSTANTS.releaseManagement && AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer()) {
            searchMeasuresByCCCtrl.model.includeUnreleased = true;
            searchMeasuresByCCCtrl.showIncludeUnreleased = true;
        } else {
            searchMeasuresByCCCtrl.model.includeUnreleased = false;
            searchMeasuresByCCCtrl.showIncludeUnreleased = false;
        }

        if (searchMeasuresByCCCtrl.isExternalLink() && searchMeasuresByCCCtrl.validateExternalParameters()) {
            if (countries) {

                // get valid CountryCode
                searchMeasuresByCCCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(countries.items, searchMeasuresByCCCtrl.searchCriteria.country, null);
            }

            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            searchMeasuresByCCCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    searchMeasuresByCCCtrl.isExternalLink = function () {
        return (!$stateParams.frm || $stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'ccView') && $stateParams.sd && $stateParams.cc;
    };

    //Check whether the external parameters are valid or not
    searchMeasuresByCCCtrl.validateExternalParameters = function () {
        searchMeasuresByCCCtrl.resetError();
        return !searchMeasuresByCCCtrl.isCommodityTooShort() && searchMeasuresByCCCtrl.validateCommodityCode() && searchMeasuresByCCCtrl.validateSimulationDate();
    };

    searchMeasuresByCCCtrl.openDatePicker = function ($event) {
        searchMeasuresByCCCtrl.isDatePickerOpen = true;
    };

    searchMeasuresByCCCtrl.onDateChange = function (dateString) {
        searchMeasuresByCCCtrl.resetError();
        searchMeasuresByCCCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchMeasuresByCCCtrl.searchCriteria.simulationDate, dateString);
        if (searchMeasuresByCCCtrl.searchCriteria.simulationDate) {
            searchMeasuresByCCCtrl.loadingReferenceData = true;
            searchMeasuresByCCCtrl.controlCountry.reload(searchMeasuresByCCCtrl.searchCriteria.simulationDate).then(function () {
                searchMeasuresByCCCtrl.loadingReferenceData = false;
            }, function (error) {
                searchMeasuresByCCCtrl.errorCode = error.data.code;
                searchMeasuresByCCCtrl.errorParams = error.data.params;
                searchMeasuresByCCCtrl.errorType = error.data.type;
                searchMeasuresByCCCtrl.loadingReferenceData = false;
            });

            searchMeasuresByCCCtrl.reloadMeasureTypes();
        }
    };

    searchMeasuresByCCCtrl.reloadMeasureTypes = function () {
        MeasureTypeModel.getMeasureTypes(searchMeasuresByCCCtrl.searchCriteria.direction, searchMeasuresByCCCtrl.searchCriteria.simulationDate).then(function (measureTypes) {
            searchMeasuresByCCCtrl.measureTypes = measureTypes;

            searchMeasuresByCCCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(measureTypes.items, searchMeasuresByCCCtrl.searchCriteria.measureType, null);
        });
    };

    searchMeasuresByCCCtrl.search = function () {
        //Load data for the first page
        searchMeasuresByCCCtrl.loadDataFromServer(1);
    };

    //Load data for a given page
    searchMeasuresByCCCtrl.loadDataFromServer = function (pageNumber) {
        if (!searchMeasuresByCCCtrl.validateSearchForm()) {
            return;
        }

        searchMeasuresByCCCtrl.loadDataFromServerWithoutValidation(pageNumber);
    };

    //Load data for a given page without validation
    searchMeasuresByCCCtrl.loadDataFromServerWithoutValidation = function (pageNumber) {
        // Reset search result before searching
        searchMeasuresByCCCtrl.resetSearchResult();
        searchMeasuresByCCCtrl.searching = true;
        MeasureByCCSearchModel.searchMeasure(pageNumber).then(function (searchMeasureResult) {
            searchMeasuresByCCCtrl.searchMeasureResult = searchMeasureResult;
            searchMeasuresByCCCtrl.searching = false;

            searchMeasuresByCCCtrl.searchMeasureResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchMeasuresByCCCtrl.searchCriteria.simulationDate);
            if (searchMeasuresByCCCtrl.searchMeasureResult.infoCode && "i8n.common.pastDate" === searchMeasuresByCCCtrl.searchMeasureResult.infoCode) {
                searchMeasuresByCCCtrl.searchMeasureResult.infoParams = CONSTANTS.pastDate;
            }

            searchMeasuresByCCCtrl.updateBrowserURL();
        }, function (error) {
            searchMeasuresByCCCtrl.errorCode = error.data.code;
            searchMeasuresByCCCtrl.errorParams = error.data.params;
            searchMeasuresByCCCtrl.errorType = error.data.type;
            searchMeasuresByCCCtrl.searching = false;

            if (searchMeasuresByCCCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    /**
     * Query measures by commodity codes
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/measure/ccrm/search?sd={SimulationDate}&d={TradeDirection}&cc={CommodityCode}&mt={MeasureType}&co={Country}&l={Language}
     *
     * Example:
     * http://www.testenv.se/arctictariff-public-web/#!/taric/measure/ccrm/search?sd=2015-01-01&d=I&cc=1005109000&mt=103&co=US&l=en
     */
    searchMeasuresByCCCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep additional parameters because there is no return to caller page
        $location.search({
            sd: CommonHelper.getBookmarkDateString(searchMeasuresByCCCtrl.searchCriteria.simulationDate),
            d: searchMeasuresByCCCtrl.searchCriteria.direction,
            cc: CommonHelper.removeSpaceCharacters(searchMeasuresByCCCtrl.searchCriteria.commodityCode),
            mt: searchMeasuresByCCCtrl.searchCriteria.measureType,
            co: searchMeasuresByCCCtrl.searchCriteria.country,
            l: $translate.use()
        }).replace();
    };

    $rootScope.$on('clearSearchResult', function (event, data) {

        // If token has become invalid
        model.reset();
        searchMeasuresByCCCtrl.searchCriteria = model.getSearchCriteria();
        searchMeasuresByCCCtrl.controlCountry.reload(searchMeasuresByCCCtrl.searchCriteria.simulationDate);
        searchMeasuresByCCCtrl.reloadMeasureTypes();
    });

    searchMeasuresByCCCtrl.resetSearchResult = function () {
        searchMeasuresByCCCtrl.searchMeasureResult = null;
        MeasureByCCSearchModel.resetSearchResult();
    };

    //Handle page change for the measure search result table
    searchMeasuresByCCCtrl.searchMeasureResultPageChanged = function (pageNumber) {
        searchMeasuresByCCCtrl.loadDataFromServer(pageNumber);
    };

    //Check whether the search form is valid or not
    searchMeasuresByCCCtrl.validateSearchForm = function () {
        searchMeasuresByCCCtrl.resetError();
        return !searchMeasuresByCCCtrl.isCommodityTooShort() && searchMeasuresByCCCtrl.validateCommodityCode() && searchMeasuresByCCCtrl.validateCountryCode() && searchMeasuresByCCCtrl.validateSimulationDate();
    };

    searchMeasuresByCCCtrl.validateCountryCode = function () {
        searchMeasuresByCCCtrl.errorCode = searchMeasuresByCCCtrl.controlCountry.validate();
        return searchMeasuresByCCCtrl.errorCode === null;
    };

    searchMeasuresByCCCtrl.validateCommodityCode = function () {
        searchMeasuresByCCCtrl.errorCode = CommonHelper.validateCommodityCode(searchMeasuresByCCCtrl.searchCriteria.commodityCode, searchMeasuresByCCCtrl.searchCriteria.direction);
        return searchMeasuresByCCCtrl.errorCode === null;
    };

    searchMeasuresByCCCtrl.validateSimulationDate = function () {
        if (!CONSTANTS.dateRestrictionEnabled) {
            searchMeasuresByCCCtrl.errorCode = CommonHelper.validateSimulationDate(searchMeasuresByCCCtrl.searchCriteria.simulationDate);
            if (searchMeasuresByCCCtrl.errorCode) {
                searchMeasuresByCCCtrl.errorParams = { param0: CONSTANTS.pastDate };
            }
        }
        return searchMeasuresByCCCtrl.errorCode === null;
    };

    searchMeasuresByCCCtrl.isCommodityTooShort = function () {
        if (!searchMeasuresByCCCtrl.searchCriteria.commodityCode || CommonHelper.removeSpaceCharacters(searchMeasuresByCCCtrl.searchCriteria.commodityCode).length < 4) {
            searchMeasuresByCCCtrl.errorCode = 'i8n.jsfconv.cc.atleast4';
            return true;
        }
        return false;
    };

    searchMeasuresByCCCtrl.openOriginPopup = function (size, _origin) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
            controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
            size: size,
            resolve: {
                geoAreaMemberships: function geoAreaMemberships() {
                    return GeographicalAreaModel.queryMembershipByGroupId(_origin, searchMeasuresByCCCtrl.searchCriteria.simulationDate);
                },
                origin: function origin() {
                    return _origin;
                }
            }
        });
    };

    searchMeasuresByCCCtrl.openMeasurePopup = function (size, measure) {
        var preferenceCodesForMeasureOnly = true;
        var selectedPreferenceCode = null;
        // In this case additional code array can be empty, only using measure SID in query
        var additionalCodes = [];
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/measure/measure-popup.tmpl.html',
            controller: 'MeasurePopupController as measurePopupCtrl',
            size: size,
            resolve: {
                measureExtendedInfo: ["MeasurePopupModel", function measureExtendedInfo(MeasurePopupModel) {
                    return MeasurePopupModel.getMeasureExtendedInfoForMeasureType(measure.sid, preferenceCodesForMeasureOnly, searchMeasuresByCCCtrl.searchCriteria.commodityCode, searchMeasuresByCCCtrl.searchCriteria.country, searchMeasuresByCCCtrl.searchCriteria.direction, selectedPreferenceCode, additionalCodes, searchMeasuresByCCCtrl.searchCriteria.simulationDate, null, measure.unreleased);
                }]
            }
        });
    };

    searchMeasuresByCCCtrl.openConditionPopup = function (size, measure) {
        var monetaryUnitCode = 'EUR';
        // In this case additional code array can be empty, only using measure SID in query
        var additionalCodes = [];
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/condition/condition-popup.tmpl.html',
            controller: 'ConditionPopupController as conditionPopupCtrl',
            size: size,
            resolve: {
                measureConditionHeadResult: ["ConditionPopupModel", function measureConditionHeadResult(ConditionPopupModel) {
                    return ConditionPopupModel.getMeasureExtendedInfoForMeasureConditions(measure.sid, monetaryUnitCode, additionalCodes, searchMeasuresByCCCtrl.searchCriteria.simulationDate, searchMeasuresByCCCtrl.searchCriteria.direction, measure.unreleased).then(function (measureCondition) {
                        var result = { count: 1 };
                        var items = [];
                        items.push(measureCondition);
                        result.items = items;
                        return result;
                    });
                }]
            }
        });
    };

    searchMeasuresByCCCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, searchMeasuresByCCCtrl.searchCriteria.simulationDate);
                }]
            }
        });
    };

    searchMeasuresByCCCtrl.openAdditionalCodePopup = function (size, additionalCodeId, commodityCode) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/additional-code/additional-code-popup.tmpl.html',
            controller: 'AdditionalCodePopupController as additionalCodePopupCtrl',
            size: size,
            resolve: {
                additionalCode: ["AdditionalCodePopupModel", function additionalCode(AdditionalCodePopupModel) {
                    return AdditionalCodePopupModel.findAdditionalCode(additionalCodeId, searchMeasuresByCCCtrl.searchCriteria.simulationDate, commodityCode);
                }],
                simulationDate: function simulationDate() {
                    return searchMeasuresByCCCtrl.searchCriteria.simulationDate;
                }
            }
        });
    };

    searchMeasuresByCCCtrl.openQuotaPopup = function (size, measure) {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/quota/quota-popup.tmpl.html',
            controller: 'ViewTaricQuotaController as viewTaricQuotaCtrl',
            size: size,
            resolve: {
                quotaDefinitionExtendedInfo: ["TaricQuotaSearchModel", function quotaDefinitionExtendedInfo(TaricQuotaSearchModel) {

                    var inputOrigin = measure.geographicalArea.id;
                    if (searchMeasuresByCCCtrl.searchCriteria.country !== " " && searchMeasuresByCCCtrl.searchCriteria.country) {
                        inputOrigin = searchMeasuresByCCCtrl.searchCriteria.country;
                    }

                    var quotaExtendedInfo = TaricQuotaSearchModel.getQuotaDefinitionExtendedInfo(measure.orderNumber, inputOrigin, searchMeasuresByCCCtrl.searchCriteria.simulationDate).then(function (quotaExtendedInfo) {
                        return quotaExtendedInfo;
                    }, function (error) {
                        searchMeasuresByCCCtrl.errorCode = error.data.code;
                        searchMeasuresByCCCtrl.errorParams = error.data.params;
                        searchMeasuresByCCCtrl.errorType = error.data.type;
                        return;
                    });

                    return quotaExtendedInfo;
                }],
                simulationDate: function simulationDate() {
                    return searchMeasuresByCCCtrl.searchCriteria.simulationDate;
                },
                showCancelButton: function showCancelButton() {
                    return false;
                },
                country: function country() {
                    return searchMeasuresByCCCtrl.searchCriteria.country;
                }
            }
        });
    };

    searchMeasuresByCCCtrl.selectCommodityCode = function (commodityCode, type) {

        $state.go('taric.nomenclature.sbn', {
            cc: CommonHelper.removeSpaceCharacters(commodityCode),
            sd: CommonHelper.getBookmarkDateString(searchMeasuresByCCCtrl.searchCriteria.simulationDate),
            d: searchMeasuresByCCCtrl.searchCriteria.direction, frm: 'taric.measure.ccrm', type: type
        });
    };

    searchMeasuresByCCCtrl.resetError = function () {
        searchMeasuresByCCCtrl.handleError(null);
    };

    searchMeasuresByCCCtrl.hasNationalMeasureTypes = function () {
        var nationalMeasureTypes = searchMeasuresByCCCtrl.measureTypes.items.filter(function (measureType) {
            return measureType.national === true;
        });
        return nationalMeasureTypes.length > 0;
    };

    searchMeasuresByCCCtrl.isTooltipEnable = function (descriptions) {
        return CommonHelper.isTooltipEnable(descriptions);
    };

    searchMeasuresByCCCtrl.formatCommodityCode = function () {
        var formattedCommodityCode = $filter('commodityCode')(searchMeasuresByCCCtrl.searchCriteria.commodityCode);
        searchMeasuresByCCCtrl.searchCriteria.commodityCode = formattedCommodityCode;
    };

    searchMeasuresByCCCtrl.handleError = function (error) {
        if (!error) {
            searchMeasuresByCCCtrl.errorCode = null;
            searchMeasuresByCCCtrl.errorParams = null;
        } else {
            searchMeasuresByCCCtrl.errorCode = error.errorCode;
            searchMeasuresByCCCtrl.errorParams = error.errorParams;
        }
    };

    searchMeasuresByCCCtrl.onCountryChange = function (country) {
        searchMeasuresByCCCtrl.searchCriteria.country = country;
    };

    searchMeasuresByCCCtrl.print = function (options) {

        if (!searchMeasuresByCCCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        MeasureByCCSearchModel.searchMeasure().then(function (searchMeasureResult) {

            searchMeasuresByCCCtrl.searchMeasureAllResult = searchMeasureResult;
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    flag: searchMeasuresByCCCtrl.flagImg,
                    eu: searchMeasuresByCCCtrl.euImg,
                    validDate: $filter('date')(searchMeasuresByCCCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qry.ccrm.report.report.title')
                }, 'l').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {
            searchMeasuresByCCCtrl.errorCode = error.data.code;
            searchMeasuresByCCCtrl.errorParams = error.data.params;
            searchMeasuresByCCCtrl.errorType = error.data.type;
            $rootScope.$broadcast('stopSpinningPrint');

            if (searchMeasuresByCCCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage("img/flags/EU.png", 21, 14, function (options) {

            searchMeasuresByCCCtrl.euImg = options.logo;
        }, true);

        var url = "img/flags/" + searchMeasuresByCCCtrl.installationCountry + ".png";
        CommonHelper.loadImage(url, 21, 14, function (options) {

            searchMeasuresByCCCtrl.flagImg = options.logo;
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchMeasuresByCCCtrl.print, true);
        }, true);
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        searchMeasuresByCCCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            searchMeasuresByCCCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.measure.mcc', ['common.model.geoarea', 'common.template.geoarea.popup', 'taric.model.measure', 'common.template.measure.popup', 'common.template.additional-code.popup', 'common.template.additional-codes.popup', 'common.template.condition.popup', 'taric.model.footnote', 'common.template.footnote.popup', 'common.template.footnotes.popup', 'common.helper', 'common.filter.measuretype.description', 'common.filter.geographicalarea.description', 'common.directive.country', 'taric.model.monetaryunits', 'common.filter.specialCharacterToHtml', 'taric.auth.model', 'common.filter.dutyexpression.description']).controller('SearchMeasuresForNomenclatureController', ["CONSTANTS", "$translatePartialLoader", "MeasureForNomenclatureSearchModel", "$uibModal", "GeographicalAreaModel", "$rootScope", "$scope", "$state", "$stateParams", "CommonHelper", "$filter", "$translate", "MonetaryUnitsModel", "AuthorizeModel", "$timeout", "countries", "currencies", "$location", function (CONSTANTS, $translatePartialLoader, MeasureForNomenclatureSearchModel, $uibModal, GeographicalAreaModel, $rootScope, $scope, $state, $stateParams, CommonHelper, $filter, $translate, MonetaryUnitsModel, AuthorizeModel, $timeout, countries, currencies, $location) {
    var searchMeasuresForNomCtrl = this;
    var model = MeasureForNomenclatureSearchModel;
    searchMeasuresForNomCtrl.init = function () {
        searchMeasuresForNomCtrl.searchCriteria = MeasureForNomenclatureSearchModel.getSearchCriteria();
        searchMeasuresForNomCtrl.installationCountry = CONSTANTS.installationCountry;
        searchMeasuresForNomCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        searchMeasuresForNomCtrl.dateFormat = CONSTANTS.dateFormat;
        searchMeasuresForNomCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        searchMeasuresForNomCtrl.searchMeasureResult = MeasureForNomenclatureSearchModel.getSearchMeasureResult();
        searchMeasuresForNomCtrl.controlCountry = {};
        searchMeasuresForNomCtrl.releaseManagement = CONSTANTS.releaseManagement;
        searchMeasuresForNomCtrl.currencies = currencies;

        searchMeasuresForNomCtrl.searchCriteria.currency = CommonHelper.getValidSelectedItem(searchMeasuresForNomCtrl.currencies.items, searchMeasuresForNomCtrl.searchCriteria.currency, CONSTANTS.installationCurrency);

        searchMeasuresForNomCtrl.model = MeasureForNomenclatureSearchModel;
        searchMeasuresForNomCtrl.model.loggedIn = AuthorizeModel.loggedIn;
        if (CONSTANTS.releaseManagement && AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer()) {
            searchMeasuresForNomCtrl.model.includeUnreleased = true;
            searchMeasuresForNomCtrl.showIncludeUnreleased = true;
        } else {
            searchMeasuresForNomCtrl.model.includeUnreleased = false;
            searchMeasuresForNomCtrl.showIncludeUnreleased = false;
        }

        // Auto-search when "Measures for nomenclature" is opened from other use cases:
        // "Query by nomenclature", "View quota", "Meursing"
        if (searchMeasuresForNomCtrl.shouldReload() && searchMeasuresForNomCtrl.validateExternalParameters()) {
            if (countries) {

                // get valid CountryCode
                searchMeasuresForNomCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(countries.items, searchMeasuresForNomCtrl.searchCriteria.country, null);
            }

            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            searchMeasuresForNomCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    $rootScope.$on('clearSearchResult', function (event, data) {
        // If token has become invalid
        model.resetSearchResult();
        model.resetSearchCriteria();
        searchMeasuresForNomCtrl.searchCriteria = model.getSearchCriteria();
        searchMeasuresForNomCtrl.controlCountry.reload(searchMeasuresForNomCtrl.searchCriteria.simulationDate);
    });

    searchMeasuresForNomCtrl.openDatePicker = function ($event) {
        searchMeasuresForNomCtrl.isDatePickerOpen = true;
    };

    searchMeasuresForNomCtrl.onDateChange = function (dateString) {
        searchMeasuresForNomCtrl.resetError();
        searchMeasuresForNomCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchMeasuresForNomCtrl.searchCriteria.simulationDate, dateString);
        searchMeasuresForNomCtrl.loadingReferenceData = true;
        searchMeasuresForNomCtrl.controlCountry.reload(searchMeasuresForNomCtrl.searchCriteria.simulationDate).then(function () {
            searchMeasuresForNomCtrl.loadingReferenceData = false;
        }, function (error) {
            searchMeasuresForNomCtrl.errorCode = error.data.code;
            searchMeasuresForNomCtrl.errorParams = error.data.params;
            searchMeasuresForNomCtrl.errorType = error.data.type;
            searchMeasuresForNomCtrl.loadingReferenceData = false;
        });
    };

    searchMeasuresForNomCtrl.search = function () {
        //Load data for the first page
        searchMeasuresForNomCtrl.loadDataFromServer(1);
    };

    //Load data for a given page
    searchMeasuresForNomCtrl.loadDataFromServer = function (pageNumber) {
        if (!searchMeasuresForNomCtrl.validateSearchForm()) {
            return;
        }

        searchMeasuresForNomCtrl.loadDataFromServerWithoutValidation(pageNumber);
    };

    //Load data for a given page without validation
    searchMeasuresForNomCtrl.loadDataFromServerWithoutValidation = function (pageNumber) {
        // Reset search result before searching
        searchMeasuresForNomCtrl.resetSearchResult();
        searchMeasuresForNomCtrl.updateAdditionalCodes();
        searchMeasuresForNomCtrl.searching = true;
        MeasureForNomenclatureSearchModel.queryMeasuresForNomenclature(pageNumber).then(function (searchMeasureResult) {
            searchMeasuresForNomCtrl.searchMeasureResult = searchMeasureResult;
            searchMeasuresForNomCtrl.searching = false;

            searchMeasuresForNomCtrl.searchMeasureResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchMeasuresForNomCtrl.searchCriteria.simulationDate);
            if (searchMeasuresForNomCtrl.searchMeasureResult.infoCode && "i8n.common.pastDate" === searchMeasuresForNomCtrl.searchMeasureResult.infoCode) {
                searchMeasuresForNomCtrl.searchMeasureResult.infoParams = CONSTANTS.pastDate;
            }

            searchMeasuresForNomCtrl.updateBrowserURL();
        }, function (error) {
            searchMeasuresForNomCtrl.errorCode = error.data.code;
            searchMeasuresForNomCtrl.errorParams = error.data.params;
            searchMeasuresForNomCtrl.errorType = error.data.type;
            searchMeasuresForNomCtrl.searching = false;

            if (searchMeasuresForNomCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    /**
     * Query measures for commodity code
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/measure/mcc/search?sd={SimulationDate}&d={TradeDirection}&cc={CommodityCode}&ad={AdditionalCode}&co={Country}&cu={Currency}&l={Language}
     *
     * Example:
     * http://www.testenv.se/arctictariff-public-web/#!/taric/measure/mcc/search?sd=2015-01-01&d=I&cc=1005109000&ad=2550&co=US&cu=EUR&l=en
     */
    searchMeasuresForNomCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        var additionalCodes = '';
        for (var i = 0; i < searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes.length; i++) {
            if (i === 0) {
                additionalCodes = searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes[i];
            } else {
                additionalCodes = additionalCodes + ',' + searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes[i];
            }
        }

        // Do not keep additional parameter 'frm' because there is no return to caller page
        // in "Measures for nomenclature" use case
        $location.search({
            sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
            d: searchMeasuresForNomCtrl.searchCriteria.direction,
            cc: CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.commodityCode),
            ad: additionalCodes,
            co: searchMeasuresForNomCtrl.searchCriteria.country,
            cu: searchMeasuresForNomCtrl.searchCriteria.currency,
            l: $translate.use()
        }).replace();
    };

    searchMeasuresForNomCtrl.resetSearchResult = function () {
        searchMeasuresForNomCtrl.searchMeasureResult = null;
        MeasureForNomenclatureSearchModel.resetSearchResult();
    };

    searchMeasuresForNomCtrl.print = function (options) {

        if (!searchMeasuresForNomCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        searchMeasuresForNomCtrl.updateAdditionalCodes();
        MeasureForNomenclatureSearchModel.queryMeasuresForNomenclature().then(function (searchMeasureResult) {

            searchMeasuresForNomCtrl.searchMeasureAllResult = searchMeasureResult;
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportFormTable'), options);
                doc.push({ text: '\n' });
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportBodyTable'), options);
                doc.push({ text: '\n' });
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    flag: searchMeasuresForNomCtrl.flagImg,
                    eu: searchMeasuresForNomCtrl.euImg,
                    validDate: $filter('date')(searchMeasuresForNomCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i18n.qry.mcc.pdf.report.title')
                }, 'l').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            searchMeasuresForNomCtrl.errorCode = error.data.code;
            searchMeasuresForNomCtrl.errorParams = error.data.params;
            searchMeasuresForNomCtrl.errorType = error.data.type;
            $rootScope.$broadcast('stopSpinningPrint');

            if (searchMeasuresForNomCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    searchMeasuresForNomCtrl.updateAdditionalCodes = function () {
        var additionalCodes = searchMeasuresForNomCtrl.getAdditionalCodeList();
        searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes = additionalCodes;
    };

    /**
     * Get a distinct list of additional codes
     * @returns {Array}
     */
    searchMeasuresForNomCtrl.getAdditionalCodeList = function () {
        var result = [];
        var adco = CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.additionalCode);
        if (adco !== "") {
            result.push(adco);
        }

        searchMeasuresForNomCtrl.searchCriteria.additionalCodes.forEach(function (additionalCode) {
            if (!searchMeasuresForNomCtrl.additionalCodeExists(result, additionalCode.id)) {
                result.push(additionalCode.id);
            }
        });
        return result;
    };

    searchMeasuresForNomCtrl.validateAdditionalCodes = function () {

        //Check for the number of additional codes to be used in the query parameters
        var additionalCodes = searchMeasuresForNomCtrl.getAdditionalCodeList();

        if (additionalCodes.length > CONSTANTS.maxNumberOfAdditionalCodes) {
            searchMeasuresForNomCtrl.errorCode = "i8n.qry.mcc.search.error.additionalcodes.exceed.limit";
            searchMeasuresForNomCtrl.errorParams = { param0: CONSTANTS.maxNumberOfAdditionalCodes };
            return false;
        }
        for (var i = 0; i < additionalCodes.length; i++) {
            searchMeasuresForNomCtrl.errorCode = CommonHelper.validateAdditionalCode(additionalCodes[i]);
            if (searchMeasuresForNomCtrl.errorCode) {
                return false;
            }
        }

        // ACSMNT-3924 If the input code is the same as one that has already been added, set the input code to empty
        var code = CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.additionalCode);
        if (code !== "" && searchMeasuresForNomCtrl.getAdditionalCodePosition(code) > -1) {
            searchMeasuresForNomCtrl.searchCriteria.additionalCode = null;
        }

        return true;
    };

    /**
     * Check if the given adco exists in the given list
     * @param additionalCodeList The additional code list
     * @param adco The given additional code
     * @returns {boolean} true if exists else return false
     */
    searchMeasuresForNomCtrl.additionalCodeExists = function (additionalCodeList, adco) {
        for (var i = 0; i < additionalCodeList.length; i++) {
            if (additionalCodeList[i] === adco) {
                return true;
            }
        }
        return false;
    };

    /**
     * Add an additional code to the search list of additional codes
     * @param adco The additional code to be added
     */
    searchMeasuresForNomCtrl.addAdditionalCode = function (adco) {
        if (!searchMeasuresForNomCtrl.validateAddingAdditionalCode(adco)) {
            return;
        }

        var adcoItem = { id: adco };
        searchMeasuresForNomCtrl.searchCriteria.additionalCodes.push(adcoItem);
        searchMeasuresForNomCtrl.searchCriteria.additionalCode = null;
    };

    /**
     * Remove a the given additional code from the list
     * @param adco The given additional code
     */
    searchMeasuresForNomCtrl.removeAdditionalCode = function (adco) {
        searchMeasuresForNomCtrl.handleError();
        var index = searchMeasuresForNomCtrl.getAdditionalCodePosition(adco);
        if (index > -1) {
            searchMeasuresForNomCtrl.searchCriteria.additionalCodes.splice(index, 1);
        }
    };

    /**
     * Validate additional code before adding
     * @param adco the additional code to be validated
     * @returns {boolean} The validation result
     */
    searchMeasuresForNomCtrl.validateAddingAdditionalCode = function (adco) {
        var result = true;
        adco = CommonHelper.removeSpaceCharacters(adco);
        if (adco === "") {
            searchMeasuresForNomCtrl.errorCode = "i8n.qry.mcc.search.error.additionalcode.empty";
            result = false;
        } else if (searchMeasuresForNomCtrl.getAdditionalCodePosition(adco) > -1) {
            searchMeasuresForNomCtrl.errorCode = "i8n.qry.mcc.search.error.additionalcode.exists";
            result = false;
        } else if (searchMeasuresForNomCtrl.searchCriteria.additionalCodes.length === CONSTANTS.maxNumberOfAdditionalCodes - 1) {
            searchMeasuresForNomCtrl.errorCode = "i8n.qry.mcc.search.error.additionalcodes.exceed.limit";
            searchMeasuresForNomCtrl.errorParams = { param0: CONSTANTS.maxNumberOfAdditionalCodes };
            result = false;
        }
        return result;
    };

    /**
     * Get the position of the given additional code in the list
     * @param adco The given additional code
     * @returns {number} The position of the additional code
     */
    searchMeasuresForNomCtrl.getAdditionalCodePosition = function (adco) {
        var index = -1;
        for (var i = 0; i < searchMeasuresForNomCtrl.searchCriteria.additionalCodes.length; i++) {
            if (searchMeasuresForNomCtrl.searchCriteria.additionalCodes[i].id === adco) {
                index = i;
                break;
            }
        }
        return index;
    };

    searchMeasuresForNomCtrl.onChangeAdditionalCode = function () {
        // ACSMNT-3907 Do not reset error to avoid clicking twice when searching with incorrect additionalCode
        searchMeasuresForNomCtrl.searchCriteria.additionalCode = CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.additionalCode);
        searchMeasuresForNomCtrl.searchCriteria.additionalCode = searchMeasuresForNomCtrl.searchCriteria.additionalCode.toUpperCase();
    };

    //Handle page change for the measure search result table
    searchMeasuresForNomCtrl.searchMeasureResultPageChanged = function (pageNumber) {
        searchMeasuresForNomCtrl.loadDataFromServerWithoutValidation(pageNumber);
    };

    searchMeasuresForNomCtrl.shouldReload = function () {
        return searchMeasuresForNomCtrl.isExternalLink() || $stateParams.frm === 'taric.duty.meursing' && $stateParams.ad && $stateParams.ad !== '7XXX';
    };

    searchMeasuresForNomCtrl.isExternalLink = function () {
        return $stateParams.sd && $stateParams.cc && (!$stateParams.frm || $stateParams.frm !== 'adcoLookup' && $stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'calDuties' && $stateParams.frm !== 'ccView');
    };

    //Check whether the external parameters are valid or not
    searchMeasuresForNomCtrl.validateExternalParameters = function () {
        searchMeasuresForNomCtrl.resetError();
        return searchMeasuresForNomCtrl.validateCommodityCode() && searchMeasuresForNomCtrl.validateAdditionalCodes() && searchMeasuresForNomCtrl.validateSimulationDate();
    };

    //Check whether the search form is valid or not
    searchMeasuresForNomCtrl.validateSearchForm = function () {
        searchMeasuresForNomCtrl.resetError();
        return searchMeasuresForNomCtrl.validateCommodityCode() && searchMeasuresForNomCtrl.validateCountryCode() && searchMeasuresForNomCtrl.validateAdditionalCodes() && searchMeasuresForNomCtrl.validateSimulationDate();
    };

    searchMeasuresForNomCtrl.validateCountryCode = function () {
        searchMeasuresForNomCtrl.errorCode = searchMeasuresForNomCtrl.controlCountry.validate();
        return searchMeasuresForNomCtrl.errorCode === null;
    };

    searchMeasuresForNomCtrl.validateCommodityCode = function () {
        searchMeasuresForNomCtrl.errorCode = CommonHelper.validateDeclarableCommodityCode(searchMeasuresForNomCtrl.searchCriteria.commodityCode, searchMeasuresForNomCtrl.searchCriteria.direction);
        return searchMeasuresForNomCtrl.errorCode === null;
    };

    searchMeasuresForNomCtrl.validateSimulationDate = function () {
        if (!CONSTANTS.dateRestrictionEnabled) {
            searchMeasuresForNomCtrl.errorCode = CommonHelper.validateSimulationDate(searchMeasuresForNomCtrl.searchCriteria.simulationDate);
            if (searchMeasuresForNomCtrl.errorCode) {
                searchMeasuresForNomCtrl.errorParams = { param0: CONSTANTS.pastDate };
            }
        }
        return searchMeasuresForNomCtrl.errorCode === null;
    };

    searchMeasuresForNomCtrl.openOriginPopup = function (size, _origin) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
            controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
            size: size,
            resolve: {
                geoAreaMemberships: function geoAreaMemberships() {
                    return GeographicalAreaModel.queryMembershipByGroupId(_origin, searchMeasuresForNomCtrl.searchCriteria.simulationDate);
                },
                origin: function origin() {
                    return _origin;
                }
            }
        });
    };

    searchMeasuresForNomCtrl.openMeasurePopup = function (size, measure) {
        var valid = searchMeasuresForNomCtrl.validateSearchForm();
        if (!valid) {
            return;
        }
        var additionalCodes = searchMeasuresForNomCtrl.getAdditionalCodeList();
        var preferenceCodesForMeasureOnly = false;
        var selectedPreferenceCode = null;
        var supportedPrefCodeVersion = null;
        var uccApplicableDate = moment(CONSTANTS.uccApplicableDate, CONSTANTS.dateFormat.toUpperCase(), true).toDate();
        if (CommonHelper.compareDatesWithoutTime(searchMeasuresForNomCtrl.searchCriteria.simulationDate, uccApplicableDate) < 0) {
            supportedPrefCodeVersion = 'PRE_UCC';
        } else {
            if (CONSTANTS.supportedCalculationVersions.length === 1) {
                supportedPrefCodeVersion = CONSTANTS.supportedCalculationVersions[0];
            } else if (CONSTANTS.supportedCalculationVersions.length > 1) {
                supportedPrefCodeVersion = CONSTANTS.supportedCalculationVersions[0];
                supportedPrefCodeVersion += "," + CONSTANTS.supportedCalculationVersions[1];
            }
        }

        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/measure/measure-popup.tmpl.html',
            controller: 'MeasurePopupController as measurePopupCtrl',
            size: size,
            resolve: {
                measureExtendedInfo: ["MeasurePopupModel", function measureExtendedInfo(MeasurePopupModel) {
                    return MeasurePopupModel.getMeasureExtendedInfoForMeasureType(measure.sid, preferenceCodesForMeasureOnly, CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.commodityCode), searchMeasuresForNomCtrl.searchCriteria.country, searchMeasuresForNomCtrl.searchCriteria.direction, selectedPreferenceCode, additionalCodes, searchMeasuresForNomCtrl.searchCriteria.simulationDate, supportedPrefCodeVersion, measure.unreleased);
                }]
            }
        });
    };

    searchMeasuresForNomCtrl.openConditionPopup = function (size, measure) {
        var valid = searchMeasuresForNomCtrl.validateSearchForm();
        if (!valid) {
            return;
        }
        var monetaryUnitCode = searchMeasuresForNomCtrl.searchCriteria.currency;
        var additionalCodes = searchMeasuresForNomCtrl.getAdditionalCodeList();
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/condition/condition-popup.tmpl.html',
            controller: 'ConditionPopupController as conditionPopupCtrl',
            size: size,
            resolve: {
                measureConditionHeadResult: ["ConditionPopupModel", function measureConditionHeadResult(ConditionPopupModel) {
                    return ConditionPopupModel.getMeasureExtendedInfoForMeasureConditions(measure.sid, monetaryUnitCode, additionalCodes, searchMeasuresForNomCtrl.searchCriteria.simulationDate, searchMeasuresForNomCtrl.searchCriteria.direction, measure.unreleased).then(function (measureCondition) {
                        var result = { count: 1 };
                        var items = [];
                        items.push(measureCondition);
                        result.items = items;
                        return result;
                    });
                }]
            }
        });
    };

    searchMeasuresForNomCtrl.viewAllMeasureConditions = function (size) {
        var valid = searchMeasuresForNomCtrl.validateSearchForm();
        if (!valid) {
            return;
        }
        searchMeasuresForNomCtrl.updateAdditionalCodes();
        searchMeasuresForNomCtrl.loadingConditions = true;
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/condition/condition-popup.tmpl.html',
            controller: 'ConditionPopupController as conditionPopupCtrl',
            size: size,
            resolve: {
                measureConditionHeadResult: ["MeasureForNomenclatureSearchModel", function measureConditionHeadResult(MeasureForNomenclatureSearchModel) {
                    return MeasureForNomenclatureSearchModel.queryMeasureConditionsForNomenclature(1).then(function (result) {
                        searchMeasuresForNomCtrl.loadingConditions = false;
                        return result;
                    }, function (error) {
                        searchMeasuresForNomCtrl.loadingConditions = false;
                        searchMeasuresForNomCtrl.errorCode = error.data.code;
                        searchMeasuresForNomCtrl.errorParams = error.data.params;
                        searchMeasuresForNomCtrl.errorType = error.data.type;
                    });
                }]
            }
        });
    };

    searchMeasuresForNomCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, searchMeasuresForNomCtrl.searchCriteria.simulationDate);
                }]
            }
        });
    };

    searchMeasuresForNomCtrl.openAdditionalCodePopup = function (size, additionalCodeId) {
        var valid = searchMeasuresForNomCtrl.validateSearchForm();
        if (!valid) {
            return;
        }
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/additional-code/additional-code-popup.tmpl.html',
            controller: 'AdditionalCodePopupController as additionalCodePopupCtrl',
            size: size,
            resolve: {
                additionalCode: ["AdditionalCodePopupModel", function additionalCode(AdditionalCodePopupModel) {
                    return AdditionalCodePopupModel.findAdditionalCode(additionalCodeId, searchMeasuresForNomCtrl.searchCriteria.simulationDate, CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.commodityCode));
                }],
                simulationDate: function simulationDate() {
                    return searchMeasuresForNomCtrl.searchCriteria.simulationDate;
                }
            }
        });
    };

    searchMeasuresForNomCtrl.openQuotaPopup = function (size, measure) {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/quota/quota-popup.tmpl.html',
            controller: 'ViewTaricQuotaController as viewTaricQuotaCtrl',
            size: size,
            resolve: {
                quotaDefinitionExtendedInfo: ["TaricQuotaSearchModel", function quotaDefinitionExtendedInfo(TaricQuotaSearchModel) {

                    var inputOrigin = measure.geographicalArea.id;
                    if (searchMeasuresForNomCtrl.searchCriteria.country !== "" && searchMeasuresForNomCtrl.searchCriteria.country) {
                        inputOrigin = searchMeasuresForNomCtrl.searchCriteria.country;
                    }

                    var quotaExtendedInfo = TaricQuotaSearchModel.getQuotaDefinitionExtendedInfo(measure.orderNumber, inputOrigin, searchMeasuresForNomCtrl.searchCriteria.simulationDate).then(function (quotaExtendedInfo) {
                        return quotaExtendedInfo;
                    }, function (error) {
                        searchMeasuresForNomCtrl.errorCode = error.data.code;
                        searchMeasuresForNomCtrl.errorParams = error.data.params;
                        searchMeasuresForNomCtrl.errorType = error.data.type;
                        return;
                    });

                    return quotaExtendedInfo;
                }],
                simulationDate: function simulationDate() {
                    return searchMeasuresForNomCtrl.searchCriteria.simulationDate;
                },
                showCancelButton: function showCancelButton() {
                    return false;
                },
                country: function country() {
                    return searchMeasuresForNomCtrl.searchCriteria.country;
                }
            }
        });
    };

    searchMeasuresForNomCtrl.selectCommodityCode = function (commodityCode, type) {

        $state.go('taric.nomenclature.sbn', {
            cc: CommonHelper.removeSpaceCharacters(commodityCode),
            sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
            d: searchMeasuresForNomCtrl.searchCriteria.direction, frm: 'taric.measure.mcc', type: type
        });
    };

    searchMeasuresForNomCtrl.lookupAdditionalCode = function (additionalCode) {
        $state.go('taric.adco.lookup', {
            frm: 'taric.measure.mcc',
            sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
            ad: CommonHelper.removeSpaceCharacters(additionalCode),
            mo: false
        });
    };

    searchMeasuresForNomCtrl.resetError = function () {
        searchMeasuresForNomCtrl.handleError(null);
    };

    searchMeasuresForNomCtrl.formatCommodityCode = function () {
        var formattedCommodityCode = $filter('commodityCode')(searchMeasuresForNomCtrl.searchCriteria.commodityCode);
        searchMeasuresForNomCtrl.searchCriteria.commodityCode = formattedCommodityCode;
    };

    searchMeasuresForNomCtrl.handleError = function (error) {
        if (!error) {
            searchMeasuresForNomCtrl.errorCode = null;
            searchMeasuresForNomCtrl.errorParams = null;
        } else {
            searchMeasuresForNomCtrl.errorCode = error.errorCode;
            searchMeasuresForNomCtrl.errorParams = error.errorParams;
        }
    };

    searchMeasuresForNomCtrl.onCountryChange = function (country) {
        searchMeasuresForNomCtrl.searchCriteria.country = country;
    };

    searchMeasuresForNomCtrl.renderResultMiddleButtons = function () {
        return searchMeasuresForNomCtrl.enableCalculate() || searchMeasuresForNomCtrl.enableMeursing() || searchMeasuresForNomCtrl.enableAdditionalCodes() || searchMeasuresForNomCtrl.enableMeasureFootnotes() || searchMeasuresForNomCtrl.enableMeasureConditions();
    };

    searchMeasuresForNomCtrl.enableCalculate = function () {
        return !(CONSTANTS.webImportOnlyDutyCalc && searchMeasuresForNomCtrl.searchCriteria.direction === 'E');
    };

    searchMeasuresForNomCtrl.enableMeursing = function () {
        return searchMeasuresForNomCtrl.searchMeasureResult !== null && searchMeasuresForNomCtrl.searchMeasureResult.hasMeursingComponents;
    };

    searchMeasuresForNomCtrl.enableMeasureConditions = function () {
        return searchMeasuresForNomCtrl.searchMeasureResult !== null && searchMeasuresForNomCtrl.searchMeasureResult.hasConditions && searchMeasuresForNomCtrl.searchMeasureResult.hasCountry;
    };

    searchMeasuresForNomCtrl.enableAdditionalCodes = function () {
        return searchMeasuresForNomCtrl.searchMeasureResult !== null && searchMeasuresForNomCtrl.searchMeasureResult.additionalCodes.length > 0 && searchMeasuresForNomCtrl.searchMeasureResult.hasCountry;
    };

    searchMeasuresForNomCtrl.enableMeasureFootnotes = function () {
        return searchMeasuresForNomCtrl.searchMeasureResult !== null && searchMeasuresForNomCtrl.searchMeasureResult.measureFootnotes.length > 0 && searchMeasuresForNomCtrl.searchMeasureResult.hasCountry;
    };

    searchMeasuresForNomCtrl.calculate = function () {
        if (!searchMeasuresForNomCtrl.validateSearchForm()) {
            return;
        }
        $state.go('taric.duty.calculate', {
            frm: 'taric.measure.mcc',
            sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
            cc: CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.commodityCode),
            d: searchMeasuresForNomCtrl.searchCriteria.direction,
            ads: searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes,
            co: searchMeasuresForNomCtrl.searchCriteria.country,
            cu: searchMeasuresForNomCtrl.searchCriteria.currency,
            ur: searchMeasuresForNomCtrl.searchCriteria.includeUnreleased
        });
    };

    searchMeasuresForNomCtrl.meursing = function () {
        if (!searchMeasuresForNomCtrl.validateSearchForm()) {
            return;
        }

        $state.go('taric.duty.meursing', {
            frm: 'taric.measure.mcc',
            sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
            co: searchMeasuresForNomCtrl.searchCriteria.country,
            cu: searchMeasuresForNomCtrl.searchCriteria.currency
        });
    };

    searchMeasuresForNomCtrl.viewAdditionalCodes = function (size) {
        var valid = searchMeasuresForNomCtrl.validateSearchForm();
        if (!valid) {
            return;
        }
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/additional-codes/additional-codes-popup.tmpl.html',
            controller: 'AdditionalCodesPopupController as adcosPopupCtrl',
            size: size,
            resolve: {
                simulationDate: function simulationDate() {
                    return searchMeasuresForNomCtrl.searchCriteria.simulationDate;
                },
                additionalCodes: function additionalCodes() {
                    return searchMeasuresForNomCtrl.searchMeasureResult.additionalCodes;
                },
                commodityCode: function commodityCode() {
                    return searchMeasuresForNomCtrl.searchMeasureResult.commodityCodeHead.commodityCode;
                }
            }
        });
    };

    searchMeasuresForNomCtrl.viewMeasureFootnotes = function (size) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnotes/footnotes-popup.tmpl.html',
            controller: 'FootnotesPopupController as footnotesPopupCtrl',
            size: size,
            resolve: {
                measureFootnotes: function measureFootnotes() {
                    return searchMeasuresForNomCtrl.searchMeasureResult.measureFootnotes;
                },
                commodityCode: function commodityCode() {
                    return searchMeasuresForNomCtrl.searchMeasureResult.commodityCodeHead.commodityCode;
                }
            }
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage("img/flags/EU.png", 21, 14, function (options) {

            searchMeasuresForNomCtrl.euImg = options.logo;
        }, true);

        var url = "img/flags/" + searchMeasuresForNomCtrl.installationCountry + ".png";
        CommonHelper.loadImage(url, 21, 14, function (options) {

            searchMeasuresForNomCtrl.flagImg = options.logo;
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchMeasuresForNomCtrl.print, true);
        }, true);
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        searchMeasuresForNomCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            searchMeasuresForNomCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.measure', ['common.helper', 'ngResource']).factory('QueryMeasure', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/secure/ccrm/measures', {}, {
        querySecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/ccrm/measures'
        },
        getMeasureExtendedInfoForMeasureType: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/meae/measures/:id'
        },
        getMeasureExtendedInfoForMeasureTypeSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/ref/meae/measures/:id'
        },
        getMeasureExtendedInfoForMeasureConditions: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/meae/conditions/:id'
        },
        queryMeasuresForNomenclature: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/mcc/measures'
        },
        queryMeasuresForNomenclatureSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/mcc/measures'
        },
        queryMeasureConditionsForNomenclature: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/mcc/measures/conditions'
        }
    });
}]).service('MeasureByCCSearchModel', ["$q", "QueryMeasure", "CommonHelper", "CONSTANTS", "AuthorizeModel", function ($q, QueryMeasure, CommonHelper, CONSTANTS, AuthorizeModel) {
    var model = this;

    var searchCriteria = {},
        searchMeasureResult = null;

    model.getSearchMeasureResult = function () {
        return searchMeasureResult;
    };
    model.resetSearchResult = function () {
        searchMeasureResult = null;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.commodityCode = '';
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
        searchCriteria.direction = "I";
        searchCriteria.country = null;

        if (CONSTANTS.releaseManagement) {
            model.includeUnreleased = AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer();
        } else {
            model.includeUnreleased = false;
        }
        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.getSearchCriteria = function () {
        return searchCriteria;
    };

    model.reset = function () {

        //Set the default search criteria when the model is initialized
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();

    model.searchMeasure = function (pageNumber) {
        var deferred = $q.defer();

        var options = {
            simulationdate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            commoditycode: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCode),
            tradedirection: searchCriteria.direction,
            measuretype: searchCriteria.measureType,
            country: searchCriteria.country,
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol
        };

        if (pageNumber) {
            options.offset = CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        // ITESUP-164: Query measures by commodity codes will only be available for logged in user.
        options.filterHiddenMeasureTypes = false;
        if (CONSTANTS.releaseManagement) {
            options.includeUnreleased = model.includeUnreleased;
        }
        var resultSecure = QueryMeasure.querySecure(options, function () {
            var returnedResult = {};
            returnedResult.totalItems = resultSecure.count;
            returnedResult.measures = resultSecure.items;
            returnedResult.currentPage = pageNumber;

            // ACSMNT-3673 Only display EU hint for Sweden.
            if (CONSTANTS.installationCountry.toUpperCase() === 'SE') {
                returnedResult.isSelectedCountryAnEUMember = resultSecure.isSelectedCountryAnEUMember;
            }

            angular.forEach(returnedResult.measures, function (measure) {
                if (measure.excludedCountryIds.length > 0) {
                    measure.excludedCountryIds = measure.excludedCountryIds.join(" ");
                } else {
                    measure.excludedCountryIds = '';
                }
                var orderNumber = measure.orderNumber;
                if (orderNumber) {
                    // Use regexp to compare with orderNumber
                    var regexp = new RegExp(CONSTANTS.licenseQuotaPattern);
                    measure.licenseQuota = regexp.test(orderNumber);
                } else {
                    measure.licenseQuota = false;
                }
            });

            if (pageNumber) {
                searchMeasureResult = returnedResult;
            }

            deferred.resolve(returnedResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]).service('MeasurePopupModel', ["$q", "QueryMeasure", "CommonHelper", "AuthorizeModel", function ($q, QueryMeasure, CommonHelper, AuthorizeModel) {
    var model = this;
    model.getMeasureExtendedInfoForMeasureType = function (measureSid, preferenceCodesForMeasureOnly, commodityCode, country, direction, selectedPreferenceCode, additionalCodes, simulationDate, version, unreleased) {
        var deferred = $q.defer();
        if (AuthorizeModel.loggedIn) {
            QueryMeasure.getMeasureExtendedInfoForMeasureTypeSecure({
                id: measureSid,
                preferenceCodesForMeasureOnly: preferenceCodesForMeasureOnly,
                commodityCode: CommonHelper.removeSpaceCharacters(commodityCode),
                country: country,
                tradeDirection: direction,
                selectedPreferenceCode: selectedPreferenceCode,
                additionalCodes: additionalCodes,
                simulationDate: CommonHelper.getRestDateString(simulationDate),
                filterHiddenMeasureTypes: false,
                version: version,
                unreleased: unreleased
            }, function (measureExtendedInfoSecure) {
                deferred.resolve(measureExtendedInfoSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            QueryMeasure.getMeasureExtendedInfoForMeasureType({
                id: measureSid,
                preferenceCodesForMeasureOnly: preferenceCodesForMeasureOnly,
                commodityCode: CommonHelper.removeSpaceCharacters(commodityCode),
                country: country,
                tradeDirection: direction,
                selectedPreferenceCode: selectedPreferenceCode,
                additionalCodes: additionalCodes,
                simulationDate: CommonHelper.getRestDateString(simulationDate),
                filterHiddenMeasureTypes: true,
                version: version
            }, function (measureExtendedInfoSecure) {
                deferred.resolve(measureExtendedInfoSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };
}]).service('ConditionPopupModel', ["$q", "QueryMeasure", "CommonHelper", "$translate", function ($q, QueryMeasure, CommonHelper, $translate) {
    var model = this;
    model.getMeasureExtendedInfoForMeasureConditions = function (measureSid, monetaryUnitCode, additionalCodes, simulationDate, direction, unreleased) {
        var deferred = $q.defer();
        QueryMeasure.getMeasureExtendedInfoForMeasureConditions({
            id: measureSid,
            monetaryUnitCode: monetaryUnitCode,
            additionalCodes: additionalCodes,
            simulationDate: CommonHelper.getRestDateString(simulationDate),
            tradeDirection: direction,
            language: CommonHelper.getLanguageCode($translate.use()),
            unreleased: unreleased
        }, function (measureConditionHead) {
            deferred.resolve(measureConditionHead);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]).service('MeasureForNomenclatureSearchModel', ["$q", "QueryMeasure", "CommonHelper", "CONSTANTS", "$translate", "AuthorizeModel", function ($q, QueryMeasure, CommonHelper, CONSTANTS, $translate, AuthorizeModel) {
    var model = this;
    var searchCriteria = {},
        searchMeasureResult = null;
    model.getSearchMeasureResult = function () {
        return searchMeasureResult;
    };
    model.resetSearchResult = function () {
        searchMeasureResult = null;
    };
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        //Set the default search criteria when the model is initialized
        searchCriteria = {};
        searchCriteria.commodityCode = '';
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
        searchCriteria.direction = "I";
        searchCriteria.currency = CONSTANTS.installationCurrency;
        searchCriteria.additionalCodes = [];
        searchCriteria.queryAdditionalCodes = [];
        searchCriteria.additionalCode = null;
        searchCriteria.country = null;

        if (CONSTANTS.releaseManagement) {
            model.includeUnreleased = AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer();
        } else {
            model.includeUnreleased = false;
        }
        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();

    model.queryMeasuresForNomenclature = function (pageNumber) {

        var options = {
            simulationdate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            commoditycode: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCode),
            tradedirection: searchCriteria.direction,
            measuretype: searchCriteria.measureType,
            country: searchCriteria.country,
            currency: searchCriteria.currency,
            additionalcodes: searchCriteria.queryAdditionalCodes,
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol
        };

        if (pageNumber) {
            options.offset = CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        var deferred = $q.defer();
        if (model.loggedIn) {
            options.filterHiddenMeasureTypes = false;
            if (CONSTANTS.releaseManagement) {
                options.includeUnreleased = model.includeUnreleased;
            }
            var resultSecure = QueryMeasure.queryMeasuresForNomenclatureSecure(options, function () {
                var returnedResult = {};
                returnedResult.totalItems = resultSecure.count;
                returnedResult.measures = resultSecure.items;
                returnedResult.currentPage = pageNumber;
                returnedResult.commodityCodeHead = resultSecure.commodityCodeHead;
                returnedResult.additionalCodes = resultSecure.additionalCodes;
                returnedResult.measureFootnotes = resultSecure.measureFootnotes;
                returnedResult.hasMeursingComponents = resultSecure.hasMeursingComponents;
                returnedResult.hasCountry = !!searchCriteria.country;
                returnedResult.hasConditions = resultSecure.hasConditions;
                if (searchCriteria.direction === 'E' && returnedResult.commodityCodeHead.commodityCode.length === 10) {
                    returnedResult.commodityCodeHead.commodityCode = returnedResult.commodityCodeHead.commodityCode.substr(0, 8);
                }

                // ACSMNT-3673 Only display EU hint for Sweden.
                if (CONSTANTS.installationCountry.toUpperCase() === 'SE') {
                    returnedResult.isSelectedCountryAnEUMember = resultSecure.isSelectedCountryAnEUMember;
                }

                angular.forEach(returnedResult.measures, function (measure) {
                    if (measure.excludedCountryIds.length > 0) {
                        measure.excludedCountryIds = measure.excludedCountryIds.join(" ");
                    } else {
                        measure.excludedCountryIds = '';
                    }
                    var orderNumber = measure.orderNumber;
                    if (orderNumber) {
                        // Use regexp to compare with orderNumber
                        var regexp = new RegExp(CONSTANTS.licenseQuotaPattern);
                        measure.licenseQuota = regexp.test(orderNumber);
                    } else {
                        measure.licenseQuota = false;
                    }
                });

                if (pageNumber) {
                    searchMeasureResult = returnedResult;
                }

                deferred.resolve(returnedResult);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            options.filterHiddenMeasureTypes = true;
            var result = QueryMeasure.queryMeasuresForNomenclature(options, function () {
                var returnedResult = {};
                returnedResult.totalItems = result.count;
                returnedResult.measures = result.items;
                returnedResult.currentPage = pageNumber;
                returnedResult.commodityCodeHead = result.commodityCodeHead;
                returnedResult.additionalCodes = result.additionalCodes;
                returnedResult.measureFootnotes = result.measureFootnotes;
                returnedResult.hasMeursingComponents = result.hasMeursingComponents;
                returnedResult.hasCountry = !!searchCriteria.country;
                returnedResult.hasConditions = result.hasConditions;
                if (searchCriteria.direction === 'E' && returnedResult.commodityCodeHead.commodityCode.length === 10) {
                    returnedResult.commodityCodeHead.commodityCode = returnedResult.commodityCodeHead.commodityCode.substr(0, 8);
                }

                // ACSMNT-3673 Only display EU hint for Sweden.
                if (CONSTANTS.installationCountry.toUpperCase() === 'SE') {
                    returnedResult.isSelectedCountryAnEUMember = result.isSelectedCountryAnEUMember;
                }

                angular.forEach(returnedResult.measures, function (measure) {
                    if (measure.excludedCountryIds.length > 0) {
                        measure.excludedCountryIds = measure.excludedCountryIds.join(" ");
                    } else {
                        measure.excludedCountryIds = '';
                    }
                    var orderNumber = measure.orderNumber;
                    if (orderNumber) {
                        // Use regexp to compare with orderNumber
                        var regexp = new RegExp(CONSTANTS.licenseQuotaPattern);
                        measure.licenseQuota = regexp.test(orderNumber);
                    } else {
                        measure.licenseQuota = false;
                    }
                });

                if (pageNumber) {
                    searchMeasureResult = returnedResult;
                }
                deferred.resolve(returnedResult);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

    model.queryMeasureConditionsForNomenclature = function (page) {
        var deferred = $q.defer();
        var options = {
            simulationdate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            commoditycode: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCode),
            tradedirection: searchCriteria.direction,
            country: searchCriteria.country,
            currency: searchCriteria.currency,
            additionalcodes: searchCriteria.queryAdditionalCodes,
            offset: CommonHelper.getOffset(page),
            count: CONSTANTS.rowsPerPage,
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol,
            language: CommonHelper.getLanguageCode($translate.use())
        };
        if (CONSTANTS.releaseManagement) {
            options.includeUnreleased = model.includeUnreleased;
        }
        var result = QueryMeasure.queryMeasureConditionsForNomenclature(options, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var taricMeasure = angular.module('taric.measure', ['taric.measure.ccrm', 'taric.measure.mcc', 'common.model.measuretype']);
taricMeasure.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.measure', {
        abstract: true,
        url: '/measure',
        template: '<ui-view></ui-view>'
    }).state('taric.measure.ccrm', {
        url: '/ccrm/search?frm&sd&d&cc&mt&co&l',
        templateUrl: 'taric/measure/ccrm/measure-ccrm-search.tmpl.html',
        controller: 'SearchMeasuresByCCController as searchMeasuresByCCCtrl',
        reloadOnSearch: false,
        resolve: {
            authenticated: ["AuthorizeModel", "LoginHelper", "CONSTANTS", "$q", function authenticated(AuthorizeModel, LoginHelper, CONSTANTS, $q) {
                var deferred = $q.defer();
                if (AuthorizeModel.loggedIn) {
                    deferred.resolve();
                } else if (CONSTANTS.credentialSetting === 'BASIC') {
                    LoginHelper.goToLogin();
                    deferred.reject('User is not authenticated');
                } else {
                    deferred.reject('User is not authenticated');
                }
                return deferred.promise;
            }],
            initializeData: ["MeasureByCCSearchModel", "$stateParams", "$translate", "$filter", "CommonHelper", function initializeData(MeasureByCCSearchModel, $stateParams, $translate, $filter, CommonHelper) {
                if ($stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'ccView') {
                    MeasureByCCSearchModel.reset();
                } else if ($stateParams.frm === 'ccLookup') {
                    MeasureByCCSearchModel.resetSearchResult();
                }

                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        MeasureByCCSearchModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.d) {
                    if ($stateParams.d === 'I' || $stateParams.d === 'E') {
                        MeasureByCCSearchModel.getSearchCriteria().direction = $stateParams.d;
                    }
                }
                if ($stateParams.cc) {
                    MeasureByCCSearchModel.getSearchCriteria().commodityCode = $filter('commodityCode')($stateParams.cc);
                }
                if ($stateParams.mt) {
                    MeasureByCCSearchModel.getSearchCriteria().measureType = $stateParams.mt;
                }
                if ($stateParams.co) {
                    MeasureByCCSearchModel.getSearchCriteria().country = $stateParams.co;
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            measureTypes: ["MeasureByCCSearchModel", "MeasureTypeModel", function measureTypes(MeasureByCCSearchModel, MeasureTypeModel) {
                return MeasureTypeModel.getMeasureTypes(MeasureByCCSearchModel.getSearchCriteria().direction, MeasureByCCSearchModel.getSearchCriteria().simulationDate);
            }],
            countries: ["GeographicalAreaModel", "MeasureByCCSearchModel", "$stateParams", function countries(GeographicalAreaModel, MeasureByCCSearchModel, $stateParams) {
                var result = null;
                // Only get countries to support bookmark when there are required parameters.
                if (!$stateParams.frm && $stateParams.sd && $stateParams.cc && $stateParams.co) {
                    result = GeographicalAreaModel.getCountriesOfOrigin(MeasureByCCSearchModel.getSearchCriteria().simulationDate);
                }
                return result;
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/measure/ccrm');
                $translatePartialLoader.addPart('taric/quota');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.measure.mcc', {
        url: '/mcc/search?frm&cc&sd&d&ad&co&cu&l&pv',
        templateUrl: 'taric/measure/mcc/measure-mcc-search.tmpl.html',
        controller: 'SearchMeasuresForNomenclatureController as searchMeasuresForNomCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["MeasureForNomenclatureSearchModel", "$stateParams", "$translate", "$filter", "CommonHelper", function initializeData(MeasureForNomenclatureSearchModel, $stateParams, $translate, $filter, CommonHelper) {
                if ($stateParams.frm !== 'taric.duty.meursing' && $stateParams.frm !== 'adcoLookup' && $stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'calDuties' && $stateParams.frm !== 'ccView') {
                    MeasureForNomenclatureSearchModel.reset();
                } else if ($stateParams.frm === 'taric.duty.meursing' && $stateParams.ad !== '7XXX' || $stateParams.frm === 'adcoLookup' || $stateParams.frm === 'ccLookup') {
                    MeasureForNomenclatureSearchModel.resetSearchResult();
                }
                if ($stateParams.cc) {
                    MeasureForNomenclatureSearchModel.getSearchCriteria().commodityCode = $filter('commodityCode')($stateParams.cc);
                }
                if ($stateParams.d) {
                    if ($stateParams.d === 'I' || $stateParams.d === 'E') {
                        MeasureForNomenclatureSearchModel.getSearchCriteria().direction = $stateParams.d;
                    }
                }
                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        MeasureForNomenclatureSearchModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.ad) {
                    if ($stateParams.ad === '7XXX') {
                        // Return from meursing search with additional code
                        // Dummy value for "not selected"
                        MeasureForNomenclatureSearchModel.getSearchCriteria().additionalCode = null;
                    } else if ($stateParams.frm === 'adcoLookup' || $stateParams.frm === 'taric.duty.meursing') {
                        MeasureForNomenclatureSearchModel.getSearchCriteria().additionalCode = $stateParams.ad;
                    } else {
                        var additionalCodes = $stateParams.ad.split(',');
                        // In case AdditionalCode parameter is returned from lookup AdditionalCode,
                        // it will be added to the current additionalCode list SearchCriteria.
                        for (var i = 0; i < additionalCodes.length; i++) {
                            if (MeasureForNomenclatureSearchModel.getSearchCriteria().additionalCodes.indexOf(additionalCodes[i]) < 0) {
                                var adcoItem = { id: additionalCodes[i] };
                                MeasureForNomenclatureSearchModel.getSearchCriteria().additionalCodes.push(adcoItem);
                            }
                        }
                    }
                }
                if ($stateParams.co) {
                    MeasureForNomenclatureSearchModel.getSearchCriteria().country = $stateParams.co;
                }
                if ($stateParams.cu) {
                    MeasureForNomenclatureSearchModel.getSearchCriteria().currency = $stateParams.cu;
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
                if ($stateParams.pv) {
                    MeasureForNomenclatureSearchModel.getSearchCriteria().preferenceCodeMappingVersion = $stateParams.pv;
                }
            }],
            countries: ["GeographicalAreaModel", "MeasureForNomenclatureSearchModel", "$stateParams", function countries(GeographicalAreaModel, MeasureForNomenclatureSearchModel, $stateParams) {
                var result = null;
                // Only get countries to support bookmark when there are required parameters.
                if (!$stateParams.frm && $stateParams.sd && $stateParams.cc && $stateParams.co) {
                    result = GeographicalAreaModel.getCountriesOfOrigin(MeasureForNomenclatureSearchModel.getSearchCriteria().simulationDate);
                }
                return result;
            }],
            currencies: ["MonetaryUnitsModel", "MeasureForNomenclatureSearchModel", function currencies(MonetaryUnitsModel, MeasureForNomenclatureSearchModel) {
                return MonetaryUnitsModel.dutyMonetaryUnits(MeasureForNomenclatureSearchModel.getSearchCriteria().simulationDate);
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/measure/mcc');
                $translatePartialLoader.addPart('taric/quota');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by pli on 10/9/2016.
 */

var taricCodelistsSearch = angular.module('taric.moreinfo.codelists.search', ['taric.model.codelists', 'common.helper', 'common.filter.description', 'common.filter.specialCharacterToHtml']).controller('SearchCodelistsController', ["CONSTANTS", "CodeListsModel", "$rootScope", "$scope", "$state", "$stateParams", "$translatePartialLoader", "$uibModal", "$filter", "CommonHelper", "preferredUILanguages", "$translate", "$timeout", "$location", function (CONSTANTS, CodeListsModel, $rootScope, $scope, $state, $stateParams, $translatePartialLoader, $uibModal, $filter, CommonHelper, preferredUILanguages, $translate, $timeout, $location) {
    var searchCodelistsCtrl = this;
    searchCodelistsCtrl.searchCodelistsResult = null;

    searchCodelistsCtrl.resetSearchCodelistsResult = function () {
        searchCodelistsCtrl.searchCodelistsResult = null;
        CodeListsModel.resetSearchResult();
    };

    //Check whether the external parameters are valid or not
    searchCodelistsCtrl.validateExternalParameters = function () {
        return searchCodelistsCtrl.validateSearchForm();
    };

    //Check whether the search form is valid or not
    searchCodelistsCtrl.validateSearchForm = function () {
        searchCodelistsCtrl.handleError();
        return searchCodelistsCtrl.validateSimulationDate() && searchCodelistsCtrl.validateCodeType();
    };

    searchCodelistsCtrl.validateSimulationDate = function () {
        if (!CONSTANTS.dateRestrictionEnabled) {
            searchCodelistsCtrl.errorCode = CommonHelper.validateSimulationDate(searchCodelistsCtrl.searchCriteria.simulationDate);
            if (searchCodelistsCtrl.errorCode) {
                searchCodelistsCtrl.errorParams = { param0: CONSTANTS.pastDate };
            }
        }
        return searchCodelistsCtrl.errorCode === null;
    };

    searchCodelistsCtrl.validateCodeType = function () {
        if (searchCodelistsCtrl.searchCriteria.codeType === null || searchCodelistsCtrl.searchCriteria.codeType === '') {
            searchCodelistsCtrl.errorCode = 'i18n.common.validation.code.type.missing';
        }
        return searchCodelistsCtrl.errorCode === null;
    };

    // Load data for a given page
    searchCodelistsCtrl.loadDataFromServer = function (pageNumber) {
        if (!searchCodelistsCtrl.validateSearchForm()) {
            return;
        }

        // Reset search result before searching
        searchCodelistsCtrl.resetSearchCodelistsResult();
        searchCodelistsCtrl.searching = true;

        if (searchCodelistsCtrl.htmlCodeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) >= 0) {
            CodeListsModel.queryHtmlCodeTypes().then(function (searchCodelistsResult) {
                searchCodelistsCtrl.searchCodelistsResult = searchCodelistsResult;
                searchCodelistsCtrl.searching = false;
                searchCodelistsCtrl.updateBrowserURL();
            }, function (error) {
                searchCodelistsCtrl.errorCode = error.data.code;
                searchCodelistsCtrl.errorParams = error.data.params;
                searchCodelistsCtrl.searching = false;
            });
        } else {
            CodeListsModel.queryAllCodeTypes(pageNumber).then(function (searchCodelistsResult) {
                searchCodelistsCtrl.searchCodelistsResult = searchCodelistsResult;
                searchCodelistsCtrl.searching = false;
                searchCodelistsCtrl.updateBrowserURL();
            }, function (error) {
                searchCodelistsCtrl.errorCode = error.data.code;
                searchCodelistsCtrl.errorParams = error.data.params;
                searchCodelistsCtrl.searching = false;
            });
        }
    };

    /**
     * Code lists
     {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/moreinfo/codelists/search?sd={SimulationDate}&ct={CodeType}&l={Language}&ql={QueryLanguage}
       Example:
     http://www.testenv.se/arctictariff-public-web/#!/taric/moreinfo/codelists/search?sd=2015-01-01&ct=MCT&l=en&ql=en
     */
    searchCodelistsCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }
        $location.search({
            sd: CommonHelper.getBookmarkDateString(searchCodelistsCtrl.searchCriteria.simulationDate),
            ct: searchCodelistsCtrl.searchCriteria.codeType,
            ql: searchCodelistsCtrl.searchCriteria.language,
            l: $translate.use()
        }).replace();
    };

    searchCodelistsCtrl.search = function () {
        searchCodelistsCtrl.searchCriteria.ascending = true;
        searchCodelistsCtrl.searchCriteria.sortCol = null;
        // Load data for the first page
        searchCodelistsCtrl.loadDataFromServer();
    };

    // Handle page change for the codelists search result table
    searchCodelistsCtrl.searchCodelistsResultPageChanged = function (pageNumber) {
        searchCodelistsCtrl.loadDataFromServer(pageNumber);
    };

    searchCodelistsCtrl.openDatePicker = function ($event) {
        searchCodelistsCtrl.isDatePickerOpen = true;
    };

    searchCodelistsCtrl.onDateChange = function (dateString) {
        searchCodelistsCtrl.resetError();
        searchCodelistsCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchCodelistsCtrl.searchCriteria.simulationDate, dateString);
        if (searchCodelistsCtrl.searchCriteria.simulationDate) {
            searchCodelistsCtrl.searchCriteria.codeType = '';
            searchCodelistsCtrl.searchCriteria.ascending = true;
            searchCodelistsCtrl.searchCriteria.sortCol = null;
        }
    };

    // View codelists detail
    searchCodelistsCtrl.viewCodelists = function (codelist) {
        CodeListsModel.setSelectedCodelist(codelist);
        searchCodelistsCtrl.searchCriteria.ascending = true;
        searchCodelistsCtrl.searchCriteria.sortCol = null;
        $state.go('taric.moreinfo.codelists.view');
    };

    searchCodelistsCtrl.init = function () {
        searchCodelistsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        searchCodelistsCtrl.searchCriteria = CodeListsModel.getSearchCriteria();
        searchCodelistsCtrl.searchCodelistsResult = CodeListsModel.getSearchResult();
        searchCodelistsCtrl.dateFormat = CONSTANTS.dateFormat;
        searchCodelistsCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        searchCodelistsCtrl.languages = preferredUILanguages.items;
        searchCodelistsCtrl.installationCountry = CONSTANTS.installationCountry;
        searchCodelistsCtrl.htmlCodeTypes = [];
        if (CONSTANTS.menu.codeLists.htmlCodeTypes) {
            searchCodelistsCtrl.htmlCodeTypes = CONSTANTS.menu.codeLists.htmlCodeTypes;
        }

        // AA-966 If AG code type list is defined, it will be used.
        // Otherwise, the code type list will be empty.
        searchCodelistsCtrl.codeTypes = [];
        if (CONSTANTS.menu.codeLists.agCodeTypes && CONSTANTS.menu.codeLists.agCodeTypes.length > 0) {
            CONSTANTS.menu.codeLists.agCodeTypes.forEach(function (agCodeType) {
                searchCodelistsCtrl.codeTypes.push(agCodeType);
            });
        }

        if (searchCodelistsCtrl.htmlCodeTypes) {
            searchCodelistsCtrl.htmlCodeTypes.forEach(function (htmlCodeType) {
                searchCodelistsCtrl.codeTypes.push(htmlCodeType);
            });
        }

        if (searchCodelistsCtrl.searchCriteria.codeType && searchCodelistsCtrl.codeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) < 0) {
            searchCodelistsCtrl.searchCriteria.codeType = null;
        }

        searchCodelistsCtrl.searchCriteria.language = CommonHelper.getValidSelectedItem(searchCodelistsCtrl.languages, searchCodelistsCtrl.searchCriteria.language, CommonHelper.getLanguageCode(CONSTANTS.availableLanguages[0]));

        searchCodelistsCtrl.loadCodeTypes();
        searchCodelistsCtrl.updateCodeType();

        if (searchCodelistsCtrl.isExternalLink() && searchCodelistsCtrl.validateExternalParameters()) {
            // Only auto-search to support bookmark when there are required parameters, and all parameters are valid.
            searchCodelistsCtrl.search();
        }
    };

    searchCodelistsCtrl.isExternalLink = function () {
        return $stateParams.sd && $stateParams.ct;
    };

    searchCodelistsCtrl.loadCodeTypes = function () {
        searchCodelistsCtrl.codeTypeData = [];
        searchCodelistsCtrl.codeTypes.forEach(function (codeType) {
            $translate("i8n.common.selectItems.codelist.codetype." + codeType).then(function (codeTypeDescription) {
                searchCodelistsCtrl.codeTypeData.push({
                    "code": codeType,
                    "description": codeTypeDescription
                });
            }, function () {
                searchCodelistsCtrl.codeTypeData.push({
                    "code": codeType,
                    "description": "Missing description for code type " + codeType
                });
            });
        });

        $timeout(function () {

            //Wait for the translation is done and then do a sort
            searchCodelistsCtrl.codeTypeData.sort(function (codeType1, codeType2) {
                return codeType1.description.localeCompare(codeType2.description, CommonHelper.getLanguageCode($translate.use()));
            });
        }, 500);
    };

    searchCodelistsCtrl.updateCodeType = function () {
        if (searchCodelistsCtrl.searchCriteria.codeType && searchCodelistsCtrl.htmlCodeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) >= 0) {

            $rootScope.$broadcast('disablePrintable');
            $rootScope.$broadcast('disableExportable');
        } else {
            $rootScope.$broadcast('enablePrintable');
            $rootScope.$broadcast('enableExportable');
        }
    };

    $rootScope.$on('$translateChangeSuccess', function () {
        searchCodelistsCtrl.loadCodeTypes();

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        searchCodelistsCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            searchCodelistsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });

    searchCodelistsCtrl.handleError = function (error) {
        if (!error) {
            searchCodelistsCtrl.errorCode = null;
            searchCodelistsCtrl.errorParams = null;
        } else {
            searchCodelistsCtrl.errorCode = error.errorCode;
            searchCodelistsCtrl.errorParams = error.errorParams;
        }
    };

    searchCodelistsCtrl.resetError = function () {
        searchCodelistsCtrl.handleError(null);
    };

    // export excel
    searchCodelistsCtrl.exportExcel = function () {

        if (!searchCodelistsCtrl.validateSearchForm() || searchCodelistsCtrl.htmlCodeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) >= 0) {
            return;
        }

        $rootScope.$broadcast('startSpinningExport');

        // queyr all the data without pagination in the database
        CodeListsModel.queryAllCodeTypes().then(function (searchCodelistsResult) {

            var elt = document.getElementById("codeType");
            var title = elt[elt.selectedIndex].text;
            var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);

            // extract file name & title from html
            searchCodelistsCtrl.searchCodelistsAllResult = searchCodelistsResult;
            document.getElementById('reportDateExtr').innerHTML = reportDate;
            document.getElementById('reportTitle').innerHTML = title;

            setTimeout(function () {

                // columns format of excel
                var ws = {
                    '!cols': [{
                        wpx: 80
                    }, {
                        wpx: 180
                    }, {
                        wpx: 270
                    }]
                };

                // export excel
                CommonHelper.printExcel("exportExcelTable", title, ws).then(function () {
                    $rootScope.$broadcast('stopSpinningExport');
                }, function () {
                    $rootScope.$broadcast('stopSpinningExport');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            searchCodelistsCtrl.errorCode = error.data.code;
            searchCodelistsCtrl.errorParams = error.data.params;
            searchCodelistsCtrl.searching = false;

            $rootScope.$broadcast('stopSpinningExport');
        });
    };

    // print pdf
    searchCodelistsCtrl.print = function (options) {

        if (!searchCodelistsCtrl.validateSearchForm() || searchCodelistsCtrl.htmlCodeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) >= 0) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');

        // query all the data without pagination in the database
        CodeListsModel.queryAllCodeTypes().then(function (searchCodelistsResult) {

            searchCodelistsCtrl.searchCodelistsAllResult = searchCodelistsResult;

            // wait for 1s for front end to render the data
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                // extract report title from html
                var elt = document.getElementById("codeType");
                var title = elt[elt.selectedIndex].text;

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    flag: searchCodelistsCtrl.flagImg,
                    eu: searchCodelistsCtrl.euImg,
                    validDate: $filter('date')(searchCodelistsCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                    title: title
                }, 'p').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            searchCodelistsCtrl.errorCode = error.data.code;
            searchCodelistsCtrl.errorParams = error.data.params;
            searchCodelistsCtrl.searching = false;
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        // preload EU flag
        CommonHelper.loadImage("img/flags/EU.png", 21, 14, function (options) {

            searchCodelistsCtrl.euImg = options.logo;
        }, true);

        // preload the logo and national flag of pdf before printing
        var url = "img/flags/" + searchCodelistsCtrl.installationCountry + ".png";
        CommonHelper.loadImage(url, 21, 14, function (options) {

            searchCodelistsCtrl.flagImg = options.logo;
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchCodelistsCtrl.print, true);
        }, true);
    });

    $scope.$on('exportDocument', function (event, data) {

        searchCodelistsCtrl.exportExcel();
    });
}]);

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Model for getting code list data
 */
angular.module('taric.model.codelists', ['common.helper', 'ngResource', 'common.config']).factory('CodeLists', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/cl/codetypes', {}, {
        queryAllCodeTypes: {
            method: 'GET',
            isArray: false
        },
        queryCodeTypeChildren: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cl/:codetype'
        },
        queryHtmlCodeTypes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cl/htmlcodetypes'
        }
    });
}]).service('CodeListsModel', ["$q", "CodeLists", "CommonHelper", "$translate", "CONSTANTS", function ($q, CodeLists, CommonHelper, $translate, CONSTANTS) {
    var model = this;

    var searchCriteria = {},
        searchResult = null,
        viewResult = null,
        selectedCodelist = null;

    model.getSearchResult = function () {
        return searchResult;
    };

    model.getViewResult = function () {
        return viewResult;
    };

    model.resetSearchResult = function () {
        searchResult = null;
    };

    model.resetViewResult = function () {
        viewResult = null;
    };

    model.resetSearchCriteria = function () {
        // Set the default search criteria when the model is initialized
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.codeType = "";
        searchCriteria.ascending = true;
        searchCriteria.language = CommonHelper.getLanguageCode(CONSTANTS.availableLanguages[0]);
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();

    model.getSearchCriteria = function () {
        return searchCriteria;
    };

    model.getSelectedCodelist = function () {
        return selectedCodelist;
    };
    model.setSelectedCodelist = function (codelist) {
        selectedCodelist = codelist;
    };

    model.queryAllCodeTypes = function (pageNumber) {
        var deferred = $q.defer();

        var options = {
            startDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            endDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            codetype: CommonHelper.removeSpaceCharacters(searchCriteria.codeType),
            language: searchCriteria.language,
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol
        };

        if (pageNumber) {
            options.offset = CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = CodeLists.queryAllCodeTypes(options, function () {

            var returnedResult = {};
            returnedResult.totalItems = result.count;
            returnedResult.codeTypeResult = result.items;
            returnedResult.currentPage = pageNumber;

            searchResult = returnedResult;
            deferred.resolve(returnedResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.queryCodeTypeChildren = function (pageNumber) {
        var deferred = $q.defer();

        var codeType = null;
        if (selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'ADD' || selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'MCT' || selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'GCR' || selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'GGP' || selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'FOO' || selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'REL' || selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'BLT') {
            codeType = selectedCodelist.codeTypeId;
        }

        var options = {
            codetype: codeType,
            type: selectedCodelist.type,
            applicableDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            language: searchCriteria.language,
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol
        };

        if (pageNumber) {
            options.offset = CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = CodeLists.queryCodeTypeChildren(options, function () {
            viewResult = {};
            viewResult.totalItems = result.count;
            viewResult.codeTypeChildrenResult = result.items;

            if (pageNumber) {
                viewResult.currentPage = pageNumber;
            }

            deferred.resolve(viewResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.queryHtmlCodeTypes = function () {
        var deferred = $q.defer();

        var options = {
            codetype: CommonHelper.removeSpaceCharacters(searchCriteria.codeType),
            language: searchCriteria.language
        };

        var result = CodeLists.queryHtmlCodeTypes(options, function () {
            searchResult = {};
            searchResult.htmlTypeContent = result.htmlTypeContent;

            deferred.resolve(searchResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getSelectedRow = function () {
        return model.queryCodeTypeChildren();
    };
}]);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var taricCodelists = angular.module('taric.moreinfo.codelists', ['taric.moreinfo.codelists.search', 'taric.moreinfo.codelists.view']);
taricCodelists.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.moreinfo.codelists', {
        abstract: true,
        url: '/codelists',
        template: '<ui-view></ui-view>'
    }).state('taric.moreinfo.codelists.search', {
        url: '/search?sd&ct&l&ql&frm',
        templateUrl: 'taric/moreinfo/codelists/search/codelists-search.tmpl.html',
        controller: 'SearchCodelistsController as searchCodelistsCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["CodeListsModel", "$stateParams", "$translate", "CommonHelper", function initializeData(CodeListsModel, $stateParams, $translate, CommonHelper) {
                if ($stateParams.frm !== 'taric.moreinfo.codelists.view') {
                    CodeListsModel.reset();
                }
                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        CodeListsModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.ct) {
                    CodeListsModel.getSearchCriteria().codeType = $stateParams.ct;
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                    CodeListsModel.getSearchCriteria().language = $stateParams.l;
                }
                if ($stateParams.ql) {
                    CodeListsModel.getSearchCriteria().language = $stateParams.ql;
                }
            }],
            preferredUILanguages: ["LanguageModel", function preferredUILanguages(LanguageModel) {
                return LanguageModel.getPreferredUILanguages();
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/moreinfo/codelists');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.moreinfo.codelists.view', {
        url: '/view',
        templateUrl: 'taric/moreinfo/codelists/view/codelists-view.tmpl.html',
        controller: 'ViewCodelistsController as viewCodelistsCtrl',
        resolve: {
            codeTypeChildren: ["CodeListsModel", function codeTypeChildren(CodeListsModel) {
                return CodeListsModel.getSelectedRow();
            }],
            simulationDate: ["CodeListsModel", function simulationDate(CodeListsModel) {
                return CodeListsModel.getSearchCriteria().simulationDate;
            }],
            showCancelButton: function showCancelButton() {
                return true;
            },
            $uibModalInstance: function $uibModalInstance() {
                return null;
            },
            codeType: ["CodeListsModel", function codeType(CodeListsModel) {
                return CodeListsModel.getSearchCriteria().codeType;
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.moreinfo.codelists.view', ['taric.model.codelists', 'common.helper', 'common.filter.specialCharacterToHtml', 'common.filter.description']).controller('ViewCodelistsController', ["codeTypeChildren", "CodeListsModel", "simulationDate", "showCancelButton", "$uibModal", "$uibModalInstance", "$state", "CONSTANTS", "CommonHelper", "$filter", "$rootScope", "$scope", "$timeout", function (codeTypeChildren, CodeListsModel, simulationDate, showCancelButton, $uibModal, $uibModalInstance, $state, CONSTANTS, CommonHelper, $filter, $rootScope, $scope, $timeout) {
    var viewCodelistsCtrl = this;
    viewCodelistsCtrl.selectedRow = codeTypeChildren;
    viewCodelistsCtrl.viewCodelistsResult = null;
    viewCodelistsCtrl.viewCriteria = CodeListsModel.getSearchCriteria();
    viewCodelistsCtrl.numberOfColumn = 2;

    if (viewCodelistsCtrl.selectedRow !== null) {
        viewCodelistsCtrl.dateFormat = CONSTANTS.dateFormat;
        viewCodelistsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        viewCodelistsCtrl.showCancelButton = showCancelButton;
        viewCodelistsCtrl.selectedCodelist = CodeListsModel.getSelectedCodelist();
    }

    if (viewCodelistsCtrl.selectedCodelist.codeTypeId === 'ADD' && viewCodelistsCtrl.selectedCodelist.type === '7') {
        viewCodelistsCtrl.selectedRow.totalItems = -1;
        viewCodelistsCtrl.selectedRow.infoMessage = "i8n.qry.cl.queryCodeListViewBean.adcoType7_detail";
    }

    if (viewCodelistsCtrl.selectedCodelist.codeTypeId === 'ADD' && viewCodelistsCtrl.selectedCodelist.type === '9') {
        viewCodelistsCtrl.numberOfColumn = 3;
    }

    viewCodelistsCtrl.resetViewCodelistsResult = function () {
        viewCodelistsCtrl.selectedRow = null;
        CodeListsModel.resetViewResult();
    };

    // Load data for a given page
    viewCodelistsCtrl.loadDataFromServer = function (pageNumber) {
        // Reset view result before searching
        viewCodelistsCtrl.resetViewCodelistsResult();

        viewCodelistsCtrl.searching = true;
        CodeListsModel.queryCodeTypeChildren(pageNumber).then(function (selectedRow) {
            viewCodelistsCtrl.selectedRow = selectedRow;
            viewCodelistsCtrl.searching = false;
        }, function (error) {
            viewCodelistsCtrl.errorCode = error.data.code;
            viewCodelistsCtrl.errorParams = error.data.params;
            viewCodelistsCtrl.searching = false;
        });
    };

    // Handle page change for the codelists view result table
    viewCodelistsCtrl.viewCodelistsResultPageChanged = function (pageNumber) {
        viewCodelistsCtrl.loadDataFromServer(pageNumber);
    };

    // export excel
    viewCodelistsCtrl.exportExcel = function () {

        $rootScope.$broadcast('startSpinningExport');

        // query all the data without pagination in the database
        CodeListsModel.queryCodeTypeChildren().then(function (selectedRow) {

            // extract dates from html
            var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
            viewCodelistsCtrl.selectedAllRow = selectedRow;
            document.getElementById('reportDateExtr').innerHTML = reportDate;

            // wait 1s for front end to render
            setTimeout(function () {

                var columnLength = document.getElementById('exportExcelTable').rows[4].cells.length;
                var title = $filter('description')(viewCodelistsCtrl.selectedCodelist.descriptions);

                // column length format of excel
                var ws = {
                    '!cols': [{
                        wpx: 180
                    }, {
                        wpx: 550
                    }, {
                        wpx: 250
                    }]
                };

                if (columnLength > 2) {

                    ws = {
                        '!cols': [{
                            wpx: 180
                        }, {
                            wpx: 250
                        }, {
                            wpx: 550
                        }, {
                            wpx: 150
                        }]
                    };
                }

                // because this report is special, it has its own format function
                CommonHelper.printExcel("exportExcelTable", title, ws, function (cell, R, C) {

                    // R is row and C is column
                    // some cells in this report has special formats
                    if (R === 0 && C === 0) {
                        cell.s = {
                            font: {
                                name: CONSTANTS.printableFont,
                                bold: true,
                                sz: 12
                            },
                            alignment: {
                                horizontal: "center"
                            }
                        };
                    } else if ((R === 1 || R === 2) && C === 0) {
                        cell.s = {
                            font: {
                                name: CONSTANTS.printableFont,
                                bold: true,
                                sz: 12
                            },
                            alignment: {
                                horizontal: "left"
                            }
                        };
                    } else if (R === 0 && C > 0) {
                        cell.s = {
                            font: {
                                name: CONSTANTS.printableFont,
                                bold: true
                            },
                            alignment: {
                                horizontal: "right"
                            }
                        };
                    } else if (R === 4) {
                        cell.s = {
                            font: {
                                name: CONSTANTS.printableFont,
                                bold: true,
                                sz: 11
                            },
                            alignment: {
                                horizontal: "center"
                            },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } }
                            }
                        };
                    } else if (R > 4) {
                        cell.s = {
                            font: {
                                name: CONSTANTS.printableFont,
                                sz: 10
                            },
                            alignment: {
                                wrapText: 1,
                                horizontal: "left"
                            }
                        };

                        if (C < 2 && columnLength > 2) cell.s.alignment = { horizontal: "center" };else if (C === 0) cell.s.alignment = { horizontal: "center" };
                    }
                }).then(function () {
                    $rootScope.$broadcast('stopSpinningExport');
                }, function () {
                    $rootScope.$broadcast('stopSpinningExport');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            $rootScope.$broadcast('stopSpinningExport');
        });
    };

    // print pdf
    viewCodelistsCtrl.print = function (options) {
        $rootScope.$broadcast('startSpinningPrint');

        // query all the data without pagination in the database
        CodeListsModel.queryCodeTypeChildren().then(function (selectedRow) {

            var items = [];

            // If description is long, this method is used to break the long description into multiple rows
            angular.forEach(selectedRow.codeTypeChildrenResult, function (codeTypeChildrenResult) {

                var description = $filter('description')(codeTypeChildrenResult.descriptions, viewCodelistsCtrl.viewCriteria.language);
                description = $filter('specialCharacterToHtml')(description);

                // the limit is 1689 characters. it is the number of characters that a row can have before it overlaps footer
                if (description && description.length > 1689) {
                    var desc1 = description.substring(0, 1689);
                    var desc2 = description.substring(1689);

                    // this is used to maintain breaking line after trimming. We dont want to see a half-break word here
                    var lastDot = desc2.indexOf("<br>");
                    codeTypeChildrenResult.descriptions = desc1 + desc2.substring(0, lastDot + 4);

                    items.push(codeTypeChildrenResult);
                    items.push({ descriptions: desc2.substring(lastDot + 4), code: '', additionalInformation: '' });
                } else {

                    codeTypeChildrenResult.descriptions = description;
                    items.push(codeTypeChildrenResult);
                }
            });
            viewCodelistsCtrl.selectedAllRow = items;

            // wait 1s before rendering
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportBodyTable'), options);

                // Only print view result table when there are data.
                if (viewCodelistsCtrl.selectedAllRow.length > 0) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);
                }

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(simulationDate, CONSTANTS.dateFormat),
                    title: $filter('description')(viewCodelistsCtrl.selectedCodelist.descriptions)
                }, 'p').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {
            viewCodelistsCtrl.errorCode = error.data.code;
            viewCodelistsCtrl.errorParams = error.data.params;
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, viewCodelistsCtrl.print, true);
    });

    $scope.$on('exportDocument', function (event, data) {

        viewCodelistsCtrl.exportExcel();
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        viewCodelistsCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            viewCodelistsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('taric.model.links', ['common.helper', 'ngResource']).factory('TariffLinks', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/link/links', {}, {
        queryLinksExternal: {
            method: 'GET',
            isArray: false
        },
        queryLinks: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/link/links/:type'
        }
    });
}]).service('TaricLinksSearchModel', ["TariffLinks", "$q", "CommonHelper", "CONSTANTS", function (TariffLinks, $q, CommonHelper, CONSTANTS) {
    var model = this;
    model.searchTariffLinks = function (page) {
        var deferred = $q.defer();
        var options = {
            simulationdate: CommonHelper.getRestDateString(new Date())
        };

        if (page) {
            options.offset = CommonHelper.getOffset(page);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = TariffLinks.queryLinksExternal(options, function () {
            var searchLinksResult = {};
            searchLinksResult.totalItems = result.count;
            searchLinksResult.tariffLinks = result.items;
            searchLinksResult.currentLinksPage = page;
            deferred.resolve(searchLinksResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    model.searchTariffLinksType = function (type, simulationDate) {
        var deferred = $q.defer();
        var result = void 0;
        if (simulationDate !== null && simulationDate !== undefined) {
            result = TariffLinks.queryLinks({
                type: type,
                simulationdate: CommonHelper.getRestDateString(simulationDate)
            }, function () {
                var searchLinksResult = {};
                searchLinksResult.count = result.count;
                searchLinksResult.items = result.items;
                deferred.resolve(searchLinksResult);
            }, function (error) {
                deferred.reject(error);
            });
        } else {
            result = TariffLinks.queryLinks({
                type: type
            }, function () {
                var searchLinksResult = {};
                searchLinksResult.count = result.count;
                searchLinksResult.items = result.items;
                deferred.resolve(searchLinksResult);
            }, function (error) {
                deferred.reject(error);
            });
        }
        return deferred.promise;
    };
}]);

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var taricLinksSearch = angular.module('taric.moreinfo.links.search', ['taric.model.links']).controller('SearchTaricLinksController', ["CONSTANTS", "TaricLinksSearchModel", "$state", "$translatePartialLoader", "CommonHelper", "$filter", "$uibModal", "$rootScope", "$scope", "$timeout", function (CONSTANTS, TaricLinksSearchModel, $state, $translatePartialLoader, CommonHelper, $filter, $uibModal, $rootScope, $scope, $timeout) {
    var searchTaricLinksCtrl = this;

    //Load data for a given page
    searchTaricLinksCtrl.loadDataFromServer = function (count) {
        TaricLinksSearchModel.searchTariffLinks(count).then(function (searchLinksResult) {
            searchTaricLinksCtrl.searchLinksResult = searchLinksResult;
            searchTaricLinksCtrl.searchClicked = false;
            searchTaricLinksCtrl.searching = false;
        }, function (error) {
            searchTaricLinksCtrl.hasError = true;
            searchTaricLinksCtrl.errorCode = error.code;
            searchTaricLinksCtrl.searchClicked = false;
            searchTaricLinksCtrl.searching = false;
        });
    };

    //Handle page change for the quota search result table
    searchTaricLinksCtrl.searchLinksResultPageChanged = function (count) {
        searchTaricLinksCtrl.loadDataFromServer(count);
    };

    searchTaricLinksCtrl.init = function () {
        searchTaricLinksCtrl.loadDataFromServer(1);
        searchTaricLinksCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
    };

    searchTaricLinksCtrl.print = function (options) {

        $rootScope.$broadcast('startSpinningPrint');
        TaricLinksSearchModel.searchTariffLinks().then(function (searchLinksResult) {

            searchTaricLinksCtrl.searchLinksAllResult = searchLinksResult;
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(new Date(), CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qry.link.report.report.title')
                }, 'p').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchTaricLinksCtrl.print, true);
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        searchTaricLinksCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            searchTaricLinksCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var taricLinks = angular.module('taric.moreinfo.links', ['taric.moreinfo.links.search']);
taricLinks.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.moreinfo', {
        abstract: true,
        url: '/moreinfo',
        template: '<ui-view></ui-view>'
    }).state('taric.moreinfo.links', {
        url: '/links',
        templateUrl: 'taric/moreinfo/links/search/links-search.tmpl.html',
        controller: 'SearchTaricLinksController as searchTaricLinksCtrl',
        resolve: {
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/moreinfo/links');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 8/25/2016.
 */
angular.module('taric.model.ct', ['common.helper', 'ngResource']).factory('QueryCtCommodity', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ct/query', {}, {
        query: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('CorrelationTableModel', ["$q", "CONSTANTS", "CommonHelper", "QueryCtCommodity", function ($q, CONSTANTS, CommonHelper, QueryCtCommodity) {
    var model = this;
    var searchCriteria = {};
    var searchCommodityResult = null;
    model.getSearchCommodityResult = function () {
        return searchCommodityResult;
    };
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.startDate = new Date();
        searchCriteria.endDate = null;
        searchCriteria.direction = 'I';
        searchCriteria.commodityCodeRangeStart = null;
        searchCriteria.commodityCodeRangeEnd = null;
    };
    model.resetSearchResult = function () {
        searchCommodityResult = null;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();
    model.searchCommodities = function (page) {
        var deferred = $q.defer();
        var options = {
            startDate: CommonHelper.getRestDateString(searchCriteria.startDate),
            endDate: CommonHelper.getRestDateString(searchCriteria.endDate),
            tradeDirection: searchCriteria.direction,
            commodityCodeRangeStart: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeRangeStart),
            commodityCodeRangeEnd: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeRangeEnd),
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol
        };

        if (page) {
            options.offset = CommonHelper.getOffset(page);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = QueryCtCommodity.query(options, function () {

            var returnedResult = {};
            returnedResult.totalItems = result.count;
            returnedResult.items = result.items;
            returnedResult.currentPage = page;
            if (page) {
                searchCommodityResult = returnedResult;
            }
            deferred.resolve(returnedResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 8/24/2016.
 */
angular.module('nomenclature.ct', ['taric.model.ct', 'common.filter.commoditycode']).controller('CorrelationTableController', ["CONSTANTS", "$translatePartialLoader", "CorrelationTableModel", "CommonHelper", "$state", "$rootScope", "$scope", "$filter", "$timeout", "$stateParams", "$translate", "$location", function (CONSTANTS, $translatePartialLoader, CorrelationTableModel, CommonHelper, $state, $rootScope, $scope, $filter, $timeout, $stateParams, $translate, $location) {
    var correlationTableCtrl = this;
    correlationTableCtrl.init = function () {
        correlationTableCtrl.installationCountry = CONSTANTS.installationCountry;
        correlationTableCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        correlationTableCtrl.dateFormat = CONSTANTS.dateFormat;
        correlationTableCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        correlationTableCtrl.searchCriteria = CorrelationTableModel.getSearchCriteria();
        correlationTableCtrl.searchCommodityResult = CorrelationTableModel.getSearchCommodityResult();

        if (correlationTableCtrl.isExternalLink() && correlationTableCtrl.validateExternalParameters()) {
            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            correlationTableCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    correlationTableCtrl.isExternalLink = function () {
        // Verify 'frm' parameter to avoid auto-search after looking up commodity code.
        return (!$stateParams.frm || $stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'ccView') && $stateParams.ds;
    };

    // Check whether the external parameters are valid or not
    correlationTableCtrl.validateExternalParameters = function () {
        return correlationTableCtrl.validateSearchForm();
    };

    correlationTableCtrl.openStartDatePicker = function ($event) {
        correlationTableCtrl.isStartDatePickerOpen = true;
    };
    correlationTableCtrl.openEndDatePicker = function ($event) {
        correlationTableCtrl.isEndDatePickerOpen = true;
    };

    correlationTableCtrl.search = function () {
        //Load data for the first page
        correlationTableCtrl.loadDataFromServer(1);
    };

    //Load data for a given page
    correlationTableCtrl.loadDataFromServer = function (page) {
        if (!correlationTableCtrl.validateSearchForm()) {
            return;
        }

        correlationTableCtrl.loadDataFromServerWithoutValidation(page);
    };

    //Load data for a given page without validation
    correlationTableCtrl.loadDataFromServerWithoutValidation = function (page) {
        // Reset search result before searching
        correlationTableCtrl.resetSearchResult();
        correlationTableCtrl.searching = true;
        CorrelationTableModel.searchCommodities(page).then(function (searchCommodityResult) {
            correlationTableCtrl.searchCommodityResult = searchCommodityResult;
            correlationTableCtrl.searching = false;
            correlationTableCtrl.updateBrowserURL();
        }, function (error) {
            correlationTableCtrl.errorCode = error.data.code;
            correlationTableCtrl.errorParams = error.data.params;
            correlationTableCtrl.searching = false;
        });
    };

    /**
     * Query correlation table
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/nomenclature/ct?d={TradeDirection}&ccs={CommodityCodeStart}&cce={CommodityCodeEnd}&ds={DateStart}&de={DateEnd}&crt={CorrelationType}&l={Language}
     *
     * Example:
     * http://localhost:8080/arctictariff-public-web/#!/taric/nomenclature/ct?d=I&ccs=1005109000&cce=2208904100&ds=2015-01-01&de=2015-12-31&crt=N&l=en
     */
    correlationTableCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep additional parameters because there is no return to caller page
        $location.search({
            d: correlationTableCtrl.searchCriteria.direction,
            ccs: CommonHelper.removeSpaceCharacters(correlationTableCtrl.searchCriteria.commodityCodeRangeStart),
            cce: CommonHelper.removeSpaceCharacters(correlationTableCtrl.searchCriteria.commodityCodeRangeEnd),
            ds: CommonHelper.getBookmarkDateString(correlationTableCtrl.searchCriteria.startDate),
            de: CommonHelper.getBookmarkDateString(correlationTableCtrl.searchCriteria.endDate),
            crt: correlationTableCtrl.searchCriteria.correlationType,
            l: $translate.use()
        }).replace();
    };

    correlationTableCtrl.resetSearchResult = function () {
        correlationTableCtrl.searchCommodityResult = null;
        CorrelationTableModel.resetSearchResult();
    };

    correlationTableCtrl.validateSearchForm = function () {
        correlationTableCtrl.resetError();

        return correlationTableCtrl.validateDates() && correlationTableCtrl.validateCommodityCodes();
    };

    correlationTableCtrl.validateDates = function () {
        correlationTableCtrl.errorCode = CommonHelper.validateSimulationDate(correlationTableCtrl.searchCriteria.startDate);
        if (correlationTableCtrl.errorCode) {
            correlationTableCtrl.errorParams = { param0: CONSTANTS.pastDate };
            return false;
        }
        if (CommonHelper.compareDatesWithoutTime(correlationTableCtrl.searchCriteria.startDate, correlationTableCtrl.searchCriteria.endDate) > 0) {
            correlationTableCtrl.errorCode = "i8n.common.invalidPeriod";
            return false;
        }
        return true;
    };

    correlationTableCtrl.validateCommodityCodes = function () {
        var ccRangeStart = CommonHelper.removeSpaceCharacters(correlationTableCtrl.searchCriteria.commodityCodeRangeStart);
        var ccRangeEnd = CommonHelper.removeSpaceCharacters(correlationTableCtrl.searchCriteria.commodityCodeRangeEnd);
        if (ccRangeStart !== "" && ccRangeEnd !== "" && ccRangeStart.localeCompare(ccRangeEnd) > 0) {
            correlationTableCtrl.errorCode = "i8n.qry.ct.invalid.commodityCodes";
            return false;
        }
        correlationTableCtrl.errorCode = CommonHelper.validateCommodityCode(correlationTableCtrl.searchCriteria.commodityCodeRangeStart, correlationTableCtrl.searchCriteria.direction);
        if (correlationTableCtrl.errorCode) {
            return false;
        }
        correlationTableCtrl.errorCode = CommonHelper.validateCommodityCode(correlationTableCtrl.searchCriteria.commodityCodeRangeEnd, correlationTableCtrl.searchCriteria.direction);
        if (correlationTableCtrl.errorCode) {
            return false;
        }

        return true;
    };

    correlationTableCtrl.resetError = function () {
        correlationTableCtrl.errorCode = null;
        correlationTableCtrl.errorParams = null;
    };

    correlationTableCtrl.searchCommodityResultPageChanged = function (page) {
        correlationTableCtrl.loadDataFromServer(page);
    };

    correlationTableCtrl.selectCommodityCode = function (commodityCode, date, type, ccField) {

        $state.go('taric.nomenclature.sbn', {
            cc: CommonHelper.removeSpaceCharacters(commodityCode),
            sd: CommonHelper.getBookmarkDateString(date),
            d: correlationTableCtrl.searchCriteria.direction,
            frm: 'taric.nomenclature.ct',
            type: type,
            ccField: ccField
        });
    };

    correlationTableCtrl.selectCommodityCodeRangeStart = function (commodityCode) {
        correlationTableCtrl.selectCommodityCode(commodityCode, correlationTableCtrl.searchCriteria.startDate, "lookup", "commodityCodeRangeStart");
    };

    correlationTableCtrl.selectCommodityCodeRangeEnd = function (commodityCode) {
        correlationTableCtrl.selectCommodityCode(commodityCode, correlationTableCtrl.searchCriteria.startDate, "lookup", "commodityCodeRangeEnd");
    };

    correlationTableCtrl.onStartDateChange = function (dateString) {
        correlationTableCtrl.resetError();
        correlationTableCtrl.searchCriteria.startDate = CommonHelper.formatDate(correlationTableCtrl.searchCriteria.startDate, dateString);
    };

    correlationTableCtrl.onEndDateChange = function (dateString) {
        correlationTableCtrl.resetError();
        correlationTableCtrl.searchCriteria.endDate = CommonHelper.formatDate(correlationTableCtrl.searchCriteria.endDate, dateString);
    };

    //export excel
    correlationTableCtrl.exportExcel = function () {
        if (!correlationTableCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningExport');
        CorrelationTableModel.searchCommodities().then(function (searchCommodityResult) {

            var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
            correlationTableCtrl.searchCommodityAllResult = searchCommodityResult;
            document.getElementById('reportDateExtr').innerHTML = reportDate;

            setTimeout(function () {
                var title = $filter('translate')('i8n.common.menu.query.nomenclature.correlationTable');
                var ws = {
                    '!cols': [{
                        wpx: 330
                    }, {
                        wpx: 330
                    }, {
                        wpx: 330
                    }, {
                        wpx: 330
                    }]
                };

                CommonHelper.printExcel("exportExcelTable", title, ws).then(function () {
                    $rootScope.$broadcast('stopSpinningExport');
                }, function () {
                    $rootScope.$broadcast('stopSpinningExport');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    // export pdf
    correlationTableCtrl.print = function (options) {

        if (!correlationTableCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        CorrelationTableModel.searchCommodities().then(function (searchCommodityResult) {

            correlationTableCtrl.searchCommodityAllResult = searchCommodityResult;
            setTimeout(function () {

                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(correlationTableCtrl.searchCriteria.startDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.common.menu.query.nomenclature.correlationTable')
                }, 'p').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('exportDocument', function (event, data) {

        correlationTableCtrl.exportExcel();
    });

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, correlationTableCtrl.print, true);
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        correlationTableCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            correlationTableCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sbn = angular.module('nomenclature.sbn', ['common.directive.gonoTree']).controller('SearchByNomenclatureController', ["CONSTANTS", "$translatePartialLoader", "SearchByNomenclatureModel", "preferredUILanguages", "links", "$stateParams", "$uibModal", "CommonHelper", "$state", "GoodsNomenclatureTreeModel", "$filter", "$translate", "$location", "$anchorScroll", function (CONSTANTS, $translatePartialLoader, SearchByNomenclatureModel, preferredUILanguages, links, $stateParams, $uibModal, CommonHelper, $state, GoodsNomenclatureTreeModel, $filter, $translate, $location, $anchorScroll) {
    var searchByNomenclatureCtrl = this;
    searchByNomenclatureCtrl.init = function () {
        searchByNomenclatureCtrl.searchCriteria = SearchByNomenclatureModel.getSearchCriteria();
        searchByNomenclatureCtrl.links = links.items;
        searchByNomenclatureCtrl.languages = preferredUILanguages.items;
        searchByNomenclatureCtrl.dateFormat = CONSTANTS.dateFormat;
        searchByNomenclatureCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        searchByNomenclatureCtrl.gonoTreeConfig = CONSTANTS.gonoTree;
        searchByNomenclatureCtrl.searchCriteria.language = CommonHelper.getValidSelectedItem(searchByNomenclatureCtrl.languages, searchByNomenclatureCtrl.searchCriteria.language, CommonHelper.getLanguageCode(CONSTANTS.availableLanguages[0]));
        searchByNomenclatureCtrl.updateExpandAll();
        searchByNomenclatureCtrl.search();
    };

    searchByNomenclatureCtrl.search = function () {
        searchByNomenclatureCtrl.errorCode = CommonHelper.validateCommodityCode(searchByNomenclatureCtrl.searchCriteria.commodityCode, searchByNomenclatureCtrl.searchCriteria.direction);
        if (searchByNomenclatureCtrl.errorCode) {
            return;
        }
        if (!CONSTANTS.dateRestrictionEnabled) {
            searchByNomenclatureCtrl.errorCode = CommonHelper.validateSimulationDate(searchByNomenclatureCtrl.searchCriteria.simulationDate);
            if (searchByNomenclatureCtrl.errorCode) {
                searchByNomenclatureCtrl.errorParams = { param0: CONSTANTS.pastDate };
                return;
            }
        }
        searchByNomenclatureCtrl.searching = true;
        searchByNomenclatureCtrl.treeDataList = null;
        SearchByNomenclatureModel.searchGoodsNomenclature(searchByNomenclatureCtrl.searchCriteria.commodityCode, searchByNomenclatureCtrl.searchCriteria.direction, searchByNomenclatureCtrl.searchCriteria.simulationDate, searchByNomenclatureCtrl.searchCriteria.language).then(function (result) {
            searchByNomenclatureCtrl.treeDataList = GoodsNomenclatureTreeModel.buildGonoTree(result.items, searchByNomenclatureCtrl.searchCriteria.commodityCode, searchByNomenclatureCtrl.searchCriteria.expandAll);
            searchByNomenclatureCtrl.searching = false;
            searchByNomenclatureCtrl.checkForCommodityCodeExistence();
            if (searchByNomenclatureCtrl.treeDataList) {
                searchByNomenclatureCtrl.treeDataList.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchByNomenclatureCtrl.searchCriteria.simulationDate);
                if (searchByNomenclatureCtrl.treeDataList.infoCode && "i8n.common.pastDate" === searchByNomenclatureCtrl.treeDataList.infoCode) {
                    searchByNomenclatureCtrl.treeDataList.infoParams = CONSTANTS.pastDate;
                }
            }

            searchByNomenclatureCtrl.updateBrowserURL();
        }, function (error) {
            searchByNomenclatureCtrl.errorCode = error.data.code;
            searchByNomenclatureCtrl.errorParams = error.data.params;
            searchByNomenclatureCtrl.searching = false;
            searchByNomenclatureCtrl.remapErrorParameters();
        });
    };

    /**
     * Search goods nomenclature
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/nomenclature/sbn?sd={SimulationDate}&d={TradeDirection}&cc={CommodityCode}&l={Language}&ql={QueryLanguage}&ea={ExpandAllSearchResults}
     *
     * Example:
     * http://www.testenv.se/arctictariff-public-web/#!/taric/nomenclature/sbn?sd=2015-01-01&d=I&cc=1005109000&l=en&ql=en&ea=true
     */
    searchByNomenclatureCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }
        // Keep additional parameters 'frm', 'type', 'ccField' to return to caller page.
        $location.search({
            sd: CommonHelper.getBookmarkDateString(searchByNomenclatureCtrl.searchCriteria.simulationDate),
            d: searchByNomenclatureCtrl.searchCriteria.direction,
            cc: CommonHelper.removeSpaceCharacters(searchByNomenclatureCtrl.searchCriteria.commodityCode),
            l: $translate.use(),
            ql: searchByNomenclatureCtrl.searchCriteria.language,
            ea: searchByNomenclatureCtrl.searchCriteria.expandAll.toString(),
            frm: $stateParams.frm,
            type: $stateParams.type,
            ccField: $stateParams.ccField
        }).replace();
    };

    searchByNomenclatureCtrl.openDatePicker = function ($event) {
        searchByNomenclatureCtrl.isDatePickerOpen = true;
    };
    searchByNomenclatureCtrl.getScreenType = function () {
        return $stateParams.type;
    };

    searchByNomenclatureCtrl.returnToCallerPage = function (commodityCode) {
        var ccFieldName = $stateParams.ccField;
        if (searchByNomenclatureCtrl.getScreenType() === 'lookup' || searchByNomenclatureCtrl.getScreenType() === 'declarableCommodityCodeLookup') {
            $state.go($stateParams.frm, {
                cc: CommonHelper.removeSpaceCharacters(commodityCode),
                sd: CommonHelper.getBookmarkDateString(searchByNomenclatureCtrl.searchCriteria.simulationDate),
                d: searchByNomenclatureCtrl.searchCriteria.direction,
                ccField: ccFieldName,
                frm: 'ccLookup'
            });
        } else {
            $state.go($stateParams.frm, { frm: 'ccView' });
        }
    };

    searchByNomenclatureCtrl.isLeafNodeClickable = function () {
        return searchByNomenclatureCtrl.getScreenType() !== 'lookup' && searchByNomenclatureCtrl.getScreenType() !== 'declarableCommodityCodeLookup';
    };

    searchByNomenclatureCtrl.invokedFromOtherScreen = function () {
        return !!$stateParams.frm;
    };

    searchByNomenclatureCtrl.shouldDisplayExportRefund = function () {
        return $stateParams.type !== 'lookup' && $stateParams.type !== 'declarableCommodityCodeLookup';
    };

    searchByNomenclatureCtrl.resetError = function () {
        searchByNomenclatureCtrl.handleError(null);
    };

    searchByNomenclatureCtrl.handleError = function (error) {
        if (!error) {
            searchByNomenclatureCtrl.errorCode = null;
            searchByNomenclatureCtrl.errorParams = null;
        } else {
            searchByNomenclatureCtrl.errorCode = error.errorCode;
            searchByNomenclatureCtrl.errorParams = error.errorParams;
        }
    };

    searchByNomenclatureCtrl.formatCommodityCode = function () {
        var formattedCommodityCode = $filter('commodityCode')(searchByNomenclatureCtrl.searchCriteria.commodityCode);
        searchByNomenclatureCtrl.searchCriteria.commodityCode = formattedCommodityCode;
    };

    searchByNomenclatureCtrl.onCommodityCodeChange = function () {
        searchByNomenclatureCtrl.formatCommodityCode();
        searchByNomenclatureCtrl.updateExpandAll();
    };

    searchByNomenclatureCtrl.updateExpandAll = function () {
        var commodityCode = CommonHelper.removeSpaceCharacters(searchByNomenclatureCtrl.searchCriteria.commodityCode);
        searchByNomenclatureCtrl.shouldEnableExpandAll = commodityCode.length >= 2;
        if (!searchByNomenclatureCtrl.shouldEnableExpandAll) {
            searchByNomenclatureCtrl.searchCriteria.expandAll = false;
        }
    };

    searchByNomenclatureCtrl.checkForCommodityCodeExistence = function () {
        if (searchByNomenclatureCtrl.treeDataList === null || searchByNomenclatureCtrl.treeDataList.length === 0) {
            searchByNomenclatureCtrl.errorCode = "tqf.cc.notFound";
            searchByNomenclatureCtrl.errorParams = { param0: searchByNomenclatureCtrl.searchCriteria.commodityCode, param1: searchByNomenclatureCtrl.searchCriteria.commodityCode };
        }
    };

    searchByNomenclatureCtrl.remapErrorParameters = function () {
        if (searchByNomenclatureCtrl.errorCode === "tqf.cc.notFound") {
            searchByNomenclatureCtrl.errorParams = { param0: searchByNomenclatureCtrl.searchCriteria.commodityCode, param1: searchByNomenclatureCtrl.searchCriteria.commodityCode };
        }
    };

    searchByNomenclatureCtrl.onDateChange = function (dateString) {
        searchByNomenclatureCtrl.resetError();
        searchByNomenclatureCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchByNomenclatureCtrl.searchCriteria.simulationDate, dateString);
        if (searchByNomenclatureCtrl.searchCriteria.simulationDate) {
            SearchByNomenclatureModel.getLinks(searchByNomenclatureCtrl.searchCriteria.simulationDate).then(function (links) {
                searchByNomenclatureCtrl.links = links.items;
            }, function (error) {
                searchByNomenclatureCtrl.errorCode = error.data.code;
                searchByNomenclatureCtrl.errorParams = error.data.params;
            });
        }
    };
}]);

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.sbt', ['common.helper', 'ngResource']).factory('QuerySbt', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/sbt/query', {}, {
        query: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('SearchByTextModel', ["$q", "$translate", "CONSTANTS", "CommonHelper", "QuerySbt", function ($q, $translate, CONSTANTS, CommonHelper, QuerySbt) {
    var model = this;
    var searchCriteria = null;
    var searchResult = null;
    model.getSearchResult = function () {
        return searchResult;
    };
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.textSearch = null;
        searchCriteria.goodsNomenclatureDescription = true;
        searchCriteria.additionalCodeDescription = true;
        searchCriteria.footnoteDescription = true;
        searchCriteria.language = CommonHelper.getLanguageCode($translate.use());
        searchCriteria.ascending = true;
    };
    model.resetSearchResult = function () {
        searchResult = null;
    };
    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };
    model.reset();
    model.searchText = function (page) {
        var deferred = $q.defer();
        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            textSearch: searchCriteria.textSearch,
            additionalCodeDescription: searchCriteria.additionalCodeDescription,
            footnoteDescription: searchCriteria.footnoteDescription,
            goodsNomenclatureDescription: searchCriteria.goodsNomenclatureDescription,
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol,
            language: CommonHelper.removeSpaceCharacters(searchCriteria.language)
        };

        if (page) {

            options.offset = CommonHelper.getOffset(page);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = QuerySbt.query(options, function () {
            var returnedResult = {};
            returnedResult.totalItems = result.count;
            returnedResult.items = result.items;
            returnedResult.currentPage = page;
            if (page) {
                searchResult = returnedResult;
            }
            deferred.resolve(returnedResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('nomenclature.sbt', ['taric.model.sbt']).controller('SearchByTextController', ["CONSTANTS", "$translatePartialLoader", "SearchByTextModel", "preferredUILanguages", "CommonHelper", "$state", "$rootScope", "$scope", "$filter", "$timeout", "$stateParams", "$translate", "$location", function (CONSTANTS, $translatePartialLoader, SearchByTextModel, preferredUILanguages, CommonHelper, $state, $rootScope, $scope, $filter, $timeout, $stateParams, $translate, $location) {
    var searchByTextCtrl = this;

    searchByTextCtrl.init = function () {
        searchByTextCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        searchByTextCtrl.dateFormat = CONSTANTS.dateFormat;
        searchByTextCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        searchByTextCtrl.languages = preferredUILanguages.items;
        searchByTextCtrl.searchCriteria = SearchByTextModel.getSearchCriteria();
        searchByTextCtrl.searchResult = SearchByTextModel.getSearchResult();

        searchByTextCtrl.searchCriteria.language = CommonHelper.getValidSelectedItem(searchByTextCtrl.languages, searchByTextCtrl.searchCriteria.language, CommonHelper.getLanguageCode(CONSTANTS.availableLanguages[0]));

        if (searchByTextCtrl.isExternalLink() && searchByTextCtrl.validateExternalParameters()) {
            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            searchByTextCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    searchByTextCtrl.isExternalLink = function () {
        // Verify 'frm' parameter to avoid auto-search after looking up commodity code.
        return (!$stateParams.frm || $stateParams.frm !== 'ccView' && $stateParams.frm !== 'adcoView' && $stateParams.frm !== 'footnoteView') && $stateParams.sd && $stateParams.ts;
    };

    // Check whether the external parameters are valid or not
    searchByTextCtrl.validateExternalParameters = function () {
        return searchByTextCtrl.validateSearchForm();
    };

    searchByTextCtrl.openDatePicker = function ($event) {
        searchByTextCtrl.isDatePickerOpen = true;
    };

    searchByTextCtrl.search = function () {
        //Load data for the first page
        searchByTextCtrl.loadDataFromServer(1);
    };

    //Load data for a given page
    searchByTextCtrl.loadDataFromServer = function (page) {
        if (!searchByTextCtrl.validateSearchForm()) {
            return;
        }

        searchByTextCtrl.loadDataFromServerWithoutValidation(page);
    };

    //Load data for a given page without validation
    searchByTextCtrl.loadDataFromServerWithoutValidation = function (page) {
        // Reset search result before searching
        searchByTextCtrl.resetSearchResult();
        searchByTextCtrl.searching = true;
        SearchByTextModel.searchText(page).then(function (searchResult) {
            searchByTextCtrl.searchResult = searchResult;
            searchByTextCtrl.searching = false;

            searchByTextCtrl.searchResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchByTextCtrl.searchCriteria.simulationDate);
            if (searchByTextCtrl.searchResult.infoCode && "i8n.common.pastDate" === searchByTextCtrl.searchResult.infoCode) {
                searchByTextCtrl.searchResult.infoParams = CONSTANTS.pastDate;
            }
            searchByTextCtrl.updateBrowserURL();
        }, function (error) {
            searchByTextCtrl.errorCode = error.data.code;
            searchByTextCtrl.errorParams = error.data.params;
            searchByTextCtrl.errorType = error.data.type;
            searchByTextCtrl.searching = false;
        });
    };

    /**
     * Search description
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/nomenclature/sbt?sd={SimulationDate}&ts={TextSearch}&gnd={GoodsNomenclatureDescription}&add={AdditionalCodeDescription}&fnd={FootnoteDescription}&ql={QueryLanguage}&l={Language}
     *
     * Example:
     * http://localhost:8080/arctictariff-public-web/#!/taric/nomenclature/sbt?sd=2015-01-01&ts=house&gnd=true&add=true&fnd=true&ql=en&l=en
     */
    searchByTextCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep additional parameters because there is no return to caller page
        $location.search({
            sd: CommonHelper.getBookmarkDateString(searchByTextCtrl.searchCriteria.simulationDate),
            ts: searchByTextCtrl.searchCriteria.textSearch,
            gnd: searchByTextCtrl.searchCriteria.goodsNomenclatureDescription.toString(),
            add: searchByTextCtrl.searchCriteria.additionalCodeDescription.toString(),
            fnd: searchByTextCtrl.searchCriteria.footnoteDescription.toString(),
            ql: searchByTextCtrl.searchCriteria.language,
            l: $translate.use()
        }).replace();
    };

    searchByTextCtrl.resetSearchResult = function () {
        searchByTextCtrl.searchResult = null;
        SearchByTextModel.resetSearchResult();
    };

    searchByTextCtrl.validateSearchForm = function () {
        searchByTextCtrl.handleError();

        if (!searchByTextCtrl.searchCriteria.simulationDate) {
            searchByTextCtrl.errorCode = 'i8n.common.mandatoryFields.missing';
            return false;
        }

        if (!searchByTextCtrl.searchCriteria.textSearch) {
            searchByTextCtrl.errorCode = 'i8n.common.mandatoryFields.missing';
            return false;
        }

        if (!searchByTextCtrl.searchCriteria.goodsNomenclatureDescription && !searchByTextCtrl.searchCriteria.additionalCodeDescription && !searchByTextCtrl.searchCriteria.footnoteDescription) {

            searchByTextCtrl.errorCode = 'i8n.common.mandatoryFields.missing';
            return false;
        }

        if (!CONSTANTS.dateRestrictionEnabled) {
            searchByTextCtrl.errorCode = CommonHelper.validateSimulationDate(searchByTextCtrl.searchCriteria.simulationDate);
            if (searchByTextCtrl.errorCode) {
                searchByTextCtrl.errorParams = { param0: CONSTANTS.pastDate };
                return false;
            }
        }

        return true;
    };

    searchByTextCtrl.searchResultPageChanged = function (page) {
        searchByTextCtrl.loadDataFromServer(page);
    };

    searchByTextCtrl.resetError = function () {
        searchByTextCtrl.handleError();
    };

    searchByTextCtrl.handleError = function (error) {
        if (!error) {
            searchByTextCtrl.errorCode = null;
            searchByTextCtrl.errorParams = null;
        } else {
            searchByTextCtrl.errorCode = error.errorCode;
            searchByTextCtrl.errorParams = error.errorParams;
        }
    };

    searchByTextCtrl.viewDetail = function (item) {
        if (item.descriptionType === 'ADDITIONAL_CODE_DESCRIPTION') {
            searchByTextCtrl.selectAdditionalCode(item);
        } else if (item.descriptionType === 'FOOTNOTE_DESCRIPTION') {
            searchByTextCtrl.selectFootnote(item);
        } else if (item.descriptionType === 'GOODS_NOMENCLATURE_DESCRIPTION') {
            searchByTextCtrl.selectCommodityCode(item);
        }
    };

    searchByTextCtrl.selectAdditionalCode = function (item) {
        $state.go('taric.adco.view', {
            sd: CommonHelper.getBookmarkDateString(searchByTextCtrl.searchCriteria.simulationDate),
            ad: CommonHelper.removeSpaceCharacters(item.id)
        });
    };

    searchByTextCtrl.selectFootnote = function (item) {
        $state.go('taric.footnote.view', {
            sd: CommonHelper.getBookmarkDateString(searchByTextCtrl.searchCriteria.simulationDate),
            fn: CommonHelper.removeSpaceCharacters(item.id)
        });
    };

    searchByTextCtrl.onDateChange = function (dateString) {
        searchByTextCtrl.resetError();
        searchByTextCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchByTextCtrl.searchCriteria.simulationDate, dateString);
    };

    searchByTextCtrl.selectCommodityCode = function (item) {
        $state.go('taric.nomenclature.sbn', {
            cc: CommonHelper.removeSpaceCharacters(item.id),
            sd: CommonHelper.getBookmarkDateString(searchByTextCtrl.searchCriteria.simulationDate),
            ql: CommonHelper.removeSpaceCharacters(searchByTextCtrl.searchCriteria.language),
            d: 'I',
            frm: 'taric.nomenclature.sbt'
        });
    };

    // export pdf
    searchByTextCtrl.print = function (options) {

        if (!searchByTextCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        SearchByTextModel.searchText().then(function (searchResult) {

            searchByTextCtrl.searchAllResult = searchResult;
            setTimeout(function () {

                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(searchByTextCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qry.sbt.search.result.description.label')
                }, 'p').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            searchByTextCtrl.errorCode = error.data.code;
            searchByTextCtrl.errorParams = error.data.params;
            searchByTextCtrl.errorType = error.data.type;
            searchByTextCtrl.searching = false;

            // show errors here
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchByTextCtrl.print, true);
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        searchByTextCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            searchByTextCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 4/25/2016.
 */

angular.module('common.directive.gonoTree', ['taric.model.nomenclature', 'common.template.footnote.popup', 'common.filter.url', 'common.filter.specialCharacterToHtml', 'common.helper']).component('gonoTree', {
    bindings: {
        data: '=',
        screenType: '@',
        simulationDate: '<',
        tradeDirection: '<',
        commodityCode: '<',
        leafNodeClickable: '<',
        language: '<',
        onSelectCommodityCode: '&',
        onHandleError: '&'
    },
    controller: ["SearchByNomenclatureModel", "GoodsNomenclatureTreeModel", "$stateParams", "$uibModal", "$state", "CommonHelper", "CONSTANTS", function controller(SearchByNomenclatureModel, GoodsNomenclatureTreeModel, $stateParams, $uibModal, $state, CommonHelper, CONSTANTS) {
        var ctrl = this;
        ctrl.gonoTreeConfig = CONSTANTS.gonoTree;

        /**
         * Handler for the event that user selects a gono tree node
         * @param node The selected node
         * @param index The position of the selected node
         */
        ctrl.selectNode = function (node, index) {
            if (node.childItems.length === 0 && !node.item.declarable && node.state.isExpanded) {

                //Load data from database in order to build goods nomenclature child nodes
                if (node.item.type === 'SECTION') {
                    SearchByNomenclatureModel.getSectionChilds(node.item.sid, ctrl.tradeDirection, ctrl.simulationDate, ctrl.language).then(function (result) {
                        GoodsNomenclatureTreeModel.addClassificationAndChildNodesToGonoTree(node, index, result, ctrl.data);
                    }, function (error) {
                        ctrl.handleError(error.data.code, error.data.params);
                    });
                } else if (node.item.type !== 'ClassificationInfo' && node.item.type !== 'ClassificationLink') {
                    SearchByNomenclatureModel.getNomenclatureChilds(node.item.sid, ctrl.tradeDirection, ctrl.simulationDate, ctrl.language).then(function (result) {
                        GoodsNomenclatureTreeModel.addClassificationAndChildNodesToGonoTree(node, index, result, ctrl.data);
                    }, function (error) {
                        ctrl.handleError(error.data.code, error.data.params);
                    });
                }
            } else {

                //Expand or collapse a node in the goods nomenclature tree
                GoodsNomenclatureTreeModel.expandCollapseGonoTreeNode(node, index, ctrl.data);
            }
        };

        ctrl.getTreeNodeClass = function (node) {
            return GoodsNomenclatureTreeModel.getTreeNodeClass(node);
        };

        ctrl.shouldDisplayCode = function (node) {
            return node.item.type === 'SECTION' || node.item.productLineSuffix === "80";
        };

        /**
         * Open footnote popup
         * @param size The size of the popup
         * @param footnoteId Footnote id
         */
        ctrl.openFootnotePopup = function (size, footnoteId) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, ctrl.simulationDate);
                    }]
                }
            });
        };

        ctrl.shouldDisplayCommodityCodeLink = function (node) {
            return ctrl.screenType === 'lookup' && (node.item.type === 'HEADING' || node.item.type === 'NOMENCLATURECODE') || ctrl.screenType === 'declarableCommodityCodeLookup' && node.item.declarable;
        };

        ctrl.handleError = function (errorCode, errorParams) {
            ctrl.onHandleError({
                error: {
                    errorCode: errorCode, errorParams: errorParams
                }
            });
        };

        ctrl.selectCommodityCode = function (commodityCode) {
            ctrl.onSelectCommodityCode({ commodityCode: commodityCode });
        };

        ctrl.viewCommodityCode = function (commodityCode, exportRefundCode) {
            var pD = ctrl.tradeDirection;
            if (pD === 'ER') {
                pD = 'E';
            }

            var pCc = CommonHelper.removeSpaceCharacters(commodityCode);
            if (pD === 'E') {
                pCc = pCc.substr(0, 8);
            }

            $state.go('taric.measure.mcc', {
                frm: 'taric.nomenclature.sbn',
                cc: pCc,
                sd: CommonHelper.getBookmarkDateString(ctrl.simulationDate),
                d: pD,
                ad: exportRefundCode
            });
        };

        ctrl.isDeclarableCommodityCodeSelected = function (node) {
            return node.item.declarable && node.item.code === CommonHelper.removeSpaceCharacters(ctrl.commodityCode);
        };

        ctrl.isLeafNodeClickable = function () {
            return ctrl.leafNodeClickable;
        };

        ctrl.isMatchingCommodityCode = function (code) {
            var commodityCode = CommonHelper.removeSpaceCharacters(ctrl.commodityCode);
            if (!code || commodityCode === "" || commodityCode.length < 6) {
                return false;
            }
            var codeWithPaddingZeros = ctrl.addPaddingZeros(code);
            return codeWithPaddingZeros.indexOf(commodityCode) === 0;
        };

        ctrl.addPaddingZeros = function (commodityCode) {
            if (!commodityCode) {
                return commodityCode;
            }
            var result = commodityCode;
            while (result.length < 10) {
                result = result + "0";
            }
            return result;
        };
    }],
    templateUrl: 'taric/nomenclature/shared/gono-tree.tmpl.html'
});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 2/3/2016.
 */

angular.module('taric.model.nomenclature', ['common.helper', 'ngResource']).factory('QueryNomenclature', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/sbn/nomenclatures/search', {}, {
        query: {
            method: 'GET',
            isArray: false
        },
        getSectionChilds: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/sbn/sections/:sid'
        },
        getNomenclatureChilds: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/sbn/nomenclatures/:sid'
        },
        getLinks: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/sbn/links'
        }
    });
}]).service('SearchByNomenclatureModel', ["$q", "QueryNomenclature", "$rootScope", "$translate", "CONSTANTS", "CommonHelper", function ($q, QueryNomenclature, $rootScope, $translate, CONSTANTS, CommonHelper) {
    var model = this;
    var searchCriteria = {};

    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.language = CommonHelper.getLanguageCode($translate.use());
        searchCriteria.direction = 'I';
        searchCriteria.expandAll = false;
    };
    model.resetSearchCriteria();

    model.searchGoodsNomenclature = function (commodityCode, tradeDirection, simulationDate, language) {
        var deferred = $q.defer();
        commodityCode = CommonHelper.removeSpaceCharacters(commodityCode);

        //Identify the commodity code to query against the ws
        var queryCommodityCode = commodityCode;

        //Remove trailing zeros if user searches for commodity code that has equal or greater than 8 digits
        var trailingDigits = queryCommodityCode.substring(queryCommodityCode.length - 2);
        while (trailingDigits === "00" && queryCommodityCode.length >= 8) {
            queryCommodityCode = queryCommodityCode.substring(0, queryCommodityCode.length - 2);
            trailingDigits = queryCommodityCode.substring(queryCommodityCode.length - 2);
        }

        //Remove the next 2 digits if the query commodity code has more than 6 digits
        if (queryCommodityCode.length >= 6) {
            queryCommodityCode = queryCommodityCode.substring(0, queryCommodityCode.length - 2);
        }
        var result = QueryNomenclature.query({
            code: queryCommodityCode,
            tradedirection: tradeDirection,
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            language: language
        }, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getSectionChilds = function (sid, tradeDirection, simulationDate, language) {
        var deferred = $q.defer();
        var result = QueryNomenclature.getSectionChilds({
            sid: sid,
            tradedirection: tradeDirection,
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            language: language
        }, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getNomenclatureChilds = function (sid, tradeDirection, simulationDate, language) {
        var deferred = $q.defer();
        var result = QueryNomenclature.getNomenclatureChilds({
            sid: sid,
            tradedirection: tradeDirection,
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            language: language
        }, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getLinks = function (simulationDate) {
        var deferred = $q.defer();
        var result = QueryNomenclature.getLinks({
            simulationdate: CommonHelper.getRestDateString(simulationDate)
        }, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]).service('GoodsNomenclatureTreeModel', ["CommonHelper", "CONSTANTS", function (CommonHelper, CONSTANTS) {
    var model = this;

    /**
     * Add classifications and child nodes of the selected node to the gono tree
     * @param node The selected node
     * @param index The position of the selected node
     * @param nodeDetails Data containing information of classifications and child nodes of the selected node
     * @param treeDataList The list of current tree nodes in the form of table rows
     */
    model.addClassificationAndChildNodesToGonoTree = function (node, index, nodeDetails, treeDataList) {
        var classLinks = model.createClassificationLinks(nodeDetails.classificationLinks, node.item.level + 1);
        if (classLinks.length > 0) {
            var classInfo = classLinks[0];

            //Add a new reference to the classInfo
            node.classInfo = classInfo;

            //Add the array of classification links to gono tree
            model.addToGonoTree(classLinks, index + 1, treeDataList);
        }
        node.childItems = nodeDetails.childItems;
        node.childItems.forEach(function (childNode) {
            model.updateNomenclatureCodeIndents(childNode);
            model.appendExportRefundAdditionalCodeToDescription(childNode);
        });

        //Add the array of child nodes to gono tree
        model.addToGonoTree(nodeDetails.childItems, classLinks.length + index + 1, treeDataList);

        //Expand or collapse a node in the goods nomenclature tree
        model.expandCollapseGonoTreeNode(node, index, treeDataList);
    };

    model.createClassificationLinks = function (classificationLinks, startLevel) {
        var result = [];

        if (!classificationLinks || classificationLinks.length === 0) {
            return result;
        }

        //First, create the node 'Classification Info'
        var gonoTreeClassInfo = {
            state: { isDisplayed: true, isExpanded: false },
            item: { type: 'ClassificationInfo', declarable: false, level: startLevel, description: 'Classification Info' },
            childItems: []
        };
        result.push(gonoTreeClassInfo);
        classificationLinks.forEach(function (classLink) {
            var gonoTreeClassLink = {
                state: { isDisplayed: false, isExpanded: false },
                item: classLink
            };
            gonoTreeClassLink.item.type = 'ClassificationLink';
            gonoTreeClassLink.item.childItems = [];
            gonoTreeClassLink.item.declarable = true;
            gonoTreeClassLink.item.level = startLevel + 1;
            gonoTreeClassInfo.childItems.push(gonoTreeClassLink);
            result.push(gonoTreeClassLink);
        });

        return result;
    };
    /**
     * Expand or collapse the selected gono tree node
     * @param node The selected node
     * @param index The position of the selected node
     * @param treeDataList The list of current tree nodes in the form of table rows
     */
    model.expandCollapseGonoTreeNode = function (node, index, treeDataList) {
        if (node.state.isExpanded) {

            //Display Classification Info if it exists
            if (node.classInfo) {
                node.classInfo.state = { isDisplayed: true, isExpanded: false };
            }

            //Display all the child nodes
            node.childItems.forEach(function (childNode) {
                childNode.state = { isDisplayed: true, isExpanded: false };
            });
        } else {

            //Find all descendant nodes and hide them
            for (var i = index + 1; i < treeDataList.length; i++) {
                var tempNode = treeDataList[i];
                if (tempNode.item.level <= node.item.level) {
                    break;
                }

                //Hide all descendant nodes
                tempNode.state = { isDisplayed: false, isExpanded: false };
            }
        }
    };

    /**
     * Add to gono tree (in the form of a table) a list of nodes from the position index
     * @param nodes The given list of nodes to be added
     * @param index The position that the first node of the given list will be added
     * @param treeDataList The list of current tree nodes in the form of table rows
     */
    model.addToGonoTree = function (nodes, index, treeDataList) {
        if (index > treeDataList.length) {
            return;
        }
        nodes.forEach(function (node) {
            treeDataList.splice(index++, 0, node);
        });
    };

    /**
     * Get the css class of a tree node based on its level
     * @param node The given node
     * @returns The class name
     */
    model.getTreeNodeClass = function (node) {
        return "indent_level_" + node.item.level;
    };

    /**
     * Build up the gono tree in the form of table rows based on a list of tree nodes
     * @param nodes The given list of tree nodes
     * @param commodityCode The commodity code in the search criteria
     * @return An array of table rows forming the target gono tree
     */
    model.buildGonoTree = function (nodes, commodityCode, expandAll) {
        var result = [];
        if (!nodes) {
            return result;
        }
        nodes.forEach(function (node) {
            result = result.concat(model.convertTreeNodeToTableRows(node));
        });

        //Remove space characters
        commodityCode = CommonHelper.removeSpaceCharacters(commodityCode);

        //If commodityCode is not specified, then display a list of sections
        if (commodityCode === "") {
            result.forEach(function (node) {
                node.state = { isExpanded: false, isDisplayed: true };
            });
        } else {
            var i, currentNode, parentNode;

            //Find exact matching commodity codes that user is searching for and open all its children - Store the first matching commodity code node for later use
            var firstMatchingCommodityCodeNode = null;
            var firstMatchingCommodityCodePos = 0;
            var trailingDigits = null;
            var shouldContinueToCheck = false;
            do {
                shouldContinueToCheck = false;
                for (var _i = 0; _i < result.length; _i++) {
                    currentNode = result[_i];
                    if (currentNode.item.code === commodityCode) {

                        //Always open the nodes that has the exact match with the given commodity code
                        currentNode.state = { isExpanded: true, isDisplayed: true };

                        //Display all of its children
                        currentNode.childItems.forEach(function (childNode) {
                            childNode.state = { isExpanded: false, isDisplayed: true };
                        });

                        if (firstMatchingCommodityCodeNode === null) {
                            firstMatchingCommodityCodeNode = currentNode;
                            firstMatchingCommodityCodePos = _i;
                        }
                    }
                }

                if (firstMatchingCommodityCodeNode === null && commodityCode.length >= 4) {

                    //Remove the trailing '00' to find the matching commodity code
                    trailingDigits = commodityCode.substring(commodityCode.length - 2);
                    if (trailingDigits === "00") {
                        commodityCode = commodityCode.substring(0, commodityCode.length - 2);
                        shouldContinueToCheck = true;
                    }
                }
            } while (firstMatchingCommodityCodeNode === null && shouldContinueToCheck);

            //The commodity code is not found, find the commodity code starting with the commodity code that user has entered
            if (firstMatchingCommodityCodeNode === null) {
                for (var _i2 = 0; _i2 < result.length; _i2++) {
                    currentNode = result[_i2];
                    if (currentNode.item.code && currentNode.item.code.indexOf(commodityCode) === 0) {

                        //Always open the nodes that has the exact match with the given commodity code
                        currentNode.state = { isExpanded: true, isDisplayed: true };

                        //Display all of its children
                        currentNode.childItems.forEach(function (childNode) {
                            childNode.state = { isExpanded: false, isDisplayed: true };
                        });

                        if (firstMatchingCommodityCodeNode === null) {
                            firstMatchingCommodityCodeNode = currentNode;
                            firstMatchingCommodityCodePos = _i2;
                        }
                    }
                }
            }

            //The commodity code is not found, show error message
            if (firstMatchingCommodityCodeNode === null) {
                return null;
            }

            if (expandAll) {
                for (var _i3 = 0; _i3 < result.length; _i3++) {
                    result[_i3].state = { isExpanded: true, isDisplayed: true };
                }
            } else {

                //Display the tree path from the root node to the first commodity code node found - Display all the child nodes on the path
                currentNode = firstMatchingCommodityCodeNode;
                do {
                    parentNode = currentNode.parent;

                    //Display the parent and its children
                    parentNode.state = { isExpanded: true, isDisplayed: true };
                    if (parentNode.childItems) {

                        //Display all of its children
                        parentNode.childItems.forEach(function (childNode) {
                            if (!childNode.state) {
                                childNode.state = { isExpanded: false, isDisplayed: true };
                            } else {
                                childNode.state.isDisplayed = true;
                            }
                        });
                    }

                    currentNode = parentNode;
                } while (parentNode !== result[0]);

                //If user is searching for a commodity code which has more than or equal to 4 digits,
                // all the commodity codes which have 6 digits under the first matching commodity code should also be displayed
                for (var _i4 = 0; _i4 < result.length; _i4++) {
                    currentNode = result[_i4];

                    //Commodity codes under the first matching commodity code
                    if (_i4 > firstMatchingCommodityCodePos) {

                        //Stop processing when it comes to the successor sibling node
                        if (currentNode.item.level <= firstMatchingCommodityCodeNode.item.level) {
                            break;
                        }
                        if (commodityCode.length >= 4 && currentNode.item.code.length === 6) {

                            //Display all of children of the current's parent node.
                            currentNode.parent.childItems.forEach(function (childNode) {
                                if (!childNode.state) {
                                    childNode.state = { isExpanded: false, isDisplayed: true };
                                } else {
                                    childNode.state.isDisplayed = true;
                                }
                            });

                            //Open the parent node when we show the child node
                            currentNode.parent.state.isExpanded = true;
                        }
                    }
                }
            }
        }
        return result;
    };

    /**
     * Convert a tree node and all of its descendants to an array of table rows
     * @param node The tree node to be converted
     * @returns An array of table rows
     */
    model.convertTreeNodeToTableRows = function (node) {
        var result = [];

        //Add the node itself to the result
        result.push(node);

        //Add the dashes before node's description if it is a 'NomenclatureCode' node
        model.updateNomenclatureCodeIndents(node);

        //Append export refund additional code to description
        model.appendExportRefundAdditionalCodeToDescription(node);

        //Add the classification links to the result
        if (node.classificationLinks.length > 0) {
            var classLinks = model.createClassificationLinks(node.classificationLinks, node.item.level + 1);

            if (classLinks.length > 0) {
                var classInfo = classLinks[0];

                //Add a new reference to the classInfo
                node.classInfo = classInfo;

                //Add the array of classification links to the result
                result = result.concat(classLinks);
            }
        }

        //Recursively convert child nodes to table rows and add them to the result
        if (node.childItems.length > 0) {
            node.childItems.forEach(function (childNode) {

                //Update the parent property
                childNode.parent = node;
                result = result.concat(model.convertTreeNodeToTableRows(childNode));
            });
        }
        return result;
    };

    /**
     * Append export refund additional code to description
     * @param node The given node
     */
    model.appendExportRefundAdditionalCodeToDescription = function (node) {
        if (node.item.declarable && node.item.exportrefundcode) {
            node.item.description = node.item.description + "(" + node.item.exportrefundcode + ")";
        }
    };

    /**
     * Add the dashes before node's description if it is a 'NomenclatureCode' node
     * @param node The given node
     */
    model.updateNomenclatureCodeIndents = function (node) {
        if (node.item.level > 2 && node.item.type === 'NOMENCLATURECODE') {
            var numberOfDashes = node.item.level - 2;
            // ITESUP-41: Decrease numberOfDashes to keep the number of DASH unchanged for nodes belonging to a sub-chapter
            if (node.item.increasedIndent) {
                numberOfDashes--;
            }
            var prefix = "";
            var count = 0;
            while (numberOfDashes > 0) {
                prefix = prefix + "- ";
                count = count + 1;
                if (CONSTANTS.gonoTree.formatIndents) {
                    if (count % 3 === 0 && numberOfDashes > 1) {
                        prefix = prefix + "&nbsp;";
                    }
                }
                numberOfDashes--;
            }
            node.item.description = prefix + node.item.description;
        }
    };
}]);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var taricNomenclature = angular.module('taric.nomenclature', ['nomenclature.sbn', 'nomenclature.sbt', 'nomenclature.ct', 'common.model.language']);
taricNomenclature.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.nomenclature', {
        abstract: true,
        url: '/nomenclature',
        template: '<ui-view></ui-view>'
    }).state('taric.nomenclature.sbn', {
        url: '/sbn?cc&sd&d&l&ql&ea&frm&type&ccField',
        templateUrl: 'taric/nomenclature/sbn/nomenclature-search.tmpl.html',
        controller: 'SearchByNomenclatureController as searchByNomenclatureCtrl',
        reloadOnSearch: false,
        resolve: {
            initialGonoTreeSearchCriteria: ["SearchByNomenclatureModel", "$stateParams", "$translate", "$filter", "CommonHelper", function initialGonoTreeSearchCriteria(SearchByNomenclatureModel, $stateParams, $translate, $filter, CommonHelper) {
                SearchByNomenclatureModel.resetSearchCriteria();
                SearchByNomenclatureModel.getSearchCriteria().commodityCode = $filter('commodityCode')($stateParams.cc);
                if ($stateParams.d) {
                    if ($stateParams.d === 'I' || $stateParams.d === 'E' || $stateParams.d === 'ER') {
                        SearchByNomenclatureModel.getSearchCriteria().direction = $stateParams.d;
                    }
                }
                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        SearchByNomenclatureModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                    SearchByNomenclatureModel.getSearchCriteria().language = $stateParams.l;
                }
                if ($stateParams.ql) {
                    SearchByNomenclatureModel.getSearchCriteria().language = $stateParams.ql;
                }
                if ($stateParams.ea) {
                    if ($stateParams.ea === 'true') {
                        SearchByNomenclatureModel.getSearchCriteria().expandAll = true;
                    } else {
                        SearchByNomenclatureModel.getSearchCriteria().expandAll = false;
                    }
                }
                return null;
            }],
            preferredUILanguages: ["LanguageModel", function preferredUILanguages(LanguageModel) {
                return LanguageModel.getPreferredUILanguages();
            }],
            links: ["SearchByNomenclatureModel", function links(SearchByNomenclatureModel) {
                return SearchByNomenclatureModel.getLinks(SearchByNomenclatureModel.getSearchCriteria().simulationDate);
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/nomenclature/sbn');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.nomenclature.ct', {
        url: '/ct?d&ccs&cce&ds&de&crt&l&frm&cc&ccField',
        templateUrl: 'taric/nomenclature/ct/correlation-table-search.tmpl.html',
        controller: 'CorrelationTableController as correlationTableCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["$stateParams", "CorrelationTableModel", "$translate", "CommonHelper", function initializeData($stateParams, CorrelationTableModel, $translate, CommonHelper) {
                if ($stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'ccView') {
                    CorrelationTableModel.reset();
                } else if ($stateParams.frm === 'ccLookup') {
                    CorrelationTableModel.resetSearchResult();
                }
                if ($stateParams.ccField && $stateParams.cc) {
                    if ($stateParams.ccField === 'commodityCodeRangeStart') {
                        CorrelationTableModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.cc;
                    } else if ($stateParams.ccField === 'commodityCodeRangeEnd') {
                        CorrelationTableModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cc;
                    }
                }
                if ($stateParams.d) {
                    if ($stateParams.d === 'I' || $stateParams.d === 'E') {
                        CorrelationTableModel.getSearchCriteria().direction = $stateParams.d;
                    }
                }
                if ($stateParams.ccs) {
                    CorrelationTableModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.ccs;
                }
                if ($stateParams.cce) {
                    CorrelationTableModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cce;
                }
                if ($stateParams.ds) {
                    var startDate = CommonHelper.parseInputDate($stateParams.ds);
                    if (startDate) {
                        CorrelationTableModel.getSearchCriteria().startDate = startDate;
                    }
                }
                if ($stateParams.de) {
                    var endDate = CommonHelper.parseInputDate($stateParams.de);
                    if (endDate) {
                        CorrelationTableModel.getSearchCriteria().endDate = endDate;
                    }
                }
                if ($stateParams.crt) {
                    if ($stateParams.crt === 'E') {
                        CorrelationTableModel.getSearchCriteria().correlationType = 'E';
                    } else {
                        CorrelationTableModel.getSearchCriteria().correlationType = 'N';
                    }
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/nomenclature/ct');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.nomenclature.sbt', {
        url: '/sbt?sd&ts&gnd&add&fnd&ql&l&frm',
        templateUrl: 'taric/nomenclature/sbt/text-search.tmpl.html',
        controller: 'SearchByTextController as searchByTextCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["SearchByTextModel", "$stateParams", "$translate", "CommonHelper", function initializeData(SearchByTextModel, $stateParams, $translate, CommonHelper) {
                if ($stateParams.frm !== 'ccView' && $stateParams.frm !== 'adcoView' && $stateParams.frm !== 'footnoteView') {
                    SearchByTextModel.reset();
                }

                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        SearchByTextModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.ts) {
                    SearchByTextModel.getSearchCriteria().textSearch = $stateParams.ts;
                }
                if ($stateParams.gnd) {
                    if ($stateParams.gnd === 'true') {
                        SearchByTextModel.getSearchCriteria().goodsNomenclatureDescription = true;
                    } else {
                        SearchByTextModel.getSearchCriteria().goodsNomenclatureDescription = false;
                    }
                }
                if ($stateParams.add) {
                    if ($stateParams.add === 'true') {
                        SearchByTextModel.getSearchCriteria().additionalCodeDescription = true;
                    } else {
                        SearchByTextModel.getSearchCriteria().additionalCodeDescription = false;
                    }
                }
                if ($stateParams.fnd) {
                    if ($stateParams.fnd === 'true') {
                        SearchByTextModel.getSearchCriteria().footnoteDescription = true;
                    } else {
                        SearchByTextModel.getSearchCriteria().footnoteDescription = false;
                    }
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                    SearchByTextModel.getSearchCriteria().language = $stateParams.l;
                }
                if ($stateParams.ql) {
                    SearchByTextModel.getSearchCriteria().language = $stateParams.ql;
                }
            }],
            preferredUILanguages: ["LanguageModel", function preferredUILanguages(LanguageModel) {
                return LanguageModel.getPreferredUILanguages();
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/nomenclature/sbt');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by MinhQuan on 9/3/2015.
 */

angular.module('taric.quota.search', ['taric.model.quota', 'taric.model.menu', 'common.template.geoarea.popup', 'common.filter.decimalNumber', 'common.helper']).controller('SearchTaricQuotaController', ["CONSTANTS", "TaricQuotaSearchModel", "GeographicalAreaModel", "$rootScope", "$scope", "$state", "$stateParams", "$uibModal", "$filter", "CommonHelper", "$translate", "$timeout", "$location", "countries", function (CONSTANTS, TaricQuotaSearchModel, GeographicalAreaModel, $rootScope, $scope, $state, $stateParams, $uibModal, $filter, CommonHelper, $translate, $timeout, $location, countries) {

    var searchTaricQuotaCtrl = this;

    searchTaricQuotaCtrl.init = function () {
        searchTaricQuotaCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        searchTaricQuotaCtrl.searchCriteria = TaricQuotaSearchModel.getSearchCriteria();
        searchTaricQuotaCtrl.searchQuotaResult = TaricQuotaSearchModel.searchQuotaResult();
        searchTaricQuotaCtrl.dateFormat = CONSTANTS.dateFormat;
        searchTaricQuotaCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        searchTaricQuotaCtrl.controlCountry = {};
        searchTaricQuotaCtrl.statuses = ["QUOTA_BLOCKING_EVENT", "QUOTA_EXHAUSTION_EVENT", "QUOTA_OPENED_EVENT", "QUOTA_REOPENING_EVENT", "QUOTA_SUSPENSION_EVENT", "QUOTA_UNBLOCKING_EVENT", "QUOTA_UNSUSPENSION_EVENT"];
        searchTaricQuotaCtrl.loadQuotaStatuses();

        if (searchTaricQuotaCtrl.searchCriteria.status && searchTaricQuotaCtrl.statuses.indexOf(searchTaricQuotaCtrl.searchCriteria.status) < 0) {
            searchTaricQuotaCtrl.searchCriteria.status = null;
        }

        if (searchTaricQuotaCtrl.isExternalLink() && searchTaricQuotaCtrl.validateExternalParameters()) {
            if (countries) {

                // get valid CountryCode
                searchTaricQuotaCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(countries.items, searchTaricQuotaCtrl.searchCriteria.country, null);
            }

            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            searchTaricQuotaCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    searchTaricQuotaCtrl.search = function () {
        //Load data for the first page
        searchTaricQuotaCtrl.loadDataFromServer(1);
    };

    //Check whether the search form is valid or not
    searchTaricQuotaCtrl.validateSearchForm = function () {
        searchTaricQuotaCtrl.resetError();
        return searchTaricQuotaCtrl.validateMandatoryFields() && searchTaricQuotaCtrl.validateOrderNumber() && searchTaricQuotaCtrl.validateCountryCode() && searchTaricQuotaCtrl.validateSimulationDate();
    };

    searchTaricQuotaCtrl.validateMandatoryFields = function () {
        if (!searchTaricQuotaCtrl.searchCriteria.simulationDate && !searchTaricQuotaCtrl.searchCriteria.orderNumber) {
            searchTaricQuotaCtrl.errorCode = 'i8n.qqry.tqa.qryTariffQuotaSearchBean.dataRequired';
        }
        return searchTaricQuotaCtrl.errorCode === null;
    };

    searchTaricQuotaCtrl.validateOrderNumber = function () {
        searchTaricQuotaCtrl.errorCode = CommonHelper.validateStringByPattern(searchTaricQuotaCtrl.searchCriteria.orderNumber, "^[0-9]{6}$", "qqry.tqa.notDigits");
        return searchTaricQuotaCtrl.errorCode === null;
    };

    searchTaricQuotaCtrl.validateCountryCode = function () {
        searchTaricQuotaCtrl.errorCode = searchTaricQuotaCtrl.controlCountry.validate();
        return searchTaricQuotaCtrl.errorCode === null;
    };

    searchTaricQuotaCtrl.validateSimulationDate = function () {
        if (!CONSTANTS.dateRestrictionEnabled) {
            searchTaricQuotaCtrl.errorCode = CommonHelper.validateSimulationDate(searchTaricQuotaCtrl.searchCriteria.simulationDate);
            if (searchTaricQuotaCtrl.errorCode) {
                searchTaricQuotaCtrl.errorParams = { param0: CONSTANTS.pastDate };
            }
        }
        return searchTaricQuotaCtrl.errorCode === null;
    };

    // export pdf
    searchTaricQuotaCtrl.print = function (options) {

        if (!searchTaricQuotaCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        TaricQuotaSearchModel.searchTariffQuotas().then(function (searchQuotaResult) {

            searchTaricQuotaCtrl.searchQuotaAllResult = searchQuotaResult;
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(searchTaricQuotaCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qqry.tqa.report.report.title')
                }, 'l').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            $rootScope.$broadcast('stopSpinningPrint');
            searchTaricQuotaCtrl.handleError(error);
        });
    };

    //Load data for a given page
    searchTaricQuotaCtrl.loadDataFromServer = function (page) {
        if (!searchTaricQuotaCtrl.validateSearchForm()) {
            return;
        }

        searchTaricQuotaCtrl.loadDataFromServerWithoutValidation(page);
    };

    //Load data for a given page without validation
    searchTaricQuotaCtrl.loadDataFromServerWithoutValidation = function (page) {
        // Reset search result before searching
        searchTaricQuotaCtrl.resetSearchResult();
        searchTaricQuotaCtrl.searching = true;
        TaricQuotaSearchModel.searchTariffQuotas(page).then(function (searchQuotaResult) {
            searchTaricQuotaCtrl.searchQuotaResult = searchQuotaResult;
            searchTaricQuotaCtrl.searching = false;

            searchTaricQuotaCtrl.searchQuotaResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchTaricQuotaCtrl.searchCriteria.simulationDate);
            if (searchTaricQuotaCtrl.searchQuotaResult.infoCode && "i8n.common.pastDate" === searchTaricQuotaCtrl.searchQuotaResult.infoCode) {
                searchTaricQuotaCtrl.searchQuotaResult.infoParams = CONSTANTS.pastDate;
            }

            searchTaricQuotaCtrl.updateBrowserURL();
        }, function (error) {
            searchTaricQuotaCtrl.errorCode = error.data.code;
            searchTaricQuotaCtrl.errorParams = error.data.params;
            searchTaricQuotaCtrl.searching = false;
        });
    };

    /**
     * Search for tariff quotas
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/quota/search?sd={SimulationDate}&on={OrderNumber}&co={CountryOfOrigin}&qs={QuotaStatus}&c={Critical}&l={Language}
     *
     * Example:
     * http://localhost:8080/arctictariff-public-web/#!/taric/quota/search?sd=2015-01-01&on=090023&co=US&qs=QUOTA_EXHAUSTION_EVENT&c=true&l=en
     */
    searchTaricQuotaCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep parameter 'frm' because there is no return to caller page
        $location.search({
            sd: CommonHelper.getBookmarkDateString(searchTaricQuotaCtrl.searchCriteria.simulationDate),
            on: searchTaricQuotaCtrl.searchCriteria.orderNumber,
            co: searchTaricQuotaCtrl.searchCriteria.country,
            qs: searchTaricQuotaCtrl.searchCriteria.status,
            c: searchTaricQuotaCtrl.searchCriteria.critical.toString(),
            l: $translate.use()
        }).replace();
    };

    searchTaricQuotaCtrl.resetSearchResult = function () {
        searchTaricQuotaCtrl.searchQuotaResult = null;
        TaricQuotaSearchModel.resetSearchResult();
    };

    //Handle page change for the quota search result table
    searchTaricQuotaCtrl.searchQuotaResultPageChanged = function (page) {
        searchTaricQuotaCtrl.loadDataFromServer(page);
    };

    searchTaricQuotaCtrl.openDatePicker = function ($event) {
        searchTaricQuotaCtrl.isDatePickerOpen = true;
    };

    searchTaricQuotaCtrl.onDateChange = function (dateString) {
        searchTaricQuotaCtrl.resetError();
        searchTaricQuotaCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchTaricQuotaCtrl.searchCriteria.simulationDate, dateString);
        searchTaricQuotaCtrl.loadingReferenceData = true;
        searchTaricQuotaCtrl.controlCountry.reload(searchTaricQuotaCtrl.searchCriteria.simulationDate).then(function () {
            searchTaricQuotaCtrl.loadingReferenceData = false;
        }, function (error) {
            searchTaricQuotaCtrl.errorCode = error.data.code;
            searchTaricQuotaCtrl.errorParams = error.data.params;
            searchTaricQuotaCtrl.loadingReferenceData = false;
        });
    };

    //View quota detail
    searchTaricQuotaCtrl.viewQuota = function (quotaDef) {
        TaricQuotaSearchModel.setSelectedQuota(quotaDef);
        $state.go('taric.quota.view');
    };

    searchTaricQuotaCtrl.isExternalLink = function () {
        // Verify 'frm' parameter to avoid auto-search after viewing quota detail.
        return (!$stateParams.frm || $stateParams.frm !== 'taric.quota.view') && ($stateParams.sd || $stateParams.on);
    };

    // Check whether the external parameters are valid or not
    searchTaricQuotaCtrl.validateExternalParameters = function () {
        searchTaricQuotaCtrl.resetError();
        return searchTaricQuotaCtrl.validateMandatoryFields() && searchTaricQuotaCtrl.validateOrderNumber() && searchTaricQuotaCtrl.validateSimulationDate();
    };

    searchTaricQuotaCtrl.loadQuotaStatuses = function () {
        searchTaricQuotaCtrl.statusData = [];
        searchTaricQuotaCtrl.statuses.forEach(function (status) {
            $translate("i8n.common.label." + status).then(function (statusDescription) {
                searchTaricQuotaCtrl.statusData.push({
                    "code": status,
                    "description": statusDescription
                });
            });
        });

        $timeout(function () {

            //Wait for the translation is done and then do a sort
            searchTaricQuotaCtrl.statusData.sort(function (status1, status2) {
                return status1.description.localeCompare(status2.description, CommonHelper.getLanguageCode($translate.use()));
            });
        }, 500);
    };

    $rootScope.$on('$translateChangeSuccess', function () {
        searchTaricQuotaCtrl.loadQuotaStatuses();

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        searchTaricQuotaCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            searchTaricQuotaCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });

    searchTaricQuotaCtrl.openOriginPopup = function (size, _origin) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
            controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
            size: size,
            resolve: {
                geoAreaMemberships: function geoAreaMemberships() {
                    return GeographicalAreaModel.queryMembershipByGroupId(_origin, searchTaricQuotaCtrl.searchCriteria.simulationDate);
                },
                origin: function origin() {
                    return _origin;
                }
            }
        });
    };

    searchTaricQuotaCtrl.resetError = function () {
        searchTaricQuotaCtrl.handleError(null);
    };

    searchTaricQuotaCtrl.handleError = function (error) {
        if (!error) {
            searchTaricQuotaCtrl.errorCode = null;
            searchTaricQuotaCtrl.errorParams = null;
        } else {
            searchTaricQuotaCtrl.errorCode = error.errorCode;
            searchTaricQuotaCtrl.errorParams = error.errorParams;
        }
    };

    searchTaricQuotaCtrl.onCountryChange = function (country) {
        searchTaricQuotaCtrl.searchCriteria.country = country;
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchTaricQuotaCtrl.print, true);
    });
}]);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('taric.model.quota', ['ngResource', 'common.model.geoarea', 'common.helper']).factory('TariffQuota', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/tqa/quotas/', {}, {
        queryQuotas: {
            method: 'GET',
            isArray: false
        },
        getQuotaDefinitionExtendedInfo: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/tqa/quotas/:quotaOrderNumber/:origin'

        }
    });
}]).service('TaricQuotaSearchModel', ["TariffQuota", "$q", "CommonHelper", "CONSTANTS", function (TariffQuota, $q, CommonHelper, CONSTANTS) {
    var model = this,
        selectedQuota = null,
        searchCriteria = {},
        searchQuotaResult = null;
    model.getSelectedQuota = function () {
        return selectedQuota;
    };
    model.setSelectedQuota = function (quota) {
        selectedQuota = quota;
    };
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.searchQuotaResult = function () {
        return searchQuotaResult;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
        searchCriteria.status = null;
        searchCriteria.critical = false;
    };
    model.resetSearchResult = function () {
        searchQuotaResult = null;
    };
    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();
    model.searchTariffQuotas = function (page) {
        var deferred = $q.defer();

        var options = {
            simulationdate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            country: searchCriteria.country,
            ordernumber: searchCriteria.orderNumber,
            status: searchCriteria.status,
            critical: searchCriteria.critical,
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol,
            language: searchCriteria.language
        };
        if (page) {
            options.offset = CommonHelper.getOffset(page);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = TariffQuota.queryQuotas(options, function () {
            var returnedResult = {};
            returnedResult.totalItems = result.count;
            returnedResult.tariffQuotas = result.items;
            returnedResult.currentQuotaPage = page;
            angular.forEach(returnedResult.tariffQuotas, function (quotaItem) {
                if (angular.isArray(quotaItem.excludedCountryIds)) {
                    quotaItem.excludedCountryIds = quotaItem.excludedCountryIds.join(" ");
                }
            });

            if (page) {
                searchQuotaResult = returnedResult;
            }
            deferred.resolve(returnedResult);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    model.getSelectedRow = function () {
        var inputOrigin = selectedQuota.origin.id;
        if (searchCriteria.country !== " " && searchCriteria.country) {
            inputOrigin = searchCriteria.country;
        }
        var simulationDate = null;
        if (searchCriteria.simulationDate) {
            simulationDate = searchCriteria.simulationDate;
        } else {
            simulationDate = selectedQuota.startDate;
        }
        return model.getQuotaDefinitionExtendedInfo(selectedQuota.quotaOrderNumber, inputOrigin, simulationDate);
    };

    model.getQuotaDefinitionExtendedInfo = function (quotaOrderNumber, origin, simulationDate) {
        var deferred = $q.defer();
        var quotaExtendedInfo = TariffQuota.getQuotaDefinitionExtendedInfo({ quotaOrderNumber: quotaOrderNumber, origin: origin,
            simulationdate: CommonHelper.getRestDateString(simulationDate) }, function () {
            deferred.resolve(quotaExtendedInfo);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    };
}]);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var taricQuota = angular.module('taric.quota', ['taric.quota.search', 'taric.quota.view']);
taricQuota.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.quota', {
        abstract: true,
        url: '/quota',
        template: '<ui-view></ui-view>'
    }).state('taric.quota.search', {
        url: '/search?sd&on&co&qs&c&l&frm',
        templateUrl: 'taric/quota/search/quota-search.tmpl.html',
        controller: 'SearchTaricQuotaController as searchTaricQuotaCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["TaricQuotaSearchModel", "$stateParams", "$translate", "CommonHelper", function initializeData(TaricQuotaSearchModel, $stateParams, $translate, CommonHelper) {
                if ($stateParams.frm !== 'taric.quota.view') {
                    TaricQuotaSearchModel.reset();
                }

                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        TaricQuotaSearchModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }

                if ($stateParams.on) {
                    TaricQuotaSearchModel.getSearchCriteria().orderNumber = $stateParams.on;
                }

                if ($stateParams.co) {
                    TaricQuotaSearchModel.getSearchCriteria().country = $stateParams.co;
                }

                if ($stateParams.qs) {
                    TaricQuotaSearchModel.getSearchCriteria().status = $stateParams.qs;
                }

                if ($stateParams.c) {
                    if ($stateParams.c === 'true') {
                        TaricQuotaSearchModel.getSearchCriteria().critical = true;
                    } else {
                        TaricQuotaSearchModel.getSearchCriteria().critical = false;
                    }
                }

                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            countries: ["GeographicalAreaModel", "TaricQuotaSearchModel", "$stateParams", function countries(GeographicalAreaModel, TaricQuotaSearchModel, $stateParams) {
                var result = null;
                // Only get countries to support bookmark when there are required parameters.
                if (!$stateParams.frm && ($stateParams.sd || $stateParams.on) && $stateParams.co) {
                    result = GeographicalAreaModel.getCountriesOfOrigin(TaricQuotaSearchModel.getSearchCriteria().simulationDate);
                }
                return result;
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/quota');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }

    }).state('taric.quota.view', {
        url: '/view',
        templateUrl: 'taric/quota/view/quota-view.tmpl.html',
        controller: 'ViewTaricQuotaController as viewTaricQuotaCtrl',
        resolve: {
            quotaDefinitionExtendedInfo: ["TaricQuotaSearchModel", function quotaDefinitionExtendedInfo(TaricQuotaSearchModel) {
                return TaricQuotaSearchModel.getSelectedRow();
            }],
            simulationDate: ["TaricQuotaSearchModel", function simulationDate(TaricQuotaSearchModel) {
                return TaricQuotaSearchModel.getSearchCriteria().simulationDate;
            }],
            showCancelButton: function showCancelButton() {
                return true;
            },
            $uibModalInstance: function $uibModalInstance() {
                return null;
            },
            country: ["TaricQuotaSearchModel", function country(TaricQuotaSearchModel) {
                return TaricQuotaSearchModel.getSearchCriteria().country;
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.quota.view', ['common.template.geoarea.popup', 'common.filter.commoditycode', 'common.filter.decimalNumber', 'common.helper', 'common.filter.specialCharacterToHtml']).controller('ViewTaricQuotaController', ["quotaDefinitionExtendedInfo", "simulationDate", "country", "showCancelButton", "GeographicalAreaModel", "$uibModal", "$uibModalInstance", "$state", "CONSTANTS", "CommonHelper", "$rootScope", "$timeout", "$scope", "$filter", function (quotaDefinitionExtendedInfo, simulationDate, country, showCancelButton, GeographicalAreaModel, $uibModal, $uibModalInstance, $state, CONSTANTS, CommonHelper, $rootScope, $timeout, $scope, $filter) {
    var viewTaricQuotaCtrl = this;
    viewTaricQuotaCtrl.selectedRow = quotaDefinitionExtendedInfo;
    viewTaricQuotaCtrl.selectedTab = {
        activeIndex: 0,
        balancesIndex: 0,
        statusIndex: 1,
        commoditiesIndex: 2
    };
    if (viewTaricQuotaCtrl.selectedRow !== null) {
        viewTaricQuotaCtrl.dateFormat = CONSTANTS.dateFormat;
        viewTaricQuotaCtrl.selectedRow.displayedBalances = CommonHelper.loadDataPerTablePage(viewTaricQuotaCtrl.selectedRow.quotaBalanceEvents, 1);
        viewTaricQuotaCtrl.selectedRow.associatedCommodityCodes = CommonHelper.loadDataPerTablePage(viewTaricQuotaCtrl.selectedRow.quotaAssociatedCommodities, 1);
        viewTaricQuotaCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        viewTaricQuotaCtrl.showCancelButton = showCancelButton;
        viewTaricQuotaCtrl.balancesTablePageChanged = function (page) {
            viewTaricQuotaCtrl.selectedRow.displayedBalances = CommonHelper.loadDataPerTablePage(viewTaricQuotaCtrl.selectedRow.quotaBalanceEvents, page);
        };

        viewTaricQuotaCtrl.commodityCodesTablePageChanged = function (page) {
            viewTaricQuotaCtrl.selectedRow.associatedCommodityCodes = CommonHelper.loadDataPerTablePage(viewTaricQuotaCtrl.selectedRow.quotaAssociatedCommodities, page);
        };
    }

    viewTaricQuotaCtrl.openOriginPopup = function (size, _origin) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
            controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
            size: size,
            resolve: {
                geoAreaMemberships: function geoAreaMemberships() {
                    return GeographicalAreaModel.queryMembershipByGroupId(_origin, simulationDate);
                },
                origin: function origin() {
                    return _origin;
                }
            }
        });
    };

    viewTaricQuotaCtrl.close = function () {
        $uibModalInstance.dismiss('Close');
    };

    viewTaricQuotaCtrl.selectCommodityCode = function (commodityCode) {
        var pCo = null;
        if (country && country.length === 2) {
            pCo = country;
        } else if (viewTaricQuotaCtrl.selectedRow.quotaHead.origin.id.length === 2) {
            pCo = viewTaricQuotaCtrl.selectedRow.quotaHead.origin.id;
        }

        var pSd = CommonHelper.getRestDateString(new Date());
        if (pSd < viewTaricQuotaCtrl.selectedRow.quotaHead.startDate || viewTaricQuotaCtrl.selectedRow.quotaHead.endDate !== null && pSd > viewTaricQuotaCtrl.selectedRow.quotaHead.endDate) {
            pSd = viewTaricQuotaCtrl.selectedRow.quotaHead.startDate;
        }

        $state.go('taric.measure.mcc', {
            frm: 'taric.quota.view',
            cc: CommonHelper.removeSpaceCharacters(commodityCode),
            sd: CommonHelper.getBookmarkDateString(pSd),
            d: 'I',
            co: pCo
        });
    };

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        viewTaricQuotaCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            viewTaricQuotaCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });

    // print pdf
    viewTaricQuotaCtrl.print = function (options) {
        $rootScope.$broadcast('startSpinningPrint');
        $scope.$apply();

        // wait 1s before rendering
        setTimeout(function () {

            // load documents
            var doc = [];
            CommonHelper.htmlTableToPdf(doc, document.getElementById('quotaDetailGeneralInfo'), options);
            doc.push({ text: '\n' });

            var title = "";
            if (viewTaricQuotaCtrl.selectedTab.activeIndex === viewTaricQuotaCtrl.selectedTab.balancesIndex) {
                title = $filter('translate')('i8n.qqry.tqa.view.tab1.label');
                if (viewTaricQuotaCtrl.selectedRow.quotaBalanceEvents.length > 0) {
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportBalancesTable'), options);
                }
            } else if (viewTaricQuotaCtrl.selectedTab.activeIndex === viewTaricQuotaCtrl.selectedTab.statusIndex) {
                title = $filter('translate')('i8n.qqry.tqa.view.tab2.label');
                if (viewTaricQuotaCtrl.selectedRow.quotaEvents.length > 0) {
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportStatusTable'), options);
                }
            } else if (viewTaricQuotaCtrl.selectedTab.activeIndex === viewTaricQuotaCtrl.selectedTab.commoditiesIndex) {
                title = $filter('translate')('i8n.qqry.tqa.view.tab4.label');
                if (viewTaricQuotaCtrl.selectedRow.quotaAssociatedCommodities.length > 0) {
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportCommoditiesTable'), options);
                }
            }

            CommonHelper.printPlainDocument({
                contents: doc,
                logo: options.logo,
                validDate: $filter('date')(simulationDate, CONSTANTS.dateFormat),
                title: title
            }, 'p').then(function () {
                $rootScope.$broadcast('stopSpinningPrint');
            }, function (error) {
                $rootScope.$broadcast('stopSpinningPrint');
            });
        }, 1000);
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, viewTaricQuotaCtrl.print, true);
    });
}]);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.measureReport', ['common.helper', 'ngResource']).factory('QueryMeasureReport', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/report/measures', {}, {
        querySecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/report/measures'
        }
    });
}]).service('MeasureReportModel', ["$q", "$translate", "CONSTANTS", "CommonHelper", "QueryMeasureReport", "AuthorizeModel", function ($q, $translate, CONSTANTS, CommonHelper, QueryMeasureReport, AuthorizeModel) {
    var model = this;
    var searchCriteria = null;
    var searchResult = null;

    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.startDate = new Date();
        searchCriteria.endDate = null;
        searchCriteria.commodityCodeRangeStart = null;
        searchCriteria.commodityCodeRangeEnd = null;
        searchCriteria.direction = 'B';
        searchCriteria.country = null;
        searchCriteria.measureType = null;
        searchCriteria.measureTypes = [];
        searchCriteria.additionalCode = null;
        searchCriteria.additionalCodes = [];
        searchCriteria.footnote = null;
        searchCriteria.footnotes = [];
        searchCriteria.certificate = null;
        searchCriteria.certificates = [];
        searchCriteria.goodsNomenclatureDescription = false;
        searchCriteria.additionalCodeDescription = false;
        searchCriteria.footnoteDescription = false;
        searchCriteria.certificateDescription = false;
        searchCriteria.geographicalAreaDescription = false;
        searchCriteria.dutyExpressionDescription = false;
        searchCriteria.ascending = true;

        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.getSearchResult = function () {
        return searchResult;
    };
    model.resetSearchResult = function () {
        searchResult = null;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };
    model.reset();

    model.searchMeasureReport = function (page, exportType) {
        var deferred = $q.defer();

        if (model.loggedIn) {
            var options = {
                startDate: CommonHelper.getRestDateString(searchCriteria.startDate),
                endDate: CommonHelper.getRestDateString(searchCriteria.endDate),
                commodityCodeRangeStart: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeRangeStart),
                commodityCodeRangeEnd: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeRangeEnd),
                tradeDirection: searchCriteria.direction === 'I' || searchCriteria.direction === 'E' ? searchCriteria.direction : null,
                country: searchCriteria.country,
                measureTypes: CommonHelper.getDistinctCodeList(searchCriteria.measureTypes, searchCriteria.measureType),
                additionalCodes: CommonHelper.getDistinctCodeList(searchCriteria.additionalCodes, searchCriteria.additionalCode),
                footnotes: CommonHelper.getDistinctCodeList(searchCriteria.footnotes, searchCriteria.footnote),
                certificates: CommonHelper.getDistinctCodeList(searchCriteria.certificates, searchCriteria.certificate),
                goodsNomenclatureDescription: searchCriteria.goodsNomenclatureDescription,
                additionalCodeDescription: searchCriteria.additionalCodeDescription,
                footnoteDescription: searchCriteria.footnoteDescription,
                certificateDescription: searchCriteria.certificateDescription,
                geographicalAreaDescription: searchCriteria.geographicalAreaDescription,
                dutyExpressionDescription: searchCriteria.dutyExpressionDescription,
                sortOrder: searchCriteria.ascending ? 'A' : 'D',
                sortColumn: searchCriteria.sortCol,
                language: CommonHelper.getLanguageCode($translate.use()),
                exportType: exportType
            };

            if (page) {
                options.offset = CommonHelper.getOffset(page);
                options.count = CONSTANTS.rowsPerPage;
            }

            var result = QueryMeasureReport.querySecure(options, function () {
                var returnedResult = {};
                returnedResult.totalItems = result.count;
                returnedResult.items = result.items;
                returnedResult.currentPage = page;

                if (searchCriteria.goodsNomenclatureDescription && result.goodsNomenclatureDescriptions && result.goodsNomenclatureDescriptions.length > 0) {
                    returnedResult.goodsNomenclatures = result.goodsNomenclatureDescriptions;
                }
                if (searchCriteria.additionalCodeDescription && result.additionalCodeDescriptions && result.additionalCodeDescriptions.length > 0) {
                    returnedResult.additionalCodes = result.additionalCodeDescriptions;
                }
                if (searchCriteria.footnoteDescription && result.footnoteDescriptions && result.footnoteDescriptions.length > 0) {
                    returnedResult.footnotes = result.footnoteDescriptions;
                }
                if (searchCriteria.certificateDescription && result.certificateDescriptions && result.certificateDescriptions.length > 0) {
                    returnedResult.certificates = result.certificateDescriptions;
                }
                if (searchCriteria.geographicalAreaDescription && result.geographicalAreaDescriptions && result.geographicalAreaDescriptions.length > 0) {
                    returnedResult.geographicalAreas = result.geographicalAreaDescriptions;
                }

                angular.forEach(returnedResult.items, function (measure) {
                    if (measure.excludedCountryIds.length > 0) {
                        measure.excludedCountryIds = measure.excludedCountryIds.join(" ");
                    } else {
                        measure.excludedCountryIds = '';
                    }
                    var orderNumber = measure.orderNumber;
                    if (orderNumber) {
                        // Use regexp to compare with orderNumber
                        var regexp = new RegExp(CONSTANTS.licenseQuotaPattern);
                        measure.licenseQuota = regexp.test(orderNumber);
                    } else {
                        measure.licenseQuota = false;
                    }
                });

                if (page) {
                    searchResult = returnedResult;
                }

                deferred.resolve(returnedResult);
            }, function (error) {
                deferred.reject(error);
            });
        } else {
            var error = {};
            error.data = {};
            error.data.code = 'i8n.bl.unauthenticated';
            error.data.params = null;
            error.data.type = 'ERROR';
            deferred.reject(error);
        }

        return deferred.promise;
    };
}]);

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.measure.report', ['taric.model.measureReport', 'common.filter.commoditycode', 'common.model.measuretype', 'taric.auth.model']).controller('MeasureReportController', ["CONSTANTS", "$translatePartialLoader", "MeasureReportModel", "MeasureTypeModel", "AuthorizeModel", "CommonHelper", "measureTypes", "countries", "$state", "$stateParams", "$rootScope", "$scope", "$filter", "$timeout", "$translate", "$location", "$uibModal", function (CONSTANTS, $translatePartialLoader, MeasureReportModel, MeasureTypeModel, AuthorizeModel, CommonHelper, measureTypes, countries, $state, $stateParams, $rootScope, $scope, $filter, $timeout, $translate, $location, $uibModal) {
    var measureReportCtrl = this;

    measureReportCtrl.init = function () {
        measureReportCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        measureReportCtrl.dateFormat = CONSTANTS.dateFormat;
        measureReportCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        measureReportCtrl.installationCountry = CONSTANTS.installationCountry;
        measureReportCtrl.searchCriteria = MeasureReportModel.getSearchCriteria();
        measureReportCtrl.searchResult = MeasureReportModel.getSearchResult();
        measureReportCtrl.measureTypes = measureTypes;
        measureReportCtrl.controlCountry = {};
        MeasureReportModel.loggedIn = AuthorizeModel.loggedIn;

        // get valid CountryCode
        if (countries) {
            measureReportCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(countries.items, measureReportCtrl.searchCriteria.country, null);
        }

        // get valid MeasureType
        if (measureTypes) {
            measureReportCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(measureTypes.items, measureReportCtrl.searchCriteria.measureType, null);
        }

        if (measureReportCtrl.isExternalLink() && measureReportCtrl.validateExternalParameters()) {
            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            measureReportCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    measureReportCtrl.isExternalLink = function () {
        // Verify 'frm' parameter to avoid auto-search after looking up commodity code, additional code, footnote, or certificate.
        return (!$stateParams.frm || $stateParams.frm !== 'ccLookup' || $stateParams.frm !== 'adcoLookup' || $stateParams.frm !== 'footnoteLookup' || $stateParams.frm !== 'certificateLookup' || $stateParams.frm !== 'ccView') && $stateParams.ds && $stateParams.ccs && $stateParams.d && $stateParams.l && ($stateParams.mt || $stateParams.ad || $stateParams.fn || $stateParams.ce);
    };

    // Check whether the external parameters are valid or not
    measureReportCtrl.validateExternalParameters = function () {
        return measureReportCtrl.validateSearchForm();
    };

    // Lookup and popup handling
    measureReportCtrl.openStartDatePicker = function ($event) {
        measureReportCtrl.isStartDatePickerOpen = true;
    };
    measureReportCtrl.openEndDatePicker = function ($event) {
        measureReportCtrl.isEndDatePickerOpen = true;
    };

    measureReportCtrl.selectCommodityCodeRangeStart = function (commodityCode) {
        measureReportCtrl.selectCommodityCode(commodityCode, measureReportCtrl.searchCriteria.direction, "lookup", "commodityCodeRangeStart");
    };

    measureReportCtrl.selectCommodityCodeRangeEnd = function (commodityCode) {
        measureReportCtrl.selectCommodityCode(commodityCode, measureReportCtrl.searchCriteria.direction, "lookup", "commodityCodeRangeEnd");
    };

    measureReportCtrl.selectCommodityCode = function (commodityCode, tradeDirection, type, ccField) {
        $state.go('taric.nomenclature.sbn', {
            cc: CommonHelper.removeSpaceCharacters(commodityCode),
            sd: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
            d: tradeDirection === '0' ? 'I' : tradeDirection === '1' ? 'E' : tradeDirection,
            frm: 'taric.report.measure',
            type: type,
            ccField: ccField
        });
    };

    measureReportCtrl.lookupAdditionalCode = function (additionalCode) {
        $state.go('taric.adco.lookup', {
            frm: 'taric.report.measure',
            sd: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
            ad: CommonHelper.removeSpaceCharacters(additionalCode),
            mo: false
        });
    };

    measureReportCtrl.lookupFootnote = function (footnote) {
        $state.go('taric.footnote.lookup', {
            frm: 'taric.report.measure',
            sd: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
            fo: CommonHelper.removeSpaceCharacters(footnote)
        });
    };

    measureReportCtrl.lookupCertificate = function (certificate) {
        $state.go('taric.certificate.lookup', {
            frm: 'taric.report.measure',
            sd: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
            ce: CommonHelper.removeSpaceCharacters(certificate)
        });
    };

    measureReportCtrl.openMeasurePopup = function (size, measure) {
        var additionalCodes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode);
        var preferenceCodesForMeasureOnly = false;
        var selectedPreferenceCode = null;
        var inputOrigin = measure.geographicalArea.id;
        // When measureType tradeDirection is '2' (both Import and Export), use Import as default value
        var tradeDirection = measure.measureType.tradeDirection === '0' ? 'I' : measure.measureType.tradeDirection === '1' ? 'E' : 'I';
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/measure/measure-popup.tmpl.html',
            controller: 'MeasurePopupController as measurePopupCtrl',
            size: size,
            resolve: {
                measureExtendedInfo: ["MeasurePopupModel", function measureExtendedInfo(MeasurePopupModel) {
                    return MeasurePopupModel.getMeasureExtendedInfoForMeasureType(measure.sid, preferenceCodesForMeasureOnly, measure.commodityCode, measureReportCtrl.searchCriteria.country, tradeDirection, selectedPreferenceCode, additionalCodes, measureReportCtrl.searchCriteria.startDate, null, measure.unreleased);
                }]
            }
        });
    };

    measureReportCtrl.openOriginPopup = function (size, _origin) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
            controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
            size: size,
            resolve: {
                geoAreaMemberships: ["GeographicalAreaModel", function geoAreaMemberships(GeographicalAreaModel) {
                    return GeographicalAreaModel.queryMembershipByGroupId(_origin, measureReportCtrl.searchCriteria.startDate);
                }],
                origin: function origin() {
                    return _origin;
                }
            }
        });
    };

    measureReportCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: ["FootnotePopupModel", function footnote(FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, measureReportCtrl.searchCriteria.startDate);
                }]
            }
        });
    };

    measureReportCtrl.openAdditionalCodePopup = function (size, additionalCodeId, commodityCode) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/additional-code/additional-code-popup.tmpl.html',
            controller: 'AdditionalCodePopupController as additionalCodePopupCtrl',
            size: size,
            resolve: {
                additionalCode: ["AdditionalCodePopupModel", function additionalCode(AdditionalCodePopupModel) {
                    return AdditionalCodePopupModel.findAdditionalCode(additionalCodeId, measureReportCtrl.searchCriteria.startDate, commodityCode);
                }],
                simulationDate: function simulationDate() {
                    return measureReportCtrl.searchCriteria.startDate;
                }
            }
        });
    };

    measureReportCtrl.openQuotaPopup = function (size, measure) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/quota/quota-popup.tmpl.html',
            controller: 'ViewTaricQuotaController as viewTaricQuotaCtrl',
            size: size,
            resolve: {
                quotaDefinitionExtendedInfo: ["TaricQuotaSearchModel", function quotaDefinitionExtendedInfo(TaricQuotaSearchModel) {
                    var inputOrigin = measure.geographicalArea.id;
                    if (measureReportCtrl.searchCriteria.country !== "" && measureReportCtrl.searchCriteria.country) {
                        inputOrigin = measureReportCtrl.searchCriteria.country;
                    }

                    var quotaExtendedInfo = TaricQuotaSearchModel.getQuotaDefinitionExtendedInfo(measure.orderNumber, inputOrigin, measureReportCtrl.searchCriteria.startDate).then(function (quotaExtendedInfo) {
                        return quotaExtendedInfo;
                    }, function (error) {
                        measureReportCtrl.errorCode = error.data.code;
                        measureReportCtrl.errorParams = error.data.params;
                        measureReportCtrl.errorType = error.data.type;
                        return;
                    });

                    return quotaExtendedInfo;
                }],
                simulationDate: function simulationDate() {
                    return measureReportCtrl.searchCriteria.startDate;
                },
                showCancelButton: function showCancelButton() {
                    return false;
                },
                country: function country() {
                    return measureReportCtrl.searchCriteria.country;
                }
            }
        });
    };

    // Reset error when user changes the additional code field
    measureReportCtrl.onChangeAdditionalCode = function () {
        measureReportCtrl.searchCriteria.additionalCode = measureReportCtrl.searchCriteria.additionalCode.toUpperCase();
        measureReportCtrl.handleError();
    };
    measureReportCtrl.onChangeFootnote = function () {
        measureReportCtrl.searchCriteria.footnote = measureReportCtrl.searchCriteria.footnote.toUpperCase();
        measureReportCtrl.handleError();
    };
    measureReportCtrl.onChangeCertificate = function () {
        measureReportCtrl.searchCriteria.certificate = measureReportCtrl.searchCriteria.certificate.toUpperCase();
        measureReportCtrl.handleError();
    };

    measureReportCtrl.onChangeCountry = function (country) {
        measureReportCtrl.searchCriteria.country = country;
    };

    // Add a measure type to the search list of measure types
    measureReportCtrl.addMeasureType = function (measureType) {
        if (!measureReportCtrl.validateAddingMeasureType(measureType)) {
            return;
        }

        measureReportCtrl.searchCriteria.measureTypes.push(measureType);
        measureReportCtrl.searchCriteria.measureType = null;
    };

    // Remove a the given measure type from the list
    measureReportCtrl.removeMeasureType = function (measureType) {
        measureReportCtrl.handleError();
        measureReportCtrl.searchCriteria.measureTypes = array.without(measureReportCtrl.searchCriteria.measureTypes, measureType);
    };

    // Validate measure type before adding
    measureReportCtrl.validateAddingMeasureType = function (measureType) {
        var result = true;
        measureType = CommonHelper.removeSpaceCharacters(measureType);
        if (measureType === "") {
            measureReportCtrl.errorCode = "i8n.common.error.measureType.empty";
            result = false;
        } else if (measureReportCtrl.searchCriteria.measureTypes.indexOf(measureType) > -1) {
            measureReportCtrl.errorCode = "i8n.common.error.measureType.exists";
            result = false;
        }
        return result;
    };

    // Add an additional code to the search list of additional codes
    measureReportCtrl.addAdditionalCode = function (adco) {
        if (!measureReportCtrl.validateAddingAdditionalCode(adco)) {
            return;
        }

        measureReportCtrl.searchCriteria.additionalCodes.push(adco);
        measureReportCtrl.searchCriteria.additionalCode = null;
    };

    // Remove a the given additional code from the list
    measureReportCtrl.removeAdditionalCode = function (adco) {
        measureReportCtrl.handleError();
        measureReportCtrl.searchCriteria.additionalCodes = array.without(measureReportCtrl.searchCriteria.additionalCodes, adco);
    };

    // Validate additional code before adding
    measureReportCtrl.validateAddingAdditionalCode = function (adco) {
        var result = true;
        adco = CommonHelper.removeSpaceCharacters(adco);
        if (adco === "") {
            measureReportCtrl.errorCode = "i8n.common.error.additionalCode.empty";
            result = false;
        } else if (measureReportCtrl.searchCriteria.additionalCodes.indexOf(adco) > -1) {
            measureReportCtrl.errorCode = "i8n.common.error.additionalCode.exists";
            result = false;
        }
        return result;
    };

    // Check for additional codes to be used in the query parameters
    measureReportCtrl.validateAdditionalCodes = function () {
        var additionalCodes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode);

        for (var i = 0; i < additionalCodes.length; i++) {
            measureReportCtrl.errorCode = CommonHelper.validateAdditionalCode(additionalCodes[i]);
            if (measureReportCtrl.errorCode) {
                return false;
            }
        }
        return true;
    };

    // Add a footnote to the search list of footnotes
    measureReportCtrl.addFootnote = function (footnote) {
        if (!measureReportCtrl.validateAddingFootnote(footnote)) {
            return;
        }

        measureReportCtrl.searchCriteria.footnotes.push(footnote);
        measureReportCtrl.searchCriteria.footnote = null;
    };

    // Remove a the given footnote from the list
    measureReportCtrl.removeFootnote = function (footnote) {
        measureReportCtrl.handleError();
        measureReportCtrl.searchCriteria.footnotes = array.without(measureReportCtrl.searchCriteria.footnotes, footnote);
    };

    // Validate footnote before adding
    measureReportCtrl.validateAddingFootnote = function (footnote) {
        var result = true;
        footnote = CommonHelper.removeSpaceCharacters(footnote);
        if (footnote === "") {
            measureReportCtrl.errorCode = "i8n.common.error.footnote.empty";
            result = false;
        } else if (measureReportCtrl.searchCriteria.footnotes.indexOf(footnote) > -1) {
            measureReportCtrl.errorCode = "i8n.common.error.footnote.exists";
            result = false;
        }
        return result;
    };

    // Check for footnotes to be used in the query parameters
    measureReportCtrl.validateFootnotes = function () {
        var footnotes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.footnotes, measureReportCtrl.searchCriteria.footnote);

        for (var i = 0; i < footnotes.length; i++) {
            measureReportCtrl.errorCode = CommonHelper.validateFootnote(footnotes[i]);
            if (measureReportCtrl.errorCode) {
                return false;
            }
        }
        return true;
    };

    // Add a certificate to the search list of certificates
    measureReportCtrl.addCertificate = function (certificate) {
        if (!measureReportCtrl.validateAddingCertificate(certificate)) {
            return;
        }

        measureReportCtrl.searchCriteria.certificates.push(certificate);
        measureReportCtrl.searchCriteria.certificate = null;
    };

    // Remove a the given certificate from the list
    measureReportCtrl.removeCertificate = function (certificate) {
        measureReportCtrl.handleError();
        measureReportCtrl.searchCriteria.certificates = array.without(measureReportCtrl.searchCriteria.certificates, certificate);
    };

    // Validate certificate before adding
    measureReportCtrl.validateAddingCertificate = function (certificate) {
        var result = true;
        certificate = CommonHelper.removeSpaceCharacters(certificate);
        if (certificate === "") {
            measureReportCtrl.errorCode = "i8n.common.error.certificate.empty";
            result = false;
        } else if (measureReportCtrl.searchCriteria.certificates.indexOf(certificate) > -1) {
            measureReportCtrl.errorCode = "i8n.common.error.certificate.exists";
            result = false;
        }
        return result;
    };

    // Check for certificates to be used in the query parameters
    measureReportCtrl.validateCertificates = function () {
        var certificates = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.certificates, measureReportCtrl.searchCriteria.certificate);

        for (var i = 0; i < certificates.length; i++) {
            measureReportCtrl.errorCode = CommonHelper.validateCertificate(certificates[i]);
            if (measureReportCtrl.errorCode) {
                return false;
            }
        }
        return true;
    };

    measureReportCtrl.search = function () {
        // Load data for the first page
        measureReportCtrl.loadDataFromServer(1);
    };

    //Load data for a given page
    measureReportCtrl.loadDataFromServer = function (page) {
        if (!measureReportCtrl.validateSearchForm()) {
            return;
        }

        measureReportCtrl.loadDataFromServerWithoutValidation(page);
    };

    //Load data for a given page without validation
    measureReportCtrl.loadDataFromServerWithoutValidation = function (page) {
        // Reset search result before searching
        measureReportCtrl.resetSearchResult();
        measureReportCtrl.searching = true;

        MeasureReportModel.searchMeasureReport(page).then(function (searchResult) {
            measureReportCtrl.searchResult = searchResult;
            measureReportCtrl.searching = false;
            measureReportCtrl.updateBrowserURL();
        }, function (error) {
            measureReportCtrl.errorCode = error.data.code;
            measureReportCtrl.errorParams = error.data.params;
            measureReportCtrl.errorType = error.data.type;
            measureReportCtrl.searching = false;

            if (measureReportCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    /**
     * Measure report
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/measure?ds={StartDate}&de={EndDate}
     * &ccs={CommodityCodeRangeStart}&cce={CommodityCodeRangeEnd}&d={TradeDirection}&co={Country}
     * &mt={MeasureTypes}&ad={AdditionalCodes}&fn={Footnotes}&ce={Certificates}
     * &gnd={GoodsNomenclatureDescription}&add={AdditionalCodeDescription}&fnd={FootnoteDescription}
     * &ced={CertificateDescription}&gad={GeographicalAreaDescription}&ded={DutyExpressionDescription}&l={Language}
     *
     * Example:
     * http://localhost:8080/arctictariff-public-web/#!/taric/report/measure?ds=2017-01-01&de=2017-12-31
     * &ccs=01&cce=99&d=I&co=US&mt=552,554&ad=A940&fn=CD698,CD699&ce=D008
     * &gnd=true&add=true&fnd=true&ced=true&gad=true&ded=true&l=en
     */
    measureReportCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep additional parameter 'frm' because there is no return to caller page
        $location.search({
            ds: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
            de: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.endDate),
            ccs: CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.commodityCodeRangeStart),
            cce: CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.commodityCodeRangeEnd),
            d: measureReportCtrl.searchCriteria.direction,
            co: measureReportCtrl.searchCriteria.country,
            mt: CommonHelper.getDistinctCodesString(measureReportCtrl.searchCriteria.measureTypes, measureReportCtrl.searchCriteria.measureType),
            ad: CommonHelper.getDistinctCodesString(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode),
            fn: CommonHelper.getDistinctCodesString(measureReportCtrl.searchCriteria.footnotes, measureReportCtrl.searchCriteria.footnote),
            ce: CommonHelper.getDistinctCodesString(measureReportCtrl.searchCriteria.certificates, measureReportCtrl.searchCriteria.certificate),
            gnd: measureReportCtrl.searchCriteria.goodsNomenclatureDescription.toString(),
            add: measureReportCtrl.searchCriteria.additionalCodeDescription.toString(),
            fnd: measureReportCtrl.searchCriteria.footnoteDescription.toString(),
            ced: measureReportCtrl.searchCriteria.certificateDescription.toString(),
            gad: measureReportCtrl.searchCriteria.geographicalAreaDescription.toString(),
            ded: measureReportCtrl.searchCriteria.dutyExpressionDescription.toString(),
            l: $translate.use()
        }).replace();
    };

    measureReportCtrl.resetSearchResult = function () {
        measureReportCtrl.searchResult = null;
    };

    measureReportCtrl.validateSearchForm = function () {
        measureReportCtrl.handleError();

        // Validate dates
        measureReportCtrl.errorCode = CommonHelper.validateSimulationDate(measureReportCtrl.searchCriteria.startDate);
        if (measureReportCtrl.errorCode) {
            measureReportCtrl.errorParams = { param0: CONSTANTS.pastDate };
            return false;
        }
        // Start date must be before or the same as end date
        if (CommonHelper.compareDatesWithoutTime(measureReportCtrl.searchCriteria.startDate, measureReportCtrl.searchCriteria.endDate) > 0) {
            measureReportCtrl.errorCode = "i8n.common.invalidPeriod";
            return false;
        }

        // Validate commodity codes
        if (!measureReportCtrl.searchCriteria.commodityCodeRangeStart) {
            measureReportCtrl.errorCode = 'i8n.error.commodity.commodityCode.required';
            return false;
        }

        var ccRangeStart = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.commodityCodeRangeStart);
        var ccRangeEnd = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.commodityCodeRangeEnd);
        if (ccRangeStart !== "" && ccRangeEnd !== "" && ccRangeStart.localeCompare(ccRangeEnd) > 0) {
            measureReportCtrl.errorCode = "i8n.qry.report.measure.search.commodityCodeRange.incorrect";
            return false;
        }
        measureReportCtrl.errorCode = CommonHelper.validateCommodityCode(measureReportCtrl.searchCriteria.commodityCodeRangeStart, measureReportCtrl.searchCriteria.direction);
        if (measureReportCtrl.errorCode) {
            return false;
        }
        measureReportCtrl.errorCode = CommonHelper.validateCommodityCode(measureReportCtrl.searchCriteria.commodityCodeRangeEnd, measureReportCtrl.searchCriteria.direction);
        if (measureReportCtrl.errorCode) {
            return false;
        }

        // The user must provide at least one of measure type, additional code, certificate or footnote
        if (CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.measureType) === "" && CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.additionalCode) === "" && CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.footnote) === "" && CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.certificate) === "" && measureReportCtrl.searchCriteria.measureTypes.length === 0 && measureReportCtrl.searchCriteria.additionalCodes.length === 0 && measureReportCtrl.searchCriteria.footnotes.length === 0 && measureReportCtrl.searchCriteria.certificates.length === 0) {

            measureReportCtrl.errorCode = 'i8n.qry.report.measure.search.requiredCriteria';
            return false;
        }

        // Validate additional codes
        if (!measureReportCtrl.validateAdditionalCodes()) {
            return false;
        }

        // Validate footnotes
        if (!measureReportCtrl.validateFootnotes()) {
            return false;
        }

        // Validate certificates
        if (!measureReportCtrl.validateCertificates()) {
            return false;
        }

        // ACSMNT-3924 If the input code is the same as one that has already been added, set the input code to empty
        var code = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.measureType);
        if (code && measureReportCtrl.searchCriteria.measureTypes.indexOf(code) > -1) {
            measureReportCtrl.searchCriteria.measureType = null;
        }

        code = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.additionalCode);
        if (code && measureReportCtrl.searchCriteria.additionalCodes.indexOf(code) > -1) {
            measureReportCtrl.searchCriteria.additionalCode = null;
        }

        code = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.footnote);
        if (code && measureReportCtrl.searchCriteria.footnotes.indexOf(code) > -1) {
            measureReportCtrl.searchCriteria.footnote = null;
        }

        code = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.certificate);
        if (code && measureReportCtrl.searchCriteria.certificates.indexOf(code) > -1) {
            measureReportCtrl.searchCriteria.certificate = null;
        }

        return true;
    };

    //Handle page change for the measure search result table
    measureReportCtrl.searchResultPageChanged = function (page) {
        measureReportCtrl.loadDataFromServer(page);
    };

    measureReportCtrl.handleError = function (error) {
        if (!error) {
            measureReportCtrl.errorCode = null;
            measureReportCtrl.errorParams = null;
            measureReportCtrl.errorType = null;
        } else {
            measureReportCtrl.errorCode = error.errorCode;
            measureReportCtrl.errorParams = error.errorParams;
            measureReportCtrl.errorType = error.errorType;
        }
    };

    measureReportCtrl.onStartDateChange = function (dateString) {
        measureReportCtrl.searchCriteria.startDate = CommonHelper.formatDate(measureReportCtrl.searchCriteria.startDate, dateString);
        measureReportCtrl.handleError();
        measureReportCtrl.reloadCountries();
        measureReportCtrl.reloadMeasureTypes();
    };

    measureReportCtrl.onEndDateChange = function (dateString) {
        measureReportCtrl.searchCriteria.endDate = CommonHelper.formatDate(measureReportCtrl.searchCriteria.endDate, dateString);
        measureReportCtrl.handleError();
        measureReportCtrl.reloadMeasureTypes();
    };

    measureReportCtrl.reloadCountries = function () {
        if (!measureReportCtrl.searchCriteria.startDate || CommonHelper.compareDatesWithoutTime(measureReportCtrl.searchCriteria.startDate, measureReportCtrl.searchCriteria.endDate) > 0) {
            return;
        }

        measureReportCtrl.loadingReferenceData = true;
        measureReportCtrl.controlCountry.reload(measureReportCtrl.searchCriteria.startDate).then(function () {
            measureReportCtrl.loadingReferenceData = false;
        }, function (error) {
            measureReportCtrl.errorCode = error.data.code;
            measureReportCtrl.errorParams = error.data.params;
            measureReportCtrl.errorType = error.data.type;
            measureReportCtrl.loadingReferenceData = false;
        });
    };

    measureReportCtrl.reloadMeasureTypes = function () {
        if (!measureReportCtrl.searchCriteria.startDate || CommonHelper.compareDatesWithoutTime(measureReportCtrl.searchCriteria.startDate, measureReportCtrl.searchCriteria.endDate) > 0) {
            return;
        }

        MeasureTypeModel.getMeasureTypes(measureReportCtrl.searchCriteria.direction, measureReportCtrl.searchCriteria.startDate, measureReportCtrl.searchCriteria.endDate).then(function (measureTypes) {
            measureReportCtrl.measureTypes = measureTypes;
            measureReportCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(measureTypes.items, measureReportCtrl.searchCriteria.measureType, null);
        });
    };

    measureReportCtrl.hasNationalMeasureTypes = function () {
        var nationalMeasureTypes = measureReportCtrl.measureTypes.items.filter(function (measureType) {
            return measureType.national === true;
        });
        return nationalMeasureTypes.length > 0;
    };

    // export pdf
    measureReportCtrl.print = function (options) {
        if (!measureReportCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');

        // Get temporary code list to add Search criteria in PDF export
        measureReportCtrl.searchCriteria.queryMeasureTypes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.measureTypes, measureReportCtrl.searchCriteria.measureType);
        measureReportCtrl.searchCriteria.queryAdditionalCodes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode);
        measureReportCtrl.searchCriteria.queryFootnotes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.footnotes, measureReportCtrl.searchCriteria.footnote);
        measureReportCtrl.searchCriteria.queryCertificates = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.certificates, measureReportCtrl.searchCriteria.certificate);

        MeasureReportModel.searchMeasureReport(null, 'pdf').then(function (searchResult) {

            measureReportCtrl.searchAllResult = searchResult;
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportFormTable'), options);
                doc.push({ text: '\n' });
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);
                if (measureReportCtrl.searchAllResult.goodsNomenclatures) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('goodsNomenclatures'), options);
                }
                if (measureReportCtrl.searchAllResult.additionalCodes) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('additionalCodes'), options);
                }
                if (measureReportCtrl.searchAllResult.footnotes) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('footnotes'), options);
                }
                if (measureReportCtrl.searchAllResult.certificates) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('certificates'), options);
                }
                if (measureReportCtrl.searchAllResult.geographicalAreas) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('geographicalAreas'), options);
                }

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    flag: measureReportCtrl.flagImg,
                    eu: measureReportCtrl.euImg,
                    validDate: $filter('date')(measureReportCtrl.searchCriteria.startDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qry.report.measure.title')
                }, 'l').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            measureReportCtrl.errorCode = error.data.code;
            measureReportCtrl.errorParams = error.data.params;
            measureReportCtrl.errorType = error.data.type;
            $rootScope.$broadcast('stopSpinningPrint');

            if (measureReportCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    $scope.$on('printDocument', function (event, data) {
        CommonHelper.loadImage("img/flags/EU.png", 21, 14, function (options) {

            measureReportCtrl.euImg = options.logo;
        }, true);

        var url = "img/flags/" + measureReportCtrl.installationCountry + ".png";
        CommonHelper.loadImage(url, 21, 14, function (options) {

            measureReportCtrl.flagImg = options.logo;
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, measureReportCtrl.print, true);
        }, true);
    });

    // export excel
    measureReportCtrl.exportExcel = function () {
        if (!measureReportCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningExport');

        // Get temporary code list to add Search criteria in XLS export
        measureReportCtrl.searchCriteria.queryMeasureTypes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.measureTypes, measureReportCtrl.searchCriteria.measureType);
        measureReportCtrl.searchCriteria.queryAdditionalCodes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode);
        measureReportCtrl.searchCriteria.queryFootnotes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.footnotes, measureReportCtrl.searchCriteria.footnote);
        measureReportCtrl.searchCriteria.queryCertificates = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.certificates, measureReportCtrl.searchCriteria.certificate);

        MeasureReportModel.searchMeasureReport(null, 'excel').then(function (searchResult) {

            measureReportCtrl.searchAllResult = searchResult;
            setTimeout(function () {

                var title = $filter('translate')('i8n.qry.report.measure.title');

                // columns format of excel
                var exportExcelTableId = "exportExcelTable";
                var ws = {
                    '!cols': [{
                        wpx: 50
                    }, {
                        wpx: 100
                    }, {
                        wpx: 80
                    }, {
                        wpx: 100
                    }, {
                        wpx: 110
                    }, {
                        wpx: 250
                    }, {
                        wpx: 100
                    }, {
                        wpx: 90
                    }, {
                        wpx: 80
                    }, {
                        wpx: 80
                    }, {
                        wpx: 80
                    }, {
                        wpx: 80
                    }, {
                        wpx: 80
                    }]
                };

                if (!measureReportCtrl.searchCriteria.dutyExpressionDescription) {
                    exportExcelTableId = "exportExcelTableWithoutDutyExpression";
                    ws = {
                        '!cols': [{
                            wpx: 50
                        }, {
                            wpx: 100
                        }, {
                            wpx: 80
                        }, {
                            wpx: 100
                        }, {
                            wpx: 110
                        }, {
                            wpx: 100
                        }, {
                            wpx: 90
                        }, {
                            wpx: 80
                        }, {
                            wpx: 80
                        }, {
                            wpx: 80
                        }, {
                            wpx: 80
                        }, {
                            wpx: 80
                        }]
                    };
                }

                // export excel
                CommonHelper.printExcel(exportExcelTableId, title, ws).then(function () {
                    $rootScope.$broadcast('stopSpinningExport');
                }, function () {
                    $rootScope.$broadcast('stopSpinningExport');
                });
            }, 1000);
        }, function (error) {

            measureReportCtrl.errorCode = error.data.code;
            measureReportCtrl.errorParams = error.data.params;
            measureReportCtrl.errorType = error.data.type;
            $rootScope.$broadcast('stopSpinningExport');

            if (measureReportCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    $scope.$on('exportDocument', function (event, data) {
        measureReportCtrl.exportExcel();
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        measureReportCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            measureReportCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.measureAmendments', ['common.helper', 'ngResource']).factory('QueryMeasureAmendments', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/report/measures', {}, {
        querySecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + '/arctictariff-se-report-rs' + '/secure/report/measures'
        }
    });
}]).service('MeasureAmendmentsModel', ["$q", "$translate", "CONSTANTS", "CommonHelper", "QueryMeasureAmendments", "AuthorizeModel", function ($q, $translate, CONSTANTS, CommonHelper, QueryMeasureAmendments, AuthorizeModel) {
    var model = this;
    var searchCriteria = null;
    var searchResult = null;

    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.startDate = new Date();
        searchCriteria.endDate = null;
        searchCriteria.commodityCodeRangeStart = null;
        searchCriteria.commodityCodeRangeEnd = null;
        searchCriteria.direction = 'I';
        searchCriteria.measureType = null;
        searchCriteria.updateType = null;
        searchCriteria.additionalCode = null;
        searchCriteria.footnote = null;
        searchCriteria.certificate = null;
        searchCriteria.goodsNomenclatureDescription = false;
        searchCriteria.additionalCodeDescription = false;
        searchCriteria.footnoteDescription = false;
        searchCriteria.certificateDescription = false;
        searchCriteria.dutyExpressionDescription = false;
        searchCriteria.ascending = true;

        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.getSearchResult = function () {
        return searchResult;
    };
    model.resetSearchResult = function () {
        searchResult = null;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };
    model.reset();

    model.searchMeasureReport = function (page, isNational) {
        var deferred = $q.defer();

        if (model.loggedIn) {
            var options = {
                startDate: CommonHelper.getRestDateString(searchCriteria.startDate),
                endDate: CommonHelper.getRestDateString(searchCriteria.endDate),
                commodityCodeRangeStart: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeRangeStart),
                commodityCodeRangeEnd: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeRangeEnd),
                tradeDirection: searchCriteria.direction,
                measureType: searchCriteria.measureType,
                updateType: searchCriteria.updateType,
                national: isNational,
                additionalCode: CommonHelper.removeSpaceCharacters(searchCriteria.additionalCode),
                footnote: CommonHelper.removeSpaceCharacters(searchCriteria.footnote),
                certificate: CommonHelper.removeSpaceCharacters(searchCriteria.certificate),
                goodsNomenclatureDescription: searchCriteria.goodsNomenclatureDescription,
                additionalCodeDescription: searchCriteria.additionalCodeDescription,
                footnoteDescription: searchCriteria.footnoteDescription,
                certificateDescription: searchCriteria.certificateDescription,
                dutyExpressionDescription: searchCriteria.dutyExpressionDescription,
                sortOrder: searchCriteria.ascending ? 'A' : 'D',
                sortColumn: searchCriteria.sortCol,
                language: CommonHelper.getLanguageCode($translate.use())
            };

            if (page) {
                options.offset = CommonHelper.getOffset(page);
                options.count = CONSTANTS.rowsPerPage;
            }

            var result = QueryMeasureAmendments.querySecure(options, function () {
                var returnedResult = {};
                returnedResult.totalItems = result.count;
                returnedResult.items = result.items;
                returnedResult.currentPage = page;
                if (searchCriteria.goodsNomenclatureDescription && result.goodsNomenclatures && result.goodsNomenclatures.length > 0) {
                    returnedResult.goodsNomenclatures = result.goodsNomenclatures;
                }
                if (searchCriteria.additionalCodeDescription && result.additionalCodes && result.additionalCodes.length > 0) {
                    returnedResult.additionalCodes = result.additionalCodes;
                }
                if (searchCriteria.footnoteDescription && result.footnotes && result.footnotes.length > 0) {
                    returnedResult.footnotes = result.footnotes;
                }
                if (searchCriteria.certificateDescription && result.certificates && result.certificates.length > 0) {
                    returnedResult.certificates = result.certificates;
                }

                if (page) {
                    searchResult = returnedResult;
                }

                deferred.resolve(returnedResult);
            }, function (error) {
                deferred.reject(error);
            });
        } else {
            var error = {};
            error.data = {};
            error.data.code = 'i8n.bl.unauthenticated';
            error.data.params = null;
            error.data.type = 'ERROR';
            deferred.reject(error);
        }

        return deferred.promise;
    };
}]);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.measure.amendments', ['taric.model.measureAmendments', 'common.filter.commoditycode', 'common.model.measuretype', 'taric.auth.model']).controller('MeasureAmendmentsController', ["CONSTANTS", "$translatePartialLoader", "MeasureAmendmentsModel", "MeasureTypeModel", "AuthorizeModel", "CommonHelper", "measureTypes", "$state", "$stateParams", "$rootScope", "$scope", "$filter", "$timeout", "$translate", "$location", function (CONSTANTS, $translatePartialLoader, MeasureAmendmentsModel, MeasureTypeModel, AuthorizeModel, CommonHelper, measureTypes, $state, $stateParams, $rootScope, $scope, $filter, $timeout, $translate, $location) {
    var measureAmendmentsCtrl = this;

    measureAmendmentsCtrl.init = function () {
        measureAmendmentsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        measureAmendmentsCtrl.dateFormat = CONSTANTS.dateFormat;
        measureAmendmentsCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        measureAmendmentsCtrl.installationCountry = CONSTANTS.installationCountry;
        measureAmendmentsCtrl.searchCriteria = MeasureAmendmentsModel.getSearchCriteria();
        measureAmendmentsCtrl.searchResult = MeasureAmendmentsModel.getSearchResult();
        measureAmendmentsCtrl.measureTypes = measureTypes;
        measureAmendmentsCtrl.loadUpdateTypes();
        MeasureAmendmentsModel.loggedIn = AuthorizeModel.loggedIn;

        // get valid MeasureType
        if (measureTypes) {
            measureAmendmentsCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(measureTypes.items, measureAmendmentsCtrl.searchCriteria.measureType, null);
        }

        if (measureAmendmentsCtrl.isExternalLink() && measureAmendmentsCtrl.validateExternalParameters()) {
            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            measureAmendmentsCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    measureAmendmentsCtrl.isExternalLink = function () {
        // Verify 'frm' parameter to avoid auto-search after looking up commodity code, additional code, footnote, or certificate.
        return (!$stateParams.frm || $stateParams.frm !== 'ccLookup' || $stateParams.frm !== 'adcoLookup' || $stateParams.frm !== 'footnoteLookup' || $stateParams.frm !== 'certificateLookup') && $stateParams.ds && $stateParams.ccs && $stateParams.d && $stateParams.mt && $stateParams.l;
    };

    // Check whether the external parameters are valid or not
    measureAmendmentsCtrl.validateExternalParameters = function () {
        return measureAmendmentsCtrl.validateSearchForm();
    };

    measureAmendmentsCtrl.openStartDatePicker = function ($event) {
        measureAmendmentsCtrl.isStartDatePickerOpen = true;
    };
    measureAmendmentsCtrl.openEndDatePicker = function ($event) {
        measureAmendmentsCtrl.isEndDatePickerOpen = true;
    };

    measureAmendmentsCtrl.selectCommodityCodeRangeStart = function (commodityCode) {
        measureAmendmentsCtrl.selectCommodityCode(commodityCode, measureAmendmentsCtrl.searchCriteria.startDate, "lookup", "commodityCodeRangeStart");
    };

    measureAmendmentsCtrl.selectCommodityCodeRangeEnd = function (commodityCode) {
        measureAmendmentsCtrl.selectCommodityCode(commodityCode, measureAmendmentsCtrl.searchCriteria.startDate, "lookup", "commodityCodeRangeEnd");
    };

    measureAmendmentsCtrl.selectCommodityCode = function (commodityCode, date, type, ccField) {

        $state.go('taric.nomenclature.sbn', {
            cc: CommonHelper.removeSpaceCharacters(commodityCode),
            sd: CommonHelper.getBookmarkDateString(date),
            d: measureAmendmentsCtrl.searchCriteria.direction,
            frm: 'taric.report.measure',
            type: type,
            ccField: ccField
        });
    };

    measureAmendmentsCtrl.lookupAdditionalCode = function (additionalCode) {
        $state.go('taric.adco.lookup', {
            frm: 'taric.report.measure',
            sd: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.startDate),
            ad: CommonHelper.removeSpaceCharacters(additionalCode),
            mo: false
        });
    };

    measureAmendmentsCtrl.lookupFootnote = function (footnote) {
        $state.go('taric.footnote.lookup', {
            frm: 'taric.report.measure',
            sd: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.startDate),
            fo: CommonHelper.removeSpaceCharacters(footnote)
        });
    };

    measureAmendmentsCtrl.lookupCertificate = function (certificate) {
        $state.go('taric.certificate.lookup', {
            frm: 'taric.report.measure',
            sd: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.startDate),
            ce: CommonHelper.removeSpaceCharacters(certificate)
        });
    };

    // Reset error when user changes the additional code field
    measureAmendmentsCtrl.onChangeAdditionalCode = function () {
        measureAmendmentsCtrl.searchCriteria.additionalCode = measureAmendmentsCtrl.searchCriteria.additionalCode.toUpperCase();
        measureAmendmentsCtrl.handleError();
    };
    measureAmendmentsCtrl.onChangeFootnote = function () {
        measureAmendmentsCtrl.searchCriteria.footnote = measureAmendmentsCtrl.searchCriteria.footnote.toUpperCase();
        measureAmendmentsCtrl.handleError();
    };
    measureAmendmentsCtrl.onChangeCertificate = function () {
        measureAmendmentsCtrl.searchCriteria.certificate = measureAmendmentsCtrl.searchCriteria.certificate.toUpperCase();
        measureAmendmentsCtrl.handleError();
    };

    measureAmendmentsCtrl.search = function () {
        // Load data for the first page
        measureAmendmentsCtrl.loadDataFromServer(1);
    };

    //Load data for a given page
    measureAmendmentsCtrl.loadDataFromServer = function (page) {
        if (!measureAmendmentsCtrl.validateSearchForm()) {
            return;
        }

        measureAmendmentsCtrl.loadDataFromServerWithoutValidation(page);
    };

    //Load data for a given page without validation
    measureAmendmentsCtrl.loadDataFromServerWithoutValidation = function (page) {
        // Reset search result before searching
        measureAmendmentsCtrl.resetSearchResult();
        measureAmendmentsCtrl.searching = true;

        MeasureAmendmentsModel.searchMeasureReport(page, measureAmendmentsCtrl.isNationalMeasureType(measureAmendmentsCtrl.searchCriteria.measureType)).then(function (searchResult) {
            measureAmendmentsCtrl.searchResult = searchResult;
            measureAmendmentsCtrl.searching = false;
            measureAmendmentsCtrl.updateBrowserURL();
        }, function (error) {
            measureAmendmentsCtrl.errorCode = error.data.code;
            measureAmendmentsCtrl.errorParams = error.data.params;
            measureAmendmentsCtrl.errorType = error.data.type;
            measureAmendmentsCtrl.searching = false;

            if (measureAmendmentsCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    /**
     * Measure report
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/measure?ds={StartDate}&de={EndDate}
     * &ccs={CommodityCodeRangeStart}&cce={CommodityCodeRangeEnd}&d={TradeDirection}&mt={MeasureType}&ut={UpdateType}
     * &na={National}&ad={AdditionalCode}&fn={Footnote}&ce={Certificate}
     * &gnd={GoodsNomenclatureDescription}&add={AdditionalCodeDescription}&fnd={FootnoteDescription}&ced={CertificateDescription}&ded={DutyExpressionDescription}&l={Language}
     *
     * Example:
     * http://localhost:8080/arctictariff-public-web/#!/taric/report/measure?ds=2017-01-01&de=2017-01-31
     * &ccs=8001&cce=8414&d=I&mt=103&ut=D
     * &na=NATIONAL&ad=2500&fn=CD989&ce=Y949
     * &gnd=true&add=true&fnd=true&ced=true&ded=true&l=en
     */
    measureAmendmentsCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep additional parameter 'frm' because there is no return to caller page
        $location.search({
            ds: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.startDate),
            de: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.endDate),
            ccs: CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeStart),
            cce: CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeEnd),
            d: measureAmendmentsCtrl.searchCriteria.direction,
            mt: measureAmendmentsCtrl.searchCriteria.measureType,
            ut: measureAmendmentsCtrl.searchCriteria.updateType,
            ad: measureAmendmentsCtrl.searchCriteria.additionalCode,
            fn: measureAmendmentsCtrl.searchCriteria.footnote,
            ce: measureAmendmentsCtrl.searchCriteria.certificate,
            gnd: measureAmendmentsCtrl.searchCriteria.goodsNomenclatureDescription.toString(),
            add: measureAmendmentsCtrl.searchCriteria.additionalCodeDescription.toString(),
            fnd: measureAmendmentsCtrl.searchCriteria.footnoteDescription.toString(),
            ced: measureAmendmentsCtrl.searchCriteria.certificateDescription.toString(),
            ded: measureAmendmentsCtrl.searchCriteria.dutyExpressionDescription.toString(),
            l: $translate.use()
        }).replace();
    };

    measureAmendmentsCtrl.resetSearchResult = function () {
        measureAmendmentsCtrl.searchResult = null;
    };

    measureAmendmentsCtrl.validateSearchForm = function () {
        measureAmendmentsCtrl.handleError();

        // Validate dates
        measureAmendmentsCtrl.errorCode = CommonHelper.validateSimulationDate(measureAmendmentsCtrl.searchCriteria.startDate);
        if (measureAmendmentsCtrl.errorCode) {
            measureAmendmentsCtrl.errorParams = { param0: CONSTANTS.pastDate };
            return false;
        }
        // Start date must be before or the same as end date
        if (CommonHelper.compareDatesWithoutTime(measureAmendmentsCtrl.searchCriteria.startDate, measureAmendmentsCtrl.searchCriteria.endDate) > 0) {
            measureAmendmentsCtrl.errorCode = "i8n.common.invalidPeriod";
            return false;
        }
        // Max start date must be after end date. If end date is empty, today will be considered as end date
        if (CONSTANTS.menu.measureAmendments.maxIntervalInMonths) {
            var startDateMoment = moment(measureAmendmentsCtrl.searchCriteria.startDate, CONSTANTS.dateFormat.toUpperCase(), true);
            var maxStartDateMoment = moment(startDateMoment).add(CONSTANTS.menu.measureAmendments.maxIntervalInMonths, 'month');
            var endDate = measureAmendmentsCtrl.searchCriteria.endDate;
            if (!endDate) {
                endDate = new Date();
            }
            if (CommonHelper.compareDatesWithoutTime(maxStartDateMoment.toDate(), endDate) <= 0) {
                measureAmendmentsCtrl.errorCode = "i8n.qry.report.measureAmendments.search.intervalLimit";
                measureAmendmentsCtrl.errorParams = { number: CONSTANTS.menu.measureAmendments.maxIntervalInMonths };
                return false;
            }
        }

        // Validate commodity codes
        if (!measureAmendmentsCtrl.searchCriteria.commodityCodeRangeStart) {
            measureAmendmentsCtrl.errorCode = 'i8n.error.commodity.commodityCode.required';
            return false;
        }

        var ccRangeStart = CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeStart);
        var ccRangeEnd = CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeEnd);
        if (ccRangeStart !== "" && ccRangeEnd !== "" && ccRangeStart.localeCompare(ccRangeEnd) > 0) {
            measureAmendmentsCtrl.errorCode = "i8n.qry.report.measureAmendments.search.commodityCodeRange.incorrect";
            return false;
        }
        measureAmendmentsCtrl.errorCode = CommonHelper.validateCommodityCode(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeStart, measureAmendmentsCtrl.searchCriteria.direction);
        if (measureAmendmentsCtrl.errorCode) {
            return false;
        }
        measureAmendmentsCtrl.errorCode = CommonHelper.validateCommodityCode(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeEnd, measureAmendmentsCtrl.searchCriteria.direction);
        if (measureAmendmentsCtrl.errorCode) {
            return false;
        }

        // Validate measure type
        if (!measureAmendmentsCtrl.searchCriteria.measureType) {
            measureAmendmentsCtrl.errorCode = 'i8n.qry.report.measureAmendments.search.measureType.required';
            return false;
        }

        // Validate additional code
        if (CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.additionalCode) !== "") {
            measureAmendmentsCtrl.errorCode = CommonHelper.validateAdditionalCode(measureAmendmentsCtrl.searchCriteria.additionalCode);
        }
        if (measureAmendmentsCtrl.errorCode) {
            return false;
        }

        // Validate footnote
        if (CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.footnote) !== "") {
            measureAmendmentsCtrl.errorCode = CommonHelper.validateFootnote(measureAmendmentsCtrl.searchCriteria.footnote);
        }
        if (measureAmendmentsCtrl.errorCode) {
            return false;
        }

        // Validate certificate
        if (CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.certificate) !== "") {
            measureAmendmentsCtrl.errorCode = CommonHelper.validateCertificate(measureAmendmentsCtrl.searchCriteria.certificate);
        }
        if (measureAmendmentsCtrl.errorCode) {
            return false;
        }

        return true;
    };

    measureAmendmentsCtrl.searchResultPageChanged = function (page) {
        measureAmendmentsCtrl.loadDataFromServerWithoutValidation(page);
    };

    measureAmendmentsCtrl.handleError = function (error) {
        if (!error) {
            measureAmendmentsCtrl.errorCode = null;
            measureAmendmentsCtrl.errorParams = null;
            measureAmendmentsCtrl.errorType = null;
        } else {
            measureAmendmentsCtrl.errorCode = error.errorCode;
            measureAmendmentsCtrl.errorParams = error.errorParams;
            measureAmendmentsCtrl.errorType = error.errorType;
        }
    };

    measureAmendmentsCtrl.onStartDateChange = function (dateString) {
        measureAmendmentsCtrl.searchCriteria.startDate = CommonHelper.formatDate(measureAmendmentsCtrl.searchCriteria.startDate, dateString);
        measureAmendmentsCtrl.handleError();
        measureAmendmentsCtrl.reloadMeasureTypes();
    };

    measureAmendmentsCtrl.onEndDateChange = function (dateString) {
        measureAmendmentsCtrl.searchCriteria.endDate = CommonHelper.formatDate(measureAmendmentsCtrl.searchCriteria.endDate, dateString);
        measureAmendmentsCtrl.onStartDateChange();
    };

    measureAmendmentsCtrl.reloadMeasureTypes = function () {
        if (!measureAmendmentsCtrl.searchCriteria.startDate || CommonHelper.compareDatesWithoutTime(measureAmendmentsCtrl.searchCriteria.startDate, measureAmendmentsCtrl.searchCriteria.endDate) > 0) {
            return;
        }

        MeasureTypeModel.getMeasureTypes(measureAmendmentsCtrl.searchCriteria.direction, measureAmendmentsCtrl.searchCriteria.startDate, measureAmendmentsCtrl.searchCriteria.endDate).then(function (measureTypes) {
            measureAmendmentsCtrl.measureTypes = measureTypes;
            measureAmendmentsCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(measureTypes.items, measureAmendmentsCtrl.searchCriteria.measureType, null);
        });
    };

    measureAmendmentsCtrl.hasNationalMeasureTypes = function () {
        var nationalMeasureTypes = measureAmendmentsCtrl.measureTypes.items.filter(function (measureType) {
            return measureType.national === true;
        });
        return nationalMeasureTypes.length > 0;
    };

    measureAmendmentsCtrl.isNationalMeasureType = function (measureTypeId) {
        var nationalMeasureTypes = measureAmendmentsCtrl.measureTypes.items.filter(function (measureType) {
            return measureType.national === true;
        });

        for (var i = 0; i < nationalMeasureTypes.length; i++) {
            if (nationalMeasureTypes[i].id === measureTypeId) {
                return true;
            }
        }

        return false;
    };

    measureAmendmentsCtrl.loadUpdateTypes = function () {
        var updateTypeCodes = ["I", "U", "D"];

        measureAmendmentsCtrl.updateTypes = [];
        updateTypeCodes.forEach(function (updateType) {
            $translate("i8n.qry.report.measureAmendments.updateType.label." + updateType).then(function (updateTypeDescription) {
                measureAmendmentsCtrl.updateTypes.push({
                    "code": updateType,
                    "description": updateTypeDescription
                });
            });
        });

        $timeout(function () {

            //Wait for the translation is done and then do a sort
            measureAmendmentsCtrl.updateTypes.sort(function (updateType1, updateType2) {
                return updateType1.description.localeCompare(updateType2.description, CommonHelper.getLanguageCode($translate.use()));
            });
        }, 500);
    };

    // export pdf
    measureAmendmentsCtrl.print = function (options) {
        if (!measureAmendmentsCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        MeasureAmendmentsModel.searchMeasureReport(null, measureAmendmentsCtrl.isNationalMeasureType(measureAmendmentsCtrl.searchCriteria.measureType)).then(function (searchResult) {

            measureAmendmentsCtrl.searchAllResult = searchResult;
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);
                if (measureAmendmentsCtrl.searchAllResult.goodsNomenclatures) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('goodsNomenclatures'), options);
                }
                if (measureAmendmentsCtrl.searchAllResult.additionalCodes) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('additionalCodes'), options);
                }
                if (measureAmendmentsCtrl.searchAllResult.footnotes) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('footnotes'), options);
                }
                if (measureAmendmentsCtrl.searchAllResult.certificates) {
                    doc.push({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('certificates'), options);
                }

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    flag: measureAmendmentsCtrl.flagImg,
                    eu: measureAmendmentsCtrl.euImg,
                    validDate: $filter('date')(measureAmendmentsCtrl.searchCriteria.startDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qry.report.measureAmendments.title')
                }, 'l').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            measureAmendmentsCtrl.errorCode = error.data.code;
            measureAmendmentsCtrl.errorParams = error.data.params;
            measureAmendmentsCtrl.errorType = error.data.type;
            $rootScope.$broadcast('stopSpinningPrint');

            if (measureAmendmentsCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    $scope.$on('printDocument', function (event, data) {
        CommonHelper.loadImage("img/flags/EU.png", 21, 14, function (options) {

            measureAmendmentsCtrl.euImg = options.logo;
        }, true);

        var url = "img/flags/" + measureAmendmentsCtrl.installationCountry + ".png";
        CommonHelper.loadImage(url, 21, 14, function (options) {

            measureAmendmentsCtrl.flagImg = options.logo;
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, measureAmendmentsCtrl.print, true);
        }, true);
    });

    // export excel
    measureAmendmentsCtrl.exportExcel = function () {
        if (!measureAmendmentsCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningExport');
        MeasureAmendmentsModel.searchMeasureReport(null, measureAmendmentsCtrl.isNationalMeasureType(measureAmendmentsCtrl.searchCriteria.measureType)).then(function (searchResult) {

            measureAmendmentsCtrl.searchAllResult = searchResult;
            setTimeout(function () {

                var title = $filter('translate')('i8n.qry.report.measureAmendments.title');

                // columns format of excel
                var exportExcelTableId = "exportExcelTable";
                var ws = {
                    '!cols': [{
                        wpx: 50
                    }, {
                        wpx: 100
                    }, {
                        wpx: 80
                    }, {
                        wpx: 100
                    }, {
                        wpx: 110
                    }, {
                        wpx: 250
                    }, {
                        wpx: 100
                    }, {
                        wpx: 90
                    }, {
                        wpx: 80
                    }]
                };

                if (!measureAmendmentsCtrl.searchCriteria.dutyExpressionDescription) {
                    exportExcelTableId = "exportExcelTableWithoutDutyExpression";
                    ws = {
                        '!cols': [{
                            wpx: 50
                        }, {
                            wpx: 100
                        }, {
                            wpx: 80
                        }, {
                            wpx: 100
                        }, {
                            wpx: 110
                        }, {
                            wpx: 100
                        }, {
                            wpx: 90
                        }, {
                            wpx: 80
                        }]
                    };
                }

                // export excel
                CommonHelper.printExcel(exportExcelTableId, title, ws).then(function () {
                    $rootScope.$broadcast('stopSpinningExport');
                }, function () {
                    $rootScope.$broadcast('stopSpinningExport');
                });
            }, 1000);
        }, function (error) {

            measureAmendmentsCtrl.errorCode = error.data.code;
            measureAmendmentsCtrl.errorParams = error.data.params;
            measureAmendmentsCtrl.errorType = error.data.type;
            $rootScope.$broadcast('stopSpinningExport');

            if (measureAmendmentsCtrl.errorCode === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
        });
    };

    $scope.$on('exportDocument', function (event, data) {
        measureAmendmentsCtrl.exportExcel();
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        measureAmendmentsCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            measureAmendmentsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('taric.model.mlr', ['ngResource', 'common.helper']).factory('MLRReport', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/mlr/measures/', {}, {
        query: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('MlrReportModel', ["MLRReport", "$q", "CommonHelper", "CONSTANTS", function (MLRReport, $q, CommonHelper, CONSTANTS) {
    var model = this,
        searchCriteria = {};
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
    };
    model.reset = function () {
        model.resetSearchCriteria();
    };

    model.reset();

    model.searchMeasures = function (page) {
        var deferred = $q.defer();
        searchCriteria.commodityCodeFrom = CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeFrom);
        searchCriteria.commodityCodeTo = CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeTo);

        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            regulationPrefix: CommonHelper.removeSpaceCharacters(searchCriteria.regulationPrefix),
            regulationNumber: CommonHelper.removeSpaceCharacters(searchCriteria.regulationNumber),
            regulationYear: CommonHelper.removeSpaceCharacters(searchCriteria.regulationYear),
            commodityCodeFrom: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeFrom),
            commodityCodeTo: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeTo),
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol
        };
        if (page) {
            options.offset = CommonHelper.getOffset(page);
            options.count = CONSTANTS.rowsPerPage;
        }
        var result = MLRReport.query(options, function () {
            var searchResult = {};
            searchResult.totalItems = result.count;
            searchResult.measures = result.items;
            searchResult.regulationHead = result.regulationHead;
            searchResult.simulationDate = searchCriteria.simulationDate;
            searchResult.commodityCodeFrom = searchCriteria.commodityCodeFrom;
            searchResult.commodityCodeTo = searchCriteria.commodityCodeTo;
            if (page) {
                searchResult.currentPage = page;
            }
            deferred.resolve(searchResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mlrSearch = angular.module('taric.mlr.search', ['taric.model.menu', 'common.helper', 'taric.model.mlr', 'common.filter.commoditycode']).controller('MlrSearchController', ["CONSTANTS", "MlrReportModel", "$rootScope", "$scope", "CommonHelper", "$timeout", "$state", "$filter", "$stateParams", "$translate", "$location", function (CONSTANTS, MlrReportModel, $rootScope, $scope, CommonHelper, $timeout, $state, $filter, $stateParams, $translate, $location) {
    var mlrSearchCtrl = this;
    mlrSearchCtrl.init = function () {
        mlrSearchCtrl.dateFormat = CONSTANTS.dateFormat;
        mlrSearchCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        mlrSearchCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        mlrSearchCtrl.searchCriteria = MlrReportModel.getSearchCriteria();
        mlrSearchCtrl.regulationPrefixList = CONSTANTS.menu.measuresLinkedRegulation.regulationPrefixList;

        if (mlrSearchCtrl.searchCriteria.regulationPrefix && mlrSearchCtrl.regulationPrefixList.indexOf(mlrSearchCtrl.searchCriteria.regulationPrefix) < 0) {
            mlrSearchCtrl.searchCriteria.regulationPrefix = null;
        }

        if (mlrSearchCtrl.isExternalLink() && mlrSearchCtrl.validateExternalParameters()) {
            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            mlrSearchCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    mlrSearchCtrl.isExternalLink = function () {
        // Verify 'frm' parameter to avoid auto-search after looking up commodity code.
        return (!$stateParams.frm || $stateParams.frm !== 'ccLookup') && $stateParams.sd && $stateParams.rp && $stateParams.rn && $stateParams.ry;
    };

    // Check whether the external parameters are valid or not
    mlrSearchCtrl.validateExternalParameters = function () {
        return mlrSearchCtrl.validateSearchForm();
    };

    mlrSearchCtrl.search = function () {
        mlrSearchCtrl.loadDataFromServer(1);
    };

    mlrSearchCtrl.validateSearchForm = function () {
        mlrSearchCtrl.resetError();
        return mlrSearchCtrl.validateSimulationDate() && mlrSearchCtrl.validateRegulationPrefix() && mlrSearchCtrl.validateRegulationNumber() && mlrSearchCtrl.validateRegulationYear() && mlrSearchCtrl.validateCommodityCodeRange();
    };

    mlrSearchCtrl.validateSimulationDate = function () {
        if (!mlrSearchCtrl.searchCriteria.simulationDate) {
            mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.missing.simulationDate";
            return false;
        }
        return true;
    };

    mlrSearchCtrl.validateRegulationPrefix = function () {
        if (CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationPrefix) === "") {
            mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.missing.regulationPrefix";
            return false;
        }
        return true;
    };

    mlrSearchCtrl.validateRegulationNumber = function () {
        if (CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationNumber) === "") {
            mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.missing.regulationNumber";
            return false;
        } else {
            mlrSearchCtrl.errorCode = CommonHelper.validateStringByPattern(mlrSearchCtrl.searchCriteria.regulationNumber, "^[0-9]{4}$", "i8n.qry.mlr.search.validation.invalid.regulationNumber");
        }
        return mlrSearchCtrl.errorCode === null;
    };

    mlrSearchCtrl.validateRegulationYear = function () {
        if (CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationYear) === "") {
            mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.missing.regulationYear";
            return false;
        } else {
            mlrSearchCtrl.errorCode = CommonHelper.validateStringByPattern(mlrSearchCtrl.searchCriteria.regulationYear, "^[0-9]{2}$", "i8n.qry.mlr.search.validation.invalid.regulationYear");
        }
        return mlrSearchCtrl.errorCode === null;
    };

    mlrSearchCtrl.validateCommodityCodeRange = function () {
        var commodityCodeFrom = CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.commodityCodeFrom);
        var commodityCodeTo = CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.commodityCodeTo);
        if (commodityCodeFrom !== "" && (commodityCodeFrom.length % 2 !== 0 || commodityCodeFrom.length > 10)) {
            mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.invalid.commodityCodeRangeStart";
            return false;
        }
        if (commodityCodeTo !== "" && (commodityCodeTo.length % 2 !== 0 || commodityCodeFrom.length > 10)) {
            mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.invalid.commodityCodeRangeEnd";
            return false;
        }
        var errorCode = CommonHelper.validateStringByPattern(commodityCodeFrom, "^[0-9 ]*$", "i8n.qry.mlr.search.validation.invalid.commodityCodeRangeStart");
        if (errorCode !== null) {
            mlrSearchCtrl.errorCode = errorCode;
            return false;
        }
        errorCode = CommonHelper.validateStringByPattern(commodityCodeTo, "^[0-9 ]*$", "i8n.qry.mlr.search.validation.invalid.commodityCodeRangeEnd");
        if (errorCode !== null) {
            mlrSearchCtrl.errorCode = errorCode;
            return false;
        }
        return true;
    };

    mlrSearchCtrl.resetError = function () {
        mlrSearchCtrl.handleError();
    };

    mlrSearchCtrl.handleError = function (error) {
        if (!error) {
            mlrSearchCtrl.errorCode = null;
            mlrSearchCtrl.errorParams = null;
        } else {
            mlrSearchCtrl.errorCode = error.data.code;
            mlrSearchCtrl.errorParams = error.data.params;
            mlrSearchCtrl.formatDateParameters(mlrSearchCtrl.errorParams);
        }
    };

    mlrSearchCtrl.openDatePicker = function () {
        mlrSearchCtrl.isDatePickerOpen = true;
    };

    mlrSearchCtrl.resetSearchResult = function () {
        mlrSearchCtrl.searchResult = null;
    };

    mlrSearchCtrl.searchResultPageChanged = function (page) {
        mlrSearchCtrl.loadDataFromServer(page);
    };

    mlrSearchCtrl.selectCommodityCode = function (commodityCode, date, type, ccField) {

        $state.go('taric.nomenclature.sbn', {
            cc: CommonHelper.removeSpaceCharacters(commodityCode),
            sd: CommonHelper.getBookmarkDateString(date),
            d: 'I',
            frm: 'taric.report.mlr',
            type: type,
            ccField: ccField
        });
    };

    mlrSearchCtrl.selectCommodityCodeFrom = function (commodityCode) {
        mlrSearchCtrl.selectCommodityCode(commodityCode, mlrSearchCtrl.searchCriteria.simulationDate, "lookup", "commodityCodeFrom");
    };

    mlrSearchCtrl.selectCommodityCodeTo = function (commodityCode) {
        mlrSearchCtrl.selectCommodityCode(commodityCode, mlrSearchCtrl.searchCriteria.simulationDate, "lookup", "commodityCodeTo");
    };

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        mlrSearchCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            mlrSearchCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });

    mlrSearchCtrl.loadDataFromServer = function (page) {
        if (!mlrSearchCtrl.validateSearchForm()) {
            return;
        }

        mlrSearchCtrl.loadDataFromServerWithoutValidation(page);
    };

    mlrSearchCtrl.loadDataFromServerWithoutValidation = function (page) {

        // Reset search result before searching
        mlrSearchCtrl.resetSearchResult();
        mlrSearchCtrl.searching = true;
        MlrReportModel.searchMeasures(page).then(function (searchResult) {
            mlrSearchCtrl.searchResult = searchResult;
            mlrSearchCtrl.searching = false;
            mlrSearchCtrl.searchResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(mlrSearchCtrl.searchCriteria.simulationDate);
            if (mlrSearchCtrl.searchResult.infoCode && "i8n.common.pastDate" === mlrSearchCtrl.searchResult.infoCode) {
                mlrSearchCtrl.searchResult.infoParams = CONSTANTS.pastDate;
            }
            mlrSearchCtrl.updateBrowserURL();
        }, function (error) {
            mlrSearchCtrl.searching = false;
            mlrSearchCtrl.handleError(error);
        });
    };

    /**
     * Measures linked to a regulation
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/mlr?sd={SimulationDate}&rp={RegulationPrefix}&rn={RegulationNumber}&ry={RegulationYear}&ccs={CommodityCodeStart}&cct={CommodityCodeEnd}&l={Language}
     *
     * Example:
     * http://localhost:8080/arctictariff-public-web/#!/taric/report/reliefcode/search?sd=2015-01-01&rp=R&rn=1006&ry=11&ccs=010121&cce=010229&l=en
     */
    mlrSearchCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep additional parameters because there is no return to caller page
        $location.search({
            sd: CommonHelper.getBookmarkDateString(mlrSearchCtrl.searchCriteria.simulationDate),
            rp: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationPrefix),
            rn: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationNumber),
            ry: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationYear),
            ccs: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.commodityCodeFrom),
            cce: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.commodityCodeTo),
            l: $translate.use()
        }).replace();
    };

    mlrSearchCtrl.formatDateParameters = function (errorParams) {
        if (errorParams) {
            var testParam = null;
            for (var param in errorParams) {
                if (errorParams.hasOwnProperty(param)) {
                    testParam = CommonHelper.parseInputDate(errorParams[param]);
                    if (testParam) {
                        errorParams[param] = $filter('date')(testParam, mlrSearchCtrl.dateFormat);
                    }
                }
            }
        }
    };

    mlrSearchCtrl.onDateChange = function (dateString) {
        mlrSearchCtrl.resetError();
        mlrSearchCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(mlrSearchCtrl.searchCriteria.simulationDate, dateString);
    };

    //export excel
    mlrSearchCtrl.exportExcel = function () {
        if (!mlrSearchCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningExport');
        MlrReportModel.searchMeasures().then(function (searchResult) {

            var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
            mlrSearchCtrl.allSearchResult = searchResult;
            document.getElementById('reportDateExtr').innerHTML = reportDate;

            setTimeout(function () {
                var title = $filter('translate')('i8n.common.menu.query.data.measuresLinkedToRegulation');
                var ws = {
                    '!cols': [{
                        wpx: 200
                    }, {
                        wpx: 130
                    }, {
                        wpx: 130
                    }, {
                        wpx: 130
                    }, {
                        wpx: 130
                    }, {
                        wpx: 130
                    }]
                };

                CommonHelper.printExcel("exportExcelTable", title, ws).then(function () {
                    $rootScope.$broadcast('stopSpinningExport');
                }, function () {
                    $rootScope.$broadcast('stopSpinningExport');
                });
            }, 1000);
        }, function (error) {
            // show errors here
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    // export pdf
    mlrSearchCtrl.print = function (options) {
        if (!mlrSearchCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        MlrReportModel.searchMeasures().then(function (searchResult) {
            mlrSearchCtrl.allSearchResult = searchResult;
            setTimeout(function () {

                // print the first table of the report
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportRegulationInformation'), options);

                // print second table of the report.
                doc.push({ text: '\n' });
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(mlrSearchCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qry.mlr.search.resultHeader.resultTitle.label', { param0: searchResult.regulationHead.id })
                }, 'l').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            $rootScope.$broadcast('stopSpinningPrint');
            mlrSearchCtrl.handleError(error);
        });
    };

    $scope.$on('exportDocument', function (event, data) {
        mlrSearchCtrl.exportExcel();
    });

    $scope.$on('printDocument', function (event, data) {
        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, mlrSearchCtrl.print, true);
    });
}]);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('taric.model.pt', ['common.helper', 'ngResource']).factory('QueryPt', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/pt/query', {}, {
        query: {
            method: 'GET',
            isArray: false
        }
    });
}]).service('PrintedTaricModel', ["$q", "$translate", "CONSTANTS", "CommonHelper", "QueryPt", function ($q, $translate, CONSTANTS, CommonHelper, QueryPt) {
    var model = this;
    var searchCriteria = {};

    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.commodityCode = null;
        searchCriteria.ascending = true;
    };

    model.reset = function () {
        model.resetSearchCriteria();
    };

    model.reset();

    model.searchPrintedTarics = function (page) {
        var deferred = $q.defer();
        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            commodityCode: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCode),
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol,
            language: CommonHelper.getLanguageCode($translate.use())
        };

        if (page) {

            options.offset = CommonHelper.getOffset(page);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = QueryPt.query(options, function () {
            var searchResult = {};
            searchResult.totalItems = result.count;
            searchResult.items = result.items;
            searchResult.currentPage = page;
            if (page) {
                searchResult.displayedItems = CommonHelper.loadDataPerTablePage(searchResult.items, page);
            } else {
                searchResult.displayedItems = CommonHelper.loadDataPerTablePage(searchResult.items, 1);
            }
            deferred.resolve(searchResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('report.pt', ['taric.model.pt', 'common.filter.commoditycode']).controller('PrintedTaricController', ["CONSTANTS", "$translatePartialLoader", "PrintedTaricModel", "CommonHelper", "$state", "$stateParams", "$rootScope", "$scope", "$filter", "$timeout", "$translate", "$location", function (CONSTANTS, $translatePartialLoader, PrintedTaricModel, CommonHelper, $state, $stateParams, $rootScope, $scope, $filter, $timeout, $translate, $location) {
    var printedTaricCtrl = this;

    printedTaricCtrl.init = function () {
        printedTaricCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        printedTaricCtrl.dateFormat = CONSTANTS.dateFormat;
        printedTaricCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        printedTaricCtrl.searchCriteria = PrintedTaricModel.getSearchCriteria();

        if (printedTaricCtrl.isExternalLink() && printedTaricCtrl.validateExternalParameters()) {
            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            printedTaricCtrl.loadDataFromServerWithoutValidation(1);
        }
    };

    printedTaricCtrl.isExternalLink = function () {
        // Verify 'frm' parameter to avoid auto-search after looking up commodity code.
        return (!$stateParams.frm || $stateParams.frm !== 'ccLookup') && $stateParams.sd && $stateParams.cc;
    };

    // Check whether the external parameters are valid or not
    printedTaricCtrl.validateExternalParameters = function () {
        return printedTaricCtrl.validateSearchForm();
    };

    printedTaricCtrl.openDatePicker = function ($event) {
        printedTaricCtrl.isDatePickerOpen = true;
    };

    printedTaricCtrl.search = function () {
        // Load data for the first page
        printedTaricCtrl.loadDataFromServer(1);
    };

    //Load data for a given page
    printedTaricCtrl.loadDataFromServer = function (page) {
        if (!printedTaricCtrl.validateSearchForm()) {
            return;
        }

        printedTaricCtrl.loadDataFromServerWithoutValidation(page);
    };

    //Load data for a given page without validation
    printedTaricCtrl.loadDataFromServerWithoutValidation = function (page) {
        // Reset search result before searching
        printedTaricCtrl.resetSearchResult();
        printedTaricCtrl.searching = true;
        PrintedTaricModel.searchPrintedTarics(page).then(function (searchResult) {
            printedTaricCtrl.searchResult = searchResult;
            printedTaricCtrl.searching = false;
            printedTaricCtrl.updateBrowserURL();
        }, function (error) {
            printedTaricCtrl.errorCode = error.data.code;
            printedTaricCtrl.errorParams = error.data.params;
            printedTaricCtrl.errorType = error.data.type;
            printedTaricCtrl.searching = false;
        });
    };

    /**
     * Printed TARIC
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/pt?sd={SimulationDate}&cc={CommodityCode}&l={Language}
     *
     * Example:
     * http://localhost:8080/arctictariff-public-web/#!/taric/report/pt?sd=2015-01-01&cc=1005109000&l=en
     */
    printedTaricCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep additional parameter 'frm' because there is no return to caller page
        $location.search({
            sd: CommonHelper.getBookmarkDateString(printedTaricCtrl.searchCriteria.simulationDate),
            cc: CommonHelper.removeSpaceCharacters(printedTaricCtrl.searchCriteria.commodityCode),
            l: $translate.use()
        }).replace();
    };

    printedTaricCtrl.resetSearchResult = function () {
        printedTaricCtrl.searchResult = null;
    };

    printedTaricCtrl.validateSearchForm = function () {
        printedTaricCtrl.handleError();

        printedTaricCtrl.errorCode = CommonHelper.validateSimulationDate(printedTaricCtrl.searchCriteria.simulationDate);
        if (printedTaricCtrl.errorCode) {
            printedTaricCtrl.errorParams = { param0: CONSTANTS.pastDate };
            return false;
        }

        if (!printedTaricCtrl.searchCriteria.commodityCode) {
            printedTaricCtrl.errorCode = 'i8n.error.commodity.commodityCode.required';
            return false;
        }

        printedTaricCtrl.errorCode = CommonHelper.validateCommodityCode(printedTaricCtrl.searchCriteria.commodityCode);
        if (printedTaricCtrl.errorCode) {
            return false;
        }

        return true;
    };

    printedTaricCtrl.searchResultPageChanged = function (page) {
        printedTaricCtrl.searchResult.displayedItems = CommonHelper.loadDataPerTablePage(printedTaricCtrl.searchResult.items, page);
    };

    printedTaricCtrl.selectCommodityCode = function (commodityCode, date) {
        $state.go('taric.nomenclature.sbn', {
            cc: CommonHelper.removeSpaceCharacters(commodityCode),
            sd: CommonHelper.getBookmarkDateString(date),
            d: 'I',
            frm: 'taric.report.pt',
            type: 'lookup'
        });
    };

    printedTaricCtrl.resetError = function () {
        printedTaricCtrl.handleError();
    };

    printedTaricCtrl.handleError = function (error) {
        if (!error) {
            printedTaricCtrl.errorCode = null;
            printedTaricCtrl.errorParams = null;
        } else {
            printedTaricCtrl.errorCode = error.errorCode;
            printedTaricCtrl.errorParams = error.errorParams;
        }
    };

    printedTaricCtrl.formatCommodityCode = function () {
        var formattedCommodityCode = $filter('commodityCode')(printedTaricCtrl.searchCriteria.commodityCode);
        printedTaricCtrl.searchCriteria.commodityCode = formattedCommodityCode;
    };

    printedTaricCtrl.onDateChange = function (dateString) {
        printedTaricCtrl.resetError();
        printedTaricCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(printedTaricCtrl.searchCriteria.simulationDate, dateString);
    };

    // export pdf
    printedTaricCtrl.print = function (options) {

        if (!printedTaricCtrl.validateSearchForm()) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        PrintedTaricModel.searchPrintedTarics().then(function (searchResult) {

            printedTaricCtrl.searchAllResult = searchResult;
            setTimeout(function () {

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(printedTaricCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.qry.pt.search.title')
                }, 'p').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {

            // show errors here
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, printedTaricCtrl.print, true);
    });

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        printedTaricCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            printedTaricCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });
}]);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reliefCodeSearch = angular.module('taric.relief.search', ['taric.model.menu', 'common.helper', 'taric.model.relief']).controller('ReliefCodeController', ["CONSTANTS", "ReliefReportModel", "$rootScope", "$scope", "CommonHelper", "reliefCodeTypes", "$timeout", "$state", "$stateParams", "$filter", "$translate", "$location", function (CONSTANTS, ReliefReportModel, $rootScope, $scope, CommonHelper, reliefCodeTypes, $timeout, $state, $stateParams, $filter, $translate, $location) {
    var reliefCodeCtrl = this;
    reliefCodeCtrl.init = function () {
        reliefCodeCtrl.dateFormat = CONSTANTS.dateFormat;
        reliefCodeCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        reliefCodeCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        reliefCodeCtrl.searchCriteria = ReliefReportModel.getSearchCriteria();
        reliefCodeCtrl.searchResult = ReliefReportModel.getSearchResult();
        reliefCodeCtrl.reliefCodeTypes = reliefCodeTypes;

        if (reliefCodeCtrl.isExternalLink() && reliefCodeCtrl.validateExternalParameters()) {
            // get valid reliefCodeType
            reliefCodeCtrl.searchCriteria.reliefCodeType = CommonHelper.getValidSelectedItem(reliefCodeTypes, reliefCodeCtrl.searchCriteria.reliefCodeType, null);

            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            reliefCodeCtrl.loadDataFromServer(1);
        }
    };

    reliefCodeCtrl.isExternalLink = function () {
        // Verify 'frm' parameter to avoid auto-search after viewing relief detail.
        return (!$stateParams.frm || $stateParams.frm !== 'taric.report.relief.view') && $stateParams.sd;
    };

    // Check whether the external parameters are valid or not
    reliefCodeCtrl.validateExternalParameters = function () {
        reliefCodeCtrl.resetError();
        return reliefCodeCtrl.validateSimulationDate();
    };

    reliefCodeCtrl.validateSimulationDate = function () {
        if (!CONSTANTS.dateRestrictionEnabled) {
            reliefCodeCtrl.errorCode = CommonHelper.validateSimulationDate(reliefCodeCtrl.searchCriteria.simulationDate);
            if (reliefCodeCtrl.errorCode) {
                reliefCodeCtrl.errorParams = { param0: CONSTANTS.pastDate };
            }
        }
        return reliefCodeCtrl.errorCode === null;
    };

    reliefCodeCtrl.search = function () {
        reliefCodeCtrl.loadDataFromServer(1);
    };

    reliefCodeCtrl.onDateChange = function (dateString) {
        reliefCodeCtrl.resetError();
        reliefCodeCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(reliefCodeCtrl.searchCriteria.simulationDate, dateString);
        if (reliefCodeCtrl.searchCriteria.simulationDate) {
            ReliefReportModel.loadReliefCodeTypes(reliefCodeCtrl.searchCriteria.simulationDate).then(function (reliefCodeTypes) {
                reliefCodeCtrl.reliefCodeTypes = reliefCodeTypes;
            }, function (error) {
                reliefCodeCtrl.errorCode = error.data.code;
                reliefCodeCtrl.errorParams = error.data.params;
            });
        }
    };

    reliefCodeCtrl.resetError = function () {
        reliefCodeCtrl.errorCode = null;
        reliefCodeCtrl.errorParams = null;
    };

    reliefCodeCtrl.openDatePicker = function () {
        reliefCodeCtrl.isDatePickerOpen = true;
    };

    reliefCodeCtrl.resetSearchResult = function () {
        reliefCodeCtrl.searchResult = null;
        ReliefReportModel.resetSearchResult();
    };

    reliefCodeCtrl.searchResultPageChanged = function (page) {
        reliefCodeCtrl.loadDataFromServer(page);
    };

    $rootScope.$on('$translateChangeSuccess', function () {

        //This is just a workaround to force the page to re-render the pagination items with translated texts
        reliefCodeCtrl.itemsPerPage = 99999999;
        $timeout(function () {
            reliefCodeCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        }, 100);
    });

    reliefCodeCtrl.loadDataFromServer = function (page) {

        // Reset search result before searching
        reliefCodeCtrl.resetSearchResult();
        reliefCodeCtrl.errorCode = null;
        reliefCodeCtrl.errorParams = null;
        reliefCodeCtrl.searching = true;
        ReliefReportModel.searchReliefCodes(page).then(function (searchResult) {
            reliefCodeCtrl.searchResult = searchResult;
            reliefCodeCtrl.searching = false;
            reliefCodeCtrl.searchResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(reliefCodeCtrl.searchCriteria.simulationDate);
            if (reliefCodeCtrl.searchResult.infoCode && "i8n.common.pastDate" === reliefCodeCtrl.searchResult.infoCode) {
                reliefCodeCtrl.searchResult.infoParams = CONSTANTS.pastDate;
            }
            reliefCodeCtrl.updateBrowserURL();
        }, function (error) {
            reliefCodeCtrl.errorCode = error.data.code;
            reliefCodeCtrl.errorParams = error.data.params;
            reliefCodeCtrl.searching = false;
        });
    };

    /**
     * Print relief code
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/reliefcode/search?sd={SimulationDate}&rt={ReliefCodeType}&rc={ReliefCode}&l={Language}
     *
     * Example:
     * http://localhost:8080/arctictariff-public-web/#!/taric/report/reliefcode/search?sd=2015-01-01&rt=E&rc=01&l=en
     */
    reliefCodeCtrl.updateBrowserURL = function () {
        if (!CONSTANTS.enableBookmark) {
            return;
        }

        // Do not keep parameter 'frm' because there is no return to caller page
        $location.search({
            sd: CommonHelper.getBookmarkDateString(reliefCodeCtrl.searchCriteria.simulationDate),
            rt: CommonHelper.removeSpaceCharacters(reliefCodeCtrl.searchCriteria.reliefCodeType),
            rc: CommonHelper.removeSpaceCharacters(reliefCodeCtrl.searchCriteria.reliefCode),
            l: $translate.use()
        }).replace();
    };

    //View relief detail
    reliefCodeCtrl.viewDetail = function (item) {
        $state.go('taric.report.relief.view', { cd: item.reliefCode, sd: CommonHelper.getBookmarkDateString(reliefCodeCtrl.searchCriteria.simulationDate) });
    };

    // export pdf
    reliefCodeCtrl.print = function (options) {
        if (!reliefCodeCtrl.searchCriteria.simulationDate) {
            $scope.$apply();
            return;
        }

        $rootScope.$broadcast('startSpinningPrint');
        ReliefReportModel.searchReliefCodes().then(function (searchResult) {

            reliefCodeCtrl.allSearchResult = searchResult;
            setTimeout(function () {
                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(reliefCodeCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                    title: $filter('translate')('i8n.report.reliefCode.search.title')
                }, 'l').then(function () {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, function (error) {
                    $rootScope.$broadcast('stopSpinningPrint');
                });
            }, 1000);
        }, function (error) {
            reliefCodeCtrl.errorCode = error.data.code;
            reliefCodeCtrl.errorParams = error.data.params;
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, reliefCodeCtrl.print, true);
    });
}]);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('taric.model.relief', ['ngResource', 'common.helper']).factory('ReliefReport', ["$resource", "CONSTANTS", function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/relief/reliefCodes/', {}, {
        query: {
            method: 'GET',
            isArray: false
        },
        getReliefCodeTypes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/relief/reliefCodeTypes'
        },
        getReliefCodeDetail: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/relief/reliefCodes/:id'
        }
    });
}]).service('ReliefReportModel', ["ReliefReport", "$q", "CommonHelper", "CONSTANTS", function (ReliefReport, $q, CommonHelper, CONSTANTS) {
    var model = this,
        searchCriteria = {},
        searchResult = null;
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.getSearchResult = function () {
        return searchResult;
    };

    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.reliefCodeType = null;
        searchCriteria.reliefCode = null;
        searchCriteria.ascending = true;
    };

    model.resetSearchResult = function () {
        searchResult = null;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();

    model.searchReliefCodes = function (page) {
        var deferred = $q.defer();
        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            reliefCodeType: CommonHelper.removeSpaceCharacters(searchCriteria.reliefCodeType),
            reliefCode: CommonHelper.removeSpaceCharacters(searchCriteria.reliefCode),
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol
        };
        if (page) {
            options.offset = CommonHelper.getOffset(page);
            options.count = CONSTANTS.rowsPerPage;
        }
        var result = ReliefReport.query(options, function () {
            var returnedResult = {};
            returnedResult.totalItems = result.count;
            returnedResult.reliefCodes = result.items;
            returnedResult.currentPage = page;
            if (page) {
                searchResult = returnedResult;
            }
            deferred.resolve(returnedResult);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    model.loadReliefCodeTypes = function (simulationDate) {
        var deferred = $q.defer();
        ReliefReport.getReliefCodeTypes({ simulationDate: CommonHelper.getRestDateString(simulationDate) }, function (reliefCodeTypes) {
            deferred.resolve(reliefCodeTypes.items);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getReliefCodeDetail = function (reliefCode, simulationDate) {
        var deferred = $q.defer();
        ReliefReport.getReliefCodeDetail({ id: CommonHelper.removeSpaceCharacters(reliefCode),
            simulationDate: CommonHelper.getRestDateString(simulationDate) }, function (reliefCodeDetail) {
            deferred.resolve(reliefCodeDetail);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}]);

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reliefCodeView = angular.module('taric.relief.view', ['taric.model.menu', 'common.helper']).controller('ReliefCodeViewController', ["CONSTANTS", "reliefCodeDetail", "CommonHelper", "$rootScope", "$scope", "$filter", "$stateParams", function (CONSTANTS, reliefCodeDetail, CommonHelper, $rootScope, $scope, $filter, $stateParams) {
    var reliefCodeViewCtrl = this;
    reliefCodeViewCtrl.init = function () {
        reliefCodeViewCtrl.dateFormat = CONSTANTS.dateFormat;
        reliefCodeViewCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        reliefCodeViewCtrl.reliefCodeType = reliefCodeDetail.reliefCode.substring(0, 1);
        reliefCodeViewCtrl.reliefCode = reliefCodeDetail.reliefCode.substring(1);
        reliefCodeViewCtrl.startDate = reliefCodeDetail.startDate;
        reliefCodeViewCtrl.endDate = reliefCodeDetail.endDate;
        reliefCodeViewCtrl.descriptions = reliefCodeDetail.descriptions;
        reliefCodeViewCtrl.reliefs = reliefCodeDetail.reliefs;
    };

    reliefCodeViewCtrl.print = function (options) {
        $rootScope.$broadcast('startSpinningPrint');
        $scope.$apply();

        // load documents
        var doc = [];
        CommonHelper.htmlTableToPdf(doc, document.getElementById('reliefCodeInformation'), options);

        var reliefAreas = document.getElementsByClassName("relief-area");
        if (reliefAreas) {
            for (var i = 0; i < reliefAreas.length; i++) {
                doc.push({ text: '\n' });
                CommonHelper.htmlTableToPdf(doc, reliefAreas[i].getElementsByClassName("relief-table")[0], options);
                doc.push({ text: '\n' });
                CommonHelper.htmlTableToPdf(doc, reliefAreas[i].getElementsByClassName("measure-type-duty-expr-table")[0], options);
            }
        }
        CommonHelper.printPlainDocument({
            contents: doc,
            logo: options.logo,
            validDate: $filter('date')($stateParams.sd, CONSTANTS.dateFormat),
            title: $filter('translate')('i8n.report.reliefCode.view.title')
        }, 'l').then(function () {
            $rootScope.$broadcast('stopSpinningPrint');
        }, function (error) {
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

    $scope.$on('printDocument', function (event, data) {

        // preload logo of the report
        // size of logo must be multiplied by 2 because it will increase resolution
        CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, reliefCodeViewCtrl.print, true);
    });
}]);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var taricPrint = angular.module('taric.report', ['report.pt', 'taric.relief.search', 'taric.relief.view', 'taric.mlr.search', 'taric.measure.report', 'taric.measure.amendments']);
taricPrint.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('taric.report', {
        abstract: true,
        url: '/report',
        template: '<ui-view></ui-view>'
    }).state('taric.report.pt', {
        url: '/pt?sd&cc&l&frm',
        templateUrl: 'taric/report/pt/printed-taric-search.tmpl.html',
        controller: 'PrintedTaricController as printedTaricCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["$stateParams", "$filter", "$translate", "PrintedTaricModel", "CommonHelper", function initializeData($stateParams, $filter, $translate, PrintedTaricModel, CommonHelper) {
                if ($stateParams.frm !== 'ccLookup') {
                    PrintedTaricModel.reset();
                }
                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        PrintedTaricModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.cc) {
                    PrintedTaricModel.getSearchCriteria().commodityCode = $filter('commodityCode')($stateParams.cc);
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/pt');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.report.relief', {
        abstract: true,
        url: '/reliefcode',
        template: '<ui-view></ui-view>'
    }).state('taric.report.relief.search', {
        url: '/search?sd&rt&rc&l&frm',
        templateUrl: 'taric/report/relief/search/relief-code-search.tmpl.html',
        controller: 'ReliefCodeController as reliefCodeCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["ReliefReportModel", "$stateParams", "$translate", "CommonHelper", function initializeData(ReliefReportModel, $stateParams, $translate, CommonHelper) {
                if ($stateParams.frm !== 'taric.report.relief.view') {
                    ReliefReportModel.reset();
                }
                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        ReliefReportModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.rt) {
                    ReliefReportModel.getSearchCriteria().reliefCodeType = $stateParams.rt;
                }
                if ($stateParams.rc) {
                    ReliefReportModel.getSearchCriteria().reliefCode = $stateParams.rc;
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/relief/search');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }],
            reliefCodeTypes: ["ReliefReportModel", function reliefCodeTypes(ReliefReportModel) {
                var searchCriteria = ReliefReportModel.getSearchCriteria();
                return ReliefReportModel.loadReliefCodeTypes(searchCriteria.simulationDate);
            }]
        }
    }).state('taric.report.relief.view', {
        url: '/view?cd&sd',
        templateUrl: 'taric/report/relief/view/relief-code-view.tmpl.html',
        controller: 'ReliefCodeViewController as reliefCodeViewCtrl',
        resolve: {
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/relief/view');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }],
            reliefCodeDetail: ["$stateParams", "ReliefReportModel", "CommonHelper", function reliefCodeDetail($stateParams, ReliefReportModel, CommonHelper) {
                var reliefCode = $stateParams.cd;
                var simulationDate = new Date();
                var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                if (inputDate) {
                    simulationDate = inputDate;
                }
                return ReliefReportModel.getReliefCodeDetail(reliefCode, simulationDate);
            }]
        }
    }).state('taric.report.mlr', {
        url: '/mlr?sd&rp&rn&ry&ccs&cce&frm&&cc&ccField',
        templateUrl: 'taric/report/mlr/mlr-search.tmpl.html',
        controller: 'MlrSearchController as mlrSearchCtrl',
        reloadOnSearch: false,
        resolve: {
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/mlr');
            }],
            initializeData: ["$stateParams", "MlrReportModel", "$translate", "CommonHelper", function initializeData($stateParams, MlrReportModel, $translate, CommonHelper) {

                if ($stateParams.frm !== 'ccLookup') {
                    MlrReportModel.reset();
                }

                //In the case of returning back from lookup commodity code screen, do not reset data
                if ($stateParams.ccField && $stateParams.cc) {
                    if ($stateParams.ccField === 'commodityCodeFrom') {
                        MlrReportModel.getSearchCriteria().commodityCodeFrom = $stateParams.cc;
                    } else if ($stateParams.ccField === 'commodityCodeTo') {
                        MlrReportModel.getSearchCriteria().commodityCodeTo = $stateParams.cc;
                    }
                }

                if ($stateParams.sd) {
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        MlrReportModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }

                if ($stateParams.rp) {
                    MlrReportModel.getSearchCriteria().regulationPrefix = $stateParams.rp;
                }
                if ($stateParams.rn) {
                    MlrReportModel.getSearchCriteria().regulationNumber = $stateParams.rn;
                }
                if ($stateParams.ry) {
                    MlrReportModel.getSearchCriteria().regulationYear = $stateParams.ry;
                }
                if ($stateParams.ccs) {
                    MlrReportModel.getSearchCriteria().commodityCodeFrom = $stateParams.ccs;
                }
                if ($stateParams.cce) {
                    MlrReportModel.getSearchCriteria().commodityCodeTo = $stateParams.cce;
                }
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.report.measure', {
        url: '/measure?frm&cc&ccField&ds&de&ccs&cce&d&co&mt&ad&fn&ce&gnd&add&fnd&ced&gad&ded&l',
        templateUrl: 'taric/report/measure/measure-report-search.tmpl.html',
        controller: 'MeasureReportController as measureReportCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["$stateParams", "$filter", "$translate", "MeasureReportModel", "CommonHelper", function initializeData($stateParams, $filter, $translate, MeasureReportModel, CommonHelper) {
                if ($stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'adcoLookup' && $stateParams.frm !== 'footnoteLookup' && $stateParams.frm !== 'certificateLookup' && $stateParams.frm !== 'ccView') {
                    MeasureReportModel.reset();
                } else if ($stateParams.frm === 'ccLookup' || $stateParams.frm === 'adcoLookup' || $stateParams.frm === 'footnoteLookup' || $stateParams.frm === 'certificateLookup') {
                    MeasureReportModel.resetSearchResult();
                }
                if ($stateParams.ccField && $stateParams.cc) {
                    if ($stateParams.ccField === 'commodityCodeRangeStart') {
                        MeasureReportModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.cc;
                    } else if ($stateParams.ccField === 'commodityCodeRangeEnd') {
                        MeasureReportModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cc;
                    }
                }
                if ($stateParams.ds) {
                    var startDate = CommonHelper.parseInputDate($stateParams.ds);
                    if (startDate) {
                        MeasureReportModel.getSearchCriteria().startDate = startDate;
                    }
                }
                if ($stateParams.de) {
                    var endDate = CommonHelper.parseInputDate($stateParams.de);
                    if (endDate) {
                        MeasureReportModel.getSearchCriteria().endDate = endDate;
                    }
                }
                if ($stateParams.ccs) {
                    MeasureReportModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.ccs;
                }
                if ($stateParams.cce) {
                    MeasureReportModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cce;
                }
                if ($stateParams.d) {
                    if ($stateParams.d === 'I' || $stateParams.d === 'E' || $stateParams.d === 'B') {
                        MeasureReportModel.getSearchCriteria().direction = $stateParams.d;
                    }
                }
                if ($stateParams.co) {
                    MeasureReportModel.getSearchCriteria().country = $stateParams.co;
                }
                if ($stateParams.mt) {
                    var measureTypes = $stateParams.mt.split(',');
                    for (var i = 0; i < measureTypes.length; i++) {
                        if (MeasureReportModel.getSearchCriteria().measureTypes.indexOf(measureTypes[i]) < 0) {
                            MeasureReportModel.getSearchCriteria().measureTypes.push(measureTypes[i]);
                        }
                    }
                }
                if ($stateParams.ad) {
                    if ($stateParams.frm === 'adcoLookup') {
                        MeasureReportModel.getSearchCriteria().additionalCode = $stateParams.ad;
                    } else {
                        var additionalCodes = $stateParams.ad.split(',');
                        for (var _i = 0; _i < additionalCodes.length; _i++) {
                            if (MeasureReportModel.getSearchCriteria().additionalCodes.indexOf(additionalCodes[_i]) < 0) {
                                MeasureReportModel.getSearchCriteria().additionalCodes.push(additionalCodes[_i]);
                            }
                        }
                    }
                }
                if ($stateParams.fn) {
                    if ($stateParams.frm === 'footnoteLookup') {
                        MeasureReportModel.getSearchCriteria().footnote = $stateParams.fn;
                    } else {
                        var footnotes = $stateParams.fn.split(',');
                        for (var _i2 = 0; _i2 < footnotes.length; _i2++) {
                            if (MeasureReportModel.getSearchCriteria().footnotes.indexOf(footnotes[_i2]) < 0) {
                                MeasureReportModel.getSearchCriteria().footnotes.push(footnotes[_i2]);
                            }
                        }
                    }
                }
                if ($stateParams.ce) {
                    if ($stateParams.frm === 'certificateLookup') {
                        MeasureReportModel.getSearchCriteria().certificate = $stateParams.ce;
                    } else {
                        var certificates = $stateParams.ce.split(',');
                        for (var _i3 = 0; _i3 < certificates.length; _i3++) {
                            if (MeasureReportModel.getSearchCriteria().certificates.indexOf(certificates[_i3]) < 0) {
                                MeasureReportModel.getSearchCriteria().certificates.push(certificates[_i3]);
                            }
                        }
                    }
                }
                if ($stateParams.gnd) {
                    MeasureReportModel.getSearchCriteria().goodsNomenclatureDescription = $stateParams.gnd === 'true';
                }
                if ($stateParams.add) {
                    MeasureReportModel.getSearchCriteria().additionalCodeDescription = $stateParams.add === 'true';
                }
                if ($stateParams.fnd) {
                    MeasureReportModel.getSearchCriteria().footnoteDescription = $stateParams.fnd === 'true';
                }
                if ($stateParams.ced) {
                    MeasureReportModel.getSearchCriteria().certificateDescription = $stateParams.ced === 'true';
                }
                if ($stateParams.gad) {
                    MeasureReportModel.getSearchCriteria().geographicalAreaDescription = $stateParams.gad === 'true';
                }
                if ($stateParams.ded) {
                    MeasureReportModel.getSearchCriteria().dutyExpressionDescription = $stateParams.ded === 'true';
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            countries: ["MeasureReportModel", "GeographicalAreaModel", "$stateParams", function countries(MeasureReportModel, GeographicalAreaModel, $stateParams) {
                var result = null;
                // Only get countries to support bookmark when there are required parameters.
                if ((!$stateParams.frm || $stateParams.frm !== 'ccLookup' || $stateParams.frm !== 'adcoLookup' || $stateParams.frm !== 'footnoteLookup' || $stateParams.frm !== 'certificateLookup' || $stateParams.frm !== 'ccView') && $stateParams.ds && $stateParams.ccs && $stateParams.d && $stateParams.l && ($stateParams.mt || $stateParams.ad || $stateParams.fn || $stateParams.ce)) {

                    result = GeographicalAreaModel.getCountriesOfOrigin(MeasureReportModel.getSearchCriteria().startDate);
                }
                return result;
            }],
            measureTypes: ["MeasureReportModel", "MeasureTypeModel", function measureTypes(MeasureReportModel, MeasureTypeModel) {
                return MeasureTypeModel.getMeasureTypes(MeasureReportModel.getSearchCriteria().direction, MeasureReportModel.getSearchCriteria().startDate, MeasureReportModel.getSearchCriteria().endDate);
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/measure');
                $translatePartialLoader.addPart('taric/quota');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric.report.measureAmendments', {
        url: '/measureamendments?frm&cc&ccField&ds&de&ccs&cce&d&mt&ut&ad&fn&ce&gnd&add&fnd&ced&ded&l',
        templateUrl: 'taric/report/measureamendments/measure-amendments-search.tmpl.html',
        controller: 'MeasureAmendmentsController as measureAmendmentsCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: ["$stateParams", "$filter", "$translate", "MeasureAmendmentsModel", "CommonHelper", function initializeData($stateParams, $filter, $translate, MeasureAmendmentsModel, CommonHelper) {
                if ($stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'adcoLookup' && $stateParams.frm !== 'footnoteLookup' && $stateParams.frm !== 'certificateLookup') {
                    MeasureAmendmentsModel.reset();
                } else if ($stateParams.frm === 'ccLookup' || $stateParams.frm === 'adcoLookup' || $stateParams.frm === 'footnoteLookup' || $stateParams.frm === 'certificateLookup') {
                    MeasureAmendmentsModel.resetSearchResult();
                }
                if ($stateParams.ccField && $stateParams.cc) {
                    if ($stateParams.ccField === 'commodityCodeRangeStart') {
                        MeasureAmendmentsModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.cc;
                    } else if ($stateParams.ccField === 'commodityCodeRangeEnd') {
                        MeasureAmendmentsModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cc;
                    }
                }
                if ($stateParams.ds) {
                    var startDate = CommonHelper.parseInputDate($stateParams.ds);
                    if (startDate) {
                        MeasureAmendmentsModel.getSearchCriteria().startDate = startDate;
                    }
                }
                if ($stateParams.de) {
                    var endDate = CommonHelper.parseInputDate($stateParams.de);
                    if (endDate) {
                        MeasureAmendmentsModel.getSearchCriteria().endDate = endDate;
                    }
                }
                if ($stateParams.ccs) {
                    MeasureAmendmentsModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.ccs;
                }
                if ($stateParams.cce) {
                    MeasureAmendmentsModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cce;
                }
                if ($stateParams.d) {
                    if ($stateParams.d === 'I' || $stateParams.d === 'E') {
                        MeasureAmendmentsModel.getSearchCriteria().direction = $stateParams.d;
                    }
                }
                if ($stateParams.mt) {
                    MeasureAmendmentsModel.getSearchCriteria().measureType = $stateParams.mt;
                }
                if ($stateParams.ut) {
                    if ($stateParams.ut === 'I' || $stateParams.ut === 'U' || $stateParams.ut === 'D') {
                        MeasureAmendmentsModel.getSearchCriteria().updateType = $stateParams.ut;
                    }
                }
                if ($stateParams.ad) {
                    if ($stateParams.ad === '7XXX') {
                        // Return from meursing search with additional code
                        // Dummy value for "not selected"
                        MeasureAmendmentsModel.getSearchCriteria().additionalCode = null;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().additionalCode = $stateParams.ad;
                    }
                }
                if ($stateParams.fn) {
                    MeasureAmendmentsModel.getSearchCriteria().footnote = $stateParams.fn;
                }
                if ($stateParams.ce) {
                    MeasureAmendmentsModel.getSearchCriteria().certificate = $stateParams.ce;
                }
                if ($stateParams.gnd) {
                    if ($stateParams.gnd === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().goodsNomenclatureDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().goodsNomenclatureDescription = false;
                    }
                }
                if ($stateParams.add) {
                    if ($stateParams.add === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().additionalCodeDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().additionalCodeDescription = false;
                    }
                }
                if ($stateParams.fnd) {
                    if ($stateParams.fnd === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().footnoteDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().footnoteDescription = false;
                    }
                }
                if ($stateParams.ced) {
                    if ($stateParams.ced === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().certificateDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().certificateDescription = false;
                    }
                }
                if ($stateParams.ded) {
                    if ($stateParams.ded === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().dutyExpressionDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().dutyExpressionDescription = false;
                    }
                }
                if ($stateParams.l) {
                    $translate.use($stateParams.l);
                }
            }],
            measureTypes: ["MeasureAmendmentsModel", "MeasureTypeModel", function measureTypes(MeasureAmendmentsModel, MeasureTypeModel) {
                return MeasureTypeModel.getMeasureTypes(MeasureAmendmentsModel.getSearchCriteria().direction, MeasureAmendmentsModel.getSearchCriteria().startDate, MeasureAmendmentsModel.getSearchCriteria().endDate);
            }],
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/measureamendments');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }]
        }
    });
}]);

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(730),
    hashDelete = __webpack_require__(731),
    hashGet = __webpack_require__(732),
    hashHas = __webpack_require__(733),
    hashSet = __webpack_require__(734);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(211),
    isArguments = __webpack_require__(161),
    isArray = __webpack_require__(35),
    isBuffer = __webpack_require__(225),
    isIndex = __webpack_require__(56),
    isTypedArray = __webpack_require__(227);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 695 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(214);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var get = __webpack_require__(223);

/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */
function baseAt(object, paths) {
  var index = -1,
      length = paths.length,
      result = Array(length),
      skip = object == null;

  while (++index < length) {
    result[index] = skip ? undefined : get(object, paths[index]);
  }
  return result;
}

module.exports = baseAt;


/***/ }),
/* 698 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(14),
    toLength = __webpack_require__(820);

/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */
function baseFill(array, value, start, end) {
  var length = array.length;

  start = toInteger(start);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : toInteger(end);
  if (end < 0) {
    end += length;
  }
  end = start > end ? 0 : toLength(end);
  while (start < end) {
    array[start++] = value;
  }
  return array;
}

module.exports = baseFill;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(150),
    isArray = __webpack_require__(35);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 701 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 702 */
/***/ (function(module, exports) {

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOfWith;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isObjectLike = __webpack_require__(65);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(203),
    equalArrays = __webpack_require__(215),
    equalByTag = __webpack_require__(720),
    equalObjects = __webpack_require__(721),
    getTag = __webpack_require__(727),
    isArray = __webpack_require__(35),
    isBuffer = __webpack_require__(225),
    isTypedArray = __webpack_require__(227);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(203),
    baseIsEqual = __webpack_require__(206);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(226),
    isMasked = __webpack_require__(737),
    isObject = __webpack_require__(64),
    toSource = __webpack_require__(221);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isLength = __webpack_require__(163),
    isObjectLike = __webpack_require__(65);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(738),
    nativeKeys = __webpack_require__(751);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(705),
    getMatchData = __webpack_require__(724),
    matchesStrictComparable = __webpack_require__(218);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(206),
    get = __webpack_require__(223),
    hasIn = __webpack_require__(785),
    isKey = __webpack_require__(159),
    isStrictComparable = __webpack_require__(217),
    matchesStrictComparable = __webpack_require__(218),
    toKey = __webpack_require__(63);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var isIndex = __webpack_require__(56);

/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return isIndex(n, length) ? array[n] : undefined;
}

module.exports = baseNth;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(151);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(205),
    castPath = __webpack_require__(99),
    isIndex = __webpack_require__(56),
    isObject = __webpack_require__(64),
    toKey = __webpack_require__(63);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(770),
    defineProperty = __webpack_require__(214),
    identity = __webpack_require__(102);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71),
    arrayMap = __webpack_require__(33),
    isArray = __webpack_require__(35),
    isSymbol = __webpack_require__(58);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(99),
    last = __webpack_require__(36),
    parent = __webpack_require__(755),
    toKey = __webpack_require__(63);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(58);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(202),
    noop = __webpack_require__(794),
    setToArray = __webpack_require__(160);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71),
    Uint8Array = __webpack_require__(692),
    eq = __webpack_require__(57),
    equalArrays = __webpack_require__(215),
    mapToArray = __webpack_require__(749),
    setToArray = __webpack_require__(160);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(723);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(222),
    overRest = __webpack_require__(219),
    setToString = __webpack_require__(220);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(700),
    getSymbols = __webpack_require__(726),
    keys = __webpack_require__(228);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(217),
    keys = __webpack_require__(228);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(72),
    stubArray = __webpack_require__(812);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(689),
    Map = __webpack_require__(146),
    Promise = __webpack_require__(691),
    Set = __webpack_require__(202),
    WeakMap = __webpack_require__(693),
    baseGetTag = __webpack_require__(74),
    toSource = __webpack_require__(221);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 728 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(99),
    isArguments = __webpack_require__(161),
    isArray = __webpack_require__(35),
    isIndex = __webpack_require__(56),
    isLength = __webpack_require__(163),
    toKey = __webpack_require__(63);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(101);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 731 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(101);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(101);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(101);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71),
    isArguments = __webpack_require__(161),
    isArray = __webpack_require__(35);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(718);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 738 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 739 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(93);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(93);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(93);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(93);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(690),
    ListCache = __webpack_require__(91),
    Map = __webpack_require__(146);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(793);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(754);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(216);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(165)(module)))

/***/ }),
/* 753 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(151),
    baseSlice = __webpack_require__(34);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 756 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(91);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 760 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 761 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 762 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(91),
    Map = __webpack_require__(146),
    MapCache = __webpack_require__(147);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 764 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 765 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.lastIndexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictLastIndexOf(array, value, fromIndex) {
  var index = fromIndex + 1;
  while (index--) {
    if (array[index] === value) {
      return index;
    }
  }
  return index;
}

module.exports = strictLastIndexOf;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(750);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34),
    isIterateeCall = __webpack_require__(158),
    toInteger = __webpack_require__(14);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 768 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(150),
    baseFlatten = __webpack_require__(28),
    copyArray = __webpack_require__(213),
    isArray = __webpack_require__(35);

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

module.exports = concat;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(73),
    baseFlatten = __webpack_require__(28),
    baseRest = __webpack_require__(12),
    isArrayLikeObject = __webpack_require__(22);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(73),
    baseFlatten = __webpack_require__(28),
    baseIteratee = __webpack_require__(11),
    baseRest = __webpack_require__(12),
    isArrayLikeObject = __webpack_require__(22),
    last = __webpack_require__(36);

/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = baseRest(function(array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2))
    : [];
});

module.exports = differenceBy;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(73),
    baseFlatten = __webpack_require__(28),
    baseRest = __webpack_require__(12),
    isArrayLikeObject = __webpack_require__(22),
    last = __webpack_require__(36);

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function(array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
    : [];
});

module.exports = differenceWith;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34),
    toInteger = __webpack_require__(14);

/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function drop(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, n < 0 ? 0 : n, length);
}

module.exports = drop;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34),
    toInteger = __webpack_require__(14);

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = dropRight;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    baseWhile = __webpack_require__(97);

/**
 * Creates a slice of `array` excluding elements dropped from the end.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.dropRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropRightWhile(users, ['active', false]);
 * // => objects for ['barney']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropRightWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropRightWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3), true, true)
    : [];
}

module.exports = dropRightWhile;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    baseWhile = __webpack_require__(97);

/**
 * Creates a slice of `array` excluding elements dropped from the beginning.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.dropWhile(users, function(o) { return !o.active; });
 * // => objects for ['pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropWhile(users, ['active', false]);
 * // => objects for ['pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3), true)
    : [];
}

module.exports = dropWhile;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var baseFill = __webpack_require__(699),
    isIterateeCall = __webpack_require__(158);

/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */
function fill(array, value, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
    start = 0;
    end = length;
  }
  return baseFill(array, value, start, end);
}

module.exports = fill;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(94),
    baseIteratee = __webpack_require__(11),
    toInteger = __webpack_require__(14);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(94),
    baseIteratee = __webpack_require__(11),
    toInteger = __webpack_require__(14);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(224);


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(28);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY) : [];
}

module.exports = flattenDeep;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(28),
    toInteger = __webpack_require__(14);

/**
 * Recursively flatten `array` up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * var array = [1, [2, [3, [4]], 5]];
 *
 * _.flattenDepth(array, 1);
 * // => [1, 2, [3, [4]], 5]
 *
 * _.flattenDepth(array, 2);
 * // => [1, 2, 3, [4], 5]
 */
function flattenDepth(array, depth) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  depth = depth === undefined ? 1 : toInteger(depth);
  return baseFlatten(array, depth);
}

module.exports = flattenDepth;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

module.exports = fromPairs;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(701),
    hasPath = __webpack_require__(729);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(152),
    toInteger = __webpack_require__(14);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

module.exports = indexOf;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34);

/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */
function initial(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 0, -1) : [];
}

module.exports = initial;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(33),
    baseIntersection = __webpack_require__(153),
    baseRest = __webpack_require__(12),
    castArrayLikeObject = __webpack_require__(157);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(33),
    baseIntersection = __webpack_require__(153),
    baseIteratee = __webpack_require__(11),
    baseRest = __webpack_require__(12),
    castArrayLikeObject = __webpack_require__(157),
    last = __webpack_require__(36);

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = baseRest(function(arrays) {
  var iteratee = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  if (iteratee === last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, baseIteratee(iteratee, 2))
    : [];
});

module.exports = intersectionBy;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(33),
    baseIntersection = __webpack_require__(153),
    baseRest = __webpack_require__(12),
    castArrayLikeObject = __webpack_require__(157),
    last = __webpack_require__(36);

/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = baseRest(function(arrays) {
  var comparator = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, undefined, comparator)
    : [];
});

module.exports = intersectionWith;


/***/ }),
/* 791 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

module.exports = join;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(94),
    baseIsNaN = __webpack_require__(207),
    strictLastIndexOf = __webpack_require__(765),
    toInteger = __webpack_require__(14);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.indexOf` except that it iterates over elements of
 * `array` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.lastIndexOf([1, 2, 1, 2], 2);
 * // => 3
 *
 * // Search from the `fromIndex`.
 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
 * // => 1
 */
function lastIndexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
  }
  return value === value
    ? strictLastIndexOf(array, value, index)
    : baseFindIndex(array, baseIsNaN, index, true);
}

module.exports = lastIndexOf;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(147);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var baseNth = __webpack_require__(711),
    toInteger = __webpack_require__(14);

/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
}

module.exports = nth;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(208),
    basePropertyDeep = __webpack_require__(712),
    isKey = __webpack_require__(159),
    toKey = __webpack_require__(63);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(12),
    pullAll = __webpack_require__(229);

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

module.exports = pull;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    basePullAll = __webpack_require__(154);

/**
 * This method is like `_.pullAll` except that it accepts `iteratee` which is
 * invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The iteratee is invoked with one argument: (value).
 *
 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
 *
 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
 * console.log(array);
 * // => [{ 'x': 2 }]
 */
function pullAllBy(array, values, iteratee) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values, baseIteratee(iteratee, 2))
    : array;
}

module.exports = pullAllBy;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__(154);

/**
 * This method is like `_.pullAll` except that it accepts `comparator` which
 * is invoked to compare elements of `array` to `values`. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
 *
 * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
 * console.log(array);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
 */
function pullAllWith(array, values, comparator) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values, undefined, comparator)
    : array;
}

module.exports = pullAllWith;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(33),
    baseAt = __webpack_require__(697),
    basePullAt = __webpack_require__(209),
    compareAscending = __webpack_require__(717),
    flatRest = __webpack_require__(722),
    isIndex = __webpack_require__(56);

/**
 * Removes elements from `array` corresponding to `indexes` and returns an
 * array of removed elements.
 *
 * **Note:** Unlike `_.at`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 * var pulled = _.pullAt(array, [1, 3]);
 *
 * console.log(array);
 * // => ['a', 'c']
 *
 * console.log(pulled);
 * // => ['b', 'd']
 */
var pullAt = flatRest(function(array, indexes) {
  var length = array == null ? 0 : array.length,
      result = baseAt(array, indexes);

  basePullAt(array, arrayMap(indexes, function(index) {
    return isIndex(index, length) ? +index : index;
  }).sort(compareAscending));

  return result;
});

module.exports = pullAt;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    basePullAt = __webpack_require__(209);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 802 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeReverse = arrayProto.reverse;

/**
 * Reverses `array` so that the first element becomes the last, the second
 * element becomes the second to last, and so on.
 *
 * **Note:** This method mutates `array` and is based on
 * [`Array#reverse`](https://mdn.io/Array/reverse).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.reverse(array);
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function reverse(array) {
  return array == null ? array : nativeReverse.call(array);
}

module.exports = reverse;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34),
    isIterateeCall = __webpack_require__(158),
    toInteger = __webpack_require__(14);

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndex = __webpack_require__(95);

/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */
function sortedIndex(array, value) {
  return baseSortedIndex(array, value);
}

module.exports = sortedIndex;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    baseSortedIndexBy = __webpack_require__(155);

/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */
function sortedIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee(iteratee, 2));
}

module.exports = sortedIndexBy;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndex = __webpack_require__(95),
    eq = __webpack_require__(57);

/**
 * This method is like `_.indexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
 * // => 1
 */
function sortedIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value);
    if (index < length && eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = sortedIndexOf;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndex = __webpack_require__(95);

/**
 * This method is like `_.sortedIndex` except that it returns the highest
 * index at which `value` should be inserted into `array` in order to
 * maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
 * // => 4
 */
function sortedLastIndex(array, value) {
  return baseSortedIndex(array, value, true);
}

module.exports = sortedLastIndex;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    baseSortedIndexBy = __webpack_require__(155);

/**
 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 1
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
 * // => 1
 */
function sortedLastIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee(iteratee, 2), true);
}

module.exports = sortedLastIndexBy;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndex = __webpack_require__(95),
    eq = __webpack_require__(57);

/**
 * This method is like `_.lastIndexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
 * // => 3
 */
function sortedLastIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value, true) - 1;
    if (eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = sortedLastIndexOf;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedUniq = __webpack_require__(210);

/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
  return (array && array.length)
    ? baseSortedUniq(array)
    : [];
}

module.exports = sortedUniq;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    baseSortedUniq = __webpack_require__(210);

/**
 * This method is like `_.uniqBy` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
 * // => [1.1, 2.3]
 */
function sortedUniqBy(array, iteratee) {
  return (array && array.length)
    ? baseSortedUniq(array, baseIteratee(iteratee, 2))
    : [];
}

module.exports = sortedUniqBy;


/***/ }),
/* 812 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 813 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34);

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

module.exports = tail;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34),
    toInteger = __webpack_require__(14);

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(34),
    toInteger = __webpack_require__(14);

/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, n < 0 ? 0 : n, length);
}

module.exports = takeRight;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    baseWhile = __webpack_require__(97);

/**
 * Creates a slice of `array` with elements taken from the end. Elements are
 * taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.takeRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeRightWhile(users, ['active', false]);
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeRightWhile(users, 'active');
 * // => []
 */
function takeRightWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3), false, true)
    : [];
}

module.exports = takeRightWhile;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    baseWhile = __webpack_require__(97);

/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */
function takeWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3))
    : [];
}

module.exports = takeWhile;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(821);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(698),
    toInteger = __webpack_require__(14);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */
function toLength(value) {
  return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
}

module.exports = toLength;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64),
    isSymbol = __webpack_require__(58);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(715);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(28),
    baseRest = __webpack_require__(12),
    baseUniq = __webpack_require__(54),
    isArrayLikeObject = __webpack_require__(22);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(28),
    baseIteratee = __webpack_require__(11),
    baseRest = __webpack_require__(12),
    baseUniq = __webpack_require__(54),
    isArrayLikeObject = __webpack_require__(22),
    last = __webpack_require__(36);

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(28),
    baseRest = __webpack_require__(12),
    baseUniq = __webpack_require__(54),
    isArrayLikeObject = __webpack_require__(22),
    last = __webpack_require__(36);

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

module.exports = unionWith;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(54);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    baseUniq = __webpack_require__(54);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(54);

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(73),
    baseRest = __webpack_require__(12),
    isArrayLikeObject = __webpack_require__(22);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(72),
    baseRest = __webpack_require__(12),
    baseXor = __webpack_require__(156),
    isArrayLikeObject = __webpack_require__(22);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(72),
    baseIteratee = __webpack_require__(11),
    baseRest = __webpack_require__(12),
    baseXor = __webpack_require__(156),
    isArrayLikeObject = __webpack_require__(22),
    last = __webpack_require__(36);

/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var xorBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseXor(arrayFilter(arrays, isArrayLikeObject), baseIteratee(iteratee, 2));
});

module.exports = xorBy;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(72),
    baseRest = __webpack_require__(12),
    baseXor = __webpack_require__(156),
    isArrayLikeObject = __webpack_require__(22),
    last = __webpack_require__(36);

/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var xorWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
});

module.exports = xorWith;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(12),
    unzip = __webpack_require__(164);

/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */
var zip = baseRest(unzip);

module.exports = zip;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(205),
    baseZipObject = __webpack_require__(212);

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

module.exports = zipObject;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(713),
    baseZipObject = __webpack_require__(212);

/**
 * This method is like `_.zipObject` except that it supports property paths.
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
 */
function zipObjectDeep(props, values) {
  return baseZipObject(props || [], values || [], baseSet);
}

module.exports = zipObjectDeep;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(12),
    unzipWith = __webpack_require__(230);

/**
 * This method is like `_.zip` except that it accepts `iteratee` to specify
 * how grouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  grouped values.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
 *   return a + b + c;
 * });
 * // => [111, 222]
 */
var zipWith = baseRest(function(arrays) {
  var length = arrays.length,
      iteratee = length > 1 ? arrays[length - 1] : undefined;

  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
  return unzipWith(arrays, iteratee);
});

module.exports = zipWith;


/***/ }),
/* 837 */,
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(118);

__webpack_require__(117);

__webpack_require__(105);

__webpack_require__(106);

__webpack_require__(107);

__webpack_require__(109);

__webpack_require__(110);

__webpack_require__(111);

__webpack_require__(115);

__webpack_require__(112);

__webpack_require__(113);

__webpack_require__(114);

__webpack_require__(108);

__webpack_require__(116);

__webpack_require__(75);

var _adler32cs = __webpack_require__(104);

var _adler32cs2 = _interopRequireDefault(_adler32cs);

var _accounting = __webpack_require__(103);

var _accounting2 = _interopRequireDefault(_accounting);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _array = __webpack_require__(374);

var _array2 = _interopRequireDefault(_array);

__webpack_require__(397);

__webpack_require__(399);

__webpack_require__(400);

__webpack_require__(461);

__webpack_require__(462);

__webpack_require__(460);

__webpack_require__(463);

__webpack_require__(408);

__webpack_require__(387);

__webpack_require__(402);

__webpack_require__(459);

__webpack_require__(454);

__webpack_require__(409);

__webpack_require__(444);

__webpack_require__(441);

__webpack_require__(443);

__webpack_require__(405);

__webpack_require__(406);

__webpack_require__(407);

__webpack_require__(396);

__webpack_require__(415);

__webpack_require__(403);

__webpack_require__(404);

__webpack_require__(379);

__webpack_require__(449);

__webpack_require__(451);

__webpack_require__(450);

__webpack_require__(458);

__webpack_require__(398);

__webpack_require__(394);

__webpack_require__(383);

__webpack_require__(395);

__webpack_require__(378);

__webpack_require__(392);

__webpack_require__(386);

__webpack_require__(384);

__webpack_require__(391);

__webpack_require__(390);

__webpack_require__(393);

__webpack_require__(381);

__webpack_require__(389);

__webpack_require__(382);

__webpack_require__(388);

__webpack_require__(401);

__webpack_require__(380);

__webpack_require__(434);

__webpack_require__(425);

__webpack_require__(427);

__webpack_require__(426);

__webpack_require__(431);

__webpack_require__(430);

__webpack_require__(457);

__webpack_require__(424);

__webpack_require__(429);

__webpack_require__(428);

__webpack_require__(385);

__webpack_require__(435);

__webpack_require__(432);

__webpack_require__(416);

__webpack_require__(413);

__webpack_require__(417);

__webpack_require__(414);

__webpack_require__(439);

__webpack_require__(438);

__webpack_require__(440);

__webpack_require__(423);

__webpack_require__(421);

__webpack_require__(422);

__webpack_require__(442);

__webpack_require__(452);

__webpack_require__(453);

__webpack_require__(475);

__webpack_require__(470);

__webpack_require__(471);

__webpack_require__(472);

__webpack_require__(473);

__webpack_require__(474);

__webpack_require__(468);

__webpack_require__(469);

__webpack_require__(465);

__webpack_require__(464);

__webpack_require__(467);

__webpack_require__(466);

__webpack_require__(436);

__webpack_require__(433);

__webpack_require__(437);

__webpack_require__(455);

__webpack_require__(456);

__webpack_require__(446);

__webpack_require__(447);

__webpack_require__(445);

__webpack_require__(448);

__webpack_require__(419);

__webpack_require__(418);

__webpack_require__(420);

__webpack_require__(410);

__webpack_require__(412);

__webpack_require__(411);

__webpack_require__(376);

__webpack_require__(375);

__webpack_require__(377);

__webpack_require__(370);

__webpack_require__(371);

__webpack_require__(369);

__webpack_require__(372);

__webpack_require__(373);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Angular ui boostrap


//Angular translate
window.adler32cs = _adler32cs2.default;

//Accounting


//Utilities


//Angular router


//Angular libs

window.accounting = _accounting2.default;

//https://momentjs.com/docs/

window.moment = _moment2.default;

// https://lodash.com/docs/

window.array = _array2.default;

//Application files


var arcticTARIFF = angular.module('arctic.tariff', ['ui.router', 'ui.bootstrap', 'tmh.dynamicLocale', 'ngAria', 'taric.auth.loginhelper', 'taric.auth.userhelper', 'taric.quota', 'taric.nomenclature', 'taric.measure', 'taric.moreinfo.links', 'taric.duty', 'taric.adco', 'taric.footnote', 'taric.certificate', 'taric.report', 'taric.moreinfo.codelists', 'common.config', 'ngCookies', 'ngSanitize', 'pascalprecht.translate', 'taric.model.menu', 'arctic.tariff.home', 'arctic.tariff.news', 'arctic.tariff.about', 'common.template.about.popup', 'arctic.tariff.callback']);

arcticTARIFF.config(["$stateProvider", "$locationProvider", "tmhDynamicLocaleProvider", "$httpProvider", function ($stateProvider, $locationProvider, tmhDynamicLocaleProvider, $httpProvider) {
    $stateProvider.state('home', {
        url: "/home",
        templateUrl: 'home/home.html',
        controller: 'HomeController as homeCtrl',
        resolve: {
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('common');
                $translatePartialLoader.addPart('home');
            }],

            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.disablePrintable();
                MenuModel.disableExportable();
                MenuModel.setHelpIndex("");
                MenuModel.notifyObservers();
            }]
        }
    }).state('news', {
        url: "/news",
        templateUrl: 'news/news.html',
        controller: 'NewsController as newsCtrl',
        resolve: {
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('common');
                $translatePartialLoader.addPart('news');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.disablePrintable();
                MenuModel.disableExportable();
                MenuModel.setHelpIndex("");
                MenuModel.notifyObservers();
            }],
            defaultRssFeeds: ["NewsModel", function defaultRssFeeds(NewsModel) {
                return NewsModel.getRssFeeds();
            }]
        }
    }).state('about', {
        url: "/about",
        templateUrl: 'about/about.html',
        controller: 'AboutController as aboutCtrl',
        resolve: {
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('common');
                $translatePartialLoader.addPart('about');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.disablePrintable();
                MenuModel.disableExportable();
                MenuModel.setHelpIndex("");
                MenuModel.notifyObservers();
            }]
        }
    }).state('taric', {
        url: "/taric",
        templateUrl: 'taric/taricTemplate.html',
        resolve: {
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('common');
            }]
        }
    }).state('cb', {
        url: "/cb",
        controller: 'CallbackController as callbackCtrl',
        templateUrl: 'callback/cb.html',
        resolve: {
            loadTranslation: ["$translatePartialLoader", function loadTranslation($translatePartialLoader) {
                $translatePartialLoader.addPart('common');
            }],
            setupMenu: ["MenuModel", function setupMenu(MenuModel) {
                MenuModel.disablePrintable();
                MenuModel.disableExportable();
                MenuModel.setHelpIndex("");
                MenuModel.notifyObservers();
            }]
        }
    });

    $locationProvider.html5Mode(false).hashPrefix('!');

    // Configure path to angular locale files.
    tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-i18n/angular-locale_{{locale}}.js');

    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    //disable ajax request caching -- ACSMNT-3843
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get.Pragma = 'no-cache';
}]);

arcticTARIFF.config(["$translateProvider", "CONSTANTS", function ($translateProvider, CONSTANTS) {
    $translateProvider.useLoader('$translatePartialLoader', {
        urlTemplate: 'i18n/{part}/{lang}.json'
    });
    // Enable escaping of HTML
    $translateProvider.useSanitizeValueStrategy('escape');
    var currentLanguage = localStorage.getItem('NG_TRANSLATE_LANG_KEY');
    if (!currentLanguage) {
        currentLanguage = CONSTANTS.availableLanguages[0];
    }
    $translateProvider.preferredLanguage(currentLanguage).fallbackLanguage(['en']);
    // remember language
    $translateProvider.useLocalStorage();
}]);

arcticTARIFF.service('MetaDataInformationService', ["CONSTANTS", "$translate", "$state", "$location", "AboutModel", function (CONSTANTS, $translate, $state, $location, AboutModel) {
    var model = this;
    var metaData = null;
    model.reloadMetaDataInformation = function () {
        if (metaData) {
            metaData.installationCountry = CONSTANTS.installationCountry;
            metaData.authority = CONSTANTS.authority;
            metaData.language = $translate.use();
            metaData.identifier = $location.absUrl();
            var titleKey = 'i8n.common.arctic-tariff.title.' + $state.current.name;
            $translate(titleKey).then(function (pageTitle) {
                metaData.title = pageTitle;
                metaData.desription = pageTitle;
                var index = pageTitle.indexOf('|');
                if (index > 0) {
                    metaData.desription = pageTitle.substring(0, index).trim();
                }
            });

            $translate('metadata.DCTERMS.type').then(function (type) {
                metaData.type = type;
            });

            AboutModel.getMetadata().then(function (result) {
                metaData.buildDate = result.buildDate;
            }, function (error) {
                //Do nothing if we can not load the meta data
            });
        }
    };

    model.init = function () {
        if (CONSTANTS.includeMetaData) {
            metaData = {};
        }
        model.reloadMetaDataInformation();
    };

    model.getMetaDataInformation = function () {
        return metaData;
    };

    model.init();
}]);

arcticTARIFF.controller('MetaDataInformationCtrl', ["$rootScope", "CONSTANTS", "MetaDataInformationService", function ($rootScope, CONSTANTS, MetaDataInformationService) {
    var metaDataInfoCtrl = this;
    metaDataInfoCtrl.includeMetaData = CONSTANTS.includeMetaData;
    metaDataInfoCtrl.metaData = MetaDataInformationService.getMetaDataInformation();
}]);

arcticTARIFF.controller('BannerController', ["$scope", "$rootScope", "$translate", "$translatePartialLoader", "CommonHelper", "AuthorizeModel", "CONSTANTS", "$uibModal", function ($scope, $rootScope, $translate, $translatePartialLoader, CommonHelper, AuthorizeModel, CONSTANTS, $uibModal) {
    $translatePartialLoader.addPart('common');
    var bannerCtrl = this;
    bannerCtrl.showApplicationTitle = CONSTANTS.showApplicationTitle;
    bannerCtrl.installationCountry = CONSTANTS.installationCountry;
    bannerCtrl.availableLanguages = CONSTANTS.availableLanguages;
    bannerCtrl.userName = AuthorizeModel.userName;
    bannerCtrl.changeLanguage = function (langKey) {
        $translate.use(langKey);
        // When changing language in Tariff GUI, we need to set used language to open ite-auth GUI later.
        CommonHelper.setCookie('language', langKey, 360);
    };
    $rootScope.$on('userName', function (event, data) {
        bannerCtrl.userName = AuthorizeModel.userName;
    });
    bannerCtrl.logoImagePath = CommonHelper.getLogoImagePath(true);
    bannerCtrl.currentLanguage = $translate.use();
    $rootScope.$on('$translateChangeSuccess', function () {
        bannerCtrl.logoImagePath = CommonHelper.getLogoImagePath(true);
        bannerCtrl.currentLanguage = $translate.use();
    });
    bannerCtrl.openAboutPopup = function (size) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/about/about-popup.tmpl.html',
            controller: 'AboutPopupController as aboutPopupCtrl',
            size: size
        });
    };
}]);

arcticTARIFF.controller('MenuController', ["CONSTANTS", "$rootScope", "$scope", "$translate", "$state", "LoginHelper", "UserHelper", "AuthorizeModel", "MenuModel", "$window", "$location", "$http", function (CONSTANTS, $rootScope, $scope, $translate, $state, LoginHelper, UserHelper, AuthorizeModel, MenuModel, $window, $location, $http) {
    var menuCtrl = this;
    menuCtrl.model = AuthorizeModel;
    menuCtrl.menu = CONSTANTS.menu;

    menuCtrl.loggedIn = AuthorizeModel.loggedIn;
    menuCtrl.userName = AuthorizeModel.userName;

    if (CONSTANTS.credentialSetting === 'BASIC') {
        menuCtrl.showLogin = true;
    } else {
        menuCtrl.showLogin = false;
    }

    menuCtrl.helpLink = "";
    menuCtrl.toggleMenu = false;
    menuCtrl.exportable = false;
    menuCtrl.printable = false;

    menuCtrl.doLogin = function () {
        LoginHelper.goToLogin();
    };

    menuCtrl.doLogout = function () {
        AuthorizeModel.logout();
        $state.go(CONSTANTS.menu.landingPage);
        $rootScope.$broadcast('enableLogin');
        $rootScope.$broadcast('clearSearchResult');
        $rootScope.$broadcast('userName');
        if (CONSTANTS.credentialSetting === 'BASIC') {
            $http.post(CONSTANTS.auth_url + '/logout', null);
        }
    };

    menuCtrl.updateMenu = function () {

        menuCtrl.exportable = MenuModel.data().exportable;
        menuCtrl.printable = MenuModel.data().printable;

        var gAgent = navigator.userAgent.toLowerCase();
        var gbChrome = gAgent.indexOf("chrome") != -1;
        var gbSafari = gAgent.indexOf("safari") != -1;
        var gbFirefox = gAgent.indexOf("firefox") != -1;

        var nMapId = MenuModel.data().helpIndex;
        var strWnd = "";
        var url = CONSTANTS.helpServer;
        var language = "/" + $translate.use() + "/";
        var pszHelpFile = "";

        if (nMapId) {

            if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {

                pszHelpFile = "#<id=" + nMapId;
            } else {

                pszHelpFile = "#%3Cid=" + nMapId;
            }
        }

        var firstSegment = url.substr(0, url.lastIndexOf('/'));
        var lastSegment = url.substr(url.lastIndexOf('/') + 1);

        if (!gbChrome && (gbSafari || gbFirefox)) menuCtrl.helpLink = firstSegment + language + lastSegment;else menuCtrl.helpLink = firstSegment + language + lastSegment + pszHelpFile;
    };

    menuCtrl.print = function () {
        if (menuCtrl.printing) {
            return;
        }
        $rootScope.$broadcast('printDocument');
    };

    menuCtrl.export = function () {
        if (menuCtrl.exporting) {
            return;
        }
        $rootScope.$broadcast('exportDocument');
    };

    $rootScope.$on('startSpinningPrint', function (event, data) {

        menuCtrl.printing = true;
    });

    $rootScope.$on('stopSpinningPrint', function (event, data) {

        menuCtrl.printing = false;
    });

    $rootScope.$on('startSpinningExport', function (event, data) {

        menuCtrl.exporting = true;
    });

    $rootScope.$on('stopSpinningExport', function (event, data) {

        menuCtrl.exporting = false;
    });

    $rootScope.$on('disablePrintable', function (event, data) {
        MenuModel.disablePrintable();
        menuCtrl.printable = MenuModel.data().printable;
    });

    $rootScope.$on('enablePrintable', function (event, data) {
        MenuModel.enablePrintable();
        menuCtrl.printable = MenuModel.data().printable;
    });

    $rootScope.$on('disableExportable', function (event, data) {
        MenuModel.disableExportable();
        menuCtrl.exportable = MenuModel.data().exportable;
    });

    $rootScope.$on('enableExportable', function (event, data) {
        MenuModel.enableExportable();
        menuCtrl.exportable = MenuModel.data().exportable;
    });

    $rootScope.$on('tokenInvalid', function (event, data) {
        AuthorizeModel.init();
        menuCtrl.loggedIn = AuthorizeModel.loggedIn;

        // Reset global authorization header
        LoginHelper.setAuthorizationHeader();

        // If SSO is enabled it should not be possible to login again if you logout. In that case the application will have to be restarted.
        if (CONSTANTS.credentialSetting === 'SSO') {
            menuCtrl.showLogin = false;
        }
        $rootScope.$broadcast('userName');
        $rootScope.$broadcast('clearSearchResult');
    });

    $rootScope.$on('enableLogin', function (event, data) {
        menuCtrl.loggedIn = AuthorizeModel.loggedIn;

        // Reset global authorization header
        LoginHelper.setAuthorizationHeader();

        // If SSO is enabled it should not be possible to login again if you logout. In that case the application will have to be restarted.
        if (CONSTANTS.credentialSetting === 'SSO') {
            menuCtrl.showLogin = false;
        }
        $rootScope.$broadcast('userName');
        if (CONSTANTS.credentialSetting === 'SSO') {
            $state.go(CONSTANTS.menu.landingPage);
        }
    });

    $rootScope.$on('disableLogin', function (event, data) {
        menuCtrl.loggedIn = AuthorizeModel.loggedIn;

        // Set global authorization header
        LoginHelper.setAuthorizationHeader();

        $rootScope.$broadcast('stopLoggingIn');
        if (CONSTANTS.credentialSetting === 'BASIC') {
            menuCtrl.showLogin = true;
        }
        $rootScope.$broadcast('clearSearchResult');
        $state.go(CONSTANTS.menu.landingPage);
    });

    $rootScope.$on('noLogin', function (event, data) {
        AuthorizeModel.init();
        menuCtrl.loggedIn = AuthorizeModel.loggedIn;
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
        menuCtrl.toggleMenu = false;
    });

    menuCtrl.showWebHelp = function () {
        var gAgent = navigator.userAgent.toLowerCase();
        var gbChrome = gAgent.indexOf("chrome") != -1;
        var gbSafari = gAgent.indexOf("safari") != -1;
        var gbFirefox = gAgent.indexOf("firefox") != -1;

        var nMapId = MenuModel.data().helpIndex;
        var strWnd = "";
        var url = CONSTANTS.helpServer;
        var helpLanguages = CONSTANTS.helpLanguages;
        var language = "/";
        var pszHelpFile = "";

        var host = $location.protocol() + "://" + $location.host();
        var port = $location.port();

        if (helpLanguages.indexOf($translate.use()) != -1) {
            language += $translate.use() + "/";
        } else {
            language += "en" + "/";
        }
        if ('80' !== port) {
            host += ":" + port;
        }
        if (!nMapId) {
            nMapId = "";
        }
        if (!gbChrome && gbSafari) {
            pszHelpFile = "#%3Cid=" + nMapId;
        } else {
            pszHelpFile = "#<id=" + nMapId;
        }

        var firstSegment = url.substr(0, url.lastIndexOf('/'));
        var lastSegment = url.substr(url.lastIndexOf('/') + 1);
        pszHelpFile = host + firstSegment + language + lastSegment + pszHelpFile;

        if (gbChrome) {
            var popup = $window.open("about:blank", "_blank"); // the about:blank is to please Chrome, and _blank to please Firefox
            popup.location = pszHelpFile;
        } else if (gbSafari) {
            window.open(pszHelpFile);
        } else {
            menuCtrl.loadData(pszHelpFile);
        }
    };

    menuCtrl.loadData = function (sFileName) {
        var gAgent = navigator.userAgent.toLowerCase();
        var gbChrome = gAgent.indexOf("chrome") != -1;
        var gbSafari = gAgent.indexOf("safari") != -1;
        var gbFirefox = gAgent.indexOf("firefox") != -1;
        var gbMac = gAgent.indexOf("mac") != -1;

        if (!menuCtrl.getElement("dataDiv")) {
            if (!menuCtrl.insertDataDiv()) {

                gsFileName = sFileName;
                return;
            }
        }

        var sHTML = "";
        if (gbMac) sHTML += "<iframe name=\"__WebHelpCshStub\" src=\"" + sFileName + "\"></iframe>";else sHTML += "<iframe name=\"__WebHelpCshStub\" style=\"visibility:hidden;width:0;height:0\" src=\"" + sFileName + "\"></iframe>";

        var oDivCon = menuCtrl.getElement("dataDiv");
        if (oDivCon) {
            if (gbChrome || gbSafari) {
                var iframe = menuCtrl.getElement("__chrome");
                if (iframe) {
                    oDivCon.removeChild(iframe);
                }
                iframe = document.createElement("iframe");
                iframe.setAttribute("id", "__chrome");
                iframe.setAttribute("name", "__WebHelpCshStub");
                iframe.setAttribute("src", sFileName);
                if (gbMac) oDivCon.setAttribute("style", "visibility:hidden;width:0;height:0");
                oDivCon.appendChild(iframe);
            } else if (gbFirefox) {
                if (oDivCon.getElementsByTagName && oDivCon.getElementsByTagName("iFrame").length > 0) {
                    oDivCon.getElementsByTagName("iFrame")[0].src = sFileName;
                } else {
                    oDivCon.innerHTML = sHTML;
                }
            } else {
                oDivCon.innerHTML = sHTML;
            }
        }
    };

    menuCtrl.getElement = function (sID) {

        if (document.getElementById) return document.getElementById(sID);else if (document.all) return document.all(sID);
        return null;
    };

    menuCtrl.insertDataDiv = function () {
        var gAgent = navigator.userAgent.toLowerCase();
        var gbChrome = gAgent.indexOf("chrome") != -1;
        var gbSafari = gAgent.indexOf("safari") != -1;
        var gbFirefox = gAgent.indexOf("firefox") != -1;
        var gbMac = gAgent.indexOf("mac") != -1;

        var sHTML = "";
        if (gbMac) {
            sHTML += "<div id=dataDiv style=\"display:none;\"></div>";
        } else {
            sHTML += "<div id=dataDiv style=\"visibility:hidden\"></div>";
        }
        var obj = document.body;
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            obj.insertAdjacentHTML("beforeEnd", sHTML);
        } else if (gbFirefox) {
            var r = obj.ownerDocument.createRange();
            r.setStartBefore(obj);
            var parsedHTML = r.createContextualFragment(sHTML);
            obj.appendChild(parsedHTML);
        } else if (gbChrome || gbSafari) {
            var e = document.createElement("div");
            e.setAttribute("id", "dataDiv");
            if (gbMac) e.setAttribute("style", "display:none");else e.setAttribute("style", "visibility:hidden");
            obj.appendChild(e);
        }
        return true;
    };
    // refresh variable after initialize
    menuCtrl.updateMenu();
    MenuModel.registerObserverCallback(menuCtrl.updateMenu);
}]);

arcticTARIFF.run(["CommonHelper", function (CommonHelper) {
    // When firstly opening Tariff GUI, we need to set used language to open ite-auth GUI later.
    CommonHelper.setCookie('language', localStorage.getItem('NG_TRANSLATE_LANG_KEY'), 360);
}]);

arcticTARIFF.run(["CONSTANTS", "LoginHelper", function (CONSTANTS, LoginHelper) {
    // Avoid error when credentialSetting is 'NONE' and ite-auth module is not deployed.
    if (CONSTANTS.credentialSetting === 'SSO' || CONSTANTS.credentialSetting === 'BASIC') {
        // If reloaded browser try to read JWT from session storage
        LoginHelper.login();
    }
}]);

arcticTARIFF.run(["$rootScope", "$translate", "CommonHelper", "tmhDynamicLocale", "$window", "$state", "MenuModel", "MetaDataInformationService", "CONSTANTS", function ($rootScope, $translate, CommonHelper, tmhDynamicLocale, $window, $state, MenuModel, MetaDataInformationService, CONSTANTS) {
    $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
        $translate.refresh();
    });

    $rootScope.$on('$translateChangeSuccess', function () {
        $rootScope.language = $translate.use();
        $rootScope.logoImagePath = CommonHelper.getLogoImagePath();
        CommonHelper.translateCalendarButtons();
        CommonHelper.setDynamicLocale(tmhDynamicLocale);

        if (!$state.current || !$state.current.name) {

            //Do not do anything below
            return;
        }

        changeDocumentTitle($state.current.name);
        MenuModel.notifyObservers();
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
        changeDocumentTitle(toState.name);
    });

    function changeDocumentTitle(stateName) {
        var defaultPageTitleKey = 'i8n.common.arctic-tariff.title.' + stateName;

        // Browser title
        $translate(defaultPageTitleKey).then(function (defaultPageTitleValue) {
            if (CONSTANTS.branding === 'KGH') {
                // 1. Browser title
                if ($rootScope.language === 'en') {
                    $translate('i8n.common.arctic-tariff.title').then(function (pageTitleValue) {
                        $window.document.title = defaultPageTitleValue + pageTitleValue;
                    });
                } else {
                    $window.document.title = defaultPageTitleValue;
                }

                // 2. Homepage text
                $translate('i8n.common.welcome.text').then(function (welcomeTextValue) {
                    if ($window.document.getElementById('home-welcomeText')) {
                        $window.document.getElementById('home-welcomeText').innerHTML = welcomeTextValue;
                    }
                });
            } else {
                if ($rootScope.language === 'en') {
                    if (['EE', 'CY', 'SE', 'DK', 'NL'].includes(CONSTANTS.installationCountry)) {
                        // 1. Browser title
                        $translate('i8n.common.arctic-tariff.title-' + CONSTANTS.installationCountry).then(function (pageTitleValue) {
                            $window.document.title = defaultPageTitleValue + pageTitleValue;
                        });

                        // 2. Homepage text
                        $translate('i8n.common.welcome.text' + CONSTANTS.installationCountry).then(function (welcomeTextValue) {
                            if ($window.document.getElementById('home-welcomeText')) {
                                $window.document.getElementById('home-welcomeText').innerHTML = welcomeTextValue;
                            }
                        });
                    } else {
                        // 1. Browser title
                        $translate('i8n.common.arctic-tariff.title').then(function (pageTitleValue) {
                            $window.document.title = defaultPageTitleValue + pageTitleValue;
                        });

                        // 2. Homepage text
                        $translate('i8n.common.welcome.text').then(function (welcomeTextValue) {
                            if ($window.document.getElementById('home-welcomeText')) {
                                $window.document.getElementById('home-welcomeText').innerHTML = welcomeTextValue;
                            }
                        });
                    }
                } else {
                    // 1. Browser title
                    $window.document.title = defaultPageTitleValue;

                    // 2. Homepage text
                    $translate('i8n.common.welcome.text').then(function (welcomeTextValue) {
                        if ($window.document.getElementById('home-welcomeText')) {
                            $window.document.getElementById('home-welcomeText').innerHTML = welcomeTextValue;
                        }
                    });
                }
            }

            MetaDataInformationService.reloadMetaDataInformation();
        }, function (error) {});
    }

    $rootScope.$on('$locationChangeSuccess', function (evt) {

        var mainContent = document.getElementById('mainContent');
        if (mainContent) {
            mainContent.focus();
        }

        $window.scrollTo(0, 0);
    });
}]);

arcticTARIFF.run(["uibPaginationConfig", "uibDatepickerConfig", "CONSTANTS", "$state", function (uibPaginationConfig, uibDatepickerConfig, CONSTANTS, $state) {
    uibPaginationConfig.itemsPerPage = CONSTANTS.rowsPerPage;

    //Open calendar with starting date = Monday
    uibDatepickerConfig.startingDay = 1;
    $state.go(CONSTANTS.menu.landingPage);
}]);

/***/ })
],[838]);


// WEBPACK FOOTER //
// js/app.a8e16f6e788296b8a98c.js